import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Any custom scalar type */
  Any: { input: any; output: any };
  /** Date custom scalar type */
  Date: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload_Scalar: { input: any; output: any };
}

export interface AbuseModel {
  abuser?: Maybe<UserModel>;
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  reason?: Maybe<UserReportReason>;
  updatedAt: Scalars["Date"]["output"];
  victim?: Maybe<UserModel>;
}

export interface ActivateUserInput {
  activationKey: Scalars["String"]["input"];
}

export interface AddBulkMembersInput {
  action: BulkAddAction;
  channelId: Scalars["String"]["input"];
  channelType: BulkChannelType;
  emails: Array<Scalars["String"]["input"]>;
}

export interface AddEventCalendarInput {
  calendarType: CalendarType;
  eventID: Scalars["String"]["input"];
}

export interface AdminFilterBannersInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterCoversInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterEventsInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface AdminFilterFeatureFlagsInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterIllustrationsInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterReportsUserFilterInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterThemesInput {
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGrammarLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResource?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStandard?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterTopicsInput {
  category?: InputMaybe<AdminTopicsCategories>;
  excludeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AdminTopicsOrderBy>;
  sort?: InputMaybe<SortDirection>;
  status?: InputMaybe<TopicStatus>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  theme?: InputMaybe<Scalars["String"]["input"]>;
}

export interface AdminFilterUsersInput {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  badges?: InputMaybe<Array<UserBadgeType>>;
  cancelledInRecovery?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** How reliably she shows up. */
  commitmentLevels?: InputMaybe<Array<CommitmentLevel>>;
  /** How much she uses the platform (E1–E5). */
  engagementLevels?: InputMaybe<Array<EngagementLevel>>;
  englishLevels?: InputMaybe<Array<SpeakingLevelCategories>>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  /** How close to drifting away (Detected / Dormant / Critical / …). */
  faderLevels?: InputMaybe<Array<FaderLevel>>;
  ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Industry ids. Broader than occupation — 'Education' rather than 'Teacher', so you can reach a whole field at once. */
  industries?: InputMaybe<Array<Scalars["String"]["input"]>>;
  interests?: InputMaybe<Array<Interest>>;
  kind?: InputMaybe<Array<EventPermissions>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location?: InputMaybe<Array<UserLocation>>;
  /** Only members who have attended at least this many events. */
  minEventsAttended?: InputMaybe<Scalars["Int"]["input"]>;
  occupations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  openToSpeakingPartners?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  order?: InputMaybe<SortDirection>;
  orderBy?: InputMaybe<AdminUsersOrderBy>;
  plan?: InputMaybe<Array<MembershipPlans>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Words to look for in her bio — 'teacher', 'mother', 'startup'. Searches only the story, unlike the main search box which also matches name and email. */
  storyKeyword?: InputMaybe<Scalars["String"]["input"]>;
  subscriptionStatus?: InputMaybe<Array<SubscriptionStatus>>;
  /** How long she's been a member. */
  tenures?: InputMaybe<Array<TenureBucket>>;
  /** Match members whose timezone currently sits at this UTC offset, in minutes (e.g. 60 = UTC+1) — 'everyone on that clock', DST-aware. */
  timezoneOffsetMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  verificationStatus?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  /** The member's colour zone — when she's actually around. */
  zones?: InputMaybe<Array<ZoneLabel>>;
}

export interface AdminFilterVideoSetInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterZineCoversInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminShareSelectionResponse {
  alreadySharedCount: Scalars["Int"]["output"];
  cap: Scalars["Int"]["output"];
  eligibleCount: Scalars["Int"]["output"];
  inactiveCount: Scalars["Int"]["output"];
  notAllowedCount: Scalars["Int"]["output"];
  totalMatched: Scalars["Int"]["output"];
  truncated: Scalars["Boolean"]["output"];
  userIds: Array<Scalars["String"]["output"]>;
}

export enum AdminTopicsCategories {
  GrammarLibrary = "GrammarLibrary",
  Resource = "Resource",
  Standard = "Standard",
  TopicLibrary = "TopicLibrary",
}

export enum AdminTopicsOrderBy {
  LastUpdated = "lastUpdated",
  Theme = "theme",
  Title = "title",
}

export interface AdminUserSignUpAnswers {
  createdAt: Scalars["Date"]["output"];
  detectedTimezone?: Maybe<Scalars["String"]["output"]>;
  eligibilityAgeGender?: Maybe<Scalars["String"]["output"]>;
  englishLevel?: Maybe<EnglishLevel>;
  firstEventBookingSkipped: Scalars["Boolean"]["output"];
  guestPassWeeklyPracticeReadiness?: Maybe<Scalars["String"]["output"]>;
  mainSpeakingPracticeChallenge?: Maybe<Scalars["String"]["output"]>;
  mainSpokenEnglishPriority?: Maybe<Scalars["String"]["output"]>;
  selectedFirstEventId?: Maybe<Scalars["String"]["output"]>;
  selectedFirstEventTime?: Maybe<Scalars["Date"]["output"]>;
  selectedTimezone?: Maybe<Scalars["String"]["output"]>;
}

export enum AdminUsersOrderBy {
  Country = "country",
  Date = "date",
  Email = "email",
  Name = "name",
  RecoveryDays = "recoveryDays",
}

export enum ArticleAction {
  Publish = "Publish",
}

export enum ArticleByAuthor {
  Any = "Any",
  Follow = "Follow",
  Heylady = "Heylady",
  Members = "Members",
}

export enum ArticleCategory {
  Any = "Any",
  Featured = "Featured",
  Interests = "Interests",
  Journey = "Journey",
  Liked = "Liked",
  Popular = "Popular",
  Recommended = "Recommended",
  Topics = "Topics",
}

export interface ArticleModel {
  attachments?: Maybe<Array<ArticlesAttachmentModel>>;
  author?: Maybe<UserModel>;
  comments?: Maybe<Array<CommentModel>>;
  content?: Maybe<Scalars["String"]["output"]>;
  coverUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  likedByMe?: Maybe<LikeModel>;
  likes?: Maybe<Array<LikeModel>>;
  myEnglishJourney?: Maybe<Scalars["Boolean"]["output"]>;
  noComments?: Maybe<Scalars["Int"]["output"]>;
  noLikes?: Maybe<Scalars["Int"]["output"]>;
  publishedAt?: Maybe<Scalars["Date"]["output"]>;
  reads: ReadArticleModel;
  scheduledFor?: Maybe<Scalars["Date"]["output"]>;
  tags?: Maybe<Array<Interest>>;
  theme?: Maybe<ArticleThemes>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface ArticleNotificationModel {
  article: ArticleModel;
  articleAction: ArticleAction;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export enum ArticleOrderBy {
  Published = "Published",
  Title = "Title",
}

export interface ArticleSearchResult {
  item: ArticleModel;
  matches?: Maybe<Array<SearchMatch>>;
  refIndex: Scalars["Int"]["output"];
}

export enum ArticleThemes {
  ArtAndCulture = "ART_AND_CULTURE",
  CareerWomen = "CAREER_WOMEN",
  Community = "COMMUNITY",
  FamilyAndFriends = "FAMILY_AND_FRIENDS",
  FoodAndTraditions = "FOOD_AND_TRADITIONS",
  HealthAndWellness = "HEALTH_AND_WELLNESS",
  PersonalDevelopment = "PERSONAL_DEVELOPMENT",
  ScienceAndTechnology = "SCIENCE_AND_TECHNOLOGY",
  TheEnvironment = "THE_ENVIRONMENT",
  Travel = "TRAVEL",
}

export interface ArticlesAttachmentModel {
  article: ArticleModel;
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  meta?: Maybe<MetaFileType>;
  updatedAt: Scalars["Date"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
}

export interface AssessmentResultContentRecord {
  question: Scalars["String"]["output"];
  recording: Scalars["String"]["output"];
}

export interface AssessmentResultModel {
  assessmentId: Scalars["String"]["output"];
  assessmentType?: Maybe<Scalars["String"]["output"]>;
  cefrScore?: Maybe<Scalars["String"]["output"]>;
  coherenceScore: Scalars["Float"]["output"];
  content?: Maybe<Array<AssessmentResultContentRecord>>;
  createdAt: Scalars["Date"]["output"];
  fluencyScore: Scalars["Float"]["output"];
  grammarScore: Scalars["Float"]["output"];
  halloScore: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  improvements?: Maybe<Array<Scalars["String"]["output"]>>;
  isAddedByAdmin: Scalars["Boolean"]["output"];
  language?: Maybe<Scalars["String"]["output"]>;
  pronunciationScore: Scalars["Float"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  vocabularyScore: Scalars["Float"]["output"];
}

export interface AssignOrDeleteBadgeInput {
  achievedDate?: InputMaybe<Scalars["Date"]["input"]>;
  type: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export enum AssistanceReasons {
  Assistance = "ASSISTANCE",
  HelpFindingEvents = "HELP_FINDING_EVENTS",
  HelpFindingPeople = "HELP_FINDING_PEOPLE",
  NeedMoreTime = "NEED_MORE_TIME",
  SomethingElse = "SOMETHING_ELSE",
}

export interface AssistanceReasonsInput {
  customReason?: InputMaybe<Scalars["String"]["input"]>;
  reason: Array<AssistanceReasons>;
}

export interface AttendEventInput {
  eventID: Scalars["String"]["input"];
}

/** Whether the member can attend the event, and if not, what stops her. */
export enum AttendVerdict {
  Blocked = "BLOCKED",
  Locked = "LOCKED",
  Open = "OPEN",
}

export interface AttendanceMetrics {
  attendedDuration?: Maybe<Scalars["Int"]["output"]>;
  attendedEvents?: Maybe<Scalars["Int"]["output"]>;
  attendedGroup?: Maybe<Scalars["Int"]["output"]>;
  attendedInPerson?: Maybe<Scalars["Int"]["output"]>;
  attendedOneToOnes?: Maybe<Scalars["Int"]["output"]>;
  attendedOther?: Maybe<Scalars["Int"]["output"]>;
  attendedWebinars?: Maybe<Scalars["Int"]["output"]>;
  hostedDuration?: Maybe<Scalars["Int"]["output"]>;
  hostedEvents?: Maybe<Scalars["Int"]["output"]>;
  hostedGroup?: Maybe<Scalars["Int"]["output"]>;
  hostedInPerson?: Maybe<Scalars["Int"]["output"]>;
  hostedOneToOnes?: Maybe<Scalars["Int"]["output"]>;
  hostedOther?: Maybe<Scalars["Int"]["output"]>;
  hostedWebinars?: Maybe<Scalars["Int"]["output"]>;
  totalAttendedNonScheduledEvents?: Maybe<Scalars["Int"]["output"]>;
  totalAttendedScheduledEvents?: Maybe<Scalars["Int"]["output"]>;
  totalDuration?: Maybe<Scalars["Int"]["output"]>;
  totalEvents?: Maybe<Scalars["Int"]["output"]>;
  totalGroup?: Maybe<Scalars["Int"]["output"]>;
  totalInPerson?: Maybe<Scalars["Int"]["output"]>;
  totalOneToOnes?: Maybe<Scalars["Int"]["output"]>;
  totalOther?: Maybe<Scalars["Int"]["output"]>;
  totalWebinars?: Maybe<Scalars["Int"]["output"]>;
  videoCalls?: Maybe<Scalars["Int"]["output"]>;
}

export interface AttendanceRecord {
  attendanceRatio?: Maybe<Scalars["Float"]["output"]>;
  attended?: Maybe<Scalars["Int"]["output"]>;
  totalRsvps?: Maybe<Scalars["Int"]["output"]>;
}

export interface AttendedEvents {
  groupEvents?: Maybe<Scalars["Int"]["output"]>;
  inPersonEvents?: Maybe<Scalars["Int"]["output"]>;
  oneToOnes?: Maybe<Scalars["Int"]["output"]>;
  other?: Maybe<Scalars["Int"]["output"]>;
  webinars?: Maybe<Scalars["Int"]["output"]>;
}

export enum Audience {
  NewMembers = "NEW_MEMBERS",
  OneMonthPlus = "ONE_MONTH_PLUS",
  Zero = "ZERO",
}

export interface Availability {
  from: Scalars["String"]["output"];
  until: Scalars["String"]["output"];
}

export interface AvailabilityForUsersInput {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface AvailabilityInput {
  from: Scalars["String"]["input"];
  until: Scalars["String"]["input"];
}

export interface AvailabilityMatchForUsers {
  availabilityMatch?: Maybe<AvailabilityStatus>;
  userId: Scalars["String"]["output"];
}

export enum AvailabilityStatus {
  Different = "Different",
  Shared = "Shared",
}

export interface BadgeNotificationModel {
  badge: UserBadgeModel;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export interface BannerModel {
  audience?: Maybe<Array<EventPermissions>>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  sliders?: Maybe<Array<SliderModel>>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface BulkActionResultType {
  failed: Scalars["Int"]["output"];
  notFound: Array<Scalars["String"]["output"]>;
  sendId?: Maybe<Scalars["String"]["output"]>;
  skipped: Array<Scalars["String"]["output"]>;
  succeeded: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
}

export enum BulkAddAction {
  Add = "add",
  Invite = "invite",
}

export enum BulkChannelType {
  GroupChat = "group_chat",
  PublicChannel = "public_channel",
}

export interface BulkInviteResponse {
  invitedUserIds: Array<Scalars["String"]["output"]>;
  warningMessages: Array<Scalars["String"]["output"]>;
}

export interface BulkInviteWithEmailsInput {
  emails: Array<Scalars["String"]["input"]>;
}

export interface BulkInviteWithUserIdsInput {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface BulkSendProgressType {
  error?: Maybe<Scalars["String"]["output"]>;
  failed: Scalars["Int"]["output"];
  finishedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  pending: Scalars["Int"]["output"];
  sent: Scalars["Int"]["output"];
  status: ChatBulkSendStatus;
  total: Scalars["Int"]["output"];
}

export interface BulkUploadCreatedEvent {
  id: Scalars["String"]["output"];
  row: Scalars["Int"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
}

export interface BulkUploadEventError {
  column: Scalars["String"]["output"];
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  row: Scalars["Int"]["output"];
}

export interface BulkUploadEventsInput {
  file: Scalars["Upload"]["input"];
}

export interface BulkUploadEventsResponse {
  createdCount: Scalars["Int"]["output"];
  createdEvents: Array<BulkUploadCreatedEvent>;
  inviteWarnings: Array<BulkUploadInviteWarning>;
  validationErrors: Array<BulkUploadEventError>;
}

export interface BulkUploadInviteWarning {
  column: Scalars["String"]["output"];
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  row: Scalars["Int"]["output"];
}

export interface BulkUploadValidationResponse {
  inviteWarnings: Array<BulkUploadInviteWarning>;
  totalRows: Scalars["Int"]["output"];
  validationErrors: Array<BulkUploadEventError>;
}

export interface CalendarEventModel {
  /** Event category (featured / new_member …). */
  category?: Maybe<Scalars["String"]["output"]>;
  /** 0 = Monday … 6 = Sunday (UTC). */
  dayOfWeek: Scalars["Int"]["output"];
  hostFirstName?: Maybe<Scalars["String"]["output"]>;
  hostName?: Maybe<Scalars["String"]["output"]>;
  /** Big Sister / Coach / CXT / Member — who's hosting. */
  hostType: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  /** Only members whose plan includes coaching can attend. */
  isCoachEvent: Scalars["Boolean"]["output"];
  /** Sign-ups have reached the cap. */
  isFull: Scalars["Boolean"]["output"];
  /** Event kind, prettified (e.g. 'Conversation'). */
  kind: Scalars["String"]["output"];
  /** Target level: Intermediate / Advanced / All levels. */
  level: Scalars["String"]["output"];
  /** Cap; null/absent when unlimited. */
  maxParticipants?: Maybe<Scalars["Int"]["output"]>;
  /** Shows locked until she has attended three events. */
  needsThreeEvents: Scalars["Boolean"]["output"];
  /** First names of some members signed up (capped). */
  participants: Array<Scalars["String"]["output"]>;
  /** Repeats weekly. */
  recurring: Scalars["Boolean"]["output"];
  /** How many members have signed up (host excluded). */
  registered: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
  /** Start clock in UTC, e.g. '19:00'. */
  timeUtc: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  /** No participant cap. */
  unlimited: Scalars["Boolean"]["output"];
  /** Who can see it: Members / Members + trial / Private. */
  visibility: Scalars["String"]["output"];
  /** The 3-hour UTC zone its start time falls in. */
  zone: ZoneLabel;
}

export interface CalendarModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
  user: UserModel;
}

export interface CalendarResponseType {
  reason?: Maybe<GoogleApiMessage>;
  status: MutationStatus;
  url?: Maybe<Scalars["String"]["output"]>;
}

export enum CalendarType {
  Google = "GOOGLE",
  Outlook = "OUTLOOK",
}

export interface CalendarWeekModel {
  events: Array<CalendarEventModel>;
  total: Scalars["Int"]["output"];
  /** Week start (Monday 00:00 UTC). */
  weekStart: Scalars["Date"]["output"];
}

export interface CampaignEventResultModel {
  came: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  invited: Scalars["Int"]["output"];
  saidYes: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  /** Everyone who attended, however they got there. */
  totalThere: Scalars["Int"]["output"];
}

export interface CampaignResultWeekModel {
  /** Of those invited, how many actually turned up. */
  came: Scalars["Int"]["output"];
  /** Events this campaign covers that were held that week. */
  events: Scalars["Int"]["output"];
  /** Members holding an invitation they did not create by signing up themselves. Counts everyone asked, including those who never replied. */
  invited: Scalars["Int"]["output"];
  /** The current week, still running — read its rate with caution. */
  partial: Scalars["Boolean"]["output"];
  /** Of those invited, how many accepted. */
  saidYes: Scalars["Int"]["output"];
  /** Everyone who attended those events, however they got there. */
  totalThere: Scalars["Int"]["output"];
  /** Monday of the week the events were held. */
  weekStarting: Scalars["Date"]["output"];
}

export interface CancelAttendanceInput {
  eventID?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CancellationGroupModel {
  /** Plan category (scheduled only). */
  category?: Maybe<Scalars["String"]["output"]>;
  count: Scalars["Int"]["output"];
  /** Stable key, e.g. 'efm:very_soon' or 'trial:zero'. */
  key: Scalars["String"]["output"];
  members: Array<CancellationMemberModel>;
  /** Group sub-heading. */
  subtitle?: Maybe<Scalars["String"]["output"]>;
  /** The editable template, with {name}/{end_date}/{link} placeholders. */
  template: Scalars["String"]["output"];
  /** Urgency tier (scheduled) or attendance tier (trial). */
  tier: Scalars["String"]["output"];
  /** Group heading. */
  title: Scalars["String"]["output"];
}

export interface CancellationMemberModel {
  country?: Maybe<Scalars["String"]["output"]>;
  /** Calendar days until her subscription ends. */
  daysLeft?: Maybe<Scalars["Int"]["output"]>;
  email: Scalars["String"]["output"];
  /** Her end date as it appears in the message, e.g. 'August 12'. */
  endDate: Scalars["String"]["output"];
  /** Subscription end, e.g. 2026-08-12. */
  endsAt?: Maybe<Scalars["Date"]["output"]>;
  /** Trial only: how many events she has actually attended. */
  eventsAttended?: Maybe<Scalars["Int"]["output"]>;
  firstName: Scalars["String"]["output"];
  /** Her message with {name}/{end_date}/{link} already filled in. */
  message: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  planId?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
}

export interface CancellationsResultModel {
  /** The look-ahead window used, in days. */
  days: Scalars["Int"]["output"];
  groups: Array<CancellationGroupModel>;
  /** 'scheduled' or 'trial'. */
  kind: Scalars["String"]["output"];
  total: Scalars["Int"]["output"];
}

export interface CapturedCampaignModel {
  campaign: Scalars["String"]["output"];
  messageCount: Scalars["Int"]["output"];
  replyCount: Scalars["Int"]["output"];
}

export interface CapturedConversationModel {
  campaigns: Array<Scalars["String"]["output"]>;
  lastFromOperator: Scalars["Boolean"]["output"];
  lastMessageAt: Scalars["Date"]["output"];
  lastText: Scalars["String"]["output"];
  memberEmail?: Maybe<Scalars["String"]["output"]>;
  memberId: Scalars["String"]["output"];
  memberName?: Maybe<Scalars["String"]["output"]>;
  messageCount: Scalars["Int"]["output"];
  replyCount: Scalars["Int"]["output"];
}

export interface CapturedMessageItemModel {
  campaign?: Maybe<Scalars["String"]["output"]>;
  fromOperator: Scalars["Boolean"]["output"];
  messageId: Scalars["String"]["output"];
  sentAt: Scalars["Date"]["output"];
  text: Scalars["String"]["output"];
}

export interface ChargeBeeAddress {
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  line1?: Maybe<Scalars["String"]["output"]>;
  line2?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  zip?: Maybe<Scalars["String"]["output"]>;
}

export interface ChargeBeeAddressInput {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  line1?: InputMaybe<Scalars["String"]["input"]>;
  line2?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  zip?: InputMaybe<Scalars["String"]["input"]>;
}

export interface ChargebeeCustomerModel {
  cbAddress?: Maybe<ChargeBeeAddress>;
  cbId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  oldId?: Maybe<Scalars["String"]["output"]>;
  paymentMethods: Array<ChargebeePaymentMethodModel>;
  promotionalCredits?: Maybe<Scalars["Int"]["output"]>;
  resourceVersion: Scalars["Date"]["output"];
  subscriptions: Array<ChargebeeSubscriptionModel>;
  user: UserModel;
}

export interface ChargebeePaymentMethodModel {
  card?: Maybe<Scalars["JSON"]["output"]>;
  cbCustomerId?: Maybe<Scalars["String"]["output"]>;
  cbId?: Maybe<Scalars["String"]["output"]>;
  cbObj?: Maybe<Scalars["JSON"]["output"]>;
  customer: ChargebeeCustomerModel;
  id: Scalars["String"]["output"];
  isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
  resourceVersion: Scalars["Date"]["output"];
  type?: Maybe<Scalars["String"]["output"]>;
}

export interface ChargebeeSubscriptionModel {
  billingCycleAnchor?: Maybe<Scalars["Date"]["output"]>;
  cancelReason?: Maybe<Scalars["String"]["output"]>;
  cancelScheduleCreatedAt?: Maybe<Scalars["Date"]["output"]>;
  cancelledAt?: Maybe<Scalars["Date"]["output"]>;
  cbCustomerId?: Maybe<Scalars["String"]["output"]>;
  cbId?: Maybe<Scalars["String"]["output"]>;
  cbPaymentMethodId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  currentPeriodEnd?: Maybe<Scalars["Date"]["output"]>;
  currentPeriodStart?: Maybe<Scalars["Date"]["output"]>;
  customer: ChargebeeCustomerModel;
  dueSince?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  plan?: Maybe<Scalars["JSON"]["output"]>;
  resourceVersion: Scalars["Date"]["output"];
  resumesAt?: Maybe<Scalars["Date"]["output"]>;
  scheduledPlan?: Maybe<Scalars["JSON"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export enum ChatAction {
  Invite = "Invite",
  Mention = "Mention",
  Thread = "Thread",
}

export enum ChatBulkSendStatus {
  Done = "done",
  Failed = "failed",
  Queued = "queued",
  Running = "running",
}

export enum ChatChannelType {
  Messaging = "messaging",
  Public = "public",
  UserPublic = "userPublic",
}

export interface ChatInviteInput {
  channelCid: Scalars["String"]["input"];
  channelName?: InputMaybe<Scalars["String"]["input"]>;
  userIds: Array<Scalars["String"]["input"]>;
}

export interface ChatInviteModel {
  actor?: Maybe<UserModel>;
  actorId?: Maybe<Scalars["String"]["output"]>;
  channelId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  status: ChatInviteStatus;
  updatedAt: Scalars["Date"]["output"];
  user?: Maybe<UserModel>;
  userId?: Maybe<Scalars["String"]["output"]>;
}

export enum ChatInviteStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Pending = "Pending",
}

export interface ChatInvitesForUsersInput {
  channelCid: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface ChatNotificationModel {
  actor?: Maybe<UserModel>;
  channelId?: Maybe<Scalars["String"]["output"]>;
  channelName?: Maybe<Scalars["String"]["output"]>;
  chatAction: ChatAction;
  chatMessage?: Maybe<Scalars["String"]["output"]>;
  chatMessageId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  parentChatMessageId?: Maybe<Scalars["String"]["output"]>;
  user: UserModel;
}

export enum ColourCode {
  Blue = "BLUE",
  Green = "GREEN",
  Orange = "ORANGE",
  Pink = "PINK",
  Red = "RED",
}

export enum CommentAction {
  Comment = "Comment",
  Mention = "Mention",
}

export interface CommentModel {
  author?: Maybe<UserModel>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  parent?: Maybe<CommentModel>;
  parentID?: Maybe<Scalars["String"]["output"]>;
  reactions?: Maybe<Array<CommentReactionsModel>>;
  replies?: Maybe<Array<CommentModel>>;
  targetArticle?: Maybe<ArticleModel>;
  targetEvent?: Maybe<EventModel>;
  targetId: Scalars["String"]["output"];
  targetTopic?: Maybe<TopicModel>;
  targetType: CommentTargetType;
  updatedAt: Scalars["Date"]["output"];
}

export interface CommentNotificationModel {
  actor?: Maybe<UserModel>;
  comment: CommentModel;
  commentAction: CommentAction;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export interface CommentReactionsModel {
  comment: CommentModel;
  commentId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  unifiedId: Scalars["String"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export enum CommentTargetType {
  Article = "Article",
  Event = "Event",
  Topic = "Topic",
}

/** How reliably a member shows up. */
export enum CommitmentLevel {
  BarelyCommitted = "BARELY_COMMITTED",
  ExtremelyCommitted = "EXTREMELY_COMMITTED",
  HighlyCommitted = "HIGHLY_COMMITTED",
  LightlyCommitted = "LIGHTLY_COMMITTED",
  ModeratelyCommitted = "MODERATELY_COMMITTED",
}

export interface CompletedVideoModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  user: UserModel;
  videoId: Scalars["String"]["output"];
}

export interface ConfirmGuestPassSignupInput {
  signUpId: Scalars["String"]["input"];
  termsAccepted: Scalars["Boolean"]["input"];
}

export interface ConfirmInPersonEventInput {
  status: InPersonEventConfirmationStatus;
  userIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface ConfirmTotpInput {
  deviceName: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
}

export enum ContactUsCategories {
  Events = "EVENTS",
  Feedback = "FEEDBACK",
  GeneralQuestion = "GENERAL_QUESTION",
  MyAccount = "MY_ACCOUNT",
  TechnicalSupport = "TECHNICAL_SUPPORT",
  TopicsAndLessons = "TOPICS_AND_LESSONS",
}

export interface ContactUsInput {
  category: ContactUsCategories;
  email: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  wantsNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export enum ConversationKind {
  CasualConversation = "CASUAL_CONVERSATION",
  DeepDive = "DEEP_DIVE",
  None = "NONE",
  StudyGroup = "STUDY_GROUP",
}

export interface Coordinates {
  lat?: Maybe<Scalars["Float"]["output"]>;
  long?: Maybe<Scalars["Float"]["output"]>;
}

export interface CoverModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  primary?: Maybe<ResponsiveType>;
  secondary?: Maybe<ResponsiveType>;
  tertiary?: Maybe<ResponsiveType>;
  theme?: Maybe<Array<ThemeModel>>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface CreateArticlesAttachmentInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<MetaFileInput>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateBannerInput {
  title: Scalars["String"]["input"];
}

export interface CreateChannelInput {
  channelType?: InputMaybe<ChatChannelType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  usersID?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface CreateCommentInput {
  mentions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  message: Scalars["String"]["input"];
  parentID?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateCoverInput {
  primary?: InputMaybe<ResponsiveInput>;
  secondary?: InputMaybe<ResponsiveInput>;
  tertiary?: InputMaybe<ResponsiveInput>;
  title: Scalars["String"]["input"];
}

export interface CreateEventAttachmentInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<MetaFileInput>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateEventInput {
  attachments?: InputMaybe<Array<CreateEventAttachmentInput>>;
  conversationKind?: InputMaybe<ConversationKind>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  createdFromTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  customTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevel>;
  eventCategory?: InputMaybe<EventCategory>;
  format?: InputMaybe<Format>;
  hostId?: InputMaybe<Scalars["String"]["input"]>;
  ideasToDiscuss?: InputMaybe<Array<Scalars["String"]["input"]>>;
  illustrationUrl?: InputMaybe<Scalars["String"]["input"]>;
  invitePeople?: InputMaybe<Scalars["Boolean"]["input"]>;
  isCoachEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isForUnverified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isLargeCall?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventKind>;
  links?: InputMaybe<Array<LinkInput>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  maxParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  peopleIDToInvite?: InputMaybe<Array<Scalars["String"]["input"]>>;
  permissions?: InputMaybe<Array<EventPermissions>>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  savedDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateFeatureFlagInput {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
}

export interface CreateIllustrationInput {
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateInviteInput {
  eventID: Scalars["String"]["input"];
  invitedByHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  isConfirmed?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  userID: Scalars["String"]["input"];
}

export interface CreateLessonInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  kind: LessonKind;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicID: Scalars["String"]["input"];
}

export interface CreateLikeInput {
  genericId: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateLiveTableInput {
  englishLevel?: InputMaybe<EventEnglishLevelNamed>;
  maxParticipants?: Scalars["Int"]["input"];
  questionId?: InputMaybe<Scalars["String"]["input"]>;
  timeLimit: TimeLimit;
  title: Scalars["String"]["input"];
}

export interface CreateMessageInput {
  description: Scalars["String"]["input"];
  receiver_id: Scalars["String"]["input"];
}

export interface CreateQuestionInput {
  question?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  type: QuestionType;
}

export interface CreateReactionInput {
  commentId: Scalars["String"]["input"];
  unifiedId: Scalars["String"]["input"];
}

export interface CreateSectionInput {
  elements?: InputMaybe<Array<ElementInput>>;
  lessonID: Scalars["String"]["input"];
  order: Scalars["Int"]["input"];
}

export interface CreateSparkInput {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  liveTableId?: InputMaybe<Scalars["String"]["input"]>;
  videoCallId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateThemeInput {
  isGrammarLibrary: Scalars["Boolean"]["input"];
  isResource: Scalars["Boolean"]["input"];
  isStandard: Scalars["Boolean"]["input"];
  isTopicLibrary: Scalars["Boolean"]["input"];
  title: Scalars["String"]["input"];
}

export interface CreateTopicInput {
  title: Scalars["String"]["input"];
}

export interface CreateUserFeatureFlagInput {
  featureFlagId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface CreateUserInput {
  charges?: InputMaybe<Array<Scalars["String"]["input"]>>;
  detectedTimezone?: InputMaybe<Scalars["String"]["input"]>;
  eligibilityAgeGender?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  englishLevel: Scalars["Int"]["input"];
  firstEventBookingSkipped?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  guestPassWeeklyPracticeReadiness?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mainSpeakingPracticeChallenge?: InputMaybe<Scalars["String"]["input"]>;
  mainSpokenEnglishPriority?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  planParam: Scalars["String"]["input"];
  referredById?: InputMaybe<Scalars["String"]["input"]>;
  selectedFirstEventId?: InputMaybe<Scalars["String"]["input"]>;
  selectedFirstEventTime?: InputMaybe<Scalars["Date"]["input"]>;
  selectedTimezone?: InputMaybe<Scalars["String"]["input"]>;
  toltReferralId?: InputMaybe<Scalars["String"]["input"]>;
  trial?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface CreateVideoCallInput {
  channelType: ChatChannelType;
  chatRoomId: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
}

export interface CreateVideoInput {
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  videoSetId: Scalars["String"]["input"];
}

export interface CreateVideoSetInput {
  colour: ColourCode;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title: Scalars["String"]["input"];
}

export interface CreateWebpushSubscriptionInput {
  authKey: Scalars["String"]["input"];
  endpoint: Scalars["String"]["input"];
  p256hdKey: Scalars["String"]["input"];
}

export interface CreateZineInput {
  coverUrl: Scalars["String"]["input"];
}

export interface CrispIdentity {
  email: Scalars["String"]["output"];
  signature: Scalars["String"]["output"];
}

export interface CursorPaginatedNotifications {
  items: Array<NotificationBaseModel>;
  nextCursor?: Maybe<Scalars["Date"]["output"]>;
  total: Scalars["Int"]["output"];
}

export interface CustomNotificationDisplayModel {
  buttonText?: Maybe<Scalars["String"]["output"]>;
  buttonUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  illustration?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface CustomNotificationModel {
  customNotificationDisplay: CustomNotificationDisplayModel;
  id: Scalars["String"]["output"];
}

export interface CustomNotificationResponseType {
  sentTo: Scalars["Int"]["output"];
  warningMessages: Array<Scalars["String"]["output"]>;
}

export enum DailyEventTypes {
  BatchProcessorError = "BATCH_PROCESSOR_ERROR",
  BatchProcessorJobFinished = "BATCH_PROCESSOR_JOB_FINISHED",
  DialinConnected = "DIALIN_CONNECTED",
  DialinError = "DIALIN_ERROR",
  DialinStopped = "DIALIN_STOPPED",
  DialinWarning = "DIALIN_WARNING",
  DialoutAnswered = "DIALOUT_ANSWERED",
  DialoutConnected = "DIALOUT_CONNECTED",
  DialoutError = "DIALOUT_ERROR",
  DialoutStopped = "DIALOUT_STOPPED",
  DialoutWarning = "DIALOUT_WARNING",
  MeetingEnded = "MEETING_ENDED",
  MeetingStarted = "MEETING_STARTED",
  ParticipantJoined = "PARTICIPANT_JOINED",
  ParticipantLeft = "PARTICIPANT_LEFT",
  RecordingError = "RECORDING_ERROR",
  RecordingReadyToDownload = "RECORDING_READY_TO_DOWNLOAD",
  RecordingStarted = "RECORDING_STARTED",
  StreamingEnded = "STREAMING_ENDED",
  StreamingError = "STREAMING_ERROR",
  StreamingStarted = "STREAMING_STARTED",
  StreamingUpdated = "STREAMING_UPDATED",
  TranscriptError = "TRANSCRIPT_ERROR",
  TranscriptReadyToDownload = "TRANSCRIPT_READY_TO_DOWNLOAD",
  TranscriptStarted = "TRANSCRIPT_STARTED",
  WaitingParticipantJoined = "WAITING_PARTICIPANT_JOINED",
  WaitingParticipantLeft = "WAITING_PARTICIPANT_LEFT",
}

export interface DailyMeetingInput {
  id: Scalars["String"]["input"];
  userID: Scalars["String"]["input"];
}

export interface DailyWebHookType {
  createdAt: Scalars["String"]["output"];
  eventTypes: Array<Scalars["String"]["output"]>;
  retryType: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
  uuid: Scalars["String"]["output"];
}

export interface DatetimeFilters {
  gt?: InputMaybe<Scalars["Date"]["input"]>;
  lt?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface DeactivateInput {
  otherReason: Scalars["String"]["input"];
  reason: Array<UserDeactivationReason>;
}

export interface DeclineInviteInput {
  inviteID?: InputMaybe<Scalars["String"]["input"]>;
}

export enum DeepDiveKind {
  RolePlay = "ROLE_PLAY",
  Roundtable = "ROUNDTABLE",
  ShareAndCompare = "SHARE_AND_COMPARE",
  SolveAProblem = "SOLVE_A_PROBLEM",
}

export interface DeleteInvitesInput {
  eventId: Scalars["String"]["input"];
  isHost: Scalars["Boolean"]["input"];
}

export interface DeletePhotoInput {
  id: Scalars["String"]["input"];
}

export interface DeleteTopicsInput {
  topicIds: Array<Scalars["String"]["input"]>;
}

export interface DunningStatusUpdatedResponse {
  dunning: Scalars["Boolean"]["output"];
  userId: Scalars["String"]["output"];
}

export interface DuplicateLessonInput {
  lessonId: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
}

export interface EditArticleInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  myEnglishJourney?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledFor?: InputMaybe<Scalars["Date"]["input"]>;
  tags?: InputMaybe<Array<Interest>>;
  theme?: InputMaybe<ArticleThemes>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditArticlesAttachmentInput {
  description: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface EditBannerInput {
  audience?: InputMaybe<Array<EventPermissions>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditCommentInput {
  message: Scalars["String"]["input"];
}

export interface EditCoverInput {
  primary?: InputMaybe<ResponsiveInput>;
  secondary?: InputMaybe<ResponsiveInput>;
  tertiary?: InputMaybe<ResponsiveInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditCustomNotificationDisplayInput {
  buttonText?: InputMaybe<Scalars["String"]["input"]>;
  buttonUrl?: InputMaybe<Scalars["String"]["input"]>;
  illustration?: InputMaybe<Scalars["String"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditEventInput {
  conversationKind?: InputMaybe<ConversationKind>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevel>;
  eventCategory?: InputMaybe<EventCategory>;
  eventLessonKind?: InputMaybe<EventLessonKind>;
  hostId?: InputMaybe<Scalars["String"]["input"]>;
  ideasToDiscuss?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isForUnverified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventKind>;
  links?: InputMaybe<Array<LinkInput>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["Any"]["input"]>;
  noParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  permissions?: InputMaybe<Array<EventPermissions>>;
  recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditFeatureFlagInput {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
}

export interface EditIllustrationInput {
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditLessonInput {
  deepDiveKind?: InputMaybe<DeepDiveKind>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  kind?: InputMaybe<LessonKind>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicID?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditQuestionInput {
  id: Scalars["String"]["input"];
  question?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditSectionInput {
  elements?: InputMaybe<Array<ElementInput>>;
  lessonID?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface EditSliderInput {
  background?: InputMaybe<ResponsiveInput>;
  buttonText?: InputMaybe<Scalars["String"]["input"]>;
  buttonURL?: InputMaybe<Scalars["String"]["input"]>;
  featureImage?: InputMaybe<Scalars["String"]["input"]>;
  imageAlignment?: InputMaybe<Scalars["String"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  textColour?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  titleStyle?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditThemeInput {
  coverId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGrammarLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResource?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStandard?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditTopicInput {
  illustrationId?: InputMaybe<Scalars["String"]["input"]>;
  stars?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<TopicStatus>;
  themeId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditUserFeatureFlagInput {
  featureFlagId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface EditUserInput {
  availability?: InputMaybe<Array<AvailabilityInput>>;
  avatarUrl?: InputMaybe<Scalars["String"]["input"]>;
  badge?: InputMaybe<UserBadge>;
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  createdAt?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  extraConversations?: InputMaybe<Scalars["Int"]["input"]>;
  extraHostedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isAgeVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHeyLady?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventPermissions>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<Scalars["String"]["input"]>;
  needSpeakingPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  occupationId?: InputMaybe<Scalars["String"]["input"]>;
  otherLanguage?: InputMaybe<Scalars["String"]["input"]>;
  pauseCredits?: InputMaybe<Scalars["Int"]["input"]>;
  showBirthday?: InputMaybe<Scalars["Boolean"]["input"]>;
  showBirthdayYear?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  story?: InputMaybe<Scalars["String"]["input"]>;
  wantsNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface EditVideoInput {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  thumbnail?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  videoSetID?: InputMaybe<Scalars["String"]["input"]>;
  videoURL?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditVideoSetInput {
  audience?: InputMaybe<Array<Audience>>;
  colour?: InputMaybe<ColourCode>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditZineInput {
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface Element {
  kind: ElementKind;
  meta: Scalars["JSON"]["output"];
  value?: Maybe<Scalars["Any"]["output"]>;
}

export interface ElementInput {
  kind: ElementKind;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  value?: InputMaybe<Scalars["Any"]["input"]>;
}

export enum ElementKind {
  Attachment = "ATTACHMENT",
  Banner = "BANNER",
  Button = "BUTTON",
  Divider = "DIVIDER",
  Embedded = "EMBEDDED",
  Grid = "GRID",
  Ideas = "IDEAS",
  Image = "IMAGE",
  ImageAndButton = "IMAGE_AND_BUTTON",
  Layout = "LAYOUT",
  Links = "LINKS",
  Paragraph = "PARAGRAPH",
  Questions = "QUESTIONS",
  Spacing = "SPACING",
  Title = "TITLE",
  Video = "VIDEO",
}

export enum EmailNotifications {
  Digest = "DIGEST",
  Inactive = "INACTIVE",
  Spot = "SPOT",
}

/** How much a member uses the platform. */
export enum EngagementLevel {
  E1PowerUser = "E1_POWER_USER",
  E2HighlyEngaged = "E2_HIGHLY_ENGAGED",
  E3ModeratelyEngaged = "E3_MODERATELY_ENGAGED",
  E4LightlyEngaged = "E4_LIGHTLY_ENGAGED",
  E5NeverEngaged = "E5_NEVER_ENGAGED",
  Unknown = "UNKNOWN",
}

export enum EnglishLevel {
  A1 = "A1",
  A2 = "A2",
  B1 = "B1",
  B2 = "B2",
  C1 = "C1",
  C2 = "C2",
}

export enum EnglishLevelMatch {
  Different = "Different",
  Same = "Same",
  Similar = "Similar",
}

export enum EnglishSkill {
  GivingAPresentation = "GIVING_A_PRESENTATION",
  InterviewOrBeInterviewed = "INTERVIEW_OR_BE_INTERVIEWED",
  IntroduceMyself = "INTRODUCE_MYSELF",
  MeetNewPeople = "MEET_NEW_PEOPLE",
  NegotiateAndDebate = "NEGOTIATE_AND_DEBATE",
  PassAnEnglishExam = "PASS_AN_ENGLISH_EXAM",
  PersonalNetworking = "PERSONAL_NETWORKING",
  Pronunciation = "PRONUNCIATION",
  SpeakConfidentlyAtWork = "SPEAK_CONFIDENTLY_AT_WORK",
  ThinkInEnglish = "THINK_IN_ENGLISH",
  UnderstandMoviesAndMusic = "UNDERSTAND_MOVIES_AND_MUSIC",
  UnderstandNativeSpeakers = "UNDERSTAND_NATIVE_SPEAKERS",
  WriteCreatively = "WRITE_CREATIVELY",
  WriteProfessionally = "WRITE_PROFESSIONALLY",
}

export interface EntityIdResponseType {
  id: Scalars["String"]["output"];
}

export interface EventAttachmentModel {
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  event: EventModel;
  id: Scalars["String"]["output"];
  meta?: Maybe<MetaFileType>;
  updatedAt: Scalars["Date"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
}

export enum EventCategory {
  Featured = "FEATURED",
  NewMember = "NEW_MEMBER",
  None = "NONE",
}

export interface EventDoorStatus {
  closedDoorAt?: Maybe<Scalars["Date"]["output"]>;
}

export enum EventEnglishLevel {
  Advanced = "ADVANCED",
  Everyone = "EVERYONE",
  Intermediate = "INTERMEDIATE",
}

export enum EventEnglishLevelFilter {
  Advanced = "ADVANCED",
  All = "ALL",
  AnyLevel = "ANY_LEVEL",
  Intermediate = "INTERMEDIATE",
}

export enum EventEnglishLevelNamed {
  Advanced = "ADVANCED",
  AnyLevel = "ANY_LEVEL",
  Intermediate = "INTERMEDIATE",
}

export interface EventForMemberModel {
  connectionScore: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  hostBadge?: Maybe<Scalars["String"]["output"]>;
  hostName?: Maybe<Scalars["String"]["output"]>;
  inHerZone: Scalars["Boolean"]["output"];
  isFull: Scalars["Boolean"]["output"];
  kind: Scalars["String"]["output"];
  labels: Array<EventLabelModel>;
  /** Her local hour for the event. */
  localHour?: Maybe<Scalars["Int"]["output"]>;
  /** 'label' (topic match) or 'zone' (also-in-zone fill). */
  matchBasis: Scalars["String"]["output"];
  spotsLeft?: Maybe<Scalars["Int"]["output"]>;
  startsAt: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  /** Why she'd enjoy it — specific reasons. */
  why: Array<Scalars["String"]["output"]>;
  zone: ZoneLabel;
}

export enum EventHostedByFilter {
  Anyone = "ANYONE",
  BigSisters = "BIG_SISTERS",
  HlCoach = "HL_COACH",
  HlMembers = "HL_MEMBERS",
  HlTeam = "HL_TEAM",
  PeopleIFollow = "PEOPLE_I_FOLLOW",
}

export interface EventInsightModel {
  /** Big Sister / Coach / CXT / Member. */
  hostType: Scalars["String"]["output"];
  isFull: Scalars["Boolean"]["output"];
  /** How the labels were found (series / keyword / host / none). */
  labelSource: Scalars["String"]["output"];
  /** Topic / skill labels for this event. */
  labels: Array<EventLabelModel>;
  /** Target level: Intermediate / Advanced / All levels. */
  level: Scalars["String"]["output"];
  maxParticipants?: Maybe<Scalars["Int"]["output"]>;
  /** Members signed up (host excluded). */
  registered: Scalars["Int"]["output"];
  unlimited: Scalars["Boolean"]["output"];
  /** Members / Members + trial / Private. */
  visibility: Scalars["String"]["output"];
  /** The zone its start time falls in. */
  zone: ZoneLabel;
}

export enum EventKind {
  CoachConversations = "COACH_CONVERSATIONS",
  CoachWorkshop = "COACH_WORKSHOP",
  ConversationsOverCoffee = "CONVERSATIONS_OVER_COFFEE",
  Custom = "CUSTOM",
  FifteenMinutes = "FIFTEEN_MINUTES",
  GrammarSpot = "GRAMMAR_SPOT",
  Interview = "INTERVIEW",
  InPerson = "IN_PERSON",
  NewMemberWelcome = "NEW_MEMBER_WELCOME",
  OfficeHours = "OFFICE_HOURS",
  OneToOne = "ONE_TO_ONE",
  SpeakingEvent = "SPEAKING_EVENT",
  StudyEvent = "STUDY_EVENT",
}

export interface EventLabelModel {
  family: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
}

export enum EventLessonKind {
  DeepDive = "DEEP_DIVE",
  Overview = "OVERVIEW",
  Vocabulary = "VOCABULARY",
}

export interface EventMatchModel {
  /** How strongly this member connects to the event's topic. */
  connectionScore: Scalars["Int"]["output"];
  country?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  /** Very active / Active / Occasional / Quiet lately. */
  engagement: Scalars["String"]["output"];
  /** Intermediate / Advanced / — (all levels). */
  englishBand: Scalars["String"]["output"];
  eventsAttended: Scalars["Int"]["output"];
  /** Events attended in the last 90 days. */
  eventsRecent: Scalars["Int"]["output"];
  industry?: Maybe<Scalars["String"]["output"]>;
  /** In her first 90 days. */
  isNewcomer: Scalars["Boolean"]["output"];
  /** Her local hour for this event. */
  localHour?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  occupation?: Maybe<Scalars["String"]["output"]>;
  /** 4+ recent invites/shares — unticked by default. */
  overContacted: Scalars["Boolean"]["output"];
  /** Still-upcoming invites/shares to her in the last 14 days. */
  recentNotifs: Scalars["Int"]["output"];
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  /** The word in her profile that matched. */
  storyMatch?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  /** Why she matched — specific reasons. */
  why: Array<Scalars["String"]["output"]>;
  zone?: Maybe<ZoneLabel>;
}

export interface EventMatchResultModel {
  /** Candidates below/above the event's English level. */
  englishFiltered: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  /** The event's level band, or '' for all levels. */
  eventLevel: Scalars["String"]["output"];
  eventZone: ZoneLabel;
  /** Candidates who can't access the event. */
  excludedCantAccess: Scalars["Int"]["output"];
  isFull: Scalars["Boolean"]["output"];
  /** How the labels were found (series / keyword / host / none). */
  labelSource: Scalars["String"]["output"];
  /** What the event is about. */
  labels: Array<EventLabelModel>;
  /** 'label' (matched on topic) or 'zone' (no topic, fell back). */
  matchBasis: Scalars["String"]["output"];
  matches: Array<EventMatchModel>;
  maxParticipants: Scalars["Int"]["output"];
  /** Candidates past their first 3 months — a New Member Welcome isn't for them. */
  newcomerFiltered: Scalars["Int"]["output"];
  /** Candidates whose local time is 11pm–7am. */
  quietFiltered: Scalars["Int"]["output"];
  spotsLeft?: Maybe<Scalars["Int"]["output"]>;
  spotsTaken: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  /** Eligible matches before the display limit. */
  totalMatches: Scalars["Int"]["output"];
}

export interface EventModel {
  attachments?: Maybe<Array<EventAttachmentModel>>;
  closedDoorAt?: Maybe<Scalars["Date"]["output"]>;
  cohosts: Array<UserModel>;
  comments?: Maybe<Array<CommentModel>>;
  confirmationStatus?: Maybe<InPersonEventConfirmationStatus>;
  conversationKind?: Maybe<ConversationKind>;
  coverUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  createdFromTopic?: Maybe<Scalars["Boolean"]["output"]>;
  customTopic?: Maybe<Scalars["Boolean"]["output"]>;
  declined: Array<UserModel>;
  deletedNote?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duplicateOf?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["Date"]["output"]>;
  endedAt?: Maybe<Scalars["Date"]["output"]>;
  englishLevel?: Maybe<EventEnglishLevel>;
  englishSkills?: Maybe<Array<EnglishSkill>>;
  eventCategory?: Maybe<EventCategory>;
  eventLessonKind?: Maybe<EventLessonKind>;
  eventParticipants: Array<EventParticipantModel>;
  format?: Maybe<Format>;
  guestPassAccess?: Maybe<GuestPassEventAccess>;
  hasSharedEventNotification?: Maybe<Scalars["Boolean"]["output"]>;
  host?: Maybe<UserModel>;
  id: Scalars["String"]["output"];
  ideasToDiscuss?: Maybe<Array<Scalars["String"]["output"]>>;
  illustrationUrl?: Maybe<Scalars["String"]["output"]>;
  interests?: Maybe<Array<Interest>>;
  invited: Array<UserModel>;
  invites?: Maybe<Array<InviteModel>>;
  isCoachEvent?: Maybe<Scalars["Boolean"]["output"]>;
  isDeleted?: Maybe<Scalars["Boolean"]["output"]>;
  isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  isForUnverified?: Maybe<Scalars["Boolean"]["output"]>;
  isFull?: Maybe<Scalars["Boolean"]["output"]>;
  isLargeCall?: Maybe<Scalars["Boolean"]["output"]>;
  isProfessional?: Maybe<Scalars["Boolean"]["output"]>;
  isPublic?: Maybe<Scalars["Boolean"]["output"]>;
  kind?: Maybe<EventKind>;
  likes?: Maybe<Array<LikeModel>>;
  links?: Maybe<Array<Link>>;
  location?: Maybe<Scalars["String"]["output"]>;
  locationId?: Maybe<Scalars["String"]["output"]>;
  locationLat?: Maybe<Scalars["Float"]["output"]>;
  locationLong?: Maybe<Scalars["Float"]["output"]>;
  maxParticipants?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  noParticipants?: Maybe<Scalars["Int"]["output"]>;
  occupations?: Maybe<Array<OccupationModel>>;
  organizer?: Maybe<UserModel>;
  participants: Array<UserModel>;
  permissions?: Maybe<Array<EventPermissions>>;
  recurring?: Maybe<Scalars["Boolean"]["output"]>;
  savedDraft?: Maybe<Scalars["Boolean"]["output"]>;
  series?: Maybe<EventSeriesModel>;
  seriesEvents?: Maybe<Array<EventModel>>;
  seriesId?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["Date"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  topic?: Maybe<TopicModel>;
  updatedAt: Scalars["Date"]["output"];
  videoUrl?: Maybe<Scalars["String"]["output"]>;
}

export enum EventNotificationAction {
  Cohosting = "Cohosting",
  ConfirmInPersonEvent = "ConfirmInPersonEvent",
  Delete = "Delete",
  FollowingIsHosting = "FollowingIsHosting",
  HostRemoveCohost = "HostRemoveCohost",
  HostRemoveParticipant = "HostRemoveParticipant",
  InApp1HourBeforeEvent = "InApp1HourBeforeEvent",
  InApp10MinBeforeEvent = "InApp10MinBeforeEvent",
  Invite = "Invite",
  OneToOneNoResponse = "OneToOneNoResponse",
  RecurringResponse = "RecurringResponse",
  SharedEvent = "SharedEvent",
  Update = "Update",
  UserAccept = "UserAccept",
  UserDecline = "UserDecline",
  Web1HourBeforeEvent = "Web1HourBeforeEvent",
  Web10MinBeforeEvent = "Web10MinBeforeEvent",
}

export interface EventNotificationModel {
  action: EventNotificationAction;
  actor?: Maybe<UserModel>;
  event?: Maybe<EventModel>;
  id: Scalars["String"]["output"];
  invite?: Maybe<InviteModel>;
  seriesId?: Maybe<Scalars["String"]["output"]>;
  user: UserModel;
}

export interface EventParticipantModel {
  createdAt: Scalars["Date"]["output"];
  event: EventModel;
  eventId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export enum EventPermissions {
  BigSister = "BIG_SISTER",
  HeyLadyAdmin = "HEY_LADY_ADMIN",
  HeyLadyTeam = "HEY_LADY_TEAM",
  InactiveMember = "INACTIVE_MEMBER",
  MoreThanTwelveMonths = "MORE_THAN_TWELVE_MONTHS",
  OneToThree = "ONE_TO_THREE",
  ThreeToTwelve = "THREE_TO_TWELVE",
  ZeroToOne = "ZERO_TO_ONE",
}

export interface EventSeriesModel {
  createdAt: Scalars["Date"]["output"];
  events?: Maybe<Array<EventModel>>;
  id: Scalars["String"]["output"];
  inviteToAllRecurring: Scalars["Boolean"]["output"];
  parentEventId?: Maybe<Scalars["String"]["output"]>;
  recurrenceCount?: Maybe<Scalars["Int"]["output"]>;
  recurrenceDays?: Maybe<Array<WeekDay>>;
  recurrenceEndDate?: Maybe<Scalars["Date"]["output"]>;
  recurrenceEndType: RecurrenceEndType;
  recurrenceInterval: Scalars["Int"]["output"];
  recurrenceType: RecurrenceType;
  updatedAt: Scalars["Date"]["output"];
}

export enum EventTimeFilter {
  Afternoon = "Afternoon",
  Custom = "Custom",
  Evening = "Evening",
  Morning = "Morning",
  Night = "Night",
}

export interface EventTimezoneSupplyModel {
  /** The look-ahead window, in days. */
  days: Scalars["Int"]["output"];
  /** Every upcoming public event in the window. */
  events: Array<TzEventModel>;
  hostTypes: Array<HostTypeOptionModel>;
  /** Members grouped by UTC offset, biggest region first. */
  regions: Array<TzRegionModel>;
}

export enum EventTopicFilter {
  All = "ALL",
  HlTopics = "HL_TOPICS",
  Other = "OTHER",
}

export enum EventTypeFilter {
  AllEventTypes = "ALL_EVENT_TYPES",
  Conversation = "CONVERSATION",
  DeepDive = "DEEP_DIVE",
  InPerson = "IN_PERSON",
  ListenOnly = "LISTEN_ONLY",
  NewMemberMeetup = "NEW_MEMBER_MEETUP",
  Professional = "PROFESSIONAL",
  StudyAndLearn = "STUDY_AND_LEARN",
}

export interface EventUpdatedResponse {
  eventAndInvites?: Maybe<EventModel>;
  eventDoorStatus?: Maybe<EventDoorStatus>;
}

export interface EventsForMemberResultModel {
  /** Events hidden because she can't join them. */
  hiddenCantJoin: Scalars["Int"]["output"];
  /** New Member Welcomes hidden because she's past her first 3 months. */
  hiddenPastNewcomerWindow: Scalars["Int"]["output"];
  /** Events hidden because they fall in her 11pm–7am. */
  hiddenQuietHours: Scalars["Int"]["output"];
  /** Events hidden as pitched at another English level. */
  hiddenWrongLevel: Scalars["Int"]["output"];
  matches: Array<EventForMemberModel>;
  member: MemberProfileModel;
  /** How many of the matches connect on topic (vs zone only). */
  topicMatchCount: Scalars["Int"]["output"];
}

export enum EventsOrderBy {
  Created = "CREATED",
  EndDate = "END_DATE",
  InvitedFirst = "INVITED_FIRST",
  StartDate = "START_DATE",
  Updated = "UPDATED",
}

export interface EventsPerDay {
  count: Scalars["Int"]["output"];
  day: Scalars["Date"]["output"];
}

/** How close a member is to drifting away. */
export enum FaderLevel {
  Cancelled = "CANCELLED",
  Critical = "CRITICAL",
  Detected = "DETECTED",
  Dormant = "DORMANT",
  New_3PlusEvents = "NEW_3_PLUS_EVENTS",
  NewBelow_3Events = "NEW_BELOW_3_EVENTS",
  NewNeverAttended = "NEW_NEVER_ATTENDED",
  Paused = "PAUSED",
  RecentlyEngaged = "RECENTLY_ENGAGED",
  Trial_3PlusEvents = "TRIAL_3_PLUS_EVENTS",
  TrialBelow_3Events = "TRIAL_BELOW_3_EVENTS",
  TrialNeverAttended = "TRIAL_NEVER_ATTENDED",
}

export interface FeatureFlagModel {
  active?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  users: Array<UserFlagModel>;
}

export interface FilterArticlesInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  byAuthor?: InputMaybe<ArticleByAuthor>;
  category?: InputMaybe<ArticleCategory>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FilterChatInvitesInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FilterCustomNotificationDisplayInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FilterPaginatedEventInput {
  customTimeFrom?: InputMaybe<Scalars["String"]["input"]>;
  customTimeUntil?: InputMaybe<Scalars["String"]["input"]>;
  duration?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  englishLevel?: InputMaybe<EventEnglishLevelFilter>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  eventDate?: InputMaybe<Scalars["Date"]["input"]>;
  eventTime?: InputMaybe<Array<EventTimeFilter>>;
  featured?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupStudy?: InputMaybe<Scalars["Boolean"]["input"]>;
  hostId?: InputMaybe<Scalars["String"]["input"]>;
  hostedBy?: InputMaybe<EventHostedByFilter>;
  interests?: InputMaybe<Array<Interest>>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPast?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  matchEnglishLevel?: InputMaybe<Scalars["Boolean"]["input"]>;
  occupationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizerId?: InputMaybe<Scalars["String"]["input"]>;
  showFullEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicFilter?: InputMaybe<EventTopicFilter>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<EventTypeFilter>;
  userInviteStatus?: InputMaybe<UserInviteStatus>;
  withSharedEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface FilterThemesInput {
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGrammarLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResource?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStandard?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface FilterTopicsInput {
  excludeTheme?: InputMaybe<Scalars["String"]["input"]>;
  includeTheme?: InputMaybe<Scalars["String"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface FilterUsersInput {
  availability?: InputMaybe<Array<AvailabilityStatus>>;
  englishLevels?: InputMaybe<Array<SpeakingLevelCategories>>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  following?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasProfilePicture?: InputMaybe<Scalars["Boolean"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOnline?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<Array<EventPermissions>>;
  lastOnlineAt?: InputMaybe<DatetimeFilters>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location?: InputMaybe<Array<UserLocation>>;
  occupations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FollowInput {
  followingId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface FollowerModel {
  createdAt: Scalars["Date"]["output"];
  follower: UserModel;
  following: UserModel;
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export enum Format {
  InPerson = "IN_PERSON",
  ListenOnly = "LISTEN_ONLY",
  Meeting = "MEETING",
}

export interface FriendInput {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
}

export interface FriendJoinedNotificationModel {
  friend: UserModel;
  id: Scalars["String"]["output"];
  type: FriendJoinedNotificationType;
  user: UserModel;
}

export enum FriendJoinedNotificationType {
  AcceptedInvite = "AcceptedInvite",
  BringAFriendThanks = "BringAFriendThanks",
  FriendDidNotJoin = "FriendDidNotJoin",
  FriendJoined = "FriendJoined",
}

export interface FriendlyFaces {
  attended?: Maybe<Scalars["Int"]["output"]>;
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
}

export interface GenericResponseType {
  reason?: Maybe<Scalars["String"]["output"]>;
  status: MutationStatus;
}

export enum GoogleApiMessage {
  CalendarAlreadyAdded = "CALENDAR_ALREADY_ADDED",
  CalendarNotFound = "CALENDAR_NOT_FOUND",
  EventAlreadyAdded = "EVENT_ALREADY_ADDED",
  EventNotFound = "EVENT_NOT_FOUND",
  InvalidGrant = "INVALID_GRANT",
  InviteNotFound = "INVITE_NOT_FOUND",
  Success = "SUCCESS",
  Unauthorized = "UNAUTHORIZED",
}

export interface GoogleCalendarModel {
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  etag?: Maybe<Scalars["String"]["output"]>;
  googleId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  kind?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface GoogleEventModel {
  createdAt: Scalars["Date"]["output"];
  endDate?: Maybe<Scalars["String"]["output"]>;
  etag?: Maybe<Scalars["String"]["output"]>;
  event?: Maybe<EventModel>;
  googleCalendar?: Maybe<GoogleCalendarModel>;
  googleId?: Maybe<Scalars["String"]["output"]>;
  hostID?: Maybe<Scalars["String"]["output"]>;
  iCalUID?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  invite: InviteModel;
  kind?: Maybe<Scalars["String"]["output"]>;
  link?: Maybe<Scalars["String"]["output"]>;
  organizerID?: Maybe<Scalars["String"]["output"]>;
  reminders?: Maybe<Scalars["JSON"]["output"]>;
  startDate?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface GrantGuestPassTokensInput {
  amount: Scalars["Int"]["input"];
  reason: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface GuestPassBookingEvent {
  durationMinutes: Scalars["Int"]["output"];
  endDate: Scalars["Date"]["output"];
  format: Format;
  id: Scalars["String"]["output"];
  kind: EventKind;
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
}

export interface GuestPassEventAccess {
  consumesToken: Scalars["Boolean"]["output"];
  status: GuestPassEventAccessStatus;
}

export enum GuestPassEventAccessStatus {
  AfterGuestPass = "AFTER_GUEST_PASS",
  Available = "AVAILABLE",
  MembersOnly = "MEMBERS_ONLY",
  TokensExhausted = "TOKENS_EXHAUSTED",
}

export interface GuestPassSignupResult {
  email: Scalars["String"]["output"];
  guestPass: GuestPassSummary;
  hasVerifiedEmail: Scalars["Boolean"]["output"];
}

export interface GuestPassSummary {
  canActivateMembership: Scalars["Boolean"]["output"];
  daysRemaining: Scalars["Int"]["output"];
  endsAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  shouldShowCompletionModal: Scalars["Boolean"]["output"];
  startsAt: Scalars["Date"]["output"];
  tokenAllowance: Scalars["Int"]["output"];
  tokensRemaining: Scalars["Int"]["output"];
  tokensUsed: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
}

export interface GuestPassTokenAdjustment {
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  grantedByEmail?: Maybe<Scalars["String"]["output"]>;
  grantedById: Scalars["String"]["output"];
  grantedByName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  reason: Scalars["String"]["output"];
}

export interface HostTypeOptionModel {
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
}

export interface IllustrationModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  topics?: Maybe<Array<TopicModel>>;
  updatedAt: Scalars["Date"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
}

export enum ImageAlignment {
  Left = "Left",
  Right = "Right",
}

export interface ImportUserInput {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  extraConversations?: InputMaybe<Scalars["Int"]["input"]>;
  extraHostedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventPermissions>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  priceId?: InputMaybe<Scalars["String"]["input"]>;
  trialDays?: InputMaybe<Scalars["Int"]["input"]>;
}

export enum InPersonEventConfirmationStatus {
  Hosted = "Hosted",
  Initial = "Initial",
  NotHosted = "NotHosted",
}

export interface Industry {
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  occupations: Array<OccupationModel>;
}

export interface IndustryInput {
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  occupations: Array<OccupationInput>;
}

export interface InitiateAssessmentResponse {
  assessmentId: Scalars["String"]["output"];
  assessmentUrl: Scalars["String"]["output"];
}

export enum Interest {
  AnimalsAndWildlife = "ANIMALS_AND_WILDLIFE",
  ArtsAndCrafts = "ARTS_AND_CRAFTS",
  BeautyAndFashion = "BEAUTY_AND_FASHION",
  BusinessAndEntrepreneurship = "BUSINESS_AND_ENTREPRENEURSHIP",
  CareersAndProfessionalDevelopment = "CAREERS_AND_PROFESSIONAL_DEVELOPMENT",
  Design = "DESIGN",
  DifferentCultures = "DIFFERENT_CULTURES",
  Economics = "ECONOMICS",
  EnvironmentalIssues = "ENVIRONMENTAL_ISSUES",
  Equality = "EQUALITY",
  FamilyAndMotherhood = "FAMILY_AND_MOTHERHOOD",
  FeminismAndEmpowerment = "FEMINISM_AND_EMPOWERMENT",
  FoodAndCooking = "FOOD_AND_COOKING",
  Games = "GAMES",
  GoalsSettingAndSuccess = "GOALS_SETTING_AND_SUCCESS",
  HealthAndWellness = "HEALTH_AND_WELLNESS",
  Hiking = "HIKING",
  History = "HISTORY",
  HomeAndGardening = "HOME_AND_GARDENING",
  Ielts = "IELTS",
  Languages = "LANGUAGES",
  Leadership = "LEADERSHIP",
  LivingAbroad = "LIVING_ABROAD",
  LoveAndRelationships = "LOVE_AND_RELATIONSHIPS",
  MoviesAndTvShows = "MOVIES_AND_TV_SHOWS",
  MusicAndDance = "MUSIC_AND_DANCE",
  NatureAndTheEnvironment = "NATURE_AND_THE_ENVIRONMENT",
  PersonalDevelopment = "PERSONAL_DEVELOPMENT",
  Photography = "PHOTOGRAPHY",
  Politics = "POLITICS",
  Psychology = "PSYCHOLOGY",
  Reading = "READING",
  ScienceAndTechnology = "SCIENCE_AND_TECHNOLOGY",
  Spirituality = "SPIRITUALITY",
  Sports = "SPORTS",
  SustainableLiving = "SUSTAINABLE_LIVING",
  TheatreAndPerformance = "THEATRE_AND_PERFORMANCE",
  Travel = "TRAVEL",
  VideoGames = "VIDEO_GAMES",
  VolunteeringAndCharity = "VOLUNTEERING_AND_CHARITY",
  Writing = "WRITING",
}

/** Which invitation list to build. */
export enum InviteCampaignKey {
  Coach = "COACH",
  CxtBigSister = "CXT_BIG_SISTER",
  HowToStudy = "HOW_TO_STUDY",
  Nmw = "NMW",
}

export interface InviteCampaignMemberModel {
  /** The event starts after her Guest Pass ends. */
  afterPass: Scalars["Boolean"]["output"];
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** She's on a Guest Pass. */
  isGuest: Scalars["Boolean"]["output"];
  /** Why she's on the list at all, when the list's own rule wouldn't have her — a Guest it had gone quiet on. */
  note?: Maybe<Scalars["String"]["output"]>;
  /** For an extra invitation: 'second' (nearer than her best one) or 'weekend'. */
  option?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  /** Why the invitation rules picked this event for her. */
  why?: Maybe<Scalars["String"]["output"]>;
}

export interface InviteCampaignZoneModel {
  /** Null when nothing is scheduled yet. */
  eventId?: Maybe<Scalars["String"]["output"]>;
  eventStartDate?: Maybe<Scalars["Date"]["output"]>;
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  /** Members this event is an EXTRA invitation for — nearer than their best one, or a weekend one for a Guest. Not included in 'Invite all'. */
  extraMembers: Array<InviteCampaignMemberModel>;
  /** How many members are waiting to be invited in this zone. */
  memberCount: Scalars["Int"]["output"];
  members: Array<InviteCampaignMemberModel>;
  /** nmw / cxt / bs, for the planned campaigns. */
  programme?: Maybe<Scalars["String"]["output"]>;
  /** Null on the row of members with no event. */
  zone?: Maybe<ZoneLabel>;
}

export interface InviteModel {
  acceptedAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  declinedAt?: Maybe<Scalars["Date"]["output"]>;
  event: EventModel;
  googleEvent: GoogleEventModel;
  id: Scalars["String"]["output"];
  invitedByHost?: Maybe<Scalars["Boolean"]["output"]>;
  isConfirmed?: Maybe<Scalars["Boolean"]["output"]>;
  isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  isHost?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<InviteStatus>;
  updatedAt: Scalars["Date"]["output"];
  user?: Maybe<UserModel>;
}

export enum InviteStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Initial = "Initial",
}

export interface InvitedFriendsStats {
  invitedFriendsTotal?: Maybe<Scalars["Int"]["output"]>;
  invitedPaidFriends?: Maybe<Scalars["Int"]["output"]>;
}

export interface Invoice {
  amount?: Maybe<Scalars["Int"]["output"]>;
  created?: Maybe<Scalars["Date"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  last4Digits?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
}

/** The rule that decided whether she may attend. */
export enum JoinReason {
  CoachTierBlocked = "COACH_TIER_BLOCKED",
  HostOrCohost = "HOST_OR_COHOST",
  Invited = "INVITED",
  KindAllowed = "KIND_ALLOWED",
  KindBlocked = "KIND_BLOCKED",
  Staff = "STAFF",
  UnverifiedAllowed = "UNVERIFIED_ALLOWED",
  UnverifiedBlocked = "UNVERIFIED_BLOCKED",
}

export enum LessonKind {
  Custom = "CUSTOM",
  DeepDive = "DEEP_DIVE",
  Overview = "OVERVIEW",
  Vocabulary = "VOCABULARY",
}

export interface LessonModel {
  createdAt: Scalars["Date"]["output"];
  deepDiveKind?: Maybe<DeepDiveKind>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  kind: LessonKind;
  sections?: Maybe<Array<SectionModel>>;
  title?: Maybe<Scalars["String"]["output"]>;
  topic: TopicModel;
  updatedAt: Scalars["Date"]["output"];
}

export interface LikeModel {
  article: ArticleModel;
  event: EventModel;
  genericId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  topic: TopicModel;
  user: UserModel;
}

export interface Link {
  description: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
}

export interface LinkInput {
  description: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface LiveTableModel {
  createdAt: Scalars["Date"]["output"];
  creatorId?: Maybe<Scalars["String"]["output"]>;
  dailyRoomId: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Date"]["output"]>;
  endedAt?: Maybe<Scalars["Date"]["output"]>;
  englishLevel?: Maybe<EventEnglishLevelNamed>;
  id: Scalars["String"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  maxParticipants: Scalars["Int"]["output"];
  participants: Array<LiveTableParticipantModel>;
  question?: Maybe<QuestionModel>;
  questionId?: Maybe<Scalars["String"]["output"]>;
  timeLimit?: Maybe<TimeLimit>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface LiveTableParticipantModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  liveTable: LiveTableModel;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export interface LiveTableStartedMessage {
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  tableCreatorId: Scalars["String"]["output"];
  tableEnglishLevel?: Maybe<EventEnglishLevelNamed>;
  tableId: Scalars["String"]["output"];
  tableTitle: Scalars["String"]["output"];
}

export interface LiveTableStartedMessageInput {
  tableEnglishLevel?: InputMaybe<EventEnglishLevelNamed>;
  tableId: Scalars["String"]["input"];
  tableTitle: Scalars["String"]["input"];
}

export interface LiveTablesFeedbackInput {
  comment: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
  willUseAgain: Scalars["Int"]["input"];
}

/** Why the member app would show this event's card locked. */
export enum LockReason {
  CoachTierLocked = "COACH_TIER_LOCKED",
  NeedsThreeEvents = "NEEDS_THREE_EVENTS",
  NotLocked = "NOT_LOCKED",
  TierLocked = "TIER_LOCKED",
}

export interface MatchDetails {
  availabilityMatch?: Maybe<AvailabilityStatus>;
  commonEnglishSkills?: Maybe<Array<EnglishSkill>>;
  commonInterests?: Maybe<Array<Interest>>;
  englishLevelMatch?: Maybe<EnglishLevelMatch>;
  occupationMatch?: Maybe<OccupationMatch>;
  sameCity?: Maybe<Scalars["Boolean"]["output"]>;
}

export interface MatchMembersInput {
  emails: Array<Scalars["String"]["input"]>;
}

export interface MatchMembersResultType {
  matched: Array<MatchedMemberType>;
  notFound: Array<Scalars["String"]["output"]>;
}

export interface MatchScores {
  availabilityScore: Scalars["Float"]["output"];
  englishInterestScore: Scalars["Float"]["output"];
  englishLevelScore: Scalars["Float"]["output"];
  eventParticipationScore: Scalars["Float"]["output"];
  interestScore: Scalars["Float"]["output"];
  locationScore: Scalars["Float"]["output"];
  occupationScore: Scalars["Float"]["output"];
}

export interface MatchedMemberType {
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
}

export interface MeetingTokenResponse {
  exp?: Maybe<Scalars["Int"]["output"]>;
  roomName: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
}

export interface MemberEventAccessModel {
  /** Whether she can attend — the headline answer. */
  canAttend: Scalars["Boolean"]["output"];
  englishLevel?: Maybe<Scalars["String"]["output"]>;
  eventId: Scalars["String"]["output"];
  hostName?: Maybe<Scalars["String"]["output"]>;
  /** Whether the event is a coach event. */
  isCoachEvent: Scalars["Boolean"]["output"];
  /** Whether the event is public. Private ones are hidden by default. */
  isPublic: Scalars["Boolean"]["output"];
  /** The permission rule that applied. */
  joinReason: JoinReason;
  kind?: Maybe<Scalars["String"]["output"]>;
  /** The lock rule that applied, if any. */
  lockReason: LockReason;
  /** Member kinds the event is restricted to, if any. */
  permissions: Array<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["Date"]["output"]>;
  title: Scalars["String"]["output"];
  verdict: AttendVerdict;
}

export interface MemberEventReviewModel {
  acceptedInvites: Scalars["Int"]["output"];
  englishLevel: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  hostBadge: Scalars["String"]["output"];
  hostName: Scalars["String"]["output"];
  /** This is the host's first public event. */
  isFirstPublic: Scalars["Boolean"]["output"];
  isPublic: Scalars["Boolean"]["output"];
  kind: Scalars["String"]["output"];
  labels: Array<EventLabelModel>;
  /** An admin pinned these labels by hand. */
  labelsEdited: Scalars["Boolean"]["output"];
  maxParticipants: Scalars["Int"]["output"];
  /** RSVP-health priority tier (🔴/🟡/🟢/⚪ with reason). */
  priority: Scalars["String"]["output"];
  spotsLeft?: Maybe<Scalars["Int"]["output"]>;
  /** Invites not declined — the seats the platform holds. */
  spotsTaken: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  zone: ZoneLabel;
}

export interface MemberExperienceModel {
  /** How many the permission gate refuses outright. */
  blocked: Scalars["Int"]["output"];
  /** Of those, how many she can attend. */
  canAttend: Scalars["Int"]["output"];
  events: Array<MemberEventAccessModel>;
  /** How many would appear locked. */
  locked: Scalars["Int"]["output"];
  member: SimulatedMemberModel;
  /** Events considered in the window. */
  total: Scalars["Int"]["output"];
}

export interface MemberProfileModel {
  country?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  /** Very active / Active / Occasional / Quiet lately. */
  engagement: Scalars["String"]["output"];
  /** Intermediate / Advanced / — (all levels). */
  englishBand: Scalars["String"]["output"];
  englishSkills: Array<Scalars["String"]["output"]>;
  eventsAttended: Scalars["Int"]["output"];
  /** Events attended in the last 90 days. */
  eventsRecent: Scalars["Int"]["output"];
  hasBio: Scalars["Boolean"]["output"];
  industry?: Maybe<Scalars["String"]["output"]>;
  interests: Array<Scalars["String"]["output"]>;
  /** In her first 90 days. */
  isNewcomer: Scalars["Boolean"]["output"];
  lastOnlineAt?: Maybe<Scalars["Date"]["output"]>;
  name: Scalars["String"]["output"];
  occupation?: Maybe<Scalars["String"]["output"]>;
  /** 4+ recent invites/shares — untick her by default. */
  overContacted: Scalars["Boolean"]["output"];
  /** Still-upcoming invites/shares to her in the last 14 days. */
  recentNotifs: Scalars["Int"]["output"];
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  /** Tenure bucket text, e.g. '1 to 3 months'. */
  tenureBucket: Scalars["String"]["output"];
  tenureDays: Scalars["Int"]["output"];
  timezone?: Maybe<Scalars["String"]["output"]>;
  /** Upcoming events she's already invited to / booked. */
  upcomingBooked: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface MemberStatsModel {
  /** How committed she's been over time. */
  commitmentLevel?: Maybe<Scalars["String"]["output"]>;
  /** How engaged she is right now. */
  engagementLevel?: Maybe<Scalars["String"]["output"]>;
  /** Scheduled events this member has attended. */
  eventsAttended: Scalars["Int"]["output"];
  /** How far she's drifted — Detected, Dormant, Critical and the rest. */
  faderLevel?: Maybe<Scalars["String"]["output"]>;
  /** When the team last sent her a chat message, by any tool. Null if she's never been messaged. */
  lastMessagedAt?: Maybe<Scalars["Date"]["output"]>;
  /** When she was last on the platform. */
  lastOnlineAt?: Maybe<Scalars["Date"]["output"]>;
  /** Logins in the last 14 days. */
  loginsRecent: Scalars["Int"]["output"];
  /** Her Chargebee plan. Null when she has no subscription. */
  plan?: Maybe<Scalars["String"]["output"]>;
  /** Where she stands with us — Member, Cancelling, Paused, Cancelled, Trial. Null when she has no subscription at all. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** How long she's been a member, measured in paid active days. */
  tenure?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  /** The three-hour UTC band this member is usually around in. */
  zone: ZoneLabel;
}

export interface MemberZoneMatrixModel {
  grandTotal: Scalars["Int"]["output"];
  /** One row per tenure bucket, in order. */
  rows: Array<MemberZoneRowModel>;
  /** Column totals — members per zone. */
  zoneTotals: Array<ZoneCountModel>;
  zones: Array<ZoneLabel>;
}

export interface MemberZoneRowModel {
  counts: Array<ZoneCountModel>;
  /** TenureBucket key. */
  tenure: Scalars["String"]["output"];
  /** Display label, e.g. '1 to 3 months'. */
  tenureLabel: Scalars["String"]["output"];
  total: Scalars["Int"]["output"];
}

export interface MemberZonesModel {
  /** Fair: each member's zone by attendance rate (÷ how often each zone is offered). */
  adjusted: MemberZoneMatrixModel;
  /** Biased: each member's zone by raw attendance count. */
  raw: MemberZoneMatrixModel;
}

/** Where a member stands with her membership now, read live. */
export enum MembershipNow {
  Cancelled = "CANCELLED",
  Leaving = "LEAVING",
  Paused = "PAUSED",
  Stayed = "STAYED",
  Unknown = "UNKNOWN",
}

export enum MembershipPlans {
  Annual = "Annual",
  FreeOneMonth = "FreeOneMonth",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Social = "Social",
  SocialAnnual = "SocialAnnual",
  SocialQuarterly = "SocialQuarterly",
  SupporterOneMonth = "SupporterOneMonth",
  ThreeMonthsOnly = "ThreeMonthsOnly",
}

export interface MessageCaptureStatusModel {
  /** When the last scan finished. */
  lastScanAt?: Maybe<Scalars["Date"]["output"]>;
  /** Messages stored, both directions. */
  messages: Scalars["Int"]["output"];
  /** The newest message captured. */
  newestMessageAt?: Maybe<Scalars["Date"]["output"]>;
  /** Messages a member sent us (replies). */
  replies: Scalars["Int"]["output"];
  /** A scan is in progress right now. */
  running: Scalars["Boolean"]["output"];
  /** Distinct DM threads captured. */
  threads: Scalars["Int"]["output"];
}

export interface MessageModel {
  bodyText: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  receiver: UserModel;
  sender: UserModel;
  updatedAt: Scalars["Date"]["output"];
}

export interface MetaFileInput {
  extension?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface MetaFileType {
  extension?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<Scalars["Int"]["output"]>;
}

export enum MonthlyRecapSteps {
  ArticlesWritten = "ArticlesWritten",
  AttendanceRatio = "AttendanceRatio",
  EventsAttended = "EventsAttended",
  EventsHosted = "EventsHosted",
  EventsStreak = "EventsStreak",
  FriendlyFaces = "FriendlyFaces",
  GlobalNetwork = "GlobalNetwork",
  ParticipationTime = "ParticipationTime",
  Sparks = "Sparks",
  SpontaneousConversations = "SpontaneousConversations",
  ThankYou = "ThankYou",
}

export interface MonthlyReportNotificationModel {
  id: Scalars["String"]["output"];
  type: MonthlyReportNotificationType;
}

export enum MonthlyReportNotificationType {
  MonthlyReport = "MonthlyReport",
}

export interface Mutation {
  acceptChannelInvite?: Maybe<GenericResponseType>;
  activateGuestPass?: Maybe<Scalars["JSON"]["output"]>;
  activateTrialSubscription: GenericResponseType;
  activateUser?: Maybe<GenericResponseType>;
  addEventToGoogleCalendar: CalendarResponseType;
  addMultipleEventsToGoogleCalendar: CalendarResponseType;
  addZoomLicenseToUser?: Maybe<GenericResponseType>;
  adminBanUser?: Maybe<GenericResponseType>;
  adminBulkUploadEvents: BulkUploadEventsResponse;
  adminCreateBanner?: Maybe<BannerModel>;
  adminCreateCover?: Maybe<CoverModel>;
  adminCreateCustomNotificationDisplay?: Maybe<CustomNotificationDisplayModel>;
  adminCreateFeatureFlag?: Maybe<FeatureFlagModel>;
  adminCreateIllustration?: Maybe<IllustrationModel>;
  adminCreateLesson?: Maybe<LessonModel>;
  adminCreateNote?: Maybe<NoteModel>;
  adminCreateQuestion?: Maybe<GenericResponseType>;
  adminCreateSection?: Maybe<SectionModel>;
  adminCreateSlider?: Maybe<GenericResponseType>;
  adminCreateTheme?: Maybe<ThemeModel>;
  adminCreateTopic?: Maybe<TopicModel>;
  adminCreateUserFeatureFlag?: Maybe<UserFlagModel>;
  adminCreateVideo?: Maybe<GenericResponseType>;
  adminCreateVideoSet?: Maybe<VideoSetModel>;
  adminCreateZineCover?: Maybe<ZineModel>;
  adminDeleteArticle?: Maybe<GenericResponseType>;
  adminDeleteBanner?: Maybe<GenericResponseType>;
  adminDeleteCover?: Maybe<GenericResponseType>;
  adminDeleteEvent?: Maybe<GenericResponseType>;
  adminDeleteFeatureFlag?: Maybe<GenericResponseType>;
  adminDeleteIllustration?: Maybe<GenericResponseType>;
  adminDeleteLesson?: Maybe<GenericResponseType>;
  adminDeleteQuestion?: Maybe<GenericResponseType>;
  adminDeleteSection?: Maybe<GenericResponseType>;
  adminDeleteSlider?: Maybe<GenericResponseType>;
  adminDeleteTheme?: Maybe<GenericResponseType>;
  adminDeleteTopic?: Maybe<GenericResponseType>;
  adminDeleteTopics?: Maybe<GenericResponseType>;
  adminDeleteUserFeatureFlag?: Maybe<GenericResponseType>;
  adminDeleteUserReport?: Maybe<GenericResponseType>;
  adminDeleteVideo?: Maybe<GenericResponseType>;
  adminDeleteVideoSet?: Maybe<GenericResponseType>;
  adminDeleteZineCover?: Maybe<GenericResponseType>;
  adminEditArticle?: Maybe<ArticleModel>;
  adminEditBanner?: Maybe<BannerModel>;
  adminEditCover?: Maybe<CoverModel>;
  adminEditCustomNotificationDisplay?: Maybe<GenericResponseType>;
  adminEditEvent?: Maybe<GenericResponseType>;
  adminEditFeatureFlag?: Maybe<FeatureFlagModel>;
  adminEditIllustration?: Maybe<IllustrationModel>;
  adminEditLesson?: Maybe<LessonModel>;
  adminEditQuestion?: Maybe<QuestionModel>;
  adminEditSection?: Maybe<SectionModel>;
  adminEditSlide?: Maybe<SliderModel>;
  adminEditTheme?: Maybe<ThemeModel>;
  adminEditTopic?: Maybe<TopicModel>;
  adminEditUser?: Maybe<GenericResponseType>;
  adminEditUserFeatureFlag?: Maybe<UserFlagModel>;
  adminEditVideo?: Maybe<VideoModel>;
  adminEditVideoSet?: Maybe<VideoSetModel>;
  adminEditZineCover?: Maybe<ZineModel>;
  adminForceSignOut?: Maybe<GenericResponseType>;
  adminFulfillReferral: ReferralRewardModel;
  adminGenerateAttachmentUploadUrl?: Maybe<UploadUrlsType>;
  adminGrantGuestPassTokens: GuestPassSummary;
  adminImportUser?: Maybe<GenericResponseType>;
  adminOrderSlider?: Maybe<GenericResponseType>;
  adminOrderVideo?: Maybe<GenericResponseType>;
  adminOrderVideoSet?: Maybe<GenericResponseType>;
  adminRecordCampaignInvites: Scalars["Int"]["output"];
  adminRecordInvites: Scalars["Int"]["output"];
  adminRecordRetentionOutreach: Scalars["Int"]["output"];
  adminRepublishEvent: GenericResponseType;
  adminReviewReferral: ReferralRewardModel;
  adminRunMessageCapture: MessageCaptureStatusModel;
  adminSelectionUserIds: AdminShareSelectionResponse;
  adminSetEventLabels: Scalars["Boolean"]["output"];
  adminShareEventToEmails: ShareEventResultModel;
  adminShareEventToUserIds: ShareEventResultModel;
  adminUnbanUser?: Maybe<GenericResponseType>;
  adminValidateBulkUploadEvents: BulkUploadValidationResponse;
  adminWelcomeUser?: Maybe<GenericResponseType>;
  applyPowerUp: GenericResponseType;
  assignAllExtraReferralBadges: GenericResponseType;
  assignAllFirstConversationBadges: GenericResponseType;
  assignAllLocalHostsBadges: GenericResponseType;
  assignAllNMMEventAttendedBadges: GenericResponseType;
  assignAllNewEventsAttendedBadges: GenericResponseType;
  assignCompleteOnboardingQuizBadge: GenericResponseType;
  assignUserBadge?: Maybe<GenericResponseType>;
  attendEvent?: Maybe<InviteModel>;
  attendMultipleEvents?: Maybe<GenericResponseType>;
  bulkInviteWithUserIds?: Maybe<BulkInviteResponse>;
  cancelAttendance: InviteModel;
  cancelScheduleCancelSubscription?: Maybe<GenericResponseType>;
  chatAddMembersToChannel?: Maybe<GenericResponseType>;
  chatAutomationsAddMembers: BulkActionResultType;
  chatAutomationsRecallSend: RecallResultType;
  chatAutomationsSendMessages: BulkActionResultType;
  chatAutomationsSendPersonalMessages: BulkActionResultType;
  chatCreateChannel?: Maybe<Scalars["String"]["output"]>;
  chatGiveAdminRole?: Maybe<Scalars["Any"]["output"]>;
  chatRemoveMembersFromChannel?: Maybe<GenericResponseType>;
  chatRenameChannel?: Maybe<GenericResponseType>;
  chatSendDirectMessage?: Maybe<GenericResponseType>;
  chatUpdatePublicChannelInfo?: Maybe<GenericResponseType>;
  chatUpdateUserChannelPermission: GenericResponseType;
  chooseSubscription?: Maybe<Scalars["JSON"]["output"]>;
  closeDoor?: Maybe<EventModel>;
  closeVideoCallDoor: VideoCallModel;
  completeVideo?: Maybe<CompletedVideoModel>;
  confirmGuestPassSignup: GuestPassSignupResult;
  confirmInPersonEvent: GenericResponseType;
  confirmStreakCelebration: GenericResponseType;
  confirmTotp: GenericResponseType;
  contactUs?: Maybe<GenericResponseType>;
  createAbuse?: Maybe<AbuseModel>;
  createArticle?: Maybe<ArticleModel>;
  createArticleAttachment?: Maybe<ArticlesAttachmentModel>;
  createAttachment?: Maybe<EventAttachmentModel>;
  createComment?: Maybe<CommentModel>;
  createEvent?: Maybe<EventModel>;
  createInvite: InviteModel;
  createLike?: Maybe<LikeModel>;
  createLiveTable: LiveTableModel;
  createMessage?: Maybe<MessageModel>;
  createNewWebhook: GenericResponseType;
  createReaction: CommentReactionsModel;
  createSpark: GenericResponseType;
  createTopicForPreviewMode?: Maybe<EntityIdResponseType>;
  createTotp: UserTotpModel;
  createUser: UserSignUpModel;
  createUserPhoto?: Maybe<UserPhotoModel>;
  createVideoCall: VideoCallModel;
  createWebpushSubscription: GenericResponseType;
  deactivate?: Maybe<GenericResponseType>;
  declineChannelInvite?: Maybe<GenericResponseType>;
  declineInvite: InviteModel;
  declineSharedEvent: GenericResponseType;
  deleteAccount?: Maybe<GenericResponseType>;
  deleteArticle?: Maybe<EntityIdResponseType>;
  deleteArticleAttachment?: Maybe<EntityIdResponseType>;
  deleteAttachment?: Maybe<EntityIdResponseType>;
  deleteChannelInvite?: Maybe<GenericResponseType>;
  deleteComment?: Maybe<GenericResponseType>;
  deleteDailyWebhook: GenericResponseType;
  deleteEvent?: Maybe<GenericResponseType>;
  deleteInvite?: Maybe<GenericResponseType>;
  deleteInvites?: Maybe<GenericResponseType>;
  deleteLike?: Maybe<GenericResponseType>;
  deleteReaction: GenericResponseType;
  deleteUserBadge?: Maybe<GenericResponseType>;
  deleteUserPhoto?: Maybe<EntityIdResponseType>;
  dismissGuestPassCompletionModal: GuestPassSummary;
  duplicateEvent?: Maybe<EventModel>;
  duplicateLesson?: Maybe<GenericResponseType>;
  duplicateTopic?: Maybe<GenericResponseType>;
  editArticle?: Maybe<ArticleModel>;
  editComment?: Maybe<CommentModel>;
  eventMeetingToken?: Maybe<MeetingTokenResponse>;
  follow?: Maybe<GenericResponseType>;
  generateArticlesAttachmentUploadUrl?: Maybe<UploadUrlsType>;
  generateAttachmentUploadUrl?: Maybe<UploadUrlsType>;
  generateChannelPictureUploadUrl?: Maybe<UploadUrlsType>;
  generateUserUploadUrl?: Maybe<UploadUrlsType>;
  getHostedPage?: Maybe<Scalars["JSON"]["output"]>;
  getOrCreateCalendar: CalendarModel;
  getPrecancelPage?: Maybe<Scalars["String"]["output"]>;
  heartbeat?: Maybe<GenericResponseType>;
  initiateAssessment: InitiateAssessmentResponse;
  issueCompleteProfileNotification: GenericResponseType;
  liveTableMeetingToken: MeetingTokenResponse;
  markAllAsSeen?: Maybe<GenericResponseType>;
  markEventsTabAsSeen?: Maybe<GenericResponseType>;
  markEventsTabAsSeenAfterAttendedThreeEvents?: Maybe<GenericResponseType>;
  markJoinEvent: GenericResponseType;
  markPowerUpRevealed: GenericResponseType;
  markRechargeExplainerSeen: GenericResponseType;
  markReportAsSeen?: Maybe<GenericResponseType>;
  markStreakResetSeen: GenericResponseType;
  markStreaksExplainerSeen: GenericResponseType;
  notificationSeen?: Maybe<NotificationBaseModel>;
  notifyAboutStartedLiveTable: GenericResponseType;
  openDoor?: Maybe<EventModel>;
  openVideoCallDoor: VideoCallModel;
  pause: GenericResponseType;
  populateUserEventStatistics?: Maybe<GenericResponseType>;
  publishEvent?: Maybe<EventModel>;
  publishOrScheduleArticle?: Maybe<ArticleModel>;
  recoverAccount?: Maybe<GenericResponseType>;
  regenerateCalendarPath: GenericResponseType;
  removeTotp: GenericResponseType;
  requestAssistance?: Maybe<GenericResponseType>;
  requestRefund?: Maybe<GenericResponseType>;
  requestResetPassword: GenericResponseType;
  resendConfirmationEmail: GenericResponseType;
  resendSignupEmailCode: UserSignUpModel;
  resetPassword?: Maybe<GenericResponseType>;
  respondToRecurringInvites?: Maybe<GenericResponseType>;
  restoreUsers?: Maybe<GenericResponseType>;
  resume: GenericResponseType;
  revokeMySession?: Maybe<GenericResponseType>;
  revokeOtherMySessions?: Maybe<GenericResponseType>;
  saveArticle?: Maybe<ArticleModel>;
  saveParticipantSession: GenericResponseType;
  scheduleCancelSubscription?: Maybe<GenericResponseType>;
  seenCompletedBasics?: Maybe<GenericResponseType>;
  sendCustomNotifications?: Maybe<CustomNotificationResponseType>;
  sendLink?: Maybe<GenericResponseType>;
  sendLiveTablesFeedback: GenericResponseType;
  sendManyChatInvites?: Maybe<GenericResponseType>;
  setChannelPictureUrl?: Maybe<GenericResponseType>;
  setToken: GenericResponseType;
  shareEvent: GenericResponseType;
  subscribe?: Maybe<Scalars["JSON"]["output"]>;
  switch?: Maybe<Scalars["JSON"]["output"]>;
  triggerAssignAllUserBadges: GenericResponseType;
  triggerBackfillConnectionStreaks: GenericResponseType;
  triggerBackupEventsParticipants: GenericResponseType;
  triggerChatServiceSync?: Maybe<GenericResponseType>;
  triggerRecreateDailyMeetings: GenericResponseType;
  triggerRecreateZoomMeetings: GenericResponseType;
  triggerUserDeletionAfterRetention: GenericResponseType;
  triggerUserPermissionPromotion: GenericResponseType;
  unFollow?: Maybe<GenericResponseType>;
  updateArticleAttachment?: Maybe<ArticlesAttachmentModel>;
  updateAttachment?: Maybe<EventAttachmentModel>;
  updateEvent?: Maybe<EventModel>;
  updateGuestPassBooking: UserSignUpModel;
  updateLiveTable: GenericResponseType;
  updateMe?: Maybe<UserModel>;
  updatePassword: GenericResponseType;
  updatePaymentMethod?: Maybe<Scalars["String"]["output"]>;
  updateUserPhoto?: Maybe<UserPhotoModel>;
  updateUserSettings?: Maybe<GenericResponseType>;
  updateWeeklyGoal: GenericResponseType;
  uploadActiveDays: GenericResponseType;
  uploadArticleCover?: Maybe<ArticleModel>;
  uploadArticleImage?: Maybe<UploadUrlsType>;
  uploadEventCover?: Maybe<UploadUrlsType>;
  uploadEventDescriptionImage?: Maybe<UploadUrlsType>;
  uploadZineCover?: Maybe<ZineModel>;
  validateForSelectionBulkInvite: ValidateSelectionBulkInviteResponse;
  validateUsersForEmailBulkInvite?: Maybe<ValidateBulkInviteResponse>;
  verifySignupEmail: UserSignUpModel;
  verifyUser?: Maybe<GenericResponseType>;
  verifyWebpushSubscription: VerifyWebpushSubscriptionResult;
  videoMeetingToken: MeetingTokenResponse;
}

export interface MutationAcceptChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
}

export interface MutationActivateGuestPassArgs {
  planId: Scalars["String"]["input"];
}

export interface MutationActivateUserArgs {
  input: ActivateUserInput;
}

export interface MutationAddEventToGoogleCalendarArgs {
  input: AddEventCalendarInput;
}

export interface MutationAddMultipleEventsToGoogleCalendarArgs {
  calendarType: CalendarType;
  eventIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAddZoomLicenseToUserArgs {
  userID: Scalars["String"]["input"];
}

export interface MutationAdminBanUserArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminBulkUploadEventsArgs {
  input: BulkUploadEventsInput;
}

export interface MutationAdminCreateBannerArgs {
  input: CreateBannerInput;
}

export interface MutationAdminCreateCoverArgs {
  input: CreateCoverInput;
}

export interface MutationAdminCreateFeatureFlagArgs {
  input: CreateFeatureFlagInput;
}

export interface MutationAdminCreateIllustrationArgs {
  input: CreateIllustrationInput;
}

export interface MutationAdminCreateLessonArgs {
  input: CreateLessonInput;
}

export interface MutationAdminCreateNoteArgs {
  input: NoteInput;
  userID: Scalars["String"]["input"];
}

export interface MutationAdminCreateQuestionArgs {
  input: CreateQuestionInput;
}

export interface MutationAdminCreateSectionArgs {
  input: CreateSectionInput;
}

export interface MutationAdminCreateSliderArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminCreateThemeArgs {
  input: CreateThemeInput;
}

export interface MutationAdminCreateTopicArgs {
  input: CreateTopicInput;
}

export interface MutationAdminCreateUserFeatureFlagArgs {
  input: CreateUserFeatureFlagInput;
}

export interface MutationAdminCreateVideoArgs {
  input: CreateVideoInput;
}

export interface MutationAdminCreateVideoSetArgs {
  input: CreateVideoSetInput;
}

export interface MutationAdminCreateZineCoverArgs {
  input: CreateZineInput;
}

export interface MutationAdminDeleteArticleArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteBannerArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteCoverArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteEventArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteIllustrationArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteLessonArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteQuestionArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteSectionArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteSliderArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteThemeArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteTopicArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteTopicsArgs {
  input: DeleteTopicsInput;
}

export interface MutationAdminDeleteUserFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteUserReportArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteVideoArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteVideoSetArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteZineCoverArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminEditArticleArgs {
  id: Scalars["String"]["input"];
  input: EditArticleInput;
}

export interface MutationAdminEditBannerArgs {
  id: Scalars["String"]["input"];
  input: EditBannerInput;
}

export interface MutationAdminEditCoverArgs {
  id: Scalars["String"]["input"];
  input: EditCoverInput;
}

export interface MutationAdminEditCustomNotificationDisplayArgs {
  id: Scalars["String"]["input"];
  input: EditCustomNotificationDisplayInput;
}

export interface MutationAdminEditEventArgs {
  id: Scalars["String"]["input"];
  input: EditEventInput;
}

export interface MutationAdminEditFeatureFlagArgs {
  id: Scalars["String"]["input"];
  input: EditFeatureFlagInput;
}

export interface MutationAdminEditIllustrationArgs {
  id: Scalars["String"]["input"];
  input: EditIllustrationInput;
}

export interface MutationAdminEditLessonArgs {
  id: Scalars["String"]["input"];
  input: EditLessonInput;
}

export interface MutationAdminEditQuestionArgs {
  input: EditQuestionInput;
}

export interface MutationAdminEditSectionArgs {
  id: Scalars["String"]["input"];
  input: EditSectionInput;
}

export interface MutationAdminEditSlideArgs {
  id: Scalars["String"]["input"];
  input: EditSliderInput;
}

export interface MutationAdminEditThemeArgs {
  id: Scalars["String"]["input"];
  input: EditThemeInput;
}

export interface MutationAdminEditTopicArgs {
  id: Scalars["String"]["input"];
  input: EditTopicInput;
}

export interface MutationAdminEditUserArgs {
  id: Scalars["String"]["input"];
  input: EditUserInput;
}

export interface MutationAdminEditUserFeatureFlagArgs {
  id: Scalars["String"]["input"];
  input: EditUserFeatureFlagInput;
}

export interface MutationAdminEditVideoArgs {
  id: Scalars["String"]["input"];
  input: EditVideoInput;
}

export interface MutationAdminEditVideoSetArgs {
  id: Scalars["String"]["input"];
  input: EditVideoSetInput;
}

export interface MutationAdminEditZineCoverArgs {
  id: Scalars["String"]["input"];
  input: EditZineInput;
}

export interface MutationAdminForceSignOutArgs {
  userId: Scalars["String"]["input"];
}

export interface MutationAdminFulfillReferralArgs {
  action: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
}

export interface MutationAdminGenerateAttachmentUploadUrlArgs {
  filename: Scalars["String"]["input"];
}

export interface MutationAdminGrantGuestPassTokensArgs {
  input: GrantGuestPassTokensInput;
}

export interface MutationAdminImportUserArgs {
  input: ImportUserInput;
}

export interface MutationAdminOrderSliderArgs {
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}

export interface MutationAdminOrderVideoArgs {
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}

export interface MutationAdminOrderVideoSetArgs {
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}

export interface MutationAdminRecordCampaignInvitesArgs {
  campaign: InviteCampaignKey;
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminRecordInvitesArgs {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  eventId: Scalars["String"]["input"];
  filters?: InputMaybe<Array<Scalars["String"]["input"]>>;
  source?: InputMaybe<OutreachSource>;
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminRecordRetentionOutreachArgs {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  fader: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminRepublishEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface MutationAdminReviewReferralArgs {
  approve: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
}

export interface MutationAdminSelectionUserIdsArgs {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  filters: AdminFilterUsersInput;
}

export interface MutationAdminSetEventLabelsArgs {
  labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: Scalars["String"]["input"];
}

export interface MutationAdminShareEventToEmailsArgs {
  emails: Array<Scalars["String"]["input"]>;
  eventId: Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
}

export interface MutationAdminShareEventToUserIdsArgs {
  eventId: Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminUnbanUserArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminValidateBulkUploadEventsArgs {
  input: BulkUploadEventsInput;
}

export interface MutationAdminWelcomeUserArgs {
  input: ImportUserInput;
}

export interface MutationAssignUserBadgeArgs {
  input: AssignOrDeleteBadgeInput;
}

export interface MutationAttendEventArgs {
  input: AttendEventInput;
}

export interface MutationAttendMultipleEventsArgs {
  eventIds: Array<Scalars["String"]["input"]>;
}

export interface MutationBulkInviteWithUserIdsArgs {
  eventId: Scalars["String"]["input"];
  input: BulkInviteWithUserIdsInput;
}

export interface MutationCancelAttendanceArgs {
  input: CancelAttendanceInput;
}

export interface MutationChatAddMembersToChannelArgs {
  id: Scalars["String"]["input"];
  input: CreateChannelInput;
}

export interface MutationChatAutomationsAddMembersArgs {
  input: AddBulkMembersInput;
}

export interface MutationChatAutomationsRecallSendArgs {
  batchId: Scalars["String"]["input"];
}

export interface MutationChatAutomationsSendMessagesArgs {
  input: SendBulkMessagesInput;
}

export interface MutationChatAutomationsSendPersonalMessagesArgs {
  input: SendPersonalMessagesInput;
}

export interface MutationChatCreateChannelArgs {
  input: CreateChannelInput;
}

export interface MutationChatGiveAdminRoleArgs {
  id: Scalars["String"]["input"];
}

export interface MutationChatRemoveMembersFromChannelArgs {
  id: Scalars["String"]["input"];
  input: CreateChannelInput;
}

export interface MutationChatRenameChannelArgs {
  channelName: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}

export interface MutationChatSendDirectMessageArgs {
  input: SendDirectChatMessageInput;
}

export interface MutationChatUpdatePublicChannelInfoArgs {
  channelDescription: Scalars["String"]["input"];
  channelName: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}

export interface MutationChatUpdateUserChannelPermissionArgs {
  input: UpdateUserChannelPermissionInput;
}

export interface MutationChooseSubscriptionArgs {
  input: SubscribeInput;
}

export interface MutationCloseDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationCloseVideoCallDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationCompleteVideoArgs {
  id: Scalars["String"]["input"];
}

export interface MutationConfirmGuestPassSignupArgs {
  input: ConfirmGuestPassSignupInput;
}

export interface MutationConfirmInPersonEventArgs {
  id: Scalars["String"]["input"];
  input: ConfirmInPersonEventInput;
}

export interface MutationConfirmTotpArgs {
  currentPassword: Scalars["String"]["input"];
  input: ConfirmTotpInput;
}

export interface MutationContactUsArgs {
  input: ContactUsInput;
}

export interface MutationCreateAbuseArgs {
  input: ReportAbuseInput;
}

export interface MutationCreateArticleAttachmentArgs {
  articleId: Scalars["String"]["input"];
  input: CreateArticlesAttachmentInput;
}

export interface MutationCreateAttachmentArgs {
  eventID: Scalars["String"]["input"];
  input: CreateEventAttachmentInput;
}

export interface MutationCreateCommentArgs {
  input: CreateCommentInput;
  targetId: Scalars["String"]["input"];
  targetType: CommentTargetType;
}

export interface MutationCreateEventArgs {
  input: CreateEventInput;
}

export interface MutationCreateInviteArgs {
  input: CreateInviteInput;
}

export interface MutationCreateLikeArgs {
  input: CreateLikeInput;
}

export interface MutationCreateLiveTableArgs {
  input: CreateLiveTableInput;
}

export interface MutationCreateMessageArgs {
  writeMessageData: CreateMessageInput;
}

export interface MutationCreateNewWebhookArgs {
  eventTypes: Array<DailyEventTypes>;
}

export interface MutationCreateReactionArgs {
  input: CreateReactionInput;
}

export interface MutationCreateSparkArgs {
  input: CreateSparkInput;
}

export interface MutationCreateTopicForPreviewModeArgs {
  input: TopicInPreviewInput;
}

export interface MutationCreateUserArgs {
  input: CreateUserInput;
}

export interface MutationCreateUserPhotoArgs {
  input: UpdatePhotoInput;
}

export interface MutationCreateVideoCallArgs {
  input: CreateVideoCallInput;
}

export interface MutationCreateWebpushSubscriptionArgs {
  input: CreateWebpushSubscriptionInput;
}

export interface MutationDeactivateArgs {
  input: DeactivateInput;
}

export interface MutationDeclineChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
}

export interface MutationDeclineInviteArgs {
  input: DeclineInviteInput;
}

export interface MutationDeclineSharedEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface MutationDeleteAccountArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteArticleArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteArticleAttachmentArgs {
  attachmentId: Scalars["String"]["input"];
}

export interface MutationDeleteAttachmentArgs {
  attachmentID: Scalars["String"]["input"];
}

export interface MutationDeleteChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface MutationDeleteCommentArgs {
  commentID: Scalars["String"]["input"];
}

export interface MutationDeleteDailyWebhookArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteEventArgs {
  deleteScope?: InputMaybe<RecurringEditScope>;
  deletedNote?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  selectedEventIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface MutationDeleteInviteArgs {
  inviteId: Scalars["String"]["input"];
}

export interface MutationDeleteInvitesArgs {
  input: DeleteInvitesInput;
}

export interface MutationDeleteLikeArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteReactionArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteUserBadgeArgs {
  input: AssignOrDeleteBadgeInput;
}

export interface MutationDeleteUserPhotoArgs {
  input: DeletePhotoInput;
}

export interface MutationDuplicateEventArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDuplicateLessonArgs {
  input: DuplicateLessonInput;
}

export interface MutationDuplicateTopicArgs {
  id: Scalars["String"]["input"];
}

export interface MutationEditArticleArgs {
  id: Scalars["String"]["input"];
  input: EditArticleInput;
}

export interface MutationEditCommentArgs {
  commentID: Scalars["String"]["input"];
  input: EditCommentInput;
}

export interface MutationEventMeetingTokenArgs {
  input: DailyMeetingInput;
}

export interface MutationFollowArgs {
  input: FollowInput;
}

export interface MutationGenerateArticlesAttachmentUploadUrlArgs {
  articleId: Scalars["String"]["input"];
  filename: Scalars["String"]["input"];
}

export interface MutationGenerateAttachmentUploadUrlArgs {
  eventID: Scalars["String"]["input"];
  filename: Scalars["String"]["input"];
}

export interface MutationGenerateChannelPictureUploadUrlArgs {
  input: UploadPictureInput;
}

export interface MutationGenerateUserUploadUrlArgs {
  input: UploadPhotoInput;
}

export interface MutationGetHostedPageArgs {
  id: Scalars["String"]["input"];
}

export interface MutationHeartbeatArgs {
  input: UpdateUserInput;
}

export interface MutationLiveTableMeetingTokenArgs {
  input: DailyMeetingInput;
}

export interface MutationMarkJoinEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface MutationNotificationSeenArgs {
  id: Scalars["String"]["input"];
}

export interface MutationNotifyAboutStartedLiveTableArgs {
  input: LiveTableStartedMessageInput;
}

export interface MutationOpenDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationOpenVideoCallDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationPauseArgs {
  input: PauseInput;
}

export interface MutationPublishEventArgs {
  id: Scalars["String"]["input"];
}

export interface MutationPublishOrScheduleArticleArgs {
  id: Scalars["String"]["input"];
  input: PublishArticleInput;
}

export interface MutationRegenerateCalendarPathArgs {
  userId: Scalars["String"]["input"];
}

export interface MutationRemoveTotpArgs {
  currentPassword?: InputMaybe<Scalars["String"]["input"]>;
  totpId: Scalars["String"]["input"];
}

export interface MutationRequestAssistanceArgs {
  input: AssistanceReasonsInput;
}

export interface MutationRequestRefundArgs {
  input: RequestRefundInput;
}

export interface MutationRequestResetPasswordArgs {
  input: RequestPasswordInput;
}

export interface MutationResendConfirmationEmailArgs {
  input: ResendConfirmationEmailInput;
}

export interface MutationResendSignupEmailCodeArgs {
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
}

export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}

export interface MutationRespondToRecurringInvitesArgs {
  acceptEventIds: Array<Scalars["String"]["input"]>;
  declineEventIds: Array<Scalars["String"]["input"]>;
  seriesId: Scalars["String"]["input"];
}

export interface MutationRestoreUsersArgs {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationRevokeMySessionArgs {
  sessionId: Scalars["String"]["input"];
}

export interface MutationSaveArticleArgs {
  id: Scalars["String"]["input"];
  input: SaveDraftArticleInput;
}

export interface MutationSaveParticipantSessionArgs {
  meetingSessionId: Scalars["String"]["input"];
  participantId: Scalars["String"]["input"];
}

export interface MutationScheduleCancelSubscriptionArgs {
  input: RequestRefundInput;
}

export interface MutationSendCustomNotificationsArgs {
  emails: Array<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
}

export interface MutationSendLinkArgs {
  input: FriendInput;
}

export interface MutationSendLiveTablesFeedbackArgs {
  input: LiveTablesFeedbackInput;
}

export interface MutationSendManyChatInvitesArgs {
  input: ChatInviteInput;
}

export interface MutationSetChannelPictureUrlArgs {
  input: SetPictureInput;
}

export interface MutationSetTokenArgs {
  input: Scalars["String"]["input"];
}

export interface MutationShareEventArgs {
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationSubscribeArgs {
  input: SubscribeInput;
}

export interface MutationSwitchArgs {
  input: SubscribeInput;
}

export interface MutationUnFollowArgs {
  input: FollowInput;
}

export interface MutationUpdateArticleAttachmentArgs {
  attachmentId: Scalars["String"]["input"];
  input: EditArticlesAttachmentInput;
}

export interface MutationUpdateAttachmentArgs {
  attachmentID: Scalars["String"]["input"];
  input: UpdateEventAttachmentInput;
}

export interface MutationUpdateEventArgs {
  id: Scalars["String"]["input"];
  input: UpdateEventInput;
}

export interface MutationUpdateGuestPassBookingArgs {
  input: UpdateGuestPassBookingInput;
}

export interface MutationUpdateLiveTableArgs {
  id: Scalars["String"]["input"];
  input: UpdateLiveTableInput;
}

export interface MutationUpdateMeArgs {
  input: UpdateUserInput;
}

export interface MutationUpdatePasswordArgs {
  input: UpdatePasswordInput;
}

export interface MutationUpdateUserPhotoArgs {
  input: UpdatePhotoInput;
  photoID: Scalars["String"]["input"];
}

export interface MutationUpdateUserSettingsArgs {
  input: UpdateSettingsInput;
}

export interface MutationUpdateWeeklyGoalArgs {
  goal: Scalars["Int"]["input"];
}

export interface MutationUploadActiveDaysArgs {
  input: UploadActiveDaysInput;
}

export interface MutationUploadArticleCoverArgs {
  input: UploadImageArticleInput;
}

export interface MutationUploadArticleImageArgs {
  input: UploadImageArticleInput;
}

export interface MutationUploadEventCoverArgs {
  id: Scalars["String"]["input"];
  input: UploadEventImageInput;
}

export interface MutationUploadEventDescriptionImageArgs {
  id: Scalars["String"]["input"];
  input: UploadEventImageInput;
}

export interface MutationUploadZineCoverArgs {
  input: UploadCoverZineInput;
}

export interface MutationValidateForSelectionBulkInviteArgs {
  eventId: Scalars["String"]["input"];
  filters: AdminFilterUsersInput;
}

export interface MutationValidateUsersForEmailBulkInviteArgs {
  eventId: Scalars["String"]["input"];
  input: BulkInviteWithEmailsInput;
}

export interface MutationVerifySignupEmailArgs {
  code: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}

export interface MutationVerifyUserArgs {
  id: Scalars["String"]["input"];
  input: VerifyUserInput;
}

export interface MutationVerifyWebpushSubscriptionArgs {
  input: VerifyWebpushSubscriptionInput;
}

export interface MutationVideoMeetingTokenArgs {
  input: DailyMeetingInput;
}

export enum MutationStatus {
  Failed = "FAILED",
  Success = "SUCCESS",
}

export interface NewMemberAngleModel {
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
}

export interface NewMemberEventModel {
  /** It starts after her Guest Pass ends. */
  afterPass: Scalars["Boolean"]["output"];
  /** Whose clock `when` is on: 'profile', 'signup' (her profile has no timezone yet), or '' when we don't know. */
  clock: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  hostName?: Maybe<Scalars["String"]["output"]>;
  /** Pitched at a level that isn't hers. */
  levelMismatch: Scalars["Boolean"]["output"];
  link: Scalars["String"]["output"];
  /** Outside 7am to 10pm on her clock. */
  outsideHerDay: Scalars["Boolean"]["output"];
  /** Which invitation queue: nmw / cxt / bs. */
  programme: Scalars["String"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  typeLabel: Scalars["String"]["output"];
  /** When it is on her clock, e.g. 'Tuesday 16 September, 19:00'. */
  when?: Maybe<Scalars["String"]["output"]>;
  /** Why the invitation rules chose it. */
  why: Scalars["String"]["output"];
}

export interface NewMemberModel {
  /** Upcoming events she has said yes to. */
  acceptedUpcoming: Scalars["Int"]["output"];
  /** Whole days since she signed up. */
  ageDays: Scalars["Int"]["output"];
  angles: Array<NewMemberAngleModel>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  /** What makes practising hard for her. */
  challengeLabel?: Maybe<Scalars["String"]["output"]>;
  defaultAngle: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  eventsAttended: Scalars["Int"]["output"];
  firstEventId?: Maybe<Scalars["String"]["output"]>;
  /** She skipped booking a first event at signup. */
  firstEventSkipped: Scalars["Boolean"]["output"];
  firstEventStart?: Maybe<Scalars["Date"]["output"]>;
  /** came / ahead / missed. */
  firstEventState?: Maybe<Scalars["String"]["output"]>;
  firstEventTitle?: Maybe<Scalars["String"]["output"]>;
  /** Its start on the clock she picked at signup. */
  firstEventWhen?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  /** Whole days left on her Guest Pass. */
  guestDaysLeft?: Maybe<Scalars["Int"]["output"]>;
  guestPassLive: Scalars["Boolean"]["output"];
  /** Guest Pass events left; null when she has no pass. */
  guestTokensLeft?: Maybe<Scalars["Int"]["output"]>;
  /** Her message for the default angle. */
  message: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  priority?: Maybe<Scalars["String"]["output"]>;
  /** Why she wants spoken English, in the words she saw. */
  priorityLabel?: Maybe<Scalars["String"]["output"]>;
  readiness?: Maybe<Scalars["String"]["output"]>;
  /** Whether she has time to practise this week. */
  readinessLabel?: Maybe<Scalars["String"]["output"]>;
  /** no_first_event / missed_first_event: reach her today. */
  redFlag?: Maybe<Scalars["String"]["output"]>;
  redFlagLabel?: Maybe<Scalars["String"]["output"]>;
  /** The timezone she picked at signup. */
  selectedTimezone?: Maybe<Scalars["String"]["output"]>;
  signedUpAt: Scalars["Date"]["output"];
  /** Where she has got to, in the terms her message is written for. */
  signupState: Scalars["String"]["output"];
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  /** guest / active / non_renewing / paused / gone. */
  status: Scalars["String"]["output"];
  statusLabel: Scalars["String"]["output"];
  suggestion: NewMemberSuggestionModel;
  /** Her profile timezone. The platform fills it in once she opens the app. */
  timezone?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
}

export interface NewMemberSuggestionModel {
  byType: Array<NewMemberTypeModel>;
  /** The one event her message suggests. */
  event?: Maybe<NewMemberEventModel>;
  /** Upcoming invitations and shares she already holds. */
  holds: Scalars["Int"]["output"];
  /** An invitation she already holds and can open. When set, her message points her to her Invitations instead. */
  invitation?: Maybe<NewMemberEventModel>;
  resourceLink: Scalars["String"]["output"];
  resourceTitle: Scalars["String"]["output"];
  /** The queues she hasn't been to yet. */
  untried: Array<Scalars["String"]["output"]>;
}

export interface NewMemberTypeModel {
  /** Null when nothing of this type is open to her. */
  event?: Maybe<NewMemberEventModel>;
  label: Scalars["String"]["output"];
  programme: Scalars["String"]["output"];
  /** She has already been to one of these. */
  tried: Scalars["Boolean"]["output"];
}

export interface NewMembersResultModel {
  /** The look-back window used, in days. */
  days: Scalars["Int"]["output"];
  generatedAt: Scalars["Date"]["output"];
  members: Array<NewMemberModel>;
  total: Scalars["Int"]["output"];
}

export interface NoteInput {
  description: Scalars["String"]["input"];
}

export interface NoteModel {
  createdAt: Scalars["Date"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface NotificationBaseModel {
  articleNotification?: Maybe<ArticleNotificationModel>;
  badgeNotification?: Maybe<BadgeNotificationModel>;
  chatNotification?: Maybe<ChatNotificationModel>;
  commentNotification?: Maybe<CommentNotificationModel>;
  createdAt: Scalars["Date"]["output"];
  customNotification?: Maybe<CustomNotificationModel>;
  eventNotification?: Maybe<EventNotificationModel>;
  friendJoinedNotification?: Maybe<FriendJoinedNotificationModel>;
  id: Scalars["String"]["output"];
  monthlyReportNotification?: Maybe<MonthlyReportNotificationModel>;
  notificationSeen?: Maybe<Array<NotificationSeenModel>>;
  profileUpdateNotification?: Maybe<ProfileUpdateNotificationModel>;
  type: NotificationType;
  updatedAt: Scalars["Date"]["output"];
}

export interface NotificationCursorPaginatedInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  maxDate?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface NotificationSeenModel {
  id: Scalars["String"]["output"];
  seenAt?: Maybe<Scalars["Date"]["output"]>;
  user: UserModel;
}

export enum NotificationType {
  Article = "Article",
  Badge = "Badge",
  Chat = "Chat",
  Comment = "Comment",
  Custom = "Custom",
  Event = "Event",
  FriendJoined = "FriendJoined",
  MonthlyReport = "MonthlyReport",
  ProfileUpdate = "ProfileUpdate",
}

export interface OccupationInput {
  id: Scalars["String"]["input"];
  industry?: InputMaybe<IndustryInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
}

export enum OccupationMatch {
  Different = "Different",
  Same = "Same",
  SharedIndustry = "SharedIndustry",
}

export interface OccupationModel {
  id: Scalars["String"]["output"];
  industry?: Maybe<Industry>;
  name?: Maybe<Scalars["String"]["output"]>;
}

export enum Onboarding {
  Availability = "AVAILABILITY",
  Avatar = "AVATAR",
  Complete = "COMPLETE",
  EnglishLevel = "ENGLISH_LEVEL",
  EnglishSkills = "ENGLISH_SKILLS",
  Interests = "INTERESTS",
  Location = "LOCATION",
  Name = "NAME",
  Occupation = "OCCUPATION",
  Story = "STORY",
}

export interface OnlineNowMemberModel {
  email: Scalars["String"]["output"];
  faderLevel?: Maybe<FaderLevel>;
  name: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  zone: ZoneLabel;
}

export interface OrderArticlesInput {
  by?: InputMaybe<ArticleOrderBy>;
  sortAsc?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface OrderEventInput {
  by?: InputMaybe<EventsOrderBy>;
  sort?: InputMaybe<SortDirection>;
}

/** How a tool's members are sliced underneath its headline funnel. */
export enum OutreachBreakdown {
  Campaign = "CAMPAIGN",
  Challenge = "CHALLENGE",
  Filter = "FILTER",
  Priority = "PRIORITY",
  RiskThen = "RISK_THEN",
}

export interface OutreachBreakdownRowModel {
  /** Accepted an invitation we sent (self-signups excluded). */
  accepted: Scalars["Int"]["output"];
  /** Came to any conversation at all after we reached her. */
  attendedAny: Scalars["Int"]["output"];
  /** Came to an event this tool actually put in front of her. */
  attendedInvited: Scalars["Int"]["output"];
  /** The slice this row covers. */
  bucket: Scalars["String"]["output"];
  /** Gone. */
  cancelled: Scalars["Int"]["output"];
  /** Declined an invitation we sent. */
  declined: Scalars["Int"]["output"];
  /** Total conversations those members attended since contact. */
  eventsAttended: Scalars["Int"]["output"];
  /** Still subscribed but set to end on a date that hasn't arrived — too early to say. */
  leaving: Scalars["Int"]["output"];
  /** Logged in since — interested, even if she hasn't come yet. */
  loggedIn: Scalars["Int"]["output"];
  /** Median conversations attended since contact. Median, not mean, so one very active member can't carry a cohort that mostly came to none. */
  medianAttended?: Maybe<Scalars["Float"]["output"]>;
  /** On pause. */
  paused: Scalars["Int"]["output"];
  /** Distinct members this reached in the period. */
  reached: Scalars["Int"]["output"];
  /** Of those reached, how many wrote back afterwards. */
  responded: Scalars["Int"]["output"];
  /** Individual sends it took to reach them. */
  sends: Scalars["Int"]["output"];
  /** Subscribed and renewing now. */
  stayed: Scalars["Int"]["output"];
  /** Still on zero conversations since we reached her. */
  stillZero: Scalars["Int"]["output"];
}

export interface OutreachFunnelModel {
  /** Accepted an invitation we sent (self-signups excluded). */
  accepted: Scalars["Int"]["output"];
  /** Came to any conversation at all after we reached her. */
  attendedAny: Scalars["Int"]["output"];
  /** Came to an event this tool actually put in front of her. */
  attendedInvited: Scalars["Int"]["output"];
  /** Gone. */
  cancelled: Scalars["Int"]["output"];
  /** Declined an invitation we sent. */
  declined: Scalars["Int"]["output"];
  /** Total conversations those members attended since contact. */
  eventsAttended: Scalars["Int"]["output"];
  /** Still subscribed but set to end on a date that hasn't arrived — too early to say. */
  leaving: Scalars["Int"]["output"];
  /** Logged in since — interested, even if she hasn't come yet. */
  loggedIn: Scalars["Int"]["output"];
  /** Median conversations attended since contact. Median, not mean, so one very active member can't carry a cohort that mostly came to none. */
  medianAttended?: Maybe<Scalars["Float"]["output"]>;
  /** On pause. */
  paused: Scalars["Int"]["output"];
  /** Distinct members this reached in the period. */
  reached: Scalars["Int"]["output"];
  /** Of those reached, how many wrote back afterwards. */
  responded: Scalars["Int"]["output"];
  /** Individual sends it took to reach them. */
  sends: Scalars["Int"]["output"];
  /** Subscribed and renewing now. */
  stayed: Scalars["Int"]["output"];
  /** Still on zero conversations since we reached her. */
  stillZero: Scalars["Int"]["output"];
}

export interface OutreachMemberModel {
  accepted: Scalars["Boolean"]["output"];
  /** Conversations attended since that first contact. */
  attendedAfter: Scalars["Int"]["output"];
  /** She came to an event this tool put in front of her. */
  attendedInvited: Scalars["Boolean"]["output"];
  /** The campaign tag on that first contact. */
  campaign?: Maybe<Scalars["String"]["output"]>;
  declined: Scalars["Boolean"]["output"];
  email: Scalars["String"]["output"];
  /** When her current billing period ends — the date a cancellation becomes real. */
  endsAt?: Maybe<Scalars["Date"]["output"]>;
  /** Conversations attended at that contact. */
  eventsThen?: Maybe<Scalars["Int"]["output"]>;
  /** Her first contact from this tool, in the period. */
  firstAt: Scalars["Date"]["output"];
  lastAt: Scalars["Date"]["output"];
  lastLoginAt?: Maybe<Scalars["Date"]["output"]>;
  loggedInSince: Scalars["Boolean"]["output"];
  membership: MembershipNow;
  name: Scalars["String"]["output"];
  /** She wrote back after we reached her. */
  responded: Scalars["Boolean"]["output"];
  /** Her risk level, frozen at that first contact. */
  riskThen?: Maybe<Scalars["String"]["output"]>;
  /** How many times this tool reached her in the period. */
  sends: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
}

export interface OutreachResultModel {
  breakdown: Array<OutreachBreakdownRowModel>;
  current: OutreachFunnelModel;
  /** The same funnel over the period immediately before this one. */
  previous?: Maybe<OutreachFunnelModel>;
  source?: Maybe<OutreachSource>;
  trend: Array<OutreachTrendPointModel>;
}

/** Which admin screen an outreach was sent from. */
export enum OutreachSource {
  Cancellations = "CANCELLATIONS",
  ChatAutomations = "CHAT_AUTOMATIONS",
  FindEvents = "FIND_EVENTS",
  InviteCampaigns = "INVITE_CAMPAIGNS",
  InviteCohort = "INVITE_COHORT",
  MemberEvents = "MEMBER_EVENTS",
  NewMembers = "NEW_MEMBERS",
  OnlineNow = "ONLINE_NOW",
  Retention = "RETENTION",
  ShareEvent = "SHARE_EVENT",
  ZoneOutreach = "ZONE_OUTREACH",
}

export interface OutreachSourceResultModel {
  /** Accepted an invitation we sent (self-signups excluded). */
  accepted: Scalars["Int"]["output"];
  /** Came to any conversation at all after we reached her. */
  attendedAny: Scalars["Int"]["output"];
  /** Came to an event this tool actually put in front of her. */
  attendedInvited: Scalars["Int"]["output"];
  /** Gone. */
  cancelled: Scalars["Int"]["output"];
  /** Declined an invitation we sent. */
  declined: Scalars["Int"]["output"];
  /** Total conversations those members attended since contact. */
  eventsAttended: Scalars["Int"]["output"];
  /** Still subscribed but set to end on a date that hasn't arrived — too early to say. */
  leaving: Scalars["Int"]["output"];
  /** Logged in since — interested, even if she hasn't come yet. */
  loggedIn: Scalars["Int"]["output"];
  /** Median conversations attended since contact. Median, not mean, so one very active member can't carry a cohort that mostly came to none. */
  medianAttended?: Maybe<Scalars["Float"]["output"]>;
  /** On pause. */
  paused: Scalars["Int"]["output"];
  /** Distinct members this reached in the period. */
  reached: Scalars["Int"]["output"];
  /** Of those reached, how many wrote back afterwards. */
  responded: Scalars["Int"]["output"];
  /** Individual sends it took to reach them. */
  sends: Scalars["Int"]["output"];
  /** Which screen sent it. Null means unattributed — sent before we recorded the screen, and its campaign tag didn't say. */
  source?: Maybe<OutreachSource>;
  /** Subscribed and renewing now. */
  stayed: Scalars["Int"]["output"];
  /** Still on zero conversations since we reached her. */
  stillZero: Scalars["Int"]["output"];
}

export interface OutreachTrendPointModel {
  attendedAny: Scalars["Int"]["output"];
  /** Start of the bucket (its week's Monday or month's first). */
  bucketStart: Scalars["Date"]["output"];
  /** This bucket is still running. Members reached days ago have had no time to act, so it always reads low and shouldn't be compared with finished buckets. */
  partial: Scalars["Boolean"]["output"];
  reached: Scalars["Int"]["output"];
  responded: Scalars["Int"]["output"];
  sends: Scalars["Int"]["output"];
}

/** The kind of outreach action recorded in the log. */
export enum OutreachType {
  AddMember = "ADD_MEMBER",
  Invite = "INVITE",
  Message = "MESSAGE",
  ShareEvent = "SHARE_EVENT",
}

export interface PaginatedArticles {
  items?: Maybe<Array<ArticleModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedAssessmentResult {
  items?: Maybe<Array<AssessmentResultModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedAssessmentResultInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface PaginatedBanners {
  items?: Maybe<Array<BannerModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedChatInvite {
  items?: Maybe<Array<ChatInviteModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedCovers {
  items?: Maybe<Array<CoverModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedCustomNotifications {
  items?: Maybe<Array<CustomNotificationDisplayModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedEvent {
  items?: Maybe<Array<EventModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedFeatureFlags {
  items?: Maybe<Array<FeatureFlagModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedIllustrations {
  items?: Maybe<Array<IllustrationModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedMatchedUser {
  items?: Maybe<Array<UserMatchingModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedReportsUser {
  items?: Maybe<Array<AbuseModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedThemes {
  items?: Maybe<Array<ThemeModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedTopics {
  items?: Maybe<Array<TopicModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedUser {
  items?: Maybe<Array<UserModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedVideoSets {
  items?: Maybe<Array<VideoSetModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedZines {
  items?: Maybe<Array<ZineModel>>;
  total: Scalars["Int"]["output"];
}

export enum ParticipationStatus {
  Attending = "Attending",
  Declined = "Declined",
  Invited = "Invited",
  NotInvited = "NotInvited",
}

export interface ParticipationStatusInput {
  eventId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface ParticipationStatusResult {
  status: ParticipationStatus;
}

export interface PauseInput {
  durationDays: Scalars["Int"]["input"];
}

export interface PausePreview {
  durationDays: Scalars["Int"]["output"];
  intendedPauseEndDate: Scalars["Date"]["output"];
  nextBillingAt: Scalars["Date"]["output"];
}

export interface PaymentMethod {
  email?: Maybe<Scalars["String"]["output"]>;
  expMonth?: Maybe<Scalars["Int"]["output"]>;
  expYear?: Maybe<Scalars["Int"]["output"]>;
  last4Digits?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
}

export interface PersonalMessageInput {
  email: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
}

export interface ProfileUpdateNotificationModel {
  id: Scalars["String"]["output"];
  type: ProfileUpdateNotificationType;
}

export enum ProfileUpdateNotificationType {
  CompleteProfile = "CompleteProfile",
}

export interface PublishArticleInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  myEnglishJourney?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledFor?: InputMaybe<Scalars["Date"]["input"]>;
  tags?: InputMaybe<Array<Interest>>;
  theme?: InputMaybe<ArticleThemes>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QuarterOptionModel {
  label: Scalars["String"]["output"];
  /** 'YYYY-Q', e.g. '2026-3'. */
  value: Scalars["String"]["output"];
}

export interface Query {
  adminCampaignEventResults: Array<CampaignEventResultModel>;
  adminCampaignResults: Array<CampaignResultWeekModel>;
  adminCapturedCampaigns: Array<CapturedCampaignModel>;
  adminCapturedConversations: Array<CapturedConversationModel>;
  adminCapturedThread: Array<CapturedMessageItemModel>;
  adminEventInsight: EventInsightModel;
  adminEventLabelCatalogue: Array<EventLabelModel>;
  adminEventMemberMatches: EventMatchResultModel;
  adminEventTimezoneSupply: EventTimezoneSupplyModel;
  adminEventsCalendar: CalendarWeekModel;
  adminEventsForMember: EventsForMemberResultModel;
  adminGetArticle: ArticleModel;
  adminGetBanner: BannerModel;
  adminGetCover: CoverModel;
  adminGetFeatureFlag: FeatureFlagModel;
  adminGetGroupedOccupations: Array<OccupationModel>;
  adminGetIllustration: IllustrationModel;
  adminGetLesson: LessonModel;
  adminGetOccupations: Array<OccupationModel>;
  adminGetPlanDetails: CbPlanDetails;
  adminGetSelectedUsers: Array<UserModel>;
  adminGetSlide: SliderModel;
  adminGetTheme: ThemeModel;
  adminGetTopic: TopicModel;
  adminGetTopicByLessonId: TopicModel;
  adminGetUserFeatureFlag: UserFlagModel;
  adminGetVideoSet?: Maybe<VideoSetModel>;
  adminGetZineCover: ZineModel;
  adminGuestPassSummary?: Maybe<GuestPassSummary>;
  adminGuestPassTokenAdjustments: Array<GuestPassTokenAdjustment>;
  adminInviteCampaign: Array<InviteCampaignZoneModel>;
  adminListCovers: Array<CoverModel>;
  adminListIllustrations: Array<IllustrationModel>;
  adminListPaginatedArticles: PaginatedArticles;
  adminListPaginatedBanners: PaginatedBanners;
  adminListPaginatedCovers: PaginatedCovers;
  adminListPaginatedCustomNotificationDisplay: PaginatedCustomNotifications;
  adminListPaginatedFeatureFlags: PaginatedFeatureFlags;
  adminListPaginatedIllustrations: PaginatedIllustrations;
  adminListPaginatedReportsUsers: PaginatedReportsUser;
  adminListPaginatedThemes: PaginatedThemes;
  adminListPaginatedTopics: PaginatedTopics;
  adminListPaginatedVideoSets: PaginatedVideoSets;
  adminListPaginatedZineCovers: PaginatedZines;
  adminListThemes: Array<ThemeModel>;
  adminListTopics: Array<TopicModel>;
  adminListUserFeatureFlags: Array<UserFlagModel>;
  adminListUsers: PaginatedUser;
  adminMemberEventsReview: Array<MemberEventReviewModel>;
  adminMemberExperience: MemberExperienceModel;
  adminMemberStats: Array<MemberStatsModel>;
  adminMemberZoneMatrix: MemberZonesModel;
  adminMessageCaptureStatus: MessageCaptureStatusModel;
  adminNewMembers: NewMembersResultModel;
  adminOnlineNowMembers: Array<OnlineNowMemberModel>;
  adminOutreachBySource: Array<OutreachSourceResultModel>;
  adminOutreachResultMembers: Array<OutreachMemberModel>;
  adminOutreachResults: OutreachResultModel;
  adminRecentOutreach: Array<RecentOutreachModel>;
  adminReferralRewards: Array<ReferralRewardModel>;
  adminRetentionAttendanceDetail: Array<RetentionAttendanceRowModel>;
  adminRetentionComeback: RetentionComebackModel;
  adminRetentionPrepare: RetentionPrepareModel;
  adminScheduledCancellations: CancellationsResultModel;
  adminSearchEvents: PaginatedEvent;
  adminSecurityEvents?: Maybe<Array<SecurityEventModel>>;
  adminShareEventPreview: ShareEventPreviewModel;
  adminTimezoneRegionMembers: TimezoneRegionMembersModel;
  adminTrialCancellations: CancellationsResultModel;
  adminUserSignUpAnswers?: Maybe<AdminUserSignUpAnswers>;
  adminZonePerformance: ZonePerformanceModel;
  adminZonePerformanceEvents: ZonePerformanceEventsModel;
  articlesWritten: Scalars["Int"]["output"];
  attendanceMetrics?: Maybe<AttendanceMetrics>;
  attendanceRatio: Scalars["Int"]["output"];
  attendanceRecord: AttendanceRecord;
  attendedEvents: AttendedEvents;
  backfillConnectionStreaksRunning: Scalars["Boolean"]["output"];
  chatAutomationsMatchMembers: MatchMembersResultType;
  chatAutomationsRecentSends: Array<SentBatchType>;
  chatAutomationsSendProgress?: Maybe<BulkSendProgressType>;
  chatCreateUserToken: Scalars["Any"]["output"];
  communityDistinctSparks: Scalars["Int"]["output"];
  completedVerificationForm: Array<VideoAskModel>;
  /** Crisp Identity Verification signature for the logged-in user's email. */
  crispIdentity?: Maybe<CrispIdentity>;
  dailyEvents: Array<EventsPerDay>;
  friendlyFaces: Array<FriendlyFaces>;
  getArticle: ArticleModel;
  getAssessmentResultById?: Maybe<AssessmentResultModel>;
  getAssessmentResultsCount: Scalars["Int"]["output"];
  getAvalibilityMatchForUsers: Array<AvailabilityMatchForUsers>;
  getCalendar?: Maybe<CalendarModel>;
  getChannelInvite?: Maybe<ChatInviteModel>;
  getChannelInvitesForUsers?: Maybe<Array<ChatInviteModel>>;
  getChannelVideoCall?: Maybe<VideoCallModel>;
  getComment?: Maybe<CommentModel>;
  getCurrentBanner?: Maybe<BannerModel>;
  getCurrentTopicQuestions: Array<QuestionModel>;
  getCurrentZine?: Maybe<ZineModel>;
  getCustomNotificationDisplay: CustomNotificationDisplayModel;
  getDailyHooks: Array<DailyWebHookType>;
  getEvent: EventModel;
  getEventAdmin?: Maybe<EventModel>;
  getEventForConnect: EventModel;
  getEventForMeeting: EventModel;
  getEventWithCache: EventModel;
  getGroupedOccupations: Array<OccupationModel>;
  getInvitedFriendsCount: Scalars["Int"]["output"];
  getInvitedFriendsStats: InvitedFriendsStats;
  getLastAssessmentResult?: Maybe<AssessmentResultModel>;
  getLiveTableById: LiveTableModel;
  getLiveTables: Array<LiveTableModel>;
  getMyStreak: UserStreak;
  getOccupations: Array<OccupationModel>;
  getParticipationStatus: ParticipationStatusResult;
  getPendingChannelInvites?: Maybe<Array<ChatInviteModel>>;
  getPopupNotifications: Array<NotificationBaseModel>;
  getPreviousAssessmentScore?: Maybe<Scalars["Float"]["output"]>;
  getTheme: ThemeModel;
  getTopic: TopicModel;
  getTotalDistinctSparks: Scalars["Int"]["output"];
  getUser: UserModel;
  getUserAdmin?: Maybe<UserModel>;
  getUserAssessmentResults: PaginatedAssessmentResult;
  getUserCalendar?: Maybe<CalendarModel>;
  getUserConnectionStreak: Scalars["Int"]["output"];
  getUserInfo: UserModel;
  getUserMatchingInfo: UserMatchingModel;
  getUserSettings: UserSettingsModel;
  getUserSignUp: UserSignUpModel;
  getUsersWithSameSpeakingLevel: UsersWithSameSpeakingLevel;
  getVideoCall: VideoCallModel;
  getVideos: Array<VideoModel>;
  globalNetwork: Array<Coordinates>;
  guestPassBookingEvents: Array<GuestPassBookingEvent>;
  guestPassSummary?: Maybe<GuestPassSummary>;
  hasSeenEventsTab: Scalars["Boolean"]["output"];
  hasSeenEventsTabAfterAttendedThreeEvents: Scalars["Boolean"]["output"];
  hostedEvents: Scalars["Int"]["output"];
  invoices?: Maybe<Array<Invoice>>;
  itemPrice?: Maybe<CbItemPrice>;
  ladiesAttended: Scalars["Int"]["output"];
  listArticles: PaginatedArticles;
  listAttachment: Array<EventAttachmentModel>;
  listMatchedUsers: PaginatedMatchedUser;
  listMessages: Array<MessageModel>;
  listNotificationsForUser: CursorPaginatedNotifications;
  listPaginatedAssessmentResults: PaginatedAssessmentResult;
  listPaginatedEvents: PaginatedEvent;
  listPendingChatInvites: PaginatedChatInvite;
  listRecommendedUsers: Array<UserMatchingModel>;
  listThemes: Array<ThemeModel>;
  listTopics: Array<TopicModel>;
  listTotp: Array<UserTotpModel>;
  listUserPhotos: Array<UserPhotoModel>;
  me: UserModel;
  monthlyRecapSteps: Array<MonthlyRecapSteps>;
  mySessions: Array<SessionInfo>;
  participationTime: Scalars["Int"]["output"];
  pausePreview: PausePreview;
  paymentMethod?: Maybe<Array<PaymentMethod>>;
  planDetails?: Maybe<CbPlanDetails>;
  recentArticles: Array<ArticleModel>;
  searchMemberzine: Array<ArticleSearchResult>;
  searchTopics: Array<TopicSearchResult>;
  searchUsers: Array<UserSearchResult>;
  seenMonthlyReport: Scalars["Boolean"]["output"];
  totalHostedParticipants: Scalars["Int"]["output"];
  totalPublishedArticles: Scalars["Int"]["output"];
  userAttendedDistinctSparks: Scalars["Int"]["output"];
  userDistinctSparks: Scalars["Int"]["output"];
  userGaveSparkInEvent: Scalars["Boolean"]["output"];
  userHasNoAcceptedInvites: Scalars["Boolean"]["output"];
  userHostedDistinctSparks: Scalars["Int"]["output"];
  userHostedEvents: PaginatedEvent;
  userHostedEventsToShareCount: Scalars["Int"]["output"];
}

export interface QueryAdminCampaignEventResultsArgs {
  campaign: InviteCampaignKey;
  weekStarting: Scalars["Date"]["input"];
}

export interface QueryAdminCampaignResultsArgs {
  campaign: InviteCampaignKey;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminCapturedCampaignsArgs {
  days?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface QueryAdminCapturedConversationsArgs {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  days?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminCapturedThreadArgs {
  days?: InputMaybe<Scalars["Int"]["input"]>;
  memberId: Scalars["String"]["input"];
}

export interface QueryAdminEventInsightArgs {
  eventId: Scalars["String"]["input"];
}

export interface QueryAdminEventMemberMatchesArgs {
  eventId: Scalars["String"]["input"];
  limit?: Scalars["Int"]["input"];
  minEnglish?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminEventTimezoneSupplyArgs {
  days?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface QueryAdminEventsCalendarArgs {
  weekStart: Scalars["String"]["input"];
}

export interface QueryAdminEventsForMemberArgs {
  days?: Scalars["Int"]["input"];
  email: Scalars["String"]["input"];
  limit?: Scalars["Int"]["input"];
}

export interface QueryAdminGetArticleArgs {
  articleID: Scalars["String"]["input"];
}

export interface QueryAdminGetBannerArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetCoverArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetIllustrationArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetLessonArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetPlanDetailsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminGetSelectedUsersArgs {
  filters: AdminFilterUsersInput;
}

export interface QueryAdminGetSlideArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetThemeArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetTopicByLessonIdArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetUserFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetVideoSetArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetZineCoverArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGuestPassSummaryArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminGuestPassTokenAdjustmentsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminInviteCampaignArgs {
  campaign: InviteCampaignKey;
}

export interface QueryAdminListPaginatedArticlesArgs {
  filters: FilterArticlesInput;
  order: OrderArticlesInput;
}

export interface QueryAdminListPaginatedBannersArgs {
  filters: AdminFilterBannersInput;
}

export interface QueryAdminListPaginatedCoversArgs {
  filters: AdminFilterCoversInput;
}

export interface QueryAdminListPaginatedCustomNotificationDisplayArgs {
  filters: FilterCustomNotificationDisplayInput;
}

export interface QueryAdminListPaginatedFeatureFlagsArgs {
  filters: AdminFilterFeatureFlagsInput;
}

export interface QueryAdminListPaginatedIllustrationsArgs {
  filters: AdminFilterIllustrationsInput;
}

export interface QueryAdminListPaginatedReportsUsersArgs {
  filters: AdminFilterReportsUserFilterInput;
}

export interface QueryAdminListPaginatedThemesArgs {
  filters: AdminFilterThemesInput;
}

export interface QueryAdminListPaginatedTopicsArgs {
  filters: AdminFilterTopicsInput;
}

export interface QueryAdminListPaginatedVideoSetsArgs {
  filters: AdminFilterVideoSetInput;
}

export interface QueryAdminListPaginatedZineCoversArgs {
  filters: AdminFilterZineCoversInput;
}

export interface QueryAdminListUsersArgs {
  filters: AdminFilterUsersInput;
}

export interface QueryAdminMemberEventsReviewArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminMemberExperienceArgs {
  attendedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  joinedAt?: InputMaybe<Scalars["Date"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  planSlug?: InputMaybe<Scalars["String"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminMemberStatsArgs {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface QueryAdminNewMembersArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminOnlineNowMembersArgs {
  faderLevels: Array<FaderLevel>;
}

export interface QueryAdminOutreachBySourceArgs {
  from?: InputMaybe<Scalars["Date"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminOutreachResultMembersArgs {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  source?: InputMaybe<OutreachSource>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminOutreachResultsArgs {
  breakdown?: InputMaybe<OutreachBreakdown>;
  bucket?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  source?: InputMaybe<OutreachSource>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminRecentOutreachArgs {
  types?: InputMaybe<Array<OutreachType>>;
  userIds: Array<Scalars["String"]["input"]>;
  withinDays?: Scalars["Int"]["input"];
}

export interface QueryAdminReferralRewardsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminRetentionAttendanceDetailArgs {
  month: Scalars["String"]["input"];
}

export interface QueryAdminRetentionComebackArgs {
  month: Scalars["String"]["input"];
}

export interface QueryAdminRetentionPrepareArgs {
  fader?: Scalars["String"]["input"];
  returningEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryAdminScheduledCancellationsArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminSearchEventsArgs {
  filters: AdminFilterEventsInput;
}

export interface QueryAdminSecurityEventsArgs {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  userId: Scalars["String"]["input"];
}

export interface QueryAdminShareEventPreviewArgs {
  emails: Array<Scalars["String"]["input"]>;
  eventId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminTimezoneRegionMembersArgs {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset: Scalars["Float"]["input"];
}

export interface QueryAdminTrialCancellationsArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminUserSignUpAnswersArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminZonePerformanceArgs {
  quarter?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminZonePerformanceEventsArgs {
  eventType?: InputMaybe<Scalars["String"]["input"]>;
  period: Scalars["String"]["input"];
  quarter?: InputMaybe<Scalars["String"]["input"]>;
  zone: Scalars["String"]["input"];
}

export interface QueryArticlesWrittenArgs {
  input: StatisticsInput;
}

export interface QueryAttendanceMetricsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAttendanceRatioArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAttendanceRecordArgs {
  input: StatisticsInput;
}

export interface QueryAttendedEventsArgs {
  input: StatisticsInput;
}

export interface QueryChatAutomationsMatchMembersArgs {
  input: MatchMembersInput;
}

export interface QueryChatAutomationsSendProgressArgs {
  sendId: Scalars["String"]["input"];
}

export interface QueryCommunityDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryDailyEventsArgs {
  input: StatisticsInput;
}

export interface QueryFriendlyFacesArgs {
  input: StatisticsInput;
}

export interface QueryGetArticleArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetAssessmentResultByIdArgs {
  assessmentResultId: Scalars["String"]["input"];
}

export interface QueryGetAvalibilityMatchForUsersArgs {
  input: AvailabilityForUsersInput;
}

export interface QueryGetChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
}

export interface QueryGetChannelInvitesForUsersArgs {
  input: ChatInvitesForUsersInput;
}

export interface QueryGetChannelVideoCallArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetCommentArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetCustomNotificationDisplayArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventAdminArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventForConnectArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventForMeetingArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventWithCacheArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetInvitedFriendsStatsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryGetLiveTableByIdArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetParticipationStatusArgs {
  input: ParticipationStatusInput;
}

export interface QueryGetPendingChannelInvitesArgs {
  channelCid: Scalars["String"]["input"];
}

export interface QueryGetPreviousAssessmentScoreArgs {
  assessmentDate: Scalars["Date"]["input"];
}

export interface QueryGetThemeArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserAdminArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserAssessmentResultsArgs {
  filters: PaginatedAssessmentResultInput;
  userId: Scalars["String"]["input"];
}

export interface QueryGetUserCalendarArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryGetUserConnectionStreakArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryGetUserInfoArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserMatchingInfoArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserSignUpArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUsersWithSameSpeakingLevelArgs {
  speakingLevel: SpeakingLevelCategories;
}

export interface QueryGetVideoCallArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGlobalNetworkArgs {
  input: StatisticsInput;
}

export interface QueryGuestPassBookingEventsArgs {
  englishLevel: EnglishLevel;
  timezone: Scalars["String"]["input"];
}

export interface QueryHostedEventsArgs {
  input: StatisticsInput;
}

export interface QueryItemPriceArgs {
  itemPriceId: Scalars["String"]["input"];
}

export interface QueryLadiesAttendedArgs {
  input: StatisticsInput;
}

export interface QueryListArticlesArgs {
  filters: FilterArticlesInput;
}

export interface QueryListAttachmentArgs {
  eventID: Scalars["String"]["input"];
}

export interface QueryListMatchedUsersArgs {
  filters: FilterUsersInput;
}

export interface QueryListNotificationsForUserArgs {
  cursor: NotificationCursorPaginatedInput;
  unreadOnly: Scalars["Boolean"]["input"];
}

export interface QueryListPaginatedAssessmentResultsArgs {
  filters: PaginatedAssessmentResultInput;
}

export interface QueryListPaginatedEventsArgs {
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}

export interface QueryListPendingChatInvitesArgs {
  filters: FilterChatInvitesInput;
}

export interface QueryListThemesArgs {
  filters: FilterThemesInput;
}

export interface QueryListTopicsArgs {
  filters: FilterTopicsInput;
}

export interface QueryListUserPhotosArgs {
  userID: Scalars["String"]["input"];
}

export interface QueryMonthlyRecapStepsArgs {
  input: StatisticsInput;
}

export interface QueryParticipationTimeArgs {
  input: StatisticsInput;
}

export interface QueryPausePreviewArgs {
  durationDays: Scalars["Int"]["input"];
}

export interface QueryRecentArticlesArgs {
  userId: Scalars["String"]["input"];
}

export interface QuerySearchMemberzineArgs {
  query: Scalars["String"]["input"];
}

export interface QuerySearchTopicsArgs {
  query: Scalars["String"]["input"];
}

export interface QuerySearchUsersArgs {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  permissions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  query: Scalars["String"]["input"];
}

export interface QueryTotalHostedParticipantsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryTotalPublishedArticlesArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryUserAttendedDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryUserDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryUserGaveSparkInEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface QueryUserHostedDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryUserHostedEventsArgs {
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}

export interface QuestionModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  liveTable?: Maybe<Array<LiveTableModel>>;
  question?: Maybe<Scalars["String"]["output"]>;
  topic?: Maybe<TopicModel>;
  type: QuestionType;
  updatedAt: Scalars["Date"]["output"];
}

export enum QuestionType {
  Icebreaker = "Icebreaker",
  Topic = "Topic",
}

export interface ReadArticleModel {
  article: ArticleModel;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface RecallResultType {
  deleted: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  remaining: Scalars["Int"]["output"];
}

export interface RecentOutreachModel {
  /** How many times contacted in the window. */
  count: Scalars["Int"]["output"];
  lastAt: Scalars["Date"]["output"];
  lastCampaign?: Maybe<Scalars["String"]["output"]>;
  lastType: OutreachType;
  userId: Scalars["String"]["output"];
}

export enum RecurrenceEndType {
  AfterOccurrences = "AFTER_OCCURRENCES",
  OnDate = "ON_DATE",
}

export interface RecurrenceInput {
  inviteToAllRecurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  recurrenceCount?: InputMaybe<Scalars["Int"]["input"]>;
  recurrenceDays?: InputMaybe<Array<WeekDay>>;
  recurrenceEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  recurrenceEndType?: InputMaybe<RecurrenceEndType>;
  recurrenceInterval?: InputMaybe<Scalars["Int"]["input"]>;
  recurrenceType?: InputMaybe<RecurrenceType>;
}

export enum RecurrenceType {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export enum RecurringEditScope {
  AllFuture = "ALL_FUTURE",
  ChooseSpecific = "CHOOSE_SPECIFIC",
  ThisAndFollowing = "THIS_AND_FOLLOWING",
  ThisOnly = "THIS_ONLY",
}

export interface ReferralRewardModel {
  activatedAt: Scalars["Date"]["output"];
  appliedAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  eligibleAt: Scalars["Date"]["output"];
  friendEmail?: Maybe<Scalars["String"]["output"]>;
  friendId: Scalars["String"]["output"];
  friendName?: Maybe<Scalars["String"]["output"]>;
  friendSubscriptionId: Scalars["String"]["output"];
  fulfilledBy?: Maybe<Scalars["String"]["output"]>;
  fulfillmentNote?: Maybe<Scalars["String"]["output"]>;
  heldReason?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  invoiceId: Scalars["String"]["output"];
  issue?: Maybe<Scalars["String"]["output"]>;
  milestones: Array<Scalars["String"]["output"]>;
  milestonesFulfilledAt?: Maybe<Scalars["Date"]["output"]>;
  milestonesFulfilledBy?: Maybe<Scalars["String"]["output"]>;
  milestonesFulfillmentNote?: Maybe<Scalars["String"]["output"]>;
  originalBillingAt?: Maybe<Scalars["Date"]["output"]>;
  referralId: Scalars["String"]["output"];
  referrerId: Scalars["String"]["output"];
  reviewNote?: Maybe<Scalars["String"]["output"]>;
  reviewedAt?: Maybe<Scalars["Date"]["output"]>;
  reviewedBy?: Maybe<Scalars["String"]["output"]>;
  rewardSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  targetBillingAt?: Maybe<Scalars["Date"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export enum RefundReasons {
  Assistance = "ASSISTANCE",
  Custom = "CUSTOM",
  HelpFindingEvents = "HELP_FINDING_EVENTS",
  HelpFindingPeople = "HELP_FINDING_PEOPLE",
  NeedMoreTime = "NEED_MORE_TIME",
  SomethingElse = "SOMETHING_ELSE",
}

export interface ReportAbuseInput {
  abuserID: Scalars["String"]["input"];
  articleId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  reason: UserReportReason;
}

export interface RequestPasswordInput {
  email: Scalars["String"]["input"];
}

export interface RequestRefundInput {
  customReason?: InputMaybe<Scalars["String"]["input"]>;
  reason: Array<RefundReasons>;
}

export interface ResendConfirmationEmailInput {
  email: Scalars["String"]["input"];
}

export interface ResetPasswordInput {
  newPassword: Scalars["String"]["input"];
  resetToken: Scalars["String"]["input"];
}

export interface ResponsiveInput {
  desktop?: InputMaybe<Scalars["String"]["input"]>;
  mobile?: InputMaybe<Scalars["String"]["input"]>;
}

export interface ResponsiveType {
  desktop?: Maybe<Scalars["String"]["output"]>;
  mobile?: Maybe<Scalars["String"]["output"]>;
}

export interface RetentionAttendanceRowModel {
  attended?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  event: Scalars["String"]["output"];
  hostBadge?: Maybe<Scalars["String"]["output"]>;
  hostName?: Maybe<Scalars["String"]["output"]>;
  kind?: Maybe<Scalars["String"]["output"]>;
  member: Scalars["String"]["output"];
}

export interface RetentionComebackModel {
  /** Attended a call after outreach. */
  cameBack: Scalars["Int"]["output"];
  /** Cancelled their membership. */
  cancelled: Scalars["Int"]["output"];
  /** Logged in after outreach but no call yet. */
  interested: Scalars["Int"]["output"];
  /** The month reported (includes the previous month too). */
  month: Scalars["String"]["output"];
  rows: Array<RetentionComebackRowModel>;
  /** Members reached out to in the window. */
  total: Scalars["Int"]["output"];
}

export interface RetentionComebackRowModel {
  /** Did she attend an event since we reached out? */
  cameBack: Scalars["Boolean"]["output"];
  /** Has she cancelled her membership? */
  cancelled: Scalars["Boolean"]["output"];
  comebackDate?: Maybe<Scalars["String"]["output"]>;
  comebackEvent?: Maybe<Scalars["String"]["output"]>;
  comebackHost?: Maybe<Scalars["String"]["output"]>;
  comebackHostBadge?: Maybe<Scalars["String"]["output"]>;
  comebackKind?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  /** Her risk level now. */
  currentFader?: Maybe<Scalars["String"]["output"]>;
  /** Which outreach cycles she got. */
  cycles: Scalars["String"]["output"];
  /** The dates we contacted her. */
  dates: Scalars["String"]["output"];
  daysToComeback?: Maybe<Scalars["Int"]["output"]>;
  email: Scalars["String"]["output"];
  /** Her risk level when first contacted. */
  entryFader?: Maybe<Scalars["String"]["output"]>;
  /** Detected or Critical. */
  entrySegment: Scalars["String"]["output"];
  firstOutreach?: Maybe<Scalars["String"]["output"]>;
  joinDate?: Maybe<Scalars["String"]["output"]>;
  lastAttendanceNow?: Maybe<Scalars["String"]["output"]>;
  lastAttendanceThen?: Maybe<Scalars["String"]["output"]>;
  lastLoginNow?: Maybe<Scalars["String"]["output"]>;
  lastLoginThen?: Maybe<Scalars["String"]["output"]>;
  /** Did she log in since we reached out? */
  loggedInSince: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  outreachCount: Scalars["Int"]["output"];
  plan?: Maybe<Scalars["String"]["output"]>;
  subscriptionStatus?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface RetentionCycle1Model {
  count: Scalars["Int"]["output"];
  groups: Array<RetentionGroupModel>;
  matchTiers: RetentionMatchTiersModel;
  unmatched: Array<RetentionUnmatchedModel>;
}

export interface RetentionCycle2MemberModel {
  email: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Why she's routed here (e.g. 'Cycle 2 — C1 was 6d ago'). */
  route: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface RetentionCycle2Model {
  count: Scalars["Int"]["output"];
  members: Array<RetentionCycle2MemberModel>;
}

export interface RetentionGroupModel {
  /** Members in this per-zone bulk-invite group. */
  emails: Array<Scalars["String"]["output"]>;
  eventId: Scalars["String"]["output"];
  eventTitle: Scalars["String"]["output"];
  startDate?: Maybe<Scalars["Date"]["output"]>;
  userIds: Array<Scalars["String"]["output"]>;
  zone?: Maybe<ZoneLabel>;
}

export interface RetentionMatchTiersModel {
  coach: Scalars["Int"]["output"];
  cxt: Scalars["Int"]["output"];
  featured: Scalars["Int"]["output"];
  /** Cycle 1 members with no matchable event (need one chosen). */
  none: Scalars["Int"]["output"];
}

export interface RetentionPrepareModel {
  /** The cap that was applied. */
  cap: Scalars["Int"]["output"];
  cycle1: RetentionCycle1Model;
  cycle2: RetentionCycle2Model;
  /** Critical only: members excluded as 'Gone' (no login in ~30 days). */
  excluded?: Maybe<Scalars["Int"]["output"]>;
  /** Detected / Dormant. */
  fader: Scalars["String"]["output"];
  /** Whether any outreach history was found (else all first-time). */
  historyKnown: Scalars["Boolean"]["output"];
  /** Total members at this fader level. */
  total: Scalars["Int"]["output"];
  /** True when more members matched than the cap allowed through. */
  truncated: Scalars["Boolean"]["output"];
  /** Contacted too recently — left for later. */
  waiting: Scalars["Int"]["output"];
}

export interface RetentionUnmatchedModel {
  email: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  route: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface SaveDraftArticleInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  myEnglishJourney?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledFor?: InputMaybe<Scalars["Date"]["input"]>;
  tags?: InputMaybe<Array<Interest>>;
  theme?: InputMaybe<ArticleThemes>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface SearchMatch {
  indices: Array<Array<Scalars["Int"]["output"]>>;
  key?: Maybe<Scalars["String"]["output"]>;
  score?: Maybe<Scalars["Float"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
}

export interface SectionModel {
  createdAt: Scalars["Date"]["output"];
  elements?: Maybe<Array<Element>>;
  id: Scalars["String"]["output"];
  lesson: LessonModel;
  order?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

/** Security-relevant event on an account (audit trail). */
export interface SecurityEventModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  ipAddress?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  type: SecurityEventType;
  user?: Maybe<UserModel>;
  userAgent?: Maybe<Scalars["String"]["output"]>;
}

export enum SecurityEventType {
  BannedLoginBlocked = "BANNED_LOGIN_BLOCKED",
  CsrfRejected = "CSRF_REJECTED",
  ImpersonationStarted = "IMPERSONATION_STARTED",
  LogoutAll = "LOGOUT_ALL",
  PasswordChanged = "PASSWORD_CHANGED",
  PasswordReset = "PASSWORD_RESET",
  RefreshWithRevokedToken = "REFRESH_WITH_REVOKED_TOKEN",
  SessionsRevokedAll = "SESSIONS_REVOKED_ALL",
  SessionForceRevoked = "SESSION_FORCE_REVOKED",
  TotpRemoved = "TOTP_REMOVED",
}

export interface SendBulkMessagesInput {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  emails: Array<Scalars["String"]["input"]>;
  message: Scalars["String"]["input"];
  skipContactedWithinDays?: InputMaybe<Scalars["Int"]["input"]>;
  source?: InputMaybe<OutreachSource>;
}

export interface SendDirectChatMessageInput {
  receiverId: Scalars["String"]["input"];
  text: Scalars["String"]["input"];
}

export interface SendPersonalMessagesInput {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  recipients: Array<PersonalMessageInput>;
  skipContactedWithinDays?: InputMaybe<Scalars["Int"]["input"]>;
  source?: InputMaybe<OutreachSource>;
}

export interface SentBatchType {
  batchId: Scalars["String"]["output"];
  campaign?: Maybe<Scalars["String"]["output"]>;
  memberCount: Scalars["Int"]["output"];
  messagePreview?: Maybe<Scalars["String"]["output"]>;
  recallableCount: Scalars["Int"]["output"];
  recalledAt?: Maybe<Scalars["Date"]["output"]>;
  sentAt: Scalars["Date"]["output"];
}

export interface SessionInfo {
  browser: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  /** Is this the calling device's session */
  current: Scalars["Boolean"]["output"];
  /** Hardware class: Desktop / Mobile / Tablet */
  device: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  ip: Scalars["String"]["output"];
  lastSeenAt: Scalars["Date"]["output"];
  /** How the session was established */
  method: Scalars["String"]["output"];
  os: Scalars["String"]["output"];
}

export interface SetPictureInput {
  channelId: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface ShareEventPreviewModel {
  /** Members you've already shared this event with. */
  alreadySharedCount?: Maybe<Scalars["Int"]["output"]>;
  /** Members who would receive the share. Null until an event is given. */
  eligibleCount?: Maybe<Scalars["Int"]["output"]>;
  /** Matched members who are inactive. */
  inactiveCount?: Maybe<Scalars["Int"]["output"]>;
  /** Emails that resolved to a member. */
  matchedCount: Scalars["Int"]["output"];
  /** Members who matched but aren't allowed in this event (wrong plan / tier). */
  notAllowedEmails?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Emails that matched no member. */
  notFound: Array<Scalars["String"]["output"]>;
  /** Distinct emails pasted. */
  totalPasted: Scalars["Int"]["output"];
}

export interface ShareEventResultModel {
  /** Emails that matched no member. */
  notFound: Array<Scalars["String"]["output"]>;
  /** Members the event was shared with. */
  sharedCount: Scalars["Int"]["output"];
}

export interface SimulatedMemberModel {
  /** Whether the advanced events are unlocked for her. */
  advancedUnlocked: Scalars["Boolean"]["output"];
  /** Events attended — the number the 3-event lock reads. */
  attendedEvents: Scalars["Int"]["output"];
  email: Scalars["String"]["output"];
  /** Whether this is a real member or a described profile. */
  isReal: Scalars["Boolean"]["output"];
  /** Staff can attend everything, so the simulation is trivially all-open. */
  isStaff: Scalars["Boolean"]["output"];
  isVerified: Scalars["Boolean"]["output"];
  /** Members who joined before 9 Oct 2025 are never locked. */
  joinedAt?: Maybe<Scalars["Date"]["output"]>;
  /** Her member kind — tenure, not events attended. */
  kind?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  planSlug?: Maybe<Scalars["String"]["output"]>;
  /** The subscription tier the coach rules read. */
  subscriptionTier: Scalars["String"]["output"];
  /** Empty when the simulation describes a member rather than naming one. */
  userId: Scalars["String"]["output"];
}

export interface SliderModel {
  background?: Maybe<ResponsiveType>;
  banner: BannerModel;
  buttonText?: Maybe<Scalars["String"]["output"]>;
  buttonURL?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  featureImage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imageAlignment?: Maybe<ImageAlignment>;
  position?: Maybe<Scalars["Int"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  textColour?: Maybe<TextColour>;
  title?: Maybe<Scalars["String"]["output"]>;
  titleStyle?: Maybe<TitleStyle>;
  updatedAt: Scalars["Date"]["output"];
}

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export interface SparkModel {
  createdAt: Scalars["Date"]["output"];
  event?: Maybe<EventModel>;
  id: Scalars["String"]["output"];
  liveTable?: Maybe<LiveTableModel>;
  user: UserModel;
  videoCall?: Maybe<VideoCallModel>;
}

export enum SpeakingLevelCategories {
  AdvancedHigh = "AdvancedHigh",
  AdvancedLow = "AdvancedLow",
  AdvancedMid = "AdvancedMid",
  Dependent = "Dependent",
  IntermediateHigh = "IntermediateHigh",
  IntermediateLow = "IntermediateLow",
  IntermediateMid = "IntermediateMid",
  Proficient = "Proficient",
}

export interface StatisticsInput {
  end: Scalars["Date"]["input"];
  start: Scalars["Date"]["input"];
  userId: Scalars["String"]["input"];
}

export interface SubscribeInput {
  charges?: InputMaybe<Array<Scalars["String"]["input"]>>;
  couponIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  planId?: InputMaybe<Scalars["String"]["input"]>;
  redirectPage?: InputMaybe<Scalars["String"]["input"]>;
  referredById?: InputMaybe<Scalars["String"]["input"]>;
  signUpId?: InputMaybe<Scalars["String"]["input"]>;
  toltReferralId?: InputMaybe<Scalars["String"]["input"]>;
  trial?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface Subscription {
  assessmentChargesAreSavedForUser: Scalars["String"]["output"];
  assessmentResultsAreSaved: AssessmentResultModel;
  channelVideoCall: VideoCallModel;
  commentCreated: CommentModel;
  commentDeleted: CommentModel;
  communitySparkCreated: SparkModel;
  dunningStatusUpdated: DunningStatusUpdatedResponse;
  eventUpdated: EventUpdatedResponse;
  guestPassUpdated: GuestPassSummary;
  liveTableAboutToEnd: LiveTableModel;
  liveTableChanged: LiveTableModel;
  liveTableHasEnded: LiveTableModel;
  liveTableHasStarted: LiveTableStartedMessage;
  liveTableUpdated: LiveTableModel;
  notificationAdded: NotificationBaseModel;
  popupNotificationAdded: NotificationBaseModel;
  reactionCreated: CommentReactionsModel;
  reactionDeleted: CommentReactionsModel;
  sparkCreated: SparkModel;
  streakEventAttended: UserStreak;
  userPermissionsUpdated: UserPermissionsUpdatedResponse;
  userStatisticsUpdated: UserStatisticsUpdatedResponse;
  videoAskFormCreated: VideoAskModel;
  videoCallUpdated: VideoCallModel;
}

export interface SubscriptionAssessmentChargesAreSavedForUserArgs {
  userId: Scalars["String"]["input"];
}

export interface SubscriptionAssessmentResultsAreSavedArgs {
  assessmentId: Scalars["String"]["input"];
}

export interface SubscriptionChannelVideoCallArgs {
  id: Scalars["String"]["input"];
}

export interface SubscriptionCommentCreatedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionCommentDeletedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionEventUpdatedArgs {
  eventId: Scalars["String"]["input"];
}

export interface SubscriptionLiveTableAboutToEndArgs {
  liveTableId: Scalars["String"]["input"];
}

export interface SubscriptionLiveTableHasEndedArgs {
  liveTableId: Scalars["String"]["input"];
}

export interface SubscriptionLiveTableUpdatedArgs {
  liveTableId: Scalars["String"]["input"];
}

export interface SubscriptionReactionCreatedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionReactionDeletedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionSparkCreatedArgs {
  eventId: Scalars["String"]["input"];
}

export interface SubscriptionVideoCallUpdatedArgs {
  id: Scalars["String"]["input"];
}

export enum SubscriptionStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Future = "FUTURE",
  Incomplete = "INCOMPLETE",
  IncompleteExpired = "INCOMPLETE_EXPIRED",
  InTrial = "IN_TRIAL",
  NonRenewing = "NON_RENEWING",
  PastDue = "PAST_DUE",
  Paused = "PAUSED",
  Unpaid = "UNPAID",
}

export enum SubscriptionTier {
  Free = "Free",
  Pause = "Pause",
  Social = "Social",
  Study = "Study",
  Supporter = "Supporter",
}

/** How long someone has been a member. */
export enum TenureBucket {
  OneTo_3Months = "ONE_TO_3_MONTHS",
  Over_12Months = "OVER_12_MONTHS",
  SixTo_12Months = "SIX_TO_12_MONTHS",
  ThreeTo_6Months = "THREE_TO_6_MONTHS",
  UpTo_1Month = "UP_TO_1_MONTH",
}

export enum TextColour {
  Dark = "Dark",
  Light = "Light",
}

export interface ThemeModel {
  cover?: Maybe<CoverModel>;
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isCurrent?: Maybe<Scalars["Boolean"]["output"]>;
  isGrammarLibrary?: Maybe<Scalars["Boolean"]["output"]>;
  isResource?: Maybe<Scalars["Boolean"]["output"]>;
  isStandard?: Maybe<Scalars["Boolean"]["output"]>;
  isTopicLibrary?: Maybe<Scalars["Boolean"]["output"]>;
  title: Scalars["String"]["output"];
  topics?: Maybe<Array<TopicModel>>;
  updatedAt: Scalars["Date"]["output"];
}

export enum TimeLimit {
  TenMinutes = "TEN_MINUTES",
  ThirtyMinutes = "THIRTY_MINUTES",
  TwentyMinutes = "TWENTY_MINUTES",
  Unlimited = "UNLIMITED",
}

export interface TimezoneRegionMembersModel {
  label: Scalars["String"]["output"];
  members: Array<TzMemberModel>;
  offset: Scalars["Float"]["output"];
  /** Whether the list was capped. */
  truncated: Scalars["Boolean"]["output"];
}

export enum TitleStyle {
  Bold = "Bold",
  Standard = "Standard",
}

export interface TopicInPreviewInput {
  lessonKind?: InputMaybe<Scalars["Int"]["input"]>;
  lessonTitle?: InputMaybe<Scalars["String"]["input"]>;
  sectionsData?: InputMaybe<Array<EditSectionInput>>;
  topicId: Scalars["String"]["input"];
}

export interface TopicModel {
  comments?: Maybe<Array<CommentModel>>;
  createdAt: Scalars["Date"]["output"];
  duplicateOf?: Maybe<Scalars["String"]["output"]>;
  events?: Maybe<Array<EventModel>>;
  id: Scalars["String"]["output"];
  ideasToDiscuss: Array<Scalars["String"]["output"]>;
  illustration?: Maybe<IllustrationModel>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  isPreviewMode?: Maybe<Scalars["Boolean"]["output"]>;
  lessons?: Maybe<Array<LessonModel>>;
  likes?: Maybe<Array<LikeModel>>;
  questions?: Maybe<Array<QuestionModel>>;
  stars?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<TopicStatus>;
  theme?: Maybe<ThemeModel>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface TopicSearchResult {
  item: TopicModel;
  matches?: Maybe<Array<SearchMatch>>;
  refIndex: Scalars["Int"]["output"];
}

export enum TopicStatus {
  ComingSoon = "COMING_SOON",
  Current = "CURRENT",
  Inactive = "INACTIVE",
}

export interface TzEventModel {
  /** Deep link to the event in the member app. */
  appLink: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  host?: Maybe<Scalars["String"]["output"]>;
  /** coach | big_sister | cxt | member. */
  hostType: Scalars["String"]["output"];
  /** Start as epoch milliseconds. */
  startMs: Scalars["Float"]["output"];
  title: Scalars["String"]["output"];
  /** Minutes-of-day it starts, in UTC (0–1439). */
  utcMin: Scalars["Int"]["output"];
  /** Start formatted in UTC. */
  whenUtc: Scalars["String"]["output"];
}

export interface TzMemberModel {
  country: Scalars["String"]["output"];
  /** English level band, or '—'. */
  level: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  timezone?: Maybe<Scalars["String"]["output"]>;
}

export interface TzRegionModel {
  /** Row label, e.g. 'Europe · UTC+1 · London, Paris'. */
  label: Scalars["String"]["output"];
  /** Current members at this offset. */
  members: Scalars["Int"]["output"];
  /** Live UTC offset in hours, e.g. -5, 1, 5.5. */
  offset: Scalars["Float"]["output"];
  /** Dominant world region, e.g. 'Europe', or 'Other'. */
  region: Scalars["String"]["output"];
}

export interface UpdateEventAttachmentInput {
  description: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface UpdateEventInput {
  conversationKind?: InputMaybe<ConversationKind>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  customTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  editScope?: InputMaybe<RecurringEditScope>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevel>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  eventCategory?: InputMaybe<EventCategory>;
  format?: InputMaybe<Format>;
  hostID?: InputMaybe<Scalars["String"]["input"]>;
  ideasToDiscuss?: InputMaybe<Array<Scalars["String"]["input"]>>;
  illustrationUrl?: InputMaybe<Scalars["String"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isCoachEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isForUnverified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isLargeCall?: InputMaybe<Scalars["Boolean"]["input"]>;
  isProfessional?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventKind>;
  links?: InputMaybe<Array<LinkInput>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  locationLat?: InputMaybe<Scalars["Float"]["input"]>;
  locationLong?: InputMaybe<Scalars["Float"]["input"]>;
  maxParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  occupationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  permissions?: InputMaybe<Array<EventPermissions>>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  savedDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  selectedEventIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateGuestPassBookingInput {
  firstEventBookingSkipped: Scalars["Boolean"]["input"];
  selectedFirstEventId?: InputMaybe<Scalars["String"]["input"]>;
  selectedFirstEventTime?: InputMaybe<Scalars["Date"]["input"]>;
  selectedTimezone?: InputMaybe<Scalars["String"]["input"]>;
  signUpId: Scalars["String"]["input"];
}

export interface UpdateLiveTableInput {
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevelNamed>;
  questionId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdatePasswordInput {
  currentPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
}

export interface UpdatePhotoInput {
  url: Scalars["String"]["input"];
}

export interface UpdateSettingsInput {
  emailNotifications?: InputMaybe<EmailNotifications>;
  receiveChannelInviteEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChannelInviteNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChannelInviteWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatMentionsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatMentionsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatMentionsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatThreadEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatThreadNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatThreadWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRemindersEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRemindersNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRemindersWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRsvpEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRsvpNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRsvpWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventUpdatesAndInvitationsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventUpdatesAndInvitationsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventUpdatesAndInvitationsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFollowsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFollowsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFollowsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveGroupMessagesWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveLiveTableStartedNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveLiveTableStartedWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveMentionsAndCommentsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveMentionsAndCommentsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveMentionsAndCommentsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receivePersonalMessagesWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receivePlatformStatusEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receivePublicChannelsMessagesWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveSubscriptionChangesEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UpdateUserChannelPermissionInput {
  channelId: Scalars["String"]["input"];
  channelType: ChatChannelType;
  permission: UserChannelPermission;
  userId: Scalars["String"]["input"];
}

export interface UpdateUserInput {
  availability?: InputMaybe<Array<AvailabilityInput>>;
  avatarUrl?: InputMaybe<Scalars["String"]["input"]>;
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  cambridgeEnglishLevel?: InputMaybe<EnglishLevel>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  cityId?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  countryId?: InputMaybe<Scalars["String"]["input"]>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isAgeVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastOnlineAt?: InputMaybe<Scalars["Date"]["input"]>;
  lat?: InputMaybe<Scalars["Float"]["input"]>;
  long?: InputMaybe<Scalars["Float"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<Scalars["String"]["input"]>;
  needSpeakingPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  occupationId?: InputMaybe<Scalars["String"]["input"]>;
  otherLanguage?: InputMaybe<Scalars["String"]["input"]>;
  showBirthday?: InputMaybe<Scalars["Boolean"]["input"]>;
  showBirthdayYear?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  story?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  wantsNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UploadActiveDaysInput {
  file: Scalars["Upload"]["input"];
}

export interface UploadCoverZineInput {
  file: Scalars["Upload"]["input"];
  zineId: Scalars["String"]["input"];
}

export interface UploadEventImageInput {
  file: Scalars["Upload"]["input"];
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UploadImageArticleInput {
  articleId: Scalars["String"]["input"];
  cropHeight?: InputMaybe<Scalars["Int"]["input"]>;
  cropWidth?: InputMaybe<Scalars["Int"]["input"]>;
  file: Scalars["Upload"]["input"];
  height?: InputMaybe<Scalars["Int"]["input"]>;
  left?: InputMaybe<Scalars["Int"]["input"]>;
  top?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UploadPhotoInput {
  filename: Scalars["String"]["input"];
}

export interface UploadPictureInput {
  channelId: Scalars["String"]["input"];
  channelType?: InputMaybe<ChatChannelType>;
  filename: Scalars["String"]["input"];
}

export interface UploadUrlsType {
  contentURL?: Maybe<Scalars["String"]["output"]>;
  uploadURL?: Maybe<Scalars["String"]["output"]>;
}

export enum UserBadge {
  BigSister = "BIG_SISTER",
  CommunitySuccess = "COMMUNITY_SUCCESS",
  EnglishCoach = "ENGLISH_COACH",
  Founder = "FOUNDER",
  Guest = "GUEST",
  InactiveMember = "INACTIVE_MEMBER",
  LittleSister = "LITTLE_SISTER",
  Member = "MEMBER",
  MemberSupport = "MEMBER_SUPPORT",
  TechnicalSupport = "TECHNICAL_SUPPORT",
}

export interface UserBadgeModel {
  achievedDate?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isSilent?: Maybe<Scalars["Boolean"]["output"]>;
  type: UserBadgeType;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export enum UserBadgeType {
  Ambassador = "Ambassador",
  ArticlesPublished_1 = "ArticlesPublished_1",
  BigSister = "BigSister",
  BroughtAFriend = "BroughtAFriend",
  CertifiedHost = "CertifiedHost",
  DiamondAmbassador = "DiamondAmbassador",
  EventsParticipated_10 = "EventsParticipated_10",
  EventsParticipated_50 = "EventsParticipated_50",
  EventsParticipated_100 = "EventsParticipated_100",
  EventsParticipated_500 = "EventsParticipated_500",
  EventsParticipated_1000 = "EventsParticipated_1000",
  FoundingMember = "FoundingMember",
  HeyLadyWay = "HeyLadyWay",
  Hosted_1 = "Hosted_1",
  Hosted_10 = "Hosted_10",
  Hosted_50 = "Hosted_50",
  Hosted_100 = "Hosted_100",
  Hosted_500 = "Hosted_500",
  LegendaryLady = "LegendaryLady",
  LocalHosted_1 = "LocalHosted_1",
  LocalHosted_3 = "LocalHosted_3",
  LocalHosted_10 = "LocalHosted_10",
  LocalHosted_25 = "LocalHosted_25",
  Membership_1 = "Membership_1",
  Membership_2 = "Membership_2",
  Membership_3 = "Membership_3",
  Membership_4 = "Membership_4",
  NmmEventAttended = "NMMEventAttended",
  PerfectProfile = "PerfectProfile",
  PlatinumAmbassador = "PlatinumAmbassador",
  ScheduledConversations_1 = "ScheduledConversations_1",
  Verified = "Verified",
}

export enum UserChannelPermission {
  Member = "Member",
  Moderator = "Moderator",
}

export enum UserDeactivationReason {
  Custom = "CUSTOM",
  HardToUse = "HARD_TO_USE",
  NoSpeakingPartner = "NO_SPEAKING_PARTNER",
  NoTimeForEnglishPractice = "NO_TIME_FOR_ENGLISH_PRACTICE",
  ToExpensive = "TO_EXPENSIVE",
  TutorOrLanguageCourse = "TUTOR_OR_LANGUAGE_COURSE",
}

export interface UserEngagementMetrics {
  attendanceRatio?: Maybe<Scalars["Float"]["output"]>;
  totalRsvps?: Maybe<Scalars["Int"]["output"]>;
}

export interface UserEventStatisticsModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  totalAttendedScheduledEvents: Scalars["Int"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export interface UserFlagModel {
  featureFlag: FeatureFlagModel;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export interface UserInviteStatus {
  inviteStatus: InviteStatus;
  userId: Scalars["String"]["input"];
  withCohostedEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  withHostedEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UserLocation {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  countryId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UserMatchingModel {
  defaultMatchScore?: Maybe<Scalars["Float"]["output"]>;
  matchDetails?: Maybe<MatchDetails>;
  matchScores?: Maybe<MatchScores>;
  matchWeights?: Maybe<MatchScores>;
  score?: Maybe<Scalars["Float"]["output"]>;
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export interface UserModel {
  abusers?: Maybe<Array<AbuseModel>>;
  activationKey?: Maybe<Scalars["String"]["output"]>;
  actualResumeDate?: Maybe<Scalars["Date"]["output"]>;
  anonymisationStartedAt?: Maybe<Scalars["Date"]["output"]>;
  anonymisedAt?: Maybe<Scalars["Date"]["output"]>;
  availability?: Maybe<Array<Availability>>;
  availabilityFrom?: Maybe<Scalars["Int"]["output"]>;
  availabilityUntil?: Maybe<Scalars["Int"]["output"]>;
  availableAssessmentCharges?: Maybe<Scalars["Int"]["output"]>;
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  badge?: Maybe<UserBadge>;
  badges: Array<UserBadgeModel>;
  birthday?: Maybe<Scalars["Date"]["output"]>;
  cambridgeEnglishLevel?: Maybe<Scalars["Int"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  cityId?: Maybe<Scalars["String"]["output"]>;
  completedHomeTour?: Maybe<Scalars["Boolean"]["output"]>;
  completedPercentage: Scalars["Int"]["output"];
  country?: Maybe<Scalars["String"]["output"]>;
  countryId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  customFlags: Array<UserFlagModel>;
  customers: Array<ChargebeeCustomerModel>;
  deletedAt?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  engagementMetrics?: Maybe<UserEngagementMetrics>;
  englishSkills?: Maybe<Array<EnglishSkill>>;
  eventStatistics?: Maybe<UserEventStatisticsModel>;
  extraConversations?: Maybe<Scalars["Int"]["output"]>;
  extraHostedEvents?: Maybe<Scalars["Int"]["output"]>;
  extraInvitedFriends?: Maybe<Scalars["Int"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  followers?: Maybe<Array<FollowerModel>>;
  following?: Maybe<Array<FollowerModel>>;
  googleRefreshToken?: Maybe<Scalars["String"]["output"]>;
  hasActivePlan: Scalars["Boolean"]["output"];
  hasGoogleRefreshToken: Scalars["Boolean"]["output"];
  hasPassword: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  impersonated: Scalars["Boolean"]["output"];
  interests?: Maybe<Array<Interest>>;
  invites: Array<InviteModel>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isAgeVisible?: Maybe<Scalars["Boolean"]["output"]>;
  isBanned: Scalars["Boolean"]["output"];
  isComplete?: Maybe<Scalars["Boolean"]["output"]>;
  isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
  isHeyLady?: Maybe<Scalars["Boolean"]["output"]>;
  isOnline?: Maybe<Scalars["Boolean"]["output"]>;
  isVerified?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  kind?: Maybe<EventPermissions>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastOnlineAt?: Maybe<Scalars["Date"]["output"]>;
  lat?: Maybe<Scalars["Float"]["output"]>;
  long?: Maybe<Scalars["Float"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name: Scalars["String"]["output"];
  nationality?: Maybe<Scalars["String"]["output"]>;
  nativeLanguage?: Maybe<Scalars["String"]["output"]>;
  needSpeakingPartner?: Maybe<Scalars["Boolean"]["output"]>;
  notes: Array<NoteModel>;
  occupation?: Maybe<OccupationModel>;
  onboarding: Onboarding;
  otherLanguage?: Maybe<Scalars["String"]["output"]>;
  partners?: Maybe<Scalars["Int"]["output"]>;
  pauseDuration?: Maybe<Scalars["Int"]["output"]>;
  pauseEligibleFrom?: Maybe<Scalars["Date"]["output"]>;
  pauseRemainingDays?: Maybe<Scalars["Int"]["output"]>;
  pauseStartAt?: Maybe<Scalars["Date"]["output"]>;
  pauseUntil?: Maybe<Scalars["Date"]["output"]>;
  photos: Array<UserPhotoModel>;
  planSlug?: Maybe<Scalars["String"]["output"]>;
  promotionalCredits?: Maybe<Scalars["Int"]["output"]>;
  recoveryStartedAt?: Maybe<Scalars["Date"]["output"]>;
  seenCompletedAt?: Maybe<Scalars["Date"]["output"]>;
  showBirthday?: Maybe<Scalars["Boolean"]["output"]>;
  showBirthdayYear?: Maybe<Scalars["Boolean"]["output"]>;
  speakingLevel: SpeakingLevelCategories;
  speakingLevelScore: Scalars["Float"]["output"];
  speakingPartners?: Maybe<Scalars["String"]["output"]>;
  stepsCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  story?: Maybe<Scalars["String"]["output"]>;
  subscriptionTier: SubscriptionTier;
  takenSpeakingAssessment?: Maybe<Scalars["Boolean"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  updatedLocation?: Maybe<Scalars["Boolean"]["output"]>;
  userSettings?: Maybe<UserSettingsModel>;
  victims?: Maybe<Array<AbuseModel>>;
  wantsNewsletter?: Maybe<Scalars["Boolean"]["output"]>;
}

export interface UserPermissionsUpdatedResponse {
  badge: UserBadge;
  kind: EventPermissions;
  userId: Scalars["String"]["output"];
}

export interface UserPhotoModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
  user: UserModel;
}

export enum UserReportReason {
  MaleGenderOrFalseIdentityOrPreviouslyBanned = "MALE_GENDER_OR_FALSE_IDENTITY_OR_PREVIOUSLY_BANNED",
  OffensiveOrDisrespectful = "OFFENSIVE_OR_DISRESPECTFUL",
  Other = "OTHER",
  UnacceptableBehaviour = "UNACCEPTABLE_BEHAVIOUR",
}

export interface UserSearchResult {
  item: UserModel;
  matches?: Maybe<Array<SearchMatch>>;
  refIndex: Scalars["Int"]["output"];
}

export interface UserSettingsModel {
  createdAt: Scalars["Date"]["output"];
  emailNotifications?: Maybe<EmailNotifications>;
  id: Scalars["String"]["output"];
  receiveChannelInviteEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChannelInviteNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChannelInviteWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatMentionsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatMentionsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatMentionsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatThreadEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatThreadNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatThreadWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRemindersEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRemindersNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRemindersWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRsvpEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRsvpNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRsvpWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventUpdatesAndInvitationsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventUpdatesAndInvitationsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventUpdatesAndInvitationsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveFollowsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveFollowsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveFollowsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveGroupMessagesWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveLiveTableStartedNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveLiveTableStartedWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveMentionsAndCommentsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveMentionsAndCommentsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveMentionsAndCommentsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receivePersonalMessagesWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receivePlatformStatusEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receivePublicChannelsMessagesWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveSubscriptionChangesEmails?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface UserSignUpModel {
  createdAt: Scalars["Date"]["output"];
  detectedTimezone?: Maybe<Scalars["String"]["output"]>;
  eligibilityAgeGender?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  englishLevel?: Maybe<Scalars["Int"]["output"]>;
  firstEventBookingSkipped: Scalars["Boolean"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  guestPassEligible: Scalars["Boolean"]["output"];
  guestPassWeeklyPracticeReadiness?: Maybe<Scalars["String"]["output"]>;
  hasVerifiedEmail: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  mainSpeakingPracticeChallenge?: Maybe<Scalars["String"]["output"]>;
  mainSpokenEnglishPriority?: Maybe<Scalars["String"]["output"]>;
  planParam: Scalars["String"]["output"];
  requiresEmailVerification: Scalars["Boolean"]["output"];
  selectedFirstEventId?: Maybe<Scalars["String"]["output"]>;
  selectedFirstEventTime?: Maybe<Scalars["Date"]["output"]>;
  selectedTimezone?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  verificationResendAt?: Maybe<Scalars["Date"]["output"]>;
}

export interface UserStatisticsUpdatedResponse {
  eventStatistics: UserEventStatisticsModel;
  userId: Scalars["String"]["output"];
}

export interface UserStreak {
  connectionStreak: Scalars["Int"]["output"];
  connectionStreakBrokeLastWeek: Scalars["Boolean"]["output"];
  connectionStreakIncrementedThisWeek: Scalars["Boolean"]["output"];
  connectionWeekCompletedThisWeek: Scalars["Boolean"]["output"];
  eventsThisWeek: Scalars["Int"]["output"];
  goalCompletedThisWeek: Scalars["Boolean"]["output"];
  goalStreak: Scalars["Int"]["output"];
  goalStreakBrokeLastWeek: Scalars["Boolean"]["output"];
  nextWeeklyGoal: Scalars["Int"]["output"];
  powerUpCount: Scalars["Int"]["output"];
  powerUpProgress: Scalars["Int"]["output"];
  powerUpRevealed: Scalars["Boolean"]["output"];
  rechargeExplainerSeen: Scalars["Boolean"]["output"];
  streaksExplainerSeen: Scalars["Boolean"]["output"];
  weeklyGoal: Scalars["Int"]["output"];
}

export interface UserTotpModel {
  algorithm: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  deviceName?: Maybe<Scalars["String"]["output"]>;
  digits: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  period: Scalars["Int"]["output"];
  secret: Scalars["String"]["output"];
  uri?: Maybe<Scalars["String"]["output"]>;
  user: UserModel;
  verified: Scalars["Boolean"]["output"];
}

export interface UsersWithSameSpeakingLevel {
  randomUsersAvatars?: Maybe<Array<Scalars["String"]["output"]>>;
  total?: Maybe<Scalars["Int"]["output"]>;
}

export interface ValidateBulkInviteResponse {
  userIds: Array<Scalars["String"]["output"]>;
  warningMessages: Array<Scalars["String"]["output"]>;
}

export interface ValidateSelectionBulkInviteResponse {
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  userIds: Array<Scalars["String"]["output"]>;
  warningMessages: Array<Scalars["String"]["output"]>;
}

export interface VerifyUserInput {
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface VerifyWebpushSubscriptionInput {
  authKey: Scalars["String"]["input"];
  endpoint: Scalars["String"]["input"];
  p256hdKey: Scalars["String"]["input"];
}

export enum VerifyWebpushSubscriptionResult {
  AlreadyExists = "AlreadyExists",
  Invalid = "Invalid",
  Stored = "Stored",
}

export enum VideoAskFormType {
  Verification = "Verification",
}

export interface VideoAskModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  type: VideoAskFormType;
  user: UserModel;
}

export interface VideoCallModel {
  chatRoomId: Scalars["String"]["output"];
  closedDoorAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  dailyRoomId: Scalars["String"]["output"];
  endedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  organizer?: Maybe<UserModel>;
  participants: Array<VideoParticipantModel>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface VideoModel {
  completedByMe: Scalars["Boolean"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  position: Scalars["Int"]["output"];
  set: VideoSetModel;
  thumbnail?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  videoURL?: Maybe<Scalars["String"]["output"]>;
}

export interface VideoParticipantModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isHost: Scalars["Boolean"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
  videoCall: VideoCallModel;
  videoCallId: Scalars["String"]["output"];
}

export interface VideoSetModel {
  audience?: Maybe<Array<Audience>>;
  colour?: Maybe<ColourCode>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  position: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  videos?: Maybe<Array<VideoModel>>;
}

export enum WeekDay {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export interface ZineModel {
  coverUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isCurrent?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface ZoneCountModel {
  count: Scalars["Int"]["output"];
  zone: ZoneLabel;
}

/** A three-hour UTC colour zone. */
export enum ZoneLabel {
  Black = "BLACK",
  Blue = "BLUE",
  Green = "GREEN",
  Orange = "ORANGE",
  Pink = "PINK",
  Purple = "PURPLE",
  Red = "RED",
  Yellow = "YELLOW",
}

export interface ZonePerfEventModel {
  attended: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  host?: Maybe<Scalars["String"]["output"]>;
  rsvps: Scalars["Int"]["output"];
  /** attended / rsvps, as a percentage. */
  showRate: Scalars["Float"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  /** EventHostType key. */
  type: Scalars["String"]["output"];
  /** Display label for the type. */
  typeLabel: Scalars["String"]["output"];
  /** Start, formatted in UTC, e.g. 'Wed 12 Feb 19:30'. */
  whenUtc: Scalars["String"]["output"];
}

export interface ZonePerfModel {
  totals: ZoneTotalsModel;
  /** Event types in this zone, busiest first. */
  types: Array<ZoneTypePerfModel>;
  zone: ZoneLabel;
}

export interface ZonePerformanceEventsModel {
  count: Scalars["Int"]["output"];
  /** EventHostType key, or '' for the whole zone. */
  eventType: Scalars["String"]["output"];
  /** Display label for the type, when one is set. */
  eventTypeLabel?: Maybe<Scalars["String"]["output"]>;
  events: Array<ZonePerfEventModel>;
  /** How many of these events had nobody there. */
  noAttendance: Scalars["Int"]["output"];
  periodLabel: Scalars["String"]["output"];
  totalAttended: Scalars["Int"]["output"];
  totalRsvps: Scalars["Int"]["output"];
  zone: ZoneLabel;
}

export interface ZonePerformanceModel {
  /** Whether the reference quarter is the current one. */
  isCurrent: Scalars["Boolean"]["output"];
  /** The current calendar month — only present for the current quarter. */
  month?: Maybe<ZonePeriodModel>;
  /** The quarter before the reference one. */
  prevQuarter: ZonePeriodModel;
  /** The reference quarter. */
  quarter: ZonePeriodModel;
  /** The last 8 quarters, newest first. */
  quarters: Array<QuarterOptionModel>;
  /** The reference quarter, as 'YYYY-Q'. */
  selectedQuarter: Scalars["String"]["output"];
  /** Server 'today' (ISO date). */
  today: Scalars["String"]["output"];
  /** Zones in band order. */
  zoneOrder: Array<ZoneLabel>;
}

export interface ZonePeriodModel {
  /** 'month' | 'quarter' | 'prev_quarter'. */
  key: Scalars["String"]["output"];
  /** Human label, e.g. 'July 2026' or 'Q3 2026 (Jul–Sep)'. */
  label: Scalars["String"]["output"];
  zones: Array<ZonePerfModel>;
}

export interface ZoneTotalsModel {
  events: Scalars["Int"]["output"];
  rsvps: Scalars["Int"]["output"];
  /** showed / rsvps, as a percentage. */
  showUpRate: Scalars["Float"]["output"];
  showed: Scalars["Int"]["output"];
}

export interface ZoneTypePerfModel {
  /** Average accepted RSVPs per event. */
  avgRsvps: Scalars["Float"]["output"];
  events: Scalars["Int"]["output"];
  /** Events of this type in this zone with nobody there. */
  noShowEvents: Scalars["Int"]["output"];
  /** Accepted RSVPs. */
  rsvps: Scalars["Int"]["output"];
  /** This type's share of the zone's events, as a percentage. */
  share: Scalars["Float"]["output"];
  /** showed / rsvps, as a percentage. */
  showUpRate: Scalars["Float"]["output"];
  /** Members who showed up. */
  showed: Scalars["Int"]["output"];
  /** EventHostType key, e.g. 'BIG_SISTER_OTHER'. */
  type: Scalars["String"]["output"];
  /** Display label, e.g. '👩 Big Sister — Other'. */
  typeLabel: Scalars["String"]["output"];
}

export interface CbItemPrice {
  amount?: Maybe<Scalars["Int"]["output"]>;
  interval?: Maybe<Scalars["String"]["output"]>;
  intervalCount?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface CbPlanDetails {
  cancelledAt?: Maybe<Scalars["Date"]["output"]>;
  customerChargebeeId?: Maybe<Scalars["String"]["output"]>;
  dunning?: Maybe<Scalars["Boolean"]["output"]>;
  end?: Maybe<Scalars["Date"]["output"]>;
  itemPriceId?: Maybe<Scalars["String"]["output"]>;
  plan?: Maybe<Scalars["JSON"]["output"]>;
  recoveryStartedAt?: Maybe<Scalars["Date"]["output"]>;
  resumesAt?: Maybe<Scalars["Date"]["output"]>;
  scheduledPlan?: Maybe<Scalars["JSON"]["output"]>;
  start?: Maybe<Scalars["Date"]["output"]>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionChargebeeId?: Maybe<Scalars["String"]["output"]>;
  userAmount?: Maybe<Scalars["Int"]["output"]>;
}

export type AdminDeleteArticleMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteArticleMutation = { adminDeleteArticle?: { status: MutationStatus } | null };

export type AdminEditArticleMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditArticleInput;
}>;

export type AdminEditArticleMutation = {
  adminEditArticle?: {
    id: string;
    title?: string | null;
    isVisible?: boolean | null;
    isFeatured?: boolean | null;
    isDraft?: boolean | null;
  } | null;
};

export type AdminGenerateAttachmentUploadUrlMutationVariables = Exact<{
  filename: Scalars["String"]["input"];
}>;

export type AdminGenerateAttachmentUploadUrlMutation = {
  adminGenerateAttachmentUploadUrl?: {
    contentURL?: string | null;
    uploadURL?: string | null;
  } | null;
};

export type DeleteCommentMutationVariables = Exact<{
  commentID: Scalars["String"]["input"];
}>;

export type DeleteCommentMutation = { deleteComment?: { status: MutationStatus } | null };

export type AdminCreateCoverMutationVariables = Exact<{
  input: CreateCoverInput;
}>;

export type AdminCreateCoverMutation = {
  adminCreateCover?: {
    id: string;
    title: string;
    primary?: { mobile?: string | null; desktop?: string | null } | null;
    secondary?: { mobile?: string | null; desktop?: string | null } | null;
    tertiary?: { mobile?: string | null; desktop?: string | null } | null;
  } | null;
};

export type AdminEditCoverMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditCoverInput;
}>;

export type AdminEditCoverMutation = {
  adminEditCover?: {
    id: string;
    title: string;
    primary?: { mobile?: string | null; desktop?: string | null } | null;
    secondary?: { mobile?: string | null; desktop?: string | null } | null;
    tertiary?: { mobile?: string | null; desktop?: string | null } | null;
  } | null;
};

export type AdminDeleteCoverMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteCoverMutation = { adminDeleteCover?: { status: MutationStatus } | null };

export type AdminDeleteEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteEventMutation = { adminDeleteEvent?: { status: MutationStatus } | null };

export type AdminEditEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditEventInput;
}>;

export type AdminEditEventMutation = { adminEditEvent?: { status: MutationStatus } | null };

export type AdminRepublishEventMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type AdminRepublishEventMutation = { adminRepublishEvent: { status: MutationStatus } };

export type ValidateUsersForEmailBulkInviteMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  input: BulkInviteWithEmailsInput;
}>;

export type ValidateUsersForEmailBulkInviteMutation = {
  validateUsersForEmailBulkInvite?: {
    userIds: Array<string>;
    warningMessages: Array<string>;
  } | null;
};

export type BulkInviteWithUserIdsMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  input: BulkInviteWithUserIdsInput;
}>;

export type BulkInviteWithUserIdsMutation = {
  bulkInviteWithUserIds?: { warningMessages: Array<string>; invitedUserIds: Array<string> } | null;
};

export type ValidateForSelectionBulkInviteMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  filters: AdminFilterUsersInput;
}>;

export type ValidateForSelectionBulkInviteMutation = {
  validateForSelectionBulkInvite: {
    eventTitle?: string | null;
    userIds: Array<string>;
    warningMessages: Array<string>;
  };
};

export type AdminSelectionUserIdsMutationVariables = Exact<{
  filters: AdminFilterUsersInput;
  eventId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminSelectionUserIdsMutation = {
  adminSelectionUserIds: {
    userIds: Array<string>;
    totalMatched: number;
    truncated: boolean;
    cap: number;
    eligibleCount: number;
    alreadySharedCount: number;
    notAllowedCount: number;
    inactiveCount: number;
  };
};

export type AdminValidateBulkUploadEventsMutationVariables = Exact<{
  input: BulkUploadEventsInput;
}>;

export type AdminValidateBulkUploadEventsMutation = {
  adminValidateBulkUploadEvents: {
    totalRows: number;
    validationErrors: Array<{
      row: number;
      eventTitle?: string | null;
      column: string;
      message: string;
    }>;
    inviteWarnings: Array<{
      row: number;
      eventTitle?: string | null;
      column: string;
      message: string;
    }>;
  };
};

export type AdminBulkUploadEventsMutationVariables = Exact<{
  input: BulkUploadEventsInput;
}>;

export type AdminBulkUploadEventsMutation = {
  adminBulkUploadEvents: {
    createdCount: number;
    createdEvents: Array<{ row: number; id: string; title?: string | null }>;
    validationErrors: Array<{
      row: number;
      eventTitle?: string | null;
      column: string;
      message: string;
    }>;
    inviteWarnings: Array<{
      row: number;
      eventTitle?: string | null;
      column: string;
      message: string;
    }>;
  };
};

export type AdminCreateFeatureFlagMutationVariables = Exact<{
  input: CreateFeatureFlagInput;
}>;

export type AdminCreateFeatureFlagMutation = {
  adminCreateFeatureFlag?: { id: string; label: string; active?: boolean | null } | null;
};

export type AdminEditFeatureFlagMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditFeatureFlagInput;
}>;

export type AdminEditFeatureFlagMutation = {
  adminEditFeatureFlag?: { id: string; label: string; active?: boolean | null } | null;
};

export type AdminDeleteFeatureFlagMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteFeatureFlagMutation = {
  adminDeleteFeatureFlag?: { reason?: string | null; status: MutationStatus } | null;
};

export type AdminDeleteIllustrationMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteIllustrationMutation = {
  adminDeleteIllustration?: { status: MutationStatus } | null;
};

export type AdminCreateIllustrationMutationVariables = Exact<{
  input: CreateIllustrationInput;
}>;

export type AdminCreateIllustrationMutation = {
  adminCreateIllustration?: { id: string; title: string; url?: string | null } | null;
};

export type AdminEditIllustrationMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditIllustrationInput;
}>;

export type AdminEditIllustrationMutation = {
  adminEditIllustration?: { id: string; title: string; url?: string | null } | null;
};

export type AdminDeleteLessonMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteLessonMutation = {
  adminDeleteLesson?: { reason?: string | null; status: MutationStatus } | null;
};

export type AdminCreateLessonMutationVariables = Exact<{
  input: CreateLessonInput;
}>;

export type AdminCreateLessonMutation = {
  adminCreateLesson?: {
    id: string;
    sections?: Array<{
      id: string;
      order?: number | null;
      elements?: Array<{ kind: ElementKind; meta: any }> | null;
    }> | null;
  } | null;
};

export type AdminEditLessonMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditLessonInput;
}>;

export type AdminEditLessonMutation = {
  adminEditLesson?: { id: string; deepDiveKind?: DeepDiveKind | null; kind: LessonKind } | null;
};

export type TriggerBackupEventsParticipantsMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerBackupEventsParticipantsMutation = {
  triggerBackupEventsParticipants: { status: MutationStatus };
};

export type TriggerUserPermissionPromotionMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerUserPermissionPromotionMutation = {
  triggerUserPermissionPromotion: { status: MutationStatus };
};

export type TriggerUserDeletionAfterRetentionMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerUserDeletionAfterRetentionMutation = {
  triggerUserDeletionAfterRetention: { status: MutationStatus };
};

export type TriggerChatServiceSyncMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerChatServiceSyncMutation = {
  triggerChatServiceSync?: { status: MutationStatus } | null;
};

export type TriggerRecreateZoomMeetingsMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerRecreateZoomMeetingsMutation = {
  triggerRecreateZoomMeetings: { status: MutationStatus };
};

export type TriggerRecreateDailyMeetingsMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerRecreateDailyMeetingsMutation = {
  triggerRecreateDailyMeetings: { status: MutationStatus };
};

export type TriggerAssignAllUserBadgesMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerAssignAllUserBadgesMutation = {
  triggerAssignAllUserBadges: { status: MutationStatus };
};

export type IssueCompleteProfileNotificationMutationVariables = Exact<{ [key: string]: never }>;

export type IssueCompleteProfileNotificationMutation = {
  issueCompleteProfileNotification: { status: MutationStatus };
};

export type UploadActiveDaysMutationVariables = Exact<{
  input: UploadActiveDaysInput;
}>;

export type UploadActiveDaysMutation = { uploadActiveDays: { status: MutationStatus } };

export type AssignAllExtraReferralBadgesMutationVariables = Exact<{ [key: string]: never }>;

export type AssignAllExtraReferralBadgesMutation = {
  assignAllExtraReferralBadges: { status: MutationStatus };
};

export type DeleteDailyWebhookMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteDailyWebhookMutation = { deleteDailyWebhook: { status: MutationStatus } };

export type CreateNewWebhookMutationVariables = Exact<{
  eventTypes: Array<DailyEventTypes> | DailyEventTypes;
}>;

export type CreateNewWebhookMutation = { createNewWebhook: { status: MutationStatus } };

export type AssignAllLocalHostsBadgesMutationVariables = Exact<{ [key: string]: never }>;

export type AssignAllLocalHostsBadgesMutation = {
  assignAllLocalHostsBadges: { status: MutationStatus };
};

export type AssignAllNewEventsAttendedBadgesMutationVariables = Exact<{ [key: string]: never }>;

export type AssignAllNewEventsAttendedBadgesMutation = {
  assignAllNewEventsAttendedBadges: { status: MutationStatus };
};

export type AssignAllFirstConversationBadgesMutationVariables = Exact<{ [key: string]: never }>;

export type AssignAllFirstConversationBadgesMutation = {
  assignAllFirstConversationBadges: { status: MutationStatus };
};

export type AssignAllNmmEventAttendedBadgesMutationVariables = Exact<{ [key: string]: never }>;

export type AssignAllNmmEventAttendedBadgesMutation = {
  assignAllNMMEventAttendedBadges: { status: MutationStatus };
};

export type PopulateUserEventStatisticsMutationVariables = Exact<{ [key: string]: never }>;

export type PopulateUserEventStatisticsMutation = {
  populateUserEventStatistics?: { status: MutationStatus } | null;
};

export type TriggerBackfillConnectionStreaksMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerBackfillConnectionStreaksMutation = {
  triggerBackfillConnectionStreaks: { status: MutationStatus };
};

export type AdminCreateCustomNotificationDisplayMutationVariables = Exact<{ [key: string]: never }>;

export type AdminCreateCustomNotificationDisplayMutation = {
  adminCreateCustomNotificationDisplay?: { id: string } | null;
};

export type AdminEditCustomNotificationDisplayMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditCustomNotificationDisplayInput;
}>;

export type AdminEditCustomNotificationDisplayMutation = {
  adminEditCustomNotificationDisplay?: { status: MutationStatus } | null;
};

export type SendCustomNotificationsMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  emails: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SendCustomNotificationsMutation = {
  sendCustomNotifications?: { sentTo: number; warningMessages: Array<string> } | null;
};

export type AdminRecordInvitesMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
  filters?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type AdminRecordInvitesMutation = { adminRecordInvites: number };

export type AdminEditQuestionMutationVariables = Exact<{
  input: EditQuestionInput;
}>;

export type AdminEditQuestionMutation = {
  adminEditQuestion?: { id: string; question?: string | null } | null;
};

export type AdminDeleteUserReportMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteUserReportMutation = {
  adminDeleteUserReport?: { status: MutationStatus } | null;
};

export type AdminCreateSectionMutationVariables = Exact<{
  input: CreateSectionInput;
}>;

export type AdminCreateSectionMutation = {
  adminCreateSection?: {
    id: string;
    order?: number | null;
    elements?: Array<{ kind: ElementKind; meta: any }> | null;
  } | null;
};

export type AdminEditSectionMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditSectionInput;
}>;

export type AdminEditSectionMutation = {
  adminEditSection?: {
    id: string;
    order?: number | null;
    elements?: Array<{ kind: ElementKind; meta: any }> | null;
  } | null;
};

export type AdminDeleteSectionMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteSectionMutation = {
  adminDeleteSection?: { reason?: string | null; status: MutationStatus } | null;
};

export type AdminCreateBannerMutationVariables = Exact<{
  input: CreateBannerInput;
}>;

export type AdminCreateBannerMutation = {
  adminCreateBanner?: { id: string; isActive: boolean } | null;
};

export type AdminEditBannerMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditBannerInput;
}>;

export type AdminEditBannerMutation = {
  adminEditBanner?: { id: string; isActive: boolean } | null;
};

export type AdminDeleteBannerMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteBannerMutation = { adminDeleteBanner?: { status: MutationStatus } | null };

export type AdminCreateSliderMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminCreateSliderMutation = { adminCreateSlider?: { status: MutationStatus } | null };

export type AdminDeleteSliderMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteSliderMutation = { adminDeleteSlider?: { status: MutationStatus } | null };

export type AdminEditSlideMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditSliderInput;
}>;

export type AdminEditSlideMutation = { adminEditSlide?: { id: string } | null };

export type AdminOrderSliderMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}>;

export type AdminOrderSliderMutation = { adminOrderSlider?: { status: MutationStatus } | null };

export type AdminCreateThemeMutationVariables = Exact<{
  input: CreateThemeInput;
}>;

export type AdminCreateThemeMutation = {
  adminCreateTheme?: {
    id: string;
    title: string;
    description?: string | null;
    isGrammarLibrary?: boolean | null;
    isTopicLibrary?: boolean | null;
    isResource?: boolean | null;
    isStandard?: boolean | null;
    isCurrent?: boolean | null;
    cover?: {
      id: string;
      title: string;
      primary?: { mobile?: string | null; desktop?: string | null } | null;
      secondary?: { mobile?: string | null; desktop?: string | null } | null;
      tertiary?: { mobile?: string | null; desktop?: string | null } | null;
    } | null;
  } | null;
};

export type AdminEditThemeMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditThemeInput;
}>;

export type AdminEditThemeMutation = {
  adminEditTheme?: {
    id: string;
    title: string;
    description?: string | null;
    isCurrent?: boolean | null;
    isStandard?: boolean | null;
    isGrammarLibrary?: boolean | null;
    isTopicLibrary?: boolean | null;
    cover?: {
      id: string;
      title: string;
      primary?: { mobile?: string | null; desktop?: string | null } | null;
      secondary?: { mobile?: string | null; desktop?: string | null } | null;
      tertiary?: { mobile?: string | null; desktop?: string | null } | null;
    } | null;
  } | null;
};

export type AdminDeleteThemeMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteThemeMutation = { adminDeleteTheme?: { status: MutationStatus } | null };

export type AdminEditTopicMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditTopicInput;
}>;

export type AdminEditTopicMutation = {
  adminEditTopic?: {
    id: string;
    title: string;
    stars?: number | null;
    theme?: { id: string; title: string } | null;
    illustration?: { id: string; title: string; url?: string | null } | null;
    lessons?: Array<{ id: string; kind: LessonKind }> | null;
  } | null;
};

export type AdminDeleteTopicMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteTopicMutation = {
  adminDeleteTopic?: { status: MutationStatus; reason?: string | null } | null;
};

export type AdminDeleteTopicsMutationVariables = Exact<{
  input: DeleteTopicsInput;
}>;

export type AdminDeleteTopicsMutation = { adminDeleteTopics?: { status: MutationStatus } | null };

export type AdminCreateTopicMutationVariables = Exact<{
  input: CreateTopicInput;
}>;

export type AdminCreateTopicMutation = {
  adminCreateTopic?: {
    id: string;
    title: string;
    stars?: number | null;
    illustration?: { id: string; title: string; url?: string | null } | null;
    theme?: { id: string; title: string } | null;
    lessons?: Array<{ id: string; kind: LessonKind }> | null;
  } | null;
};

export type DuplicateTopicMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DuplicateTopicMutation = { duplicateTopic?: { status: MutationStatus } | null };

export type DuplicateLessonMutationVariables = Exact<{
  input: DuplicateLessonInput;
}>;

export type DuplicateLessonMutation = { duplicateLesson?: { status: MutationStatus } | null };

export type CreateTopicForPreviewModeMutationVariables = Exact<{
  input: TopicInPreviewInput;
}>;

export type CreateTopicForPreviewModeMutation = {
  createTopicForPreviewMode?: { id: string } | null;
};

export type CreateTotpMutationVariables = Exact<{ [key: string]: never }>;

export type CreateTotpMutation = { createTotp: { id: string; uri?: string | null } };

export type ConfirmTotpMutationVariables = Exact<{
  input: ConfirmTotpInput;
  currentPassword: Scalars["String"]["input"];
}>;

export type ConfirmTotpMutation = { confirmTotp: { status: MutationStatus } };

export type RemoveTotpMutationVariables = Exact<{
  totpId: Scalars["String"]["input"];
  currentPassword?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RemoveTotpMutation = { removeTotp: { status: MutationStatus } };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteAccountMutation = { deleteAccount?: { status: MutationStatus } | null };

export type AdminEditUserMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditUserInput;
}>;

export type AdminEditUserMutation = { adminEditUser?: { status: MutationStatus } | null };

export type AdminGrantGuestPassTokensMutationVariables = Exact<{
  input: GrantGuestPassTokensInput;
}>;

export type AdminGrantGuestPassTokensMutation = {
  adminGrantGuestPassTokens: {
    id: string;
    tokenAllowance: number;
    tokensUsed: number;
    tokensRemaining: number;
    daysRemaining: number;
    isActive: boolean;
  };
};

export type AdminCreateNoteMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: NoteInput;
}>;

export type AdminCreateNoteMutation = {
  adminCreateNote?: { id: string; description: string } | null;
};

export type AdminBanUserMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminBanUserMutation = { adminBanUser?: { status: MutationStatus } | null };

export type AdminUnbanUserMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminUnbanUserMutation = { adminUnbanUser?: { status: MutationStatus } | null };

export type AssignUserBadgeMutationVariables = Exact<{
  input: AssignOrDeleteBadgeInput;
}>;

export type AssignUserBadgeMutation = { assignUserBadge?: { status: MutationStatus } | null };

export type DeleteUserBadgeMutationVariables = Exact<{
  input: AssignOrDeleteBadgeInput;
}>;

export type DeleteUserBadgeMutation = { deleteUserBadge?: { status: MutationStatus } | null };

export type RegenerateCalendarPathMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type RegenerateCalendarPathMutation = { regenerateCalendarPath: { status: MutationStatus } };

export type AdminCreateVideoSetMutationVariables = Exact<{
  input: CreateVideoSetInput;
}>;

export type AdminCreateVideoSetMutation = {
  adminCreateVideoSet?: { id: string; title: string } | null;
};

export type AdminDeleteVideoSetMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteVideoSetMutation = {
  adminDeleteVideoSet?: { status: MutationStatus } | null;
};

export type AdminCreateVideoMutationVariables = Exact<{
  input: CreateVideoInput;
}>;

export type AdminCreateVideoMutation = { adminCreateVideo?: { status: MutationStatus } | null };

export type AdminDeleteVideoMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteVideoMutation = { adminDeleteVideo?: { status: MutationStatus } | null };

export type AdminEditVideoSetMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditVideoSetInput;
}>;

export type AdminEditVideoSetMutation = { adminEditVideoSet?: { id: string } | null };

export type AdminOrderVideoSetMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}>;

export type AdminOrderVideoSetMutation = { adminOrderVideoSet?: { status: MutationStatus } | null };

export type AdminEditVideoMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditVideoInput;
}>;

export type AdminEditVideoMutation = { adminEditVideo?: { id: string } | null };

export type AdminOrderVideoMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}>;

export type AdminOrderVideoMutation = { adminOrderVideo?: { status: MutationStatus } | null };

export type AdminDeleteZineCoverMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminDeleteZineCoverMutation = {
  adminDeleteZineCover?: { status: MutationStatus } | null;
};

export type AdminCreateZineCoverMutationVariables = Exact<{
  input: CreateZineInput;
}>;

export type AdminCreateZineCoverMutation = {
  adminCreateZineCover?: {
    id: string;
    coverUrl?: string | null;
    isCurrent?: boolean | null;
  } | null;
};

export type AdminEditZineCoverMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: EditZineInput;
}>;

export type AdminEditZineCoverMutation = {
  adminEditZineCover?: { id: string; coverUrl?: string | null; isCurrent?: boolean | null } | null;
};

export type UploadZineCoverMutationVariables = Exact<{
  input: UploadCoverZineInput;
}>;

export type UploadZineCoverMutation = {
  uploadZineCover?: { id: string; coverUrl?: string | null } | null;
};

export type AdminGetArticleQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  filters: AdminFilterUsersInput;
}>;

export type AdminGetArticleQuery = {
  adminGetArticle: {
    id: string;
    title?: string | null;
    content?: string | null;
    coverUrl?: string | null;
    isFeatured?: boolean | null;
    tags?: Array<Interest> | null;
    isVisible?: boolean | null;
    isDraft?: boolean | null;
    author?: { id: string; name: string } | null;
  };
  adminListUsers: { total: number; items?: Array<{ id: string; name: string }> | null };
};

export type AdminListPaginatedArticlesQueryVariables = Exact<{
  order: OrderArticlesInput;
  filters: FilterArticlesInput;
}>;

export type AdminListPaginatedArticlesQuery = {
  adminListPaginatedArticles: {
    total: number;
    items?: Array<{
      id: string;
      title?: string | null;
      content?: string | null;
      coverUrl?: string | null;
      isFeatured?: boolean | null;
      publishedAt?: any | null;
      tags?: Array<Interest> | null;
      isVisible?: boolean | null;
      isDraft?: boolean | null;
      author?: { id: string; name: string } | null;
    }> | null;
  };
};

export type AdminListPaginatedCoversQueryVariables = Exact<{
  filters: AdminFilterCoversInput;
}>;

export type AdminListPaginatedCoversQuery = {
  adminListPaginatedCovers: {
    total: number;
    items?: Array<{
      id: string;
      title: string;
      primary?: { mobile?: string | null; desktop?: string | null } | null;
      secondary?: { mobile?: string | null; desktop?: string | null } | null;
      tertiary?: { mobile?: string | null; desktop?: string | null } | null;
    }> | null;
  };
};

export type AdminGetCoverQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetCoverQuery = {
  adminGetCover: {
    id: string;
    title: string;
    primary?: { mobile?: string | null; desktop?: string | null } | null;
    secondary?: { mobile?: string | null; desktop?: string | null } | null;
    tertiary?: { mobile?: string | null; desktop?: string | null } | null;
  };
};

export type AdminSearchEventsQueryVariables = Exact<{
  filters: AdminFilterEventsInput;
}>;

export type AdminSearchEventsQuery = {
  adminSearchEvents: {
    total: number;
    items?: Array<{
      title?: string | null;
      id: string;
      endDate?: any | null;
      coverUrl?: string | null;
      startDate?: any | null;
      organizer?: { id: string; firstName?: string | null; lastName?: string | null } | null;
    }> | null;
  };
};

export type GetEventAdminQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventAdminQuery = {
  getEventAdmin?: {
    id: string;
    coverUrl?: string | null;
    createdAt: any;
    description?: string | null;
    endDate?: any | null;
    isDraft?: boolean | null;
    isPublic?: boolean | null;
    kind?: EventKind | null;
    meta?: any | null;
    location?: string | null;
    noParticipants?: number | null;
    recurring?: boolean | null;
    startDate?: any | null;
    title?: string | null;
    updatedAt: any;
    videoUrl?: string | null;
    isForUnverified?: boolean | null;
    permissions?: Array<EventPermissions> | null;
    englishLevel?: EventEnglishLevel | null;
    isCoachEvent?: boolean | null;
    maxParticipants?: number | null;
    isFull?: boolean | null;
    seriesId?: string | null;
    eventCategory?: EventCategory | null;
    interests?: Array<Interest> | null;
    englishSkills?: Array<EnglishSkill> | null;
    topic?: { id: string; title: string } | null;
    organizer?: { id: string; name: string; avatarUrl?: string | null } | null;
    host?: { id: string; name: string; avatarUrl?: string | null; badge?: UserBadge | null } | null;
  } | null;
};

export type GetEventAndTopicsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventAndTopicsQuery = {
  getEventAdmin?: {
    id: string;
    coverUrl?: string | null;
    createdAt: any;
    description?: string | null;
    endDate?: any | null;
    eventCategory?: EventCategory | null;
    isDraft?: boolean | null;
    isDeleted?: boolean | null;
    isPublic?: boolean | null;
    kind?: EventKind | null;
    meta?: any | null;
    location?: string | null;
    noParticipants?: number | null;
    recurring?: boolean | null;
    englishLevel?: EventEnglishLevel | null;
    isForUnverified?: boolean | null;
    permissions?: Array<EventPermissions> | null;
    startDate?: any | null;
    title?: string | null;
    updatedAt: any;
    videoUrl?: string | null;
    host?: { kind?: EventPermissions | null } | null;
    organizer?: { id: string; name: string; avatarUrl?: string | null } | null;
    topic?: { id: string; title: string } | null;
  } | null;
  adminListTopics: Array<{ id: string; title: string }>;
};

export type GetEventParticipantsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventParticipantsQuery = {
  getEventAdmin?: {
    id: string;
    participants: Array<{
      id: string;
      name: string;
      createdAt: any;
      email: string;
      city?: string | null;
      isVerified?: boolean | null;
      country?: string | null;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
    }>;
    invited: Array<{
      id: string;
      name: string;
      createdAt: any;
      email: string;
      city?: string | null;
      isVerified?: boolean | null;
      country?: string | null;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
    }>;
    declined: Array<{
      id: string;
      name: string;
      createdAt: any;
      email: string;
      city?: string | null;
      isVerified?: boolean | null;
      country?: string | null;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
    }>;
  } | null;
};

export type GetEventCommentsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventCommentsQuery = {
  getEventAdmin?: {
    id: string;
    comments?: Array<{
      id: string;
      message: string;
      createdAt: any;
      author?: { id: string; avatarUrl?: string | null; name: string } | null;
    }> | null;
  } | null;
};

export type AdminMemberExperienceQueryVariables = Exact<{
  from?: InputMaybe<Scalars["Date"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  planSlug?: InputMaybe<Scalars["String"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  attendedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  joinedAt?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type AdminMemberExperienceQuery = {
  adminMemberExperience: {
    total: number;
    canAttend: number;
    locked: number;
    blocked: number;
    member: {
      userId: string;
      name: string;
      email: string;
      isReal: boolean;
      kind?: string | null;
      planSlug?: string | null;
      subscriptionTier: string;
      isVerified: boolean;
      isStaff: boolean;
      attendedEvents: number;
      advancedUnlocked: boolean;
      joinedAt?: any | null;
    };
    events: Array<{
      eventId: string;
      canAttend: boolean;
      verdict: AttendVerdict;
      joinReason: JoinReason;
      lockReason: LockReason;
    }>;
  };
};

export type AdminMemberEventsReviewQueryVariables = Exact<{
  days?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdminMemberEventsReviewQuery = {
  adminMemberEventsReview: Array<{
    eventId: string;
    startDate: any;
    zone: ZoneLabel;
    isPublic: boolean;
    priority: string;
    title: string;
    kind: string;
    englishLevel: string;
    hostName: string;
    hostBadge: string;
    isFirstPublic: boolean;
    acceptedInvites: number;
    spotsTaken: number;
    maxParticipants: number;
    spotsLeft?: number | null;
    labelsEdited: boolean;
    labels: Array<{ key: string; name: string; family: string }>;
  }>;
};

export type AdminEventMemberMatchesQueryVariables = Exact<{
  eventId: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  minEnglish?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminEventMemberMatchesQuery = {
  adminEventMemberMatches: {
    eventId: string;
    title: string;
    labelSource: string;
    matchBasis: string;
    eventZone: ZoneLabel;
    eventLevel: string;
    maxParticipants: number;
    spotsTaken: number;
    spotsLeft?: number | null;
    isFull: boolean;
    totalMatches: number;
    excludedCantAccess: number;
    englishFiltered: number;
    quietFiltered: number;
    newcomerFiltered: number;
    labels: Array<{ key: string; name: string; family: string }>;
    matches: Array<{
      userId: string;
      name: string;
      email: string;
      occupation?: string | null;
      industry?: string | null;
      speakingLevel?: string | null;
      eventsAttended: number;
      eventsRecent: number;
      engagement: string;
      englishBand: string;
      isNewcomer: boolean;
      localHour?: number | null;
      recentNotifs: number;
      overContacted: boolean;
      connectionScore: number;
      storyMatch?: string | null;
      why: Array<string>;
      zone?: ZoneLabel | null;
    }>;
  };
};

export type AdminEventsForMemberQueryVariables = Exact<{
  email: Scalars["String"]["input"];
  days?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdminEventsForMemberQuery = {
  adminEventsForMember: {
    topicMatchCount: number;
    hiddenCantJoin: number;
    hiddenQuietHours: number;
    hiddenWrongLevel: number;
    hiddenPastNewcomerWindow: number;
    member: {
      userId: string;
      name: string;
      email: string;
      country?: string | null;
      timezone?: string | null;
      zone?: ZoneLabel | null;
      tenureDays: number;
      tenureBucket: string;
      isNewcomer: boolean;
      engagement: string;
      speakingLevel?: string | null;
      englishBand: string;
      occupation?: string | null;
      industry?: string | null;
      hasBio: boolean;
      interests: Array<string>;
      englishSkills: Array<string>;
      eventsAttended: number;
      eventsRecent: number;
      lastOnlineAt?: any | null;
      upcomingBooked: number;
      recentNotifs: number;
      overContacted: boolean;
    };
    matches: Array<{
      eventId: string;
      title: string;
      hostName?: string | null;
      hostBadge?: string | null;
      kind: string;
      zone: ZoneLabel;
      startsAt: any;
      localHour?: number | null;
      connectionScore: number;
      matchBasis: string;
      inHerZone: boolean;
      isFull: boolean;
      spotsLeft?: number | null;
      why: Array<string>;
      labels: Array<{ key: string; name: string; family: string }>;
    }>;
  };
};

export type AdminEventLabelCatalogueQueryVariables = Exact<{ [key: string]: never }>;

export type AdminEventLabelCatalogueQuery = {
  adminEventLabelCatalogue: Array<{ key: string; name: string; family: string }>;
};

export type AdminSetEventLabelsMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  labels?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type AdminSetEventLabelsMutation = { adminSetEventLabels: boolean };

export type AdminEventInsightQueryVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type AdminEventInsightQuery = {
  adminEventInsight: {
    zone: ZoneLabel;
    hostType: string;
    level: string;
    visibility: string;
    labelSource: string;
    registered: number;
    maxParticipants?: number | null;
    unlimited: boolean;
    isFull: boolean;
    labels: Array<{ key: string; name: string; family: string }>;
  };
};

export type AdminEventsCalendarQueryVariables = Exact<{
  weekStart: Scalars["String"]["input"];
}>;

export type AdminEventsCalendarQuery = {
  adminEventsCalendar: {
    weekStart: any;
    total: number;
    events: Array<{
      id: string;
      title: string;
      startDate: any;
      zone: ZoneLabel;
      dayOfWeek: number;
      timeUtc: string;
      hostType: string;
      hostFirstName?: string | null;
      hostName?: string | null;
      kind: string;
      level: string;
      category?: string | null;
      visibility: string;
      maxParticipants?: number | null;
      registered: number;
      unlimited: boolean;
      isFull: boolean;
      recurring: boolean;
      isCoachEvent: boolean;
      needsThreeEvents: boolean;
      participants: Array<string>;
    }>;
  };
};

export type AdminGetFeatureFlagQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetFeatureFlagQuery = {
  adminGetFeatureFlag: { id: string; label: string; active?: boolean | null };
};

export type AdminListPaginatedFeatureFlagsQueryVariables = Exact<{
  filters: AdminFilterFeatureFlagsInput;
}>;

export type AdminListPaginatedFeatureFlagsQuery = {
  adminListPaginatedFeatureFlags: {
    total: number;
    items?: Array<{ id: string; label: string; active?: boolean | null }> | null;
  };
};

export type AdminGetIllustrationQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetIllustrationQuery = {
  adminGetIllustration: { id: string; title: string; url?: string | null };
};

export type AdminListPaginatedIllustrationsQueryVariables = Exact<{
  filters: AdminFilterIllustrationsInput;
}>;

export type AdminListPaginatedIllustrationsQuery = {
  adminListPaginatedIllustrations: {
    total: number;
    items?: Array<{ id: string; title: string; url?: string | null }> | null;
  };
};

export type AdminRecordCampaignInvitesMutationVariables = Exact<{
  campaign: InviteCampaignKey;
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type AdminRecordCampaignInvitesMutation = { adminRecordCampaignInvites: number };

export type AdminCampaignResultsQueryVariables = Exact<{
  campaign: InviteCampaignKey;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type AdminCampaignResultsQuery = {
  adminCampaignResults: Array<{
    weekStarting: any;
    events: number;
    invited: number;
    saidYes: number;
    came: number;
    totalThere: number;
    partial: boolean;
  }>;
};

export type AdminCampaignEventResultsQueryVariables = Exact<{
  campaign: InviteCampaignKey;
  weekStarting: Scalars["Date"]["input"];
}>;

export type AdminCampaignEventResultsQuery = {
  adminCampaignEventResults: Array<{
    eventId: string;
    title: string;
    startDate: any;
    invited: number;
    saidYes: number;
    came: number;
    totalThere: number;
  }>;
};

export type AdminInviteCampaignQueryVariables = Exact<{
  campaign: InviteCampaignKey;
}>;

export type AdminInviteCampaignQuery = {
  adminInviteCampaign: Array<{
    zone?: ZoneLabel | null;
    programme?: string | null;
    eventId?: string | null;
    eventTitle?: string | null;
    eventStartDate?: any | null;
    memberCount: number;
    members: Array<{
      userId: string;
      email: string;
      firstName?: string | null;
      isGuest: boolean;
      why?: string | null;
      note?: string | null;
      afterPass: boolean;
      option?: string | null;
    }>;
    extraMembers: Array<{
      userId: string;
      email: string;
      firstName?: string | null;
      isGuest: boolean;
      why?: string | null;
      note?: string | null;
      afterPass: boolean;
      option?: string | null;
    }>;
  }>;
};

export type AdminGetLessonQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetLessonQuery = {
  adminGetLesson: {
    id: string;
    kind: LessonKind;
    title?: string | null;
    sections?: Array<{
      id: string;
      order?: number | null;
      elements?: Array<{ kind: ElementKind; value?: any | null; meta: any }> | null;
    }> | null;
  };
  adminGetTopicByLessonId: { id: string; title: string };
};

export type GetDailyHooksQueryVariables = Exact<{ [key: string]: never }>;

export type GetDailyHooksQuery = {
  getDailyHooks: Array<{
    uuid: string;
    url: string;
    state: string;
    retryType: string;
    eventTypes: Array<string>;
    createdAt: string;
  }>;
};

export type BackfillConnectionStreaksRunningQueryVariables = Exact<{ [key: string]: never }>;

export type BackfillConnectionStreaksRunningQuery = { backfillConnectionStreaksRunning: boolean };

export type GetCustomNotificationDisplayQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetCustomNotificationDisplayQuery = {
  getCustomNotificationDisplay: {
    id: string;
    illustration?: string | null;
    title?: string | null;
    text?: string | null;
    buttonText?: string | null;
    buttonUrl?: string | null;
  };
};

export type AdminListPaginatedCustomNotificationDisplayQueryVariables = Exact<{
  filters: FilterCustomNotificationDisplayInput;
}>;

export type AdminListPaginatedCustomNotificationDisplayQuery = {
  adminListPaginatedCustomNotificationDisplay: {
    total: number;
    items?: Array<{
      id: string;
      illustration?: string | null;
      title?: string | null;
      text?: string | null;
      buttonText?: string | null;
      buttonUrl?: string | null;
    }> | null;
  };
};

export type AdminOnlineNowMembersQueryVariables = Exact<{
  faderLevels: Array<FaderLevel> | FaderLevel;
}>;

export type AdminOnlineNowMembersQuery = {
  adminOnlineNowMembers: Array<{
    userId: string;
    name: string;
    email: string;
    zone: ZoneLabel;
    faderLevel?: FaderLevel | null;
  }>;
};

export type GetCurrentTopicQuestionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentTopicQuestionsQuery = {
  getCurrentTopicQuestions: Array<{
    id: string;
    question?: string | null;
    updatedAt: any;
    topic?: { id: string; title: string } | null;
  }>;
};

export type AdminListPaginatedReportsUsersQueryVariables = Exact<{
  filters: AdminFilterReportsUserFilterInput;
}>;

export type AdminListPaginatedReportsUsersQuery = {
  adminListPaginatedReportsUsers: {
    total: number;
    items?: Array<{
      id: string;
      description?: string | null;
      reason?: UserReportReason | null;
      createdAt: any;
      abuser?: { id: string; name: string } | null;
      victim?: { id: string; name: string } | null;
    }> | null;
  };
};

export type AdminRecordRetentionOutreachMutationVariables = Exact<{
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  fader: Scalars["String"]["input"];
  eventId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminRecordRetentionOutreachMutation = { adminRecordRetentionOutreach: number };

export type AdminRetentionComebackQueryVariables = Exact<{
  month: Scalars["String"]["input"];
}>;

export type AdminRetentionComebackQuery = {
  adminRetentionComeback: {
    month: string;
    total: number;
    cameBack: number;
    interested: number;
    cancelled: number;
    rows: Array<{
      userId: string;
      name: string;
      email: string;
      country?: string | null;
      plan?: string | null;
      joinDate?: string | null;
      zone?: ZoneLabel | null;
      entrySegment: string;
      entryFader?: string | null;
      currentFader?: string | null;
      subscriptionStatus?: string | null;
      cycles: string;
      dates: string;
      outreachCount: number;
      firstOutreach?: string | null;
      cameBack: boolean;
      comebackDate?: string | null;
      daysToComeback?: number | null;
      comebackEvent?: string | null;
      comebackKind?: string | null;
      comebackHost?: string | null;
      comebackHostBadge?: string | null;
      loggedInSince: boolean;
      cancelled: boolean;
      lastLoginThen?: string | null;
      lastLoginNow?: string | null;
      lastAttendanceThen?: string | null;
      lastAttendanceNow?: string | null;
    }>;
  };
};

export type AdminRetentionAttendanceDetailQueryVariables = Exact<{
  month: Scalars["String"]["input"];
}>;

export type AdminRetentionAttendanceDetailQuery = {
  adminRetentionAttendanceDetail: Array<{
    member: string;
    email: string;
    event: string;
    kind?: string | null;
    hostName?: string | null;
    hostBadge?: string | null;
    attended?: string | null;
  }>;
};

export type AdminRetentionPrepareQueryVariables = Exact<{
  fader?: InputMaybe<Scalars["String"]["input"]>;
  returningEmails?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type AdminRetentionPrepareQuery = {
  adminRetentionPrepare: {
    fader: string;
    total: number;
    truncated: boolean;
    cap: number;
    historyKnown: boolean;
    excluded?: number | null;
    waiting: number;
    cycle1: {
      count: number;
      matchTiers: { featured: number; coach: number; cxt: number; none: number };
      groups: Array<{
        eventId: string;
        eventTitle: string;
        zone?: ZoneLabel | null;
        startDate?: any | null;
        emails: Array<string>;
        userIds: Array<string>;
      }>;
      unmatched: Array<{
        userId: string;
        name: string;
        email: string;
        zone?: ZoneLabel | null;
        route: string;
      }>;
    };
    cycle2: {
      count: number;
      members: Array<{
        userId: string;
        name: string;
        email: string;
        zone?: ZoneLabel | null;
        route: string;
      }>;
    };
  };
};

export type AdminShareEventPreviewQueryVariables = Exact<{
  emails: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  eventId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdminShareEventPreviewQuery = {
  adminShareEventPreview: {
    totalPasted: number;
    matchedCount: number;
    notFound: Array<string>;
    eligibleCount?: number | null;
    alreadySharedCount?: number | null;
    notAllowedEmails?: Array<string> | null;
    inactiveCount?: number | null;
  };
};

export type AdminShareEventToEmailsMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  emails: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
}>;

export type AdminShareEventToEmailsMutation = {
  adminShareEventToEmails: { sharedCount: number; notFound: Array<string> };
};

export type AdminShareEventToUserIdsMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
}>;

export type AdminShareEventToUserIdsMutation = {
  adminShareEventToUserIds: { sharedCount: number; notFound: Array<string> };
};

export type AdminUserSignUpAnswersQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AdminUserSignUpAnswersQuery = {
  adminUserSignUpAnswers?: {
    createdAt: any;
    eligibilityAgeGender?: string | null;
    englishLevel?: EnglishLevel | null;
    mainSpokenEnglishPriority?: string | null;
    mainSpeakingPracticeChallenge?: string | null;
    guestPassWeeklyPracticeReadiness?: string | null;
    detectedTimezone?: string | null;
    selectedTimezone?: string | null;
    selectedFirstEventId?: string | null;
    selectedFirstEventTime?: any | null;
    firstEventBookingSkipped: boolean;
  } | null;
};

export type AdminListPaginatedBannersQueryVariables = Exact<{
  filters: AdminFilterBannersInput;
}>;

export type AdminListPaginatedBannersQuery = {
  adminListPaginatedBanners: {
    total: number;
    items?: Array<{ id: string; title: string; isActive: boolean }> | null;
  };
};

export type AdminGetBannerQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetBannerQuery = {
  adminGetBanner: {
    id: string;
    title: string;
    isActive: boolean;
    createdAt: any;
    updatedAt: any;
    audience?: Array<EventPermissions> | null;
    sliders?: Array<{ id: string; position?: number | null; title?: string | null }> | null;
  };
};

export type AdminGetSlideQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetSlideQuery = {
  adminGetSlide: {
    buttonText?: string | null;
    buttonURL?: string | null;
    createdAt: any;
    featureImage?: string | null;
    id: string;
    imageAlignment?: ImageAlignment | null;
    subtitle?: string | null;
    textColour?: TextColour | null;
    title?: string | null;
    titleStyle?: TitleStyle | null;
    updatedAt: any;
    background?: { desktop?: string | null; mobile?: string | null } | null;
    banner: { id: string; title: string };
  };
};

export type AdminListPaginatedThemesQueryVariables = Exact<{
  filters: AdminFilterThemesInput;
}>;

export type AdminListPaginatedThemesQuery = {
  adminListPaginatedThemes: {
    total: number;
    items?: Array<{
      title: string;
      id: string;
      isCurrent?: boolean | null;
      isStandard?: boolean | null;
      isGrammarLibrary?: boolean | null;
      isTopicLibrary?: boolean | null;
      isResource?: boolean | null;
      topics?: Array<{ id: string; title: string }> | null;
    }> | null;
  };
};

export type AdminListThemesQueryVariables = Exact<{ [key: string]: never }>;

export type AdminListThemesQuery = {
  adminListThemes: Array<{
    title: string;
    id: string;
    isCurrent?: boolean | null;
    isStandard?: boolean | null;
    isGrammarLibrary?: boolean | null;
    isTopicLibrary?: boolean | null;
    isResource?: boolean | null;
    topics?: Array<{ id: string; title: string }> | null;
  }>;
};

export type AdminGetThemeAndCoversQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetThemeAndCoversQuery = {
  adminGetTheme: {
    id: string;
    title: string;
    description?: string | null;
    isCurrent?: boolean | null;
    isStandard?: boolean | null;
    isGrammarLibrary?: boolean | null;
    isTopicLibrary?: boolean | null;
    isResource?: boolean | null;
    cover?: {
      id: string;
      title: string;
      primary?: { mobile?: string | null; desktop?: string | null } | null;
      secondary?: { mobile?: string | null; desktop?: string | null } | null;
      tertiary?: { mobile?: string | null; desktop?: string | null } | null;
    } | null;
  };
  adminListCovers: Array<{
    id: string;
    title: string;
    primary?: { mobile?: string | null; desktop?: string | null } | null;
    secondary?: { mobile?: string | null; desktop?: string | null } | null;
    tertiary?: { mobile?: string | null; desktop?: string | null } | null;
  }>;
};

export type AdminListPaginatedTopicsQueryVariables = Exact<{
  filters: AdminFilterTopicsInput;
}>;

export type AdminListPaginatedTopicsQuery = {
  adminListPaginatedTopics: {
    total: number;
    items?: Array<{
      title: string;
      id: string;
      status?: TopicStatus | null;
      updatedAt: any;
      theme?: {
        id: string;
        title: string;
        isGrammarLibrary?: boolean | null;
        isTopicLibrary?: boolean | null;
        isStandard?: boolean | null;
        isResource?: boolean | null;
      } | null;
    }> | null;
  };
};

export type AdminGetTopicThemesAndIllustrationsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetTopicThemesAndIllustrationsQuery = {
  adminGetTopic: {
    id: string;
    title: string;
    status?: TopicStatus | null;
    theme?: { id: string; title: string } | null;
    comments?: Array<{
      id: string;
      createdAt: any;
      message: string;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
      replies?: Array<{
        id: string;
        createdAt: any;
        message: string;
        author?: { id: string; name: string; avatarUrl?: string | null } | null;
      }> | null;
    }> | null;
    illustration?: { id: string; title: string; url?: string | null } | null;
    lessons?: Array<{ id: string; kind: LessonKind; title?: string | null }> | null;
  };
  adminListThemes: Array<{ id: string; title: string }>;
  adminListIllustrations: Array<{ id: string; title: string; url?: string | null }>;
};

export type ListTotpQueryVariables = Exact<{ [key: string]: never }>;

export type ListTotpQuery = {
  listTotp: Array<{ id: string; deviceName?: string | null; createdAt: any }>;
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  me: {
    id: string;
    name: string;
    email: string;
    avatarUrl?: string | null;
    needSpeakingPartner?: boolean | null;
    cambridgeEnglishLevel?: number | null;
    kind?: EventPermissions | null;
    firstName?: string | null;
    otherLanguage?: string | null;
    isComplete?: boolean | null;
    badge?: UserBadge | null;
    createdAt: any;
    lastName?: string | null;
    city?: string | null;
    country?: string | null;
    timezone?: string | null;
    story?: string | null;
    birthday?: any | null;
    interests?: Array<Interest> | null;
    showBirthday?: boolean | null;
    showBirthdayYear?: boolean | null;
    nationality?: string | null;
    nativeLanguage?: string | null;
    completedPercentage: number;
    isVisible?: boolean | null;
    wantsNewsletter?: boolean | null;
    promotionalCredits?: number | null;
    occupation?: { id: string; name?: string | null } | null;
    availability?: Array<{ from: string; until: string }> | null;
  };
};

export type AdminMemberStatsQueryVariables = Exact<{
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type AdminMemberStatsQuery = {
  adminMemberStats: Array<{
    userId: string;
    zone: ZoneLabel;
    eventsAttended: number;
    status?: string | null;
    lastMessagedAt?: any | null;
    plan?: string | null;
    lastOnlineAt?: any | null;
    faderLevel?: string | null;
    engagementLevel?: string | null;
    commitmentLevel?: string | null;
    loginsRecent: number;
    tenure?: string | null;
  }>;
};

export type AdminListUsersQueryVariables = Exact<{
  filters: AdminFilterUsersInput;
}>;

export type AdminListUsersQuery = {
  adminListUsers: {
    total: number;
    items?: Array<{
      id: string;
      name: string;
      email: string;
      avatarUrl?: string | null;
      needSpeakingPartner?: boolean | null;
      cambridgeEnglishLevel?: number | null;
      otherLanguage?: string | null;
      isComplete?: boolean | null;
      isVerified?: boolean | null;
      badge?: UserBadge | null;
      createdAt: any;
      recoveryStartedAt?: any | null;
      city?: string | null;
      country?: string | null;
      timezone?: string | null;
      story?: string | null;
      birthday?: any | null;
      interests?: Array<Interest> | null;
      showBirthday?: boolean | null;
      nativeLanguage?: string | null;
      completedPercentage: number;
      isVisible?: boolean | null;
      wantsNewsletter?: boolean | null;
      occupation?: { id: string; name?: string | null } | null;
      availability?: Array<{ from: string; until: string }> | null;
    }> | null;
  };
};

export type AdminGetSelectedUsersQueryVariables = Exact<{
  filters: AdminFilterUsersInput;
}>;

export type AdminGetSelectedUsersQuery = {
  adminGetSelectedUsers: Array<{
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    cambridgeEnglishLevel?: number | null;
    speakingLevelScore: number;
    speakingLevel: SpeakingLevelCategories;
    availableAssessmentCharges?: number | null;
    takenSpeakingAssessment?: boolean | null;
    city?: string | null;
    country?: string | null;
    birthday?: any | null;
    nativeLanguage?: string | null;
    needSpeakingPartner?: boolean | null;
    badge?: UserBadge | null;
    isVerified?: boolean | null;
    lastOnlineAt?: any | null;
    timezone?: string | null;
    isActive?: boolean | null;
    isComplete?: boolean | null;
    interests?: Array<Interest> | null;
    englishSkills?: Array<EnglishSkill> | null;
    createdAt: any;
    kind?: EventPermissions | null;
    showBirthday?: boolean | null;
    completedPercentage: number;
    isVisible?: boolean | null;
    wantsNewsletter?: boolean | null;
    availability?: Array<{ from: string; until: string }> | null;
    occupation?: { id: string; name?: string | null } | null;
    customers: Array<{
      subscriptions: Array<{
        status?: string | null;
        plan?: any | null;
        currentPeriodStart?: any | null;
        currentPeriodEnd?: any | null;
        resumesAt?: any | null;
        cancelledAt?: any | null;
      }>;
    }>;
  }>;
};

export type AdminGetPlanDetailsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AdminGetPlanDetailsQuery = {
  adminGetPlanDetails: {
    itemPriceId?: string | null;
    subscriptionChargebeeId?: string | null;
    customerChargebeeId?: string | null;
    userAmount?: number | null;
  };
};

export type GetUserAdminQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetUserAdminQuery = {
  getUserAdmin?: {
    id: string;
    email: string;
    name: string;
    createdAt: any;
    kind?: EventPermissions | null;
    avatarUrl?: string | null;
    needSpeakingPartner?: boolean | null;
    cambridgeEnglishLevel?: number | null;
    speakingLevelScore: number;
    speakingLevel: SpeakingLevelCategories;
    firstName?: string | null;
    otherLanguage?: string | null;
    isComplete?: boolean | null;
    badge?: UserBadge | null;
    lastName?: string | null;
    isActive?: boolean | null;
    isBanned: boolean;
    isVerified?: boolean | null;
    hasPassword: boolean;
    city?: string | null;
    country?: string | null;
    timezone?: string | null;
    story?: string | null;
    birthday?: any | null;
    interests?: Array<Interest> | null;
    isAgeVisible?: boolean | null;
    showBirthday?: boolean | null;
    nativeLanguage?: string | null;
    completedPercentage: number;
    isVisible?: boolean | null;
    isFeatured?: boolean | null;
    wantsNewsletter?: boolean | null;
    hasActivePlan: boolean;
    availableAssessmentCharges?: number | null;
    extraInvitedFriends?: number | null;
    occupation?: { id: string; name?: string | null } | null;
    badges: Array<{ id: string; type: UserBadgeType; achievedDate?: any | null }>;
    availability?: Array<{ from: string; until: string }> | null;
    notes: Array<{ id: string; description: string }>;
    engagementMetrics?: { totalRsvps?: number | null } | null;
  } | null;
};

export type AdminGuestPassSummaryQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AdminGuestPassSummaryQuery = {
  adminGuestPassSummary?: {
    id: string;
    startsAt: any;
    endsAt: any;
    daysRemaining: number;
    tokenAllowance: number;
    tokensUsed: number;
    tokensRemaining: number;
    isActive: boolean;
  } | null;
  adminGuestPassTokenAdjustments: Array<{
    id: string;
    amount: number;
    reason: string;
    grantedById: string;
    grantedByName?: string | null;
    grantedByEmail?: string | null;
    createdAt: any;
  }>;
};

export type AdminGetOccupationsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminGetOccupationsQuery = {
  adminGetOccupations: Array<{ id: string; name?: string | null }>;
};

export type AdminGetGroupedOccupationsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminGetGroupedOccupationsQuery = {
  adminGetGroupedOccupations: Array<{
    id: string;
    name?: string | null;
    industry?: { id: string; name: string } | null;
  }>;
};

export type GetInvitedFriendsStatsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetInvitedFriendsStatsQuery = {
  getInvitedFriendsStats: {
    invitedFriendsTotal?: number | null;
    invitedPaidFriends?: number | null;
  };
};

export type ListPaginatedAssessmentResultsQueryVariables = Exact<{
  filters: PaginatedAssessmentResultInput;
}>;

export type ListPaginatedAssessmentResultsQuery = {
  listPaginatedAssessmentResults: {
    total: number;
    items?: Array<{
      id: string;
      assessmentId: string;
      cefrScore?: string | null;
      halloScore: number;
      createdAt: any;
    }> | null;
  };
};

export type GetUserAssessmentResultsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
  filters: PaginatedAssessmentResultInput;
}>;

export type GetUserAssessmentResultsQuery = {
  getUserAssessmentResults: {
    total: number;
    items?: Array<{
      id: string;
      assessmentId: string;
      cefrScore?: string | null;
      halloScore: number;
      createdAt: any;
      isAddedByAdmin: boolean;
    }> | null;
  };
};

export type TotalHostedParticipantsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type TotalHostedParticipantsQuery = { totalHostedParticipants: number };

export type TotalPublishedArticlesQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type TotalPublishedArticlesQuery = { totalPublishedArticles: number };

export type AttendanceRatioQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AttendanceRatioQuery = { attendanceRatio: number };

export type AttendanceMetricsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AttendanceMetricsQuery = {
  attendanceMetrics?: {
    totalEvents?: number | null;
    totalOneToOnes?: number | null;
    totalGroup?: number | null;
    totalWebinars?: number | null;
    totalInPerson?: number | null;
    totalOther?: number | null;
    totalDuration?: number | null;
    hostedEvents?: number | null;
    hostedOneToOnes?: number | null;
    hostedGroup?: number | null;
    hostedWebinars?: number | null;
    hostedInPerson?: number | null;
    hostedOther?: number | null;
    hostedDuration?: number | null;
    attendedEvents?: number | null;
    totalAttendedScheduledEvents?: number | null;
    totalAttendedNonScheduledEvents?: number | null;
    attendedOneToOnes?: number | null;
    attendedGroup?: number | null;
    attendedWebinars?: number | null;
    attendedInPerson?: number | null;
    attendedOther?: number | null;
    attendedDuration?: number | null;
    videoCalls?: number | null;
  } | null;
};

export type GetUserCalendarQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserCalendarQuery = { getUserCalendar?: { url: string } | null };

export type AdminListPaginatedVideoSetsQueryVariables = Exact<{
  filters: AdminFilterVideoSetInput;
}>;

export type AdminListPaginatedVideoSetsQuery = {
  adminListPaginatedVideoSets: {
    total: number;
    items?: Array<{
      id: string;
      title: string;
      isActive: boolean;
      audience?: Array<Audience> | null;
      colour?: ColourCode | null;
      updatedAt: any;
    }> | null;
  };
};

export type AdminGetVideoSetQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetVideoSetQuery = {
  adminGetVideoSet?: {
    id: string;
    title: string;
    isActive: boolean;
    audience?: Array<Audience> | null;
    colour?: ColourCode | null;
    updatedAt: any;
    videos?: Array<{
      id: string;
      title?: string | null;
      videoURL?: string | null;
      thumbnail?: string | null;
      isActive: boolean;
      position: number;
    }> | null;
  } | null;
};

export type AdminGetZineCoverQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminGetZineCoverQuery = {
  adminGetZineCover: { id: string; coverUrl?: string | null; isCurrent?: boolean | null };
};

export type AdminListPaginatedZineCoversQueryVariables = Exact<{
  filters: AdminFilterZineCoversInput;
}>;

export type AdminListPaginatedZineCoversQuery = {
  adminListPaginatedZineCovers: {
    total: number;
    items?: Array<{ id: string; coverUrl?: string | null; isCurrent?: boolean | null }> | null;
  };
};

export type AdminForceSignOutMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AdminForceSignOutMutation = { adminForceSignOut?: { status: MutationStatus } | null };

export type AdminSecurityEventsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdminSecurityEventsQuery = {
  adminSecurityEvents?: Array<{
    id: string;
    type: SecurityEventType;
    ipAddress?: string | null;
    userAgent?: string | null;
    createdAt: any;
  }> | null;
};

export const AdminDeleteArticleDocument = gql`
    mutation adminDeleteArticle($id: String!) {
  adminDeleteArticle(id: $id) {
    status
  }
}
    `;
export type AdminDeleteArticleMutationFn = Apollo.MutationFunction<
  AdminDeleteArticleMutation,
  AdminDeleteArticleMutationVariables
>;

/**
 * __useAdminDeleteArticleMutation__
 *
 * To run a mutation, you first call `useAdminDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteArticleMutation, { data, loading, error }] = useAdminDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteArticleMutation,
    AdminDeleteArticleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteArticleMutation, AdminDeleteArticleMutationVariables>(
    AdminDeleteArticleDocument,
    options,
  );
}
export type AdminDeleteArticleMutationHookResult = ReturnType<typeof useAdminDeleteArticleMutation>;
export type AdminDeleteArticleMutationResult = Apollo.MutationResult<AdminDeleteArticleMutation>;
export type AdminDeleteArticleMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteArticleMutation,
  AdminDeleteArticleMutationVariables
>;
export const AdminEditArticleDocument = gql`
    mutation adminEditArticle($id: String!, $input: EditArticleInput!) {
  adminEditArticle(id: $id, input: $input) {
    id
    title
    isVisible
    isFeatured
    isDraft
  }
}
    `;
export type AdminEditArticleMutationFn = Apollo.MutationFunction<
  AdminEditArticleMutation,
  AdminEditArticleMutationVariables
>;

/**
 * __useAdminEditArticleMutation__
 *
 * To run a mutation, you first call `useAdminEditArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditArticleMutation, { data, loading, error }] = useAdminEditArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditArticleMutation,
    AdminEditArticleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditArticleMutation, AdminEditArticleMutationVariables>(
    AdminEditArticleDocument,
    options,
  );
}
export type AdminEditArticleMutationHookResult = ReturnType<typeof useAdminEditArticleMutation>;
export type AdminEditArticleMutationResult = Apollo.MutationResult<AdminEditArticleMutation>;
export type AdminEditArticleMutationOptions = Apollo.BaseMutationOptions<
  AdminEditArticleMutation,
  AdminEditArticleMutationVariables
>;
export const AdminGenerateAttachmentUploadUrlDocument = gql`
    mutation adminGenerateAttachmentUploadUrl($filename: String!) {
  adminGenerateAttachmentUploadUrl(filename: $filename) {
    contentURL
    uploadURL
  }
}
    `;
export type AdminGenerateAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
  AdminGenerateAttachmentUploadUrlMutation,
  AdminGenerateAttachmentUploadUrlMutationVariables
>;

/**
 * __useAdminGenerateAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useAdminGenerateAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminGenerateAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminGenerateAttachmentUploadUrlMutation, { data, loading, error }] = useAdminGenerateAttachmentUploadUrlMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useAdminGenerateAttachmentUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminGenerateAttachmentUploadUrlMutation,
    AdminGenerateAttachmentUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminGenerateAttachmentUploadUrlMutation,
    AdminGenerateAttachmentUploadUrlMutationVariables
  >(AdminGenerateAttachmentUploadUrlDocument, options);
}
export type AdminGenerateAttachmentUploadUrlMutationHookResult = ReturnType<
  typeof useAdminGenerateAttachmentUploadUrlMutation
>;
export type AdminGenerateAttachmentUploadUrlMutationResult =
  Apollo.MutationResult<AdminGenerateAttachmentUploadUrlMutation>;
export type AdminGenerateAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  AdminGenerateAttachmentUploadUrlMutation,
  AdminGenerateAttachmentUploadUrlMutationVariables
>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($commentID: String!) {
  deleteComment(commentID: $commentID) {
    status
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(
    DeleteCommentDocument,
    options,
  );
}
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export const AdminCreateCoverDocument = gql`
    mutation adminCreateCover($input: CreateCoverInput!) {
  adminCreateCover(input: $input) {
    id
    title
    primary {
      mobile
      desktop
    }
    secondary {
      mobile
      desktop
    }
    tertiary {
      mobile
      desktop
    }
  }
}
    `;
export type AdminCreateCoverMutationFn = Apollo.MutationFunction<
  AdminCreateCoverMutation,
  AdminCreateCoverMutationVariables
>;

/**
 * __useAdminCreateCoverMutation__
 *
 * To run a mutation, you first call `useAdminCreateCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCoverMutation, { data, loading, error }] = useAdminCreateCoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateCoverMutation,
    AdminCreateCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateCoverMutation, AdminCreateCoverMutationVariables>(
    AdminCreateCoverDocument,
    options,
  );
}
export type AdminCreateCoverMutationHookResult = ReturnType<typeof useAdminCreateCoverMutation>;
export type AdminCreateCoverMutationResult = Apollo.MutationResult<AdminCreateCoverMutation>;
export type AdminCreateCoverMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateCoverMutation,
  AdminCreateCoverMutationVariables
>;
export const AdminEditCoverDocument = gql`
    mutation adminEditCover($id: String!, $input: EditCoverInput!) {
  adminEditCover(id: $id, input: $input) {
    id
    title
    primary {
      mobile
      desktop
    }
    secondary {
      mobile
      desktop
    }
    tertiary {
      mobile
      desktop
    }
  }
}
    `;
export type AdminEditCoverMutationFn = Apollo.MutationFunction<
  AdminEditCoverMutation,
  AdminEditCoverMutationVariables
>;

/**
 * __useAdminEditCoverMutation__
 *
 * To run a mutation, you first call `useAdminEditCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditCoverMutation, { data, loading, error }] = useAdminEditCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditCoverMutation, AdminEditCoverMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditCoverMutation, AdminEditCoverMutationVariables>(
    AdminEditCoverDocument,
    options,
  );
}
export type AdminEditCoverMutationHookResult = ReturnType<typeof useAdminEditCoverMutation>;
export type AdminEditCoverMutationResult = Apollo.MutationResult<AdminEditCoverMutation>;
export type AdminEditCoverMutationOptions = Apollo.BaseMutationOptions<
  AdminEditCoverMutation,
  AdminEditCoverMutationVariables
>;
export const AdminDeleteCoverDocument = gql`
    mutation adminDeleteCover($id: String!) {
  adminDeleteCover(id: $id) {
    status
  }
}
    `;
export type AdminDeleteCoverMutationFn = Apollo.MutationFunction<
  AdminDeleteCoverMutation,
  AdminDeleteCoverMutationVariables
>;

/**
 * __useAdminDeleteCoverMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCoverMutation, { data, loading, error }] = useAdminDeleteCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteCoverMutation,
    AdminDeleteCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteCoverMutation, AdminDeleteCoverMutationVariables>(
    AdminDeleteCoverDocument,
    options,
  );
}
export type AdminDeleteCoverMutationHookResult = ReturnType<typeof useAdminDeleteCoverMutation>;
export type AdminDeleteCoverMutationResult = Apollo.MutationResult<AdminDeleteCoverMutation>;
export type AdminDeleteCoverMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteCoverMutation,
  AdminDeleteCoverMutationVariables
>;
export const AdminDeleteEventDocument = gql`
    mutation adminDeleteEvent($id: String!) {
  adminDeleteEvent(id: $id) {
    status
  }
}
    `;
export type AdminDeleteEventMutationFn = Apollo.MutationFunction<
  AdminDeleteEventMutation,
  AdminDeleteEventMutationVariables
>;

/**
 * __useAdminDeleteEventMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEventMutation, { data, loading, error }] = useAdminDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteEventMutation,
    AdminDeleteEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteEventMutation, AdminDeleteEventMutationVariables>(
    AdminDeleteEventDocument,
    options,
  );
}
export type AdminDeleteEventMutationHookResult = ReturnType<typeof useAdminDeleteEventMutation>;
export type AdminDeleteEventMutationResult = Apollo.MutationResult<AdminDeleteEventMutation>;
export type AdminDeleteEventMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteEventMutation,
  AdminDeleteEventMutationVariables
>;
export const AdminEditEventDocument = gql`
    mutation adminEditEvent($id: String!, $input: EditEventInput!) {
  adminEditEvent(id: $id, input: $input) {
    status
  }
}
    `;
export type AdminEditEventMutationFn = Apollo.MutationFunction<
  AdminEditEventMutation,
  AdminEditEventMutationVariables
>;

/**
 * __useAdminEditEventMutation__
 *
 * To run a mutation, you first call `useAdminEditEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditEventMutation, { data, loading, error }] = useAdminEditEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditEventMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditEventMutation, AdminEditEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditEventMutation, AdminEditEventMutationVariables>(
    AdminEditEventDocument,
    options,
  );
}
export type AdminEditEventMutationHookResult = ReturnType<typeof useAdminEditEventMutation>;
export type AdminEditEventMutationResult = Apollo.MutationResult<AdminEditEventMutation>;
export type AdminEditEventMutationOptions = Apollo.BaseMutationOptions<
  AdminEditEventMutation,
  AdminEditEventMutationVariables
>;
export const AdminRepublishEventDocument = gql`
    mutation adminRepublishEvent($eventId: String!) {
  adminRepublishEvent(eventId: $eventId) {
    status
  }
}
    `;
export type AdminRepublishEventMutationFn = Apollo.MutationFunction<
  AdminRepublishEventMutation,
  AdminRepublishEventMutationVariables
>;

/**
 * __useAdminRepublishEventMutation__
 *
 * To run a mutation, you first call `useAdminRepublishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRepublishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRepublishEventMutation, { data, loading, error }] = useAdminRepublishEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAdminRepublishEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminRepublishEventMutation,
    AdminRepublishEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminRepublishEventMutation, AdminRepublishEventMutationVariables>(
    AdminRepublishEventDocument,
    options,
  );
}
export type AdminRepublishEventMutationHookResult = ReturnType<
  typeof useAdminRepublishEventMutation
>;
export type AdminRepublishEventMutationResult = Apollo.MutationResult<AdminRepublishEventMutation>;
export type AdminRepublishEventMutationOptions = Apollo.BaseMutationOptions<
  AdminRepublishEventMutation,
  AdminRepublishEventMutationVariables
>;
export const ValidateUsersForEmailBulkInviteDocument = gql`
    mutation validateUsersForEmailBulkInvite($eventId: String!, $input: BulkInviteWithEmailsInput!) {
  validateUsersForEmailBulkInvite(eventId: $eventId, input: $input) {
    userIds
    warningMessages
  }
}
    `;
export type ValidateUsersForEmailBulkInviteMutationFn = Apollo.MutationFunction<
  ValidateUsersForEmailBulkInviteMutation,
  ValidateUsersForEmailBulkInviteMutationVariables
>;

/**
 * __useValidateUsersForEmailBulkInviteMutation__
 *
 * To run a mutation, you first call `useValidateUsersForEmailBulkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateUsersForEmailBulkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateUsersForEmailBulkInviteMutation, { data, loading, error }] = useValidateUsersForEmailBulkInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateUsersForEmailBulkInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateUsersForEmailBulkInviteMutation,
    ValidateUsersForEmailBulkInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateUsersForEmailBulkInviteMutation,
    ValidateUsersForEmailBulkInviteMutationVariables
  >(ValidateUsersForEmailBulkInviteDocument, options);
}
export type ValidateUsersForEmailBulkInviteMutationHookResult = ReturnType<
  typeof useValidateUsersForEmailBulkInviteMutation
>;
export type ValidateUsersForEmailBulkInviteMutationResult =
  Apollo.MutationResult<ValidateUsersForEmailBulkInviteMutation>;
export type ValidateUsersForEmailBulkInviteMutationOptions = Apollo.BaseMutationOptions<
  ValidateUsersForEmailBulkInviteMutation,
  ValidateUsersForEmailBulkInviteMutationVariables
>;
export const BulkInviteWithUserIdsDocument = gql`
    mutation bulkInviteWithUserIds($eventId: String!, $input: BulkInviteWithUserIdsInput!) {
  bulkInviteWithUserIds(eventId: $eventId, input: $input) {
    warningMessages
    invitedUserIds
  }
}
    `;
export type BulkInviteWithUserIdsMutationFn = Apollo.MutationFunction<
  BulkInviteWithUserIdsMutation,
  BulkInviteWithUserIdsMutationVariables
>;

/**
 * __useBulkInviteWithUserIdsMutation__
 *
 * To run a mutation, you first call `useBulkInviteWithUserIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkInviteWithUserIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkInviteWithUserIdsMutation, { data, loading, error }] = useBulkInviteWithUserIdsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkInviteWithUserIdsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkInviteWithUserIdsMutation,
    BulkInviteWithUserIdsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkInviteWithUserIdsMutation, BulkInviteWithUserIdsMutationVariables>(
    BulkInviteWithUserIdsDocument,
    options,
  );
}
export type BulkInviteWithUserIdsMutationHookResult = ReturnType<
  typeof useBulkInviteWithUserIdsMutation
>;
export type BulkInviteWithUserIdsMutationResult =
  Apollo.MutationResult<BulkInviteWithUserIdsMutation>;
export type BulkInviteWithUserIdsMutationOptions = Apollo.BaseMutationOptions<
  BulkInviteWithUserIdsMutation,
  BulkInviteWithUserIdsMutationVariables
>;
export const ValidateForSelectionBulkInviteDocument = gql`
    mutation validateForSelectionBulkInvite($eventId: String!, $filters: AdminFilterUsersInput!) {
  validateForSelectionBulkInvite(eventId: $eventId, filters: $filters) {
    eventTitle
    userIds
    warningMessages
  }
}
    `;
export type ValidateForSelectionBulkInviteMutationFn = Apollo.MutationFunction<
  ValidateForSelectionBulkInviteMutation,
  ValidateForSelectionBulkInviteMutationVariables
>;

/**
 * __useValidateForSelectionBulkInviteMutation__
 *
 * To run a mutation, you first call `useValidateForSelectionBulkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateForSelectionBulkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateForSelectionBulkInviteMutation, { data, loading, error }] = useValidateForSelectionBulkInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useValidateForSelectionBulkInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateForSelectionBulkInviteMutation,
    ValidateForSelectionBulkInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateForSelectionBulkInviteMutation,
    ValidateForSelectionBulkInviteMutationVariables
  >(ValidateForSelectionBulkInviteDocument, options);
}
export type ValidateForSelectionBulkInviteMutationHookResult = ReturnType<
  typeof useValidateForSelectionBulkInviteMutation
>;
export type ValidateForSelectionBulkInviteMutationResult =
  Apollo.MutationResult<ValidateForSelectionBulkInviteMutation>;
export type ValidateForSelectionBulkInviteMutationOptions = Apollo.BaseMutationOptions<
  ValidateForSelectionBulkInviteMutation,
  ValidateForSelectionBulkInviteMutationVariables
>;
export const AdminSelectionUserIdsDocument = gql`
    mutation adminSelectionUserIds($filters: AdminFilterUsersInput!, $eventId: String) {
  adminSelectionUserIds(filters: $filters, eventId: $eventId) {
    userIds
    totalMatched
    truncated
    cap
    eligibleCount
    alreadySharedCount
    notAllowedCount
    inactiveCount
  }
}
    `;
export type AdminSelectionUserIdsMutationFn = Apollo.MutationFunction<
  AdminSelectionUserIdsMutation,
  AdminSelectionUserIdsMutationVariables
>;

/**
 * __useAdminSelectionUserIdsMutation__
 *
 * To run a mutation, you first call `useAdminSelectionUserIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSelectionUserIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSelectionUserIdsMutation, { data, loading, error }] = useAdminSelectionUserIdsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAdminSelectionUserIdsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminSelectionUserIdsMutation,
    AdminSelectionUserIdsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminSelectionUserIdsMutation, AdminSelectionUserIdsMutationVariables>(
    AdminSelectionUserIdsDocument,
    options,
  );
}
export type AdminSelectionUserIdsMutationHookResult = ReturnType<
  typeof useAdminSelectionUserIdsMutation
>;
export type AdminSelectionUserIdsMutationResult =
  Apollo.MutationResult<AdminSelectionUserIdsMutation>;
export type AdminSelectionUserIdsMutationOptions = Apollo.BaseMutationOptions<
  AdminSelectionUserIdsMutation,
  AdminSelectionUserIdsMutationVariables
>;
export const AdminValidateBulkUploadEventsDocument = gql`
    mutation adminValidateBulkUploadEvents($input: BulkUploadEventsInput!) {
  adminValidateBulkUploadEvents(input: $input) {
    totalRows
    validationErrors {
      row
      eventTitle
      column
      message
    }
    inviteWarnings {
      row
      eventTitle
      column
      message
    }
  }
}
    `;
export type AdminValidateBulkUploadEventsMutationFn = Apollo.MutationFunction<
  AdminValidateBulkUploadEventsMutation,
  AdminValidateBulkUploadEventsMutationVariables
>;

/**
 * __useAdminValidateBulkUploadEventsMutation__
 *
 * To run a mutation, you first call `useAdminValidateBulkUploadEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminValidateBulkUploadEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminValidateBulkUploadEventsMutation, { data, loading, error }] = useAdminValidateBulkUploadEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminValidateBulkUploadEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminValidateBulkUploadEventsMutation,
    AdminValidateBulkUploadEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminValidateBulkUploadEventsMutation,
    AdminValidateBulkUploadEventsMutationVariables
  >(AdminValidateBulkUploadEventsDocument, options);
}
export type AdminValidateBulkUploadEventsMutationHookResult = ReturnType<
  typeof useAdminValidateBulkUploadEventsMutation
>;
export type AdminValidateBulkUploadEventsMutationResult =
  Apollo.MutationResult<AdminValidateBulkUploadEventsMutation>;
export type AdminValidateBulkUploadEventsMutationOptions = Apollo.BaseMutationOptions<
  AdminValidateBulkUploadEventsMutation,
  AdminValidateBulkUploadEventsMutationVariables
>;
export const AdminBulkUploadEventsDocument = gql`
    mutation adminBulkUploadEvents($input: BulkUploadEventsInput!) {
  adminBulkUploadEvents(input: $input) {
    createdCount
    createdEvents {
      row
      id
      title
    }
    validationErrors {
      row
      eventTitle
      column
      message
    }
    inviteWarnings {
      row
      eventTitle
      column
      message
    }
  }
}
    `;
export type AdminBulkUploadEventsMutationFn = Apollo.MutationFunction<
  AdminBulkUploadEventsMutation,
  AdminBulkUploadEventsMutationVariables
>;

/**
 * __useAdminBulkUploadEventsMutation__
 *
 * To run a mutation, you first call `useAdminBulkUploadEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkUploadEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkUploadEventsMutation, { data, loading, error }] = useAdminBulkUploadEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBulkUploadEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminBulkUploadEventsMutation,
    AdminBulkUploadEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminBulkUploadEventsMutation, AdminBulkUploadEventsMutationVariables>(
    AdminBulkUploadEventsDocument,
    options,
  );
}
export type AdminBulkUploadEventsMutationHookResult = ReturnType<
  typeof useAdminBulkUploadEventsMutation
>;
export type AdminBulkUploadEventsMutationResult =
  Apollo.MutationResult<AdminBulkUploadEventsMutation>;
export type AdminBulkUploadEventsMutationOptions = Apollo.BaseMutationOptions<
  AdminBulkUploadEventsMutation,
  AdminBulkUploadEventsMutationVariables
>;
export const AdminCreateFeatureFlagDocument = gql`
    mutation adminCreateFeatureFlag($input: CreateFeatureFlagInput!) {
  adminCreateFeatureFlag(input: $input) {
    id
    label
    active
  }
}
    `;
export type AdminCreateFeatureFlagMutationFn = Apollo.MutationFunction<
  AdminCreateFeatureFlagMutation,
  AdminCreateFeatureFlagMutationVariables
>;

/**
 * __useAdminCreateFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAdminCreateFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateFeatureFlagMutation, { data, loading, error }] = useAdminCreateFeatureFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateFeatureFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateFeatureFlagMutation,
    AdminCreateFeatureFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminCreateFeatureFlagMutation,
    AdminCreateFeatureFlagMutationVariables
  >(AdminCreateFeatureFlagDocument, options);
}
export type AdminCreateFeatureFlagMutationHookResult = ReturnType<
  typeof useAdminCreateFeatureFlagMutation
>;
export type AdminCreateFeatureFlagMutationResult =
  Apollo.MutationResult<AdminCreateFeatureFlagMutation>;
export type AdminCreateFeatureFlagMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateFeatureFlagMutation,
  AdminCreateFeatureFlagMutationVariables
>;
export const AdminEditFeatureFlagDocument = gql`
    mutation adminEditFeatureFlag($id: String!, $input: EditFeatureFlagInput!) {
  adminEditFeatureFlag(id: $id, input: $input) {
    id
    label
    active
  }
}
    `;
export type AdminEditFeatureFlagMutationFn = Apollo.MutationFunction<
  AdminEditFeatureFlagMutation,
  AdminEditFeatureFlagMutationVariables
>;

/**
 * __useAdminEditFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAdminEditFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditFeatureFlagMutation, { data, loading, error }] = useAdminEditFeatureFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditFeatureFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditFeatureFlagMutation,
    AdminEditFeatureFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditFeatureFlagMutation, AdminEditFeatureFlagMutationVariables>(
    AdminEditFeatureFlagDocument,
    options,
  );
}
export type AdminEditFeatureFlagMutationHookResult = ReturnType<
  typeof useAdminEditFeatureFlagMutation
>;
export type AdminEditFeatureFlagMutationResult =
  Apollo.MutationResult<AdminEditFeatureFlagMutation>;
export type AdminEditFeatureFlagMutationOptions = Apollo.BaseMutationOptions<
  AdminEditFeatureFlagMutation,
  AdminEditFeatureFlagMutationVariables
>;
export const AdminDeleteFeatureFlagDocument = gql`
    mutation adminDeleteFeatureFlag($id: String!) {
  adminDeleteFeatureFlag(id: $id) {
    reason
    status
  }
}
    `;
export type AdminDeleteFeatureFlagMutationFn = Apollo.MutationFunction<
  AdminDeleteFeatureFlagMutation,
  AdminDeleteFeatureFlagMutationVariables
>;

/**
 * __useAdminDeleteFeatureFlagMutation__
 *
 * To run a mutation, you first call `useAdminDeleteFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteFeatureFlagMutation, { data, loading, error }] = useAdminDeleteFeatureFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteFeatureFlagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteFeatureFlagMutation,
    AdminDeleteFeatureFlagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminDeleteFeatureFlagMutation,
    AdminDeleteFeatureFlagMutationVariables
  >(AdminDeleteFeatureFlagDocument, options);
}
export type AdminDeleteFeatureFlagMutationHookResult = ReturnType<
  typeof useAdminDeleteFeatureFlagMutation
>;
export type AdminDeleteFeatureFlagMutationResult =
  Apollo.MutationResult<AdminDeleteFeatureFlagMutation>;
export type AdminDeleteFeatureFlagMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteFeatureFlagMutation,
  AdminDeleteFeatureFlagMutationVariables
>;
export const AdminDeleteIllustrationDocument = gql`
    mutation adminDeleteIllustration($id: String!) {
  adminDeleteIllustration(id: $id) {
    status
  }
}
    `;
export type AdminDeleteIllustrationMutationFn = Apollo.MutationFunction<
  AdminDeleteIllustrationMutation,
  AdminDeleteIllustrationMutationVariables
>;

/**
 * __useAdminDeleteIllustrationMutation__
 *
 * To run a mutation, you first call `useAdminDeleteIllustrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteIllustrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteIllustrationMutation, { data, loading, error }] = useAdminDeleteIllustrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteIllustrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteIllustrationMutation,
    AdminDeleteIllustrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminDeleteIllustrationMutation,
    AdminDeleteIllustrationMutationVariables
  >(AdminDeleteIllustrationDocument, options);
}
export type AdminDeleteIllustrationMutationHookResult = ReturnType<
  typeof useAdminDeleteIllustrationMutation
>;
export type AdminDeleteIllustrationMutationResult =
  Apollo.MutationResult<AdminDeleteIllustrationMutation>;
export type AdminDeleteIllustrationMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteIllustrationMutation,
  AdminDeleteIllustrationMutationVariables
>;
export const AdminCreateIllustrationDocument = gql`
    mutation adminCreateIllustration($input: CreateIllustrationInput!) {
  adminCreateIllustration(input: $input) {
    id
    title
    url
  }
}
    `;
export type AdminCreateIllustrationMutationFn = Apollo.MutationFunction<
  AdminCreateIllustrationMutation,
  AdminCreateIllustrationMutationVariables
>;

/**
 * __useAdminCreateIllustrationMutation__
 *
 * To run a mutation, you first call `useAdminCreateIllustrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateIllustrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateIllustrationMutation, { data, loading, error }] = useAdminCreateIllustrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateIllustrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateIllustrationMutation,
    AdminCreateIllustrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminCreateIllustrationMutation,
    AdminCreateIllustrationMutationVariables
  >(AdminCreateIllustrationDocument, options);
}
export type AdminCreateIllustrationMutationHookResult = ReturnType<
  typeof useAdminCreateIllustrationMutation
>;
export type AdminCreateIllustrationMutationResult =
  Apollo.MutationResult<AdminCreateIllustrationMutation>;
export type AdminCreateIllustrationMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateIllustrationMutation,
  AdminCreateIllustrationMutationVariables
>;
export const AdminEditIllustrationDocument = gql`
    mutation adminEditIllustration($id: String!, $input: EditIllustrationInput!) {
  adminEditIllustration(id: $id, input: $input) {
    id
    title
    url
  }
}
    `;
export type AdminEditIllustrationMutationFn = Apollo.MutationFunction<
  AdminEditIllustrationMutation,
  AdminEditIllustrationMutationVariables
>;

/**
 * __useAdminEditIllustrationMutation__
 *
 * To run a mutation, you first call `useAdminEditIllustrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditIllustrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditIllustrationMutation, { data, loading, error }] = useAdminEditIllustrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditIllustrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditIllustrationMutation,
    AdminEditIllustrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditIllustrationMutation, AdminEditIllustrationMutationVariables>(
    AdminEditIllustrationDocument,
    options,
  );
}
export type AdminEditIllustrationMutationHookResult = ReturnType<
  typeof useAdminEditIllustrationMutation
>;
export type AdminEditIllustrationMutationResult =
  Apollo.MutationResult<AdminEditIllustrationMutation>;
export type AdminEditIllustrationMutationOptions = Apollo.BaseMutationOptions<
  AdminEditIllustrationMutation,
  AdminEditIllustrationMutationVariables
>;
export const AdminDeleteLessonDocument = gql`
    mutation adminDeleteLesson($id: String!) {
  adminDeleteLesson(id: $id) {
    reason
    status
  }
}
    `;
export type AdminDeleteLessonMutationFn = Apollo.MutationFunction<
  AdminDeleteLessonMutation,
  AdminDeleteLessonMutationVariables
>;

/**
 * __useAdminDeleteLessonMutation__
 *
 * To run a mutation, you first call `useAdminDeleteLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteLessonMutation, { data, loading, error }] = useAdminDeleteLessonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteLessonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteLessonMutation,
    AdminDeleteLessonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteLessonMutation, AdminDeleteLessonMutationVariables>(
    AdminDeleteLessonDocument,
    options,
  );
}
export type AdminDeleteLessonMutationHookResult = ReturnType<typeof useAdminDeleteLessonMutation>;
export type AdminDeleteLessonMutationResult = Apollo.MutationResult<AdminDeleteLessonMutation>;
export type AdminDeleteLessonMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteLessonMutation,
  AdminDeleteLessonMutationVariables
>;
export const AdminCreateLessonDocument = gql`
    mutation adminCreateLesson($input: CreateLessonInput!) {
  adminCreateLesson(input: $input) {
    id
    sections {
      id
      order
      elements {
        kind
        meta
      }
    }
  }
}
    `;
export type AdminCreateLessonMutationFn = Apollo.MutationFunction<
  AdminCreateLessonMutation,
  AdminCreateLessonMutationVariables
>;

/**
 * __useAdminCreateLessonMutation__
 *
 * To run a mutation, you first call `useAdminCreateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateLessonMutation, { data, loading, error }] = useAdminCreateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateLessonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateLessonMutation,
    AdminCreateLessonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateLessonMutation, AdminCreateLessonMutationVariables>(
    AdminCreateLessonDocument,
    options,
  );
}
export type AdminCreateLessonMutationHookResult = ReturnType<typeof useAdminCreateLessonMutation>;
export type AdminCreateLessonMutationResult = Apollo.MutationResult<AdminCreateLessonMutation>;
export type AdminCreateLessonMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateLessonMutation,
  AdminCreateLessonMutationVariables
>;
export const AdminEditLessonDocument = gql`
    mutation adminEditLesson($id: String!, $input: EditLessonInput!) {
  adminEditLesson(id: $id, input: $input) {
    id
    deepDiveKind
    kind
  }
}
    `;
export type AdminEditLessonMutationFn = Apollo.MutationFunction<
  AdminEditLessonMutation,
  AdminEditLessonMutationVariables
>;

/**
 * __useAdminEditLessonMutation__
 *
 * To run a mutation, you first call `useAdminEditLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditLessonMutation, { data, loading, error }] = useAdminEditLessonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditLessonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditLessonMutation,
    AdminEditLessonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditLessonMutation, AdminEditLessonMutationVariables>(
    AdminEditLessonDocument,
    options,
  );
}
export type AdminEditLessonMutationHookResult = ReturnType<typeof useAdminEditLessonMutation>;
export type AdminEditLessonMutationResult = Apollo.MutationResult<AdminEditLessonMutation>;
export type AdminEditLessonMutationOptions = Apollo.BaseMutationOptions<
  AdminEditLessonMutation,
  AdminEditLessonMutationVariables
>;
export const TriggerBackupEventsParticipantsDocument = gql`
    mutation triggerBackupEventsParticipants {
  triggerBackupEventsParticipants {
    status
  }
}
    `;
export type TriggerBackupEventsParticipantsMutationFn = Apollo.MutationFunction<
  TriggerBackupEventsParticipantsMutation,
  TriggerBackupEventsParticipantsMutationVariables
>;

/**
 * __useTriggerBackupEventsParticipantsMutation__
 *
 * To run a mutation, you first call `useTriggerBackupEventsParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerBackupEventsParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerBackupEventsParticipantsMutation, { data, loading, error }] = useTriggerBackupEventsParticipantsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerBackupEventsParticipantsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerBackupEventsParticipantsMutation,
    TriggerBackupEventsParticipantsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerBackupEventsParticipantsMutation,
    TriggerBackupEventsParticipantsMutationVariables
  >(TriggerBackupEventsParticipantsDocument, options);
}
export type TriggerBackupEventsParticipantsMutationHookResult = ReturnType<
  typeof useTriggerBackupEventsParticipantsMutation
>;
export type TriggerBackupEventsParticipantsMutationResult =
  Apollo.MutationResult<TriggerBackupEventsParticipantsMutation>;
export type TriggerBackupEventsParticipantsMutationOptions = Apollo.BaseMutationOptions<
  TriggerBackupEventsParticipantsMutation,
  TriggerBackupEventsParticipantsMutationVariables
>;
export const TriggerUserPermissionPromotionDocument = gql`
    mutation triggerUserPermissionPromotion {
  triggerUserPermissionPromotion {
    status
  }
}
    `;
export type TriggerUserPermissionPromotionMutationFn = Apollo.MutationFunction<
  TriggerUserPermissionPromotionMutation,
  TriggerUserPermissionPromotionMutationVariables
>;

/**
 * __useTriggerUserPermissionPromotionMutation__
 *
 * To run a mutation, you first call `useTriggerUserPermissionPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerUserPermissionPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerUserPermissionPromotionMutation, { data, loading, error }] = useTriggerUserPermissionPromotionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerUserPermissionPromotionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerUserPermissionPromotionMutation,
    TriggerUserPermissionPromotionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerUserPermissionPromotionMutation,
    TriggerUserPermissionPromotionMutationVariables
  >(TriggerUserPermissionPromotionDocument, options);
}
export type TriggerUserPermissionPromotionMutationHookResult = ReturnType<
  typeof useTriggerUserPermissionPromotionMutation
>;
export type TriggerUserPermissionPromotionMutationResult =
  Apollo.MutationResult<TriggerUserPermissionPromotionMutation>;
export type TriggerUserPermissionPromotionMutationOptions = Apollo.BaseMutationOptions<
  TriggerUserPermissionPromotionMutation,
  TriggerUserPermissionPromotionMutationVariables
>;
export const TriggerUserDeletionAfterRetentionDocument = gql`
    mutation triggerUserDeletionAfterRetention {
  triggerUserDeletionAfterRetention {
    status
  }
}
    `;
export type TriggerUserDeletionAfterRetentionMutationFn = Apollo.MutationFunction<
  TriggerUserDeletionAfterRetentionMutation,
  TriggerUserDeletionAfterRetentionMutationVariables
>;

/**
 * __useTriggerUserDeletionAfterRetentionMutation__
 *
 * To run a mutation, you first call `useTriggerUserDeletionAfterRetentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerUserDeletionAfterRetentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerUserDeletionAfterRetentionMutation, { data, loading, error }] = useTriggerUserDeletionAfterRetentionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerUserDeletionAfterRetentionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerUserDeletionAfterRetentionMutation,
    TriggerUserDeletionAfterRetentionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerUserDeletionAfterRetentionMutation,
    TriggerUserDeletionAfterRetentionMutationVariables
  >(TriggerUserDeletionAfterRetentionDocument, options);
}
export type TriggerUserDeletionAfterRetentionMutationHookResult = ReturnType<
  typeof useTriggerUserDeletionAfterRetentionMutation
>;
export type TriggerUserDeletionAfterRetentionMutationResult =
  Apollo.MutationResult<TriggerUserDeletionAfterRetentionMutation>;
export type TriggerUserDeletionAfterRetentionMutationOptions = Apollo.BaseMutationOptions<
  TriggerUserDeletionAfterRetentionMutation,
  TriggerUserDeletionAfterRetentionMutationVariables
>;
export const TriggerChatServiceSyncDocument = gql`
    mutation triggerChatServiceSync {
  triggerChatServiceSync {
    status
  }
}
    `;
export type TriggerChatServiceSyncMutationFn = Apollo.MutationFunction<
  TriggerChatServiceSyncMutation,
  TriggerChatServiceSyncMutationVariables
>;

/**
 * __useTriggerChatServiceSyncMutation__
 *
 * To run a mutation, you first call `useTriggerChatServiceSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerChatServiceSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerChatServiceSyncMutation, { data, loading, error }] = useTriggerChatServiceSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerChatServiceSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerChatServiceSyncMutation,
    TriggerChatServiceSyncMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerChatServiceSyncMutation,
    TriggerChatServiceSyncMutationVariables
  >(TriggerChatServiceSyncDocument, options);
}
export type TriggerChatServiceSyncMutationHookResult = ReturnType<
  typeof useTriggerChatServiceSyncMutation
>;
export type TriggerChatServiceSyncMutationResult =
  Apollo.MutationResult<TriggerChatServiceSyncMutation>;
export type TriggerChatServiceSyncMutationOptions = Apollo.BaseMutationOptions<
  TriggerChatServiceSyncMutation,
  TriggerChatServiceSyncMutationVariables
>;
export const TriggerRecreateZoomMeetingsDocument = gql`
    mutation triggerRecreateZoomMeetings {
  triggerRecreateZoomMeetings {
    status
  }
}
    `;
export type TriggerRecreateZoomMeetingsMutationFn = Apollo.MutationFunction<
  TriggerRecreateZoomMeetingsMutation,
  TriggerRecreateZoomMeetingsMutationVariables
>;

/**
 * __useTriggerRecreateZoomMeetingsMutation__
 *
 * To run a mutation, you first call `useTriggerRecreateZoomMeetingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerRecreateZoomMeetingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerRecreateZoomMeetingsMutation, { data, loading, error }] = useTriggerRecreateZoomMeetingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerRecreateZoomMeetingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerRecreateZoomMeetingsMutation,
    TriggerRecreateZoomMeetingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerRecreateZoomMeetingsMutation,
    TriggerRecreateZoomMeetingsMutationVariables
  >(TriggerRecreateZoomMeetingsDocument, options);
}
export type TriggerRecreateZoomMeetingsMutationHookResult = ReturnType<
  typeof useTriggerRecreateZoomMeetingsMutation
>;
export type TriggerRecreateZoomMeetingsMutationResult =
  Apollo.MutationResult<TriggerRecreateZoomMeetingsMutation>;
export type TriggerRecreateZoomMeetingsMutationOptions = Apollo.BaseMutationOptions<
  TriggerRecreateZoomMeetingsMutation,
  TriggerRecreateZoomMeetingsMutationVariables
>;
export const TriggerRecreateDailyMeetingsDocument = gql`
    mutation triggerRecreateDailyMeetings {
  triggerRecreateDailyMeetings {
    status
  }
}
    `;
export type TriggerRecreateDailyMeetingsMutationFn = Apollo.MutationFunction<
  TriggerRecreateDailyMeetingsMutation,
  TriggerRecreateDailyMeetingsMutationVariables
>;

/**
 * __useTriggerRecreateDailyMeetingsMutation__
 *
 * To run a mutation, you first call `useTriggerRecreateDailyMeetingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerRecreateDailyMeetingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerRecreateDailyMeetingsMutation, { data, loading, error }] = useTriggerRecreateDailyMeetingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerRecreateDailyMeetingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerRecreateDailyMeetingsMutation,
    TriggerRecreateDailyMeetingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerRecreateDailyMeetingsMutation,
    TriggerRecreateDailyMeetingsMutationVariables
  >(TriggerRecreateDailyMeetingsDocument, options);
}
export type TriggerRecreateDailyMeetingsMutationHookResult = ReturnType<
  typeof useTriggerRecreateDailyMeetingsMutation
>;
export type TriggerRecreateDailyMeetingsMutationResult =
  Apollo.MutationResult<TriggerRecreateDailyMeetingsMutation>;
export type TriggerRecreateDailyMeetingsMutationOptions = Apollo.BaseMutationOptions<
  TriggerRecreateDailyMeetingsMutation,
  TriggerRecreateDailyMeetingsMutationVariables
>;
export const TriggerAssignAllUserBadgesDocument = gql`
    mutation triggerAssignAllUserBadges {
  triggerAssignAllUserBadges {
    status
  }
}
    `;
export type TriggerAssignAllUserBadgesMutationFn = Apollo.MutationFunction<
  TriggerAssignAllUserBadgesMutation,
  TriggerAssignAllUserBadgesMutationVariables
>;

/**
 * __useTriggerAssignAllUserBadgesMutation__
 *
 * To run a mutation, you first call `useTriggerAssignAllUserBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAssignAllUserBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAssignAllUserBadgesMutation, { data, loading, error }] = useTriggerAssignAllUserBadgesMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerAssignAllUserBadgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerAssignAllUserBadgesMutation,
    TriggerAssignAllUserBadgesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerAssignAllUserBadgesMutation,
    TriggerAssignAllUserBadgesMutationVariables
  >(TriggerAssignAllUserBadgesDocument, options);
}
export type TriggerAssignAllUserBadgesMutationHookResult = ReturnType<
  typeof useTriggerAssignAllUserBadgesMutation
>;
export type TriggerAssignAllUserBadgesMutationResult =
  Apollo.MutationResult<TriggerAssignAllUserBadgesMutation>;
export type TriggerAssignAllUserBadgesMutationOptions = Apollo.BaseMutationOptions<
  TriggerAssignAllUserBadgesMutation,
  TriggerAssignAllUserBadgesMutationVariables
>;
export const IssueCompleteProfileNotificationDocument = gql`
    mutation issueCompleteProfileNotification {
  issueCompleteProfileNotification {
    status
  }
}
    `;
export type IssueCompleteProfileNotificationMutationFn = Apollo.MutationFunction<
  IssueCompleteProfileNotificationMutation,
  IssueCompleteProfileNotificationMutationVariables
>;

/**
 * __useIssueCompleteProfileNotificationMutation__
 *
 * To run a mutation, you first call `useIssueCompleteProfileNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCompleteProfileNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCompleteProfileNotificationMutation, { data, loading, error }] = useIssueCompleteProfileNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useIssueCompleteProfileNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IssueCompleteProfileNotificationMutation,
    IssueCompleteProfileNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IssueCompleteProfileNotificationMutation,
    IssueCompleteProfileNotificationMutationVariables
  >(IssueCompleteProfileNotificationDocument, options);
}
export type IssueCompleteProfileNotificationMutationHookResult = ReturnType<
  typeof useIssueCompleteProfileNotificationMutation
>;
export type IssueCompleteProfileNotificationMutationResult =
  Apollo.MutationResult<IssueCompleteProfileNotificationMutation>;
export type IssueCompleteProfileNotificationMutationOptions = Apollo.BaseMutationOptions<
  IssueCompleteProfileNotificationMutation,
  IssueCompleteProfileNotificationMutationVariables
>;
export const UploadActiveDaysDocument = gql`
    mutation uploadActiveDays($input: UploadActiveDaysInput!) {
  uploadActiveDays(input: $input) {
    status
  }
}
    `;
export type UploadActiveDaysMutationFn = Apollo.MutationFunction<
  UploadActiveDaysMutation,
  UploadActiveDaysMutationVariables
>;

/**
 * __useUploadActiveDaysMutation__
 *
 * To run a mutation, you first call `useUploadActiveDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadActiveDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadActiveDaysMutation, { data, loading, error }] = useUploadActiveDaysMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadActiveDaysMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadActiveDaysMutation,
    UploadActiveDaysMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadActiveDaysMutation, UploadActiveDaysMutationVariables>(
    UploadActiveDaysDocument,
    options,
  );
}
export type UploadActiveDaysMutationHookResult = ReturnType<typeof useUploadActiveDaysMutation>;
export type UploadActiveDaysMutationResult = Apollo.MutationResult<UploadActiveDaysMutation>;
export type UploadActiveDaysMutationOptions = Apollo.BaseMutationOptions<
  UploadActiveDaysMutation,
  UploadActiveDaysMutationVariables
>;
export const AssignAllExtraReferralBadgesDocument = gql`
    mutation assignAllExtraReferralBadges {
  assignAllExtraReferralBadges {
    status
  }
}
    `;
export type AssignAllExtraReferralBadgesMutationFn = Apollo.MutationFunction<
  AssignAllExtraReferralBadgesMutation,
  AssignAllExtraReferralBadgesMutationVariables
>;

/**
 * __useAssignAllExtraReferralBadgesMutation__
 *
 * To run a mutation, you first call `useAssignAllExtraReferralBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllExtraReferralBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllExtraReferralBadgesMutation, { data, loading, error }] = useAssignAllExtraReferralBadgesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllExtraReferralBadgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllExtraReferralBadgesMutation,
    AssignAllExtraReferralBadgesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignAllExtraReferralBadgesMutation,
    AssignAllExtraReferralBadgesMutationVariables
  >(AssignAllExtraReferralBadgesDocument, options);
}
export type AssignAllExtraReferralBadgesMutationHookResult = ReturnType<
  typeof useAssignAllExtraReferralBadgesMutation
>;
export type AssignAllExtraReferralBadgesMutationResult =
  Apollo.MutationResult<AssignAllExtraReferralBadgesMutation>;
export type AssignAllExtraReferralBadgesMutationOptions = Apollo.BaseMutationOptions<
  AssignAllExtraReferralBadgesMutation,
  AssignAllExtraReferralBadgesMutationVariables
>;
export const DeleteDailyWebhookDocument = gql`
    mutation deleteDailyWebhook($id: String!) {
  deleteDailyWebhook(id: $id) {
    status
  }
}
    `;
export type DeleteDailyWebhookMutationFn = Apollo.MutationFunction<
  DeleteDailyWebhookMutation,
  DeleteDailyWebhookMutationVariables
>;

/**
 * __useDeleteDailyWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteDailyWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyWebhookMutation, { data, loading, error }] = useDeleteDailyWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDailyWebhookMutation,
    DeleteDailyWebhookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDailyWebhookMutation, DeleteDailyWebhookMutationVariables>(
    DeleteDailyWebhookDocument,
    options,
  );
}
export type DeleteDailyWebhookMutationHookResult = ReturnType<typeof useDeleteDailyWebhookMutation>;
export type DeleteDailyWebhookMutationResult = Apollo.MutationResult<DeleteDailyWebhookMutation>;
export type DeleteDailyWebhookMutationOptions = Apollo.BaseMutationOptions<
  DeleteDailyWebhookMutation,
  DeleteDailyWebhookMutationVariables
>;
export const CreateNewWebhookDocument = gql`
    mutation createNewWebhook($eventTypes: [DailyEventTypes!]!) {
  createNewWebhook(eventTypes: $eventTypes) {
    status
  }
}
    `;
export type CreateNewWebhookMutationFn = Apollo.MutationFunction<
  CreateNewWebhookMutation,
  CreateNewWebhookMutationVariables
>;

/**
 * __useCreateNewWebhookMutation__
 *
 * To run a mutation, you first call `useCreateNewWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewWebhookMutation, { data, loading, error }] = useCreateNewWebhookMutation({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *   },
 * });
 */
export function useCreateNewWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNewWebhookMutation,
    CreateNewWebhookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateNewWebhookMutation, CreateNewWebhookMutationVariables>(
    CreateNewWebhookDocument,
    options,
  );
}
export type CreateNewWebhookMutationHookResult = ReturnType<typeof useCreateNewWebhookMutation>;
export type CreateNewWebhookMutationResult = Apollo.MutationResult<CreateNewWebhookMutation>;
export type CreateNewWebhookMutationOptions = Apollo.BaseMutationOptions<
  CreateNewWebhookMutation,
  CreateNewWebhookMutationVariables
>;
export const AssignAllLocalHostsBadgesDocument = gql`
    mutation assignAllLocalHostsBadges {
  assignAllLocalHostsBadges {
    status
  }
}
    `;
export type AssignAllLocalHostsBadgesMutationFn = Apollo.MutationFunction<
  AssignAllLocalHostsBadgesMutation,
  AssignAllLocalHostsBadgesMutationVariables
>;

/**
 * __useAssignAllLocalHostsBadgesMutation__
 *
 * To run a mutation, you first call `useAssignAllLocalHostsBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllLocalHostsBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllLocalHostsBadgesMutation, { data, loading, error }] = useAssignAllLocalHostsBadgesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllLocalHostsBadgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllLocalHostsBadgesMutation,
    AssignAllLocalHostsBadgesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignAllLocalHostsBadgesMutation,
    AssignAllLocalHostsBadgesMutationVariables
  >(AssignAllLocalHostsBadgesDocument, options);
}
export type AssignAllLocalHostsBadgesMutationHookResult = ReturnType<
  typeof useAssignAllLocalHostsBadgesMutation
>;
export type AssignAllLocalHostsBadgesMutationResult =
  Apollo.MutationResult<AssignAllLocalHostsBadgesMutation>;
export type AssignAllLocalHostsBadgesMutationOptions = Apollo.BaseMutationOptions<
  AssignAllLocalHostsBadgesMutation,
  AssignAllLocalHostsBadgesMutationVariables
>;
export const AssignAllNewEventsAttendedBadgesDocument = gql`
    mutation assignAllNewEventsAttendedBadges {
  assignAllNewEventsAttendedBadges {
    status
  }
}
    `;
export type AssignAllNewEventsAttendedBadgesMutationFn = Apollo.MutationFunction<
  AssignAllNewEventsAttendedBadgesMutation,
  AssignAllNewEventsAttendedBadgesMutationVariables
>;

/**
 * __useAssignAllNewEventsAttendedBadgesMutation__
 *
 * To run a mutation, you first call `useAssignAllNewEventsAttendedBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllNewEventsAttendedBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllNewEventsAttendedBadgesMutation, { data, loading, error }] = useAssignAllNewEventsAttendedBadgesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllNewEventsAttendedBadgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllNewEventsAttendedBadgesMutation,
    AssignAllNewEventsAttendedBadgesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignAllNewEventsAttendedBadgesMutation,
    AssignAllNewEventsAttendedBadgesMutationVariables
  >(AssignAllNewEventsAttendedBadgesDocument, options);
}
export type AssignAllNewEventsAttendedBadgesMutationHookResult = ReturnType<
  typeof useAssignAllNewEventsAttendedBadgesMutation
>;
export type AssignAllNewEventsAttendedBadgesMutationResult =
  Apollo.MutationResult<AssignAllNewEventsAttendedBadgesMutation>;
export type AssignAllNewEventsAttendedBadgesMutationOptions = Apollo.BaseMutationOptions<
  AssignAllNewEventsAttendedBadgesMutation,
  AssignAllNewEventsAttendedBadgesMutationVariables
>;
export const AssignAllFirstConversationBadgesDocument = gql`
    mutation assignAllFirstConversationBadges {
  assignAllFirstConversationBadges {
    status
  }
}
    `;
export type AssignAllFirstConversationBadgesMutationFn = Apollo.MutationFunction<
  AssignAllFirstConversationBadgesMutation,
  AssignAllFirstConversationBadgesMutationVariables
>;

/**
 * __useAssignAllFirstConversationBadgesMutation__
 *
 * To run a mutation, you first call `useAssignAllFirstConversationBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllFirstConversationBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllFirstConversationBadgesMutation, { data, loading, error }] = useAssignAllFirstConversationBadgesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllFirstConversationBadgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllFirstConversationBadgesMutation,
    AssignAllFirstConversationBadgesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignAllFirstConversationBadgesMutation,
    AssignAllFirstConversationBadgesMutationVariables
  >(AssignAllFirstConversationBadgesDocument, options);
}
export type AssignAllFirstConversationBadgesMutationHookResult = ReturnType<
  typeof useAssignAllFirstConversationBadgesMutation
>;
export type AssignAllFirstConversationBadgesMutationResult =
  Apollo.MutationResult<AssignAllFirstConversationBadgesMutation>;
export type AssignAllFirstConversationBadgesMutationOptions = Apollo.BaseMutationOptions<
  AssignAllFirstConversationBadgesMutation,
  AssignAllFirstConversationBadgesMutationVariables
>;
export const AssignAllNmmEventAttendedBadgesDocument = gql`
    mutation assignAllNMMEventAttendedBadges {
  assignAllNMMEventAttendedBadges {
    status
  }
}
    `;
export type AssignAllNmmEventAttendedBadgesMutationFn = Apollo.MutationFunction<
  AssignAllNmmEventAttendedBadgesMutation,
  AssignAllNmmEventAttendedBadgesMutationVariables
>;

/**
 * __useAssignAllNmmEventAttendedBadgesMutation__
 *
 * To run a mutation, you first call `useAssignAllNmmEventAttendedBadgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllNmmEventAttendedBadgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllNmmEventAttendedBadgesMutation, { data, loading, error }] = useAssignAllNmmEventAttendedBadgesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllNmmEventAttendedBadgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllNmmEventAttendedBadgesMutation,
    AssignAllNmmEventAttendedBadgesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignAllNmmEventAttendedBadgesMutation,
    AssignAllNmmEventAttendedBadgesMutationVariables
  >(AssignAllNmmEventAttendedBadgesDocument, options);
}
export type AssignAllNmmEventAttendedBadgesMutationHookResult = ReturnType<
  typeof useAssignAllNmmEventAttendedBadgesMutation
>;
export type AssignAllNmmEventAttendedBadgesMutationResult =
  Apollo.MutationResult<AssignAllNmmEventAttendedBadgesMutation>;
export type AssignAllNmmEventAttendedBadgesMutationOptions = Apollo.BaseMutationOptions<
  AssignAllNmmEventAttendedBadgesMutation,
  AssignAllNmmEventAttendedBadgesMutationVariables
>;
export const PopulateUserEventStatisticsDocument = gql`
    mutation populateUserEventStatistics {
  populateUserEventStatistics {
    status
  }
}
    `;
export type PopulateUserEventStatisticsMutationFn = Apollo.MutationFunction<
  PopulateUserEventStatisticsMutation,
  PopulateUserEventStatisticsMutationVariables
>;

/**
 * __usePopulateUserEventStatisticsMutation__
 *
 * To run a mutation, you first call `usePopulateUserEventStatisticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateUserEventStatisticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateUserEventStatisticsMutation, { data, loading, error }] = usePopulateUserEventStatisticsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePopulateUserEventStatisticsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PopulateUserEventStatisticsMutation,
    PopulateUserEventStatisticsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PopulateUserEventStatisticsMutation,
    PopulateUserEventStatisticsMutationVariables
  >(PopulateUserEventStatisticsDocument, options);
}
export type PopulateUserEventStatisticsMutationHookResult = ReturnType<
  typeof usePopulateUserEventStatisticsMutation
>;
export type PopulateUserEventStatisticsMutationResult =
  Apollo.MutationResult<PopulateUserEventStatisticsMutation>;
export type PopulateUserEventStatisticsMutationOptions = Apollo.BaseMutationOptions<
  PopulateUserEventStatisticsMutation,
  PopulateUserEventStatisticsMutationVariables
>;
export const TriggerBackfillConnectionStreaksDocument = gql`
    mutation triggerBackfillConnectionStreaks {
  triggerBackfillConnectionStreaks {
    status
  }
}
    `;
export type TriggerBackfillConnectionStreaksMutationFn = Apollo.MutationFunction<
  TriggerBackfillConnectionStreaksMutation,
  TriggerBackfillConnectionStreaksMutationVariables
>;

/**
 * __useTriggerBackfillConnectionStreaksMutation__
 *
 * To run a mutation, you first call `useTriggerBackfillConnectionStreaksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerBackfillConnectionStreaksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerBackfillConnectionStreaksMutation, { data, loading, error }] = useTriggerBackfillConnectionStreaksMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerBackfillConnectionStreaksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerBackfillConnectionStreaksMutation,
    TriggerBackfillConnectionStreaksMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TriggerBackfillConnectionStreaksMutation,
    TriggerBackfillConnectionStreaksMutationVariables
  >(TriggerBackfillConnectionStreaksDocument, options);
}
export type TriggerBackfillConnectionStreaksMutationHookResult = ReturnType<
  typeof useTriggerBackfillConnectionStreaksMutation
>;
export type TriggerBackfillConnectionStreaksMutationResult =
  Apollo.MutationResult<TriggerBackfillConnectionStreaksMutation>;
export type TriggerBackfillConnectionStreaksMutationOptions = Apollo.BaseMutationOptions<
  TriggerBackfillConnectionStreaksMutation,
  TriggerBackfillConnectionStreaksMutationVariables
>;
export const AdminCreateCustomNotificationDisplayDocument = gql`
    mutation adminCreateCustomNotificationDisplay {
  adminCreateCustomNotificationDisplay {
    id
  }
}
    `;
export type AdminCreateCustomNotificationDisplayMutationFn = Apollo.MutationFunction<
  AdminCreateCustomNotificationDisplayMutation,
  AdminCreateCustomNotificationDisplayMutationVariables
>;

/**
 * __useAdminCreateCustomNotificationDisplayMutation__
 *
 * To run a mutation, you first call `useAdminCreateCustomNotificationDisplayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCustomNotificationDisplayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCustomNotificationDisplayMutation, { data, loading, error }] = useAdminCreateCustomNotificationDisplayMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminCreateCustomNotificationDisplayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateCustomNotificationDisplayMutation,
    AdminCreateCustomNotificationDisplayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminCreateCustomNotificationDisplayMutation,
    AdminCreateCustomNotificationDisplayMutationVariables
  >(AdminCreateCustomNotificationDisplayDocument, options);
}
export type AdminCreateCustomNotificationDisplayMutationHookResult = ReturnType<
  typeof useAdminCreateCustomNotificationDisplayMutation
>;
export type AdminCreateCustomNotificationDisplayMutationResult =
  Apollo.MutationResult<AdminCreateCustomNotificationDisplayMutation>;
export type AdminCreateCustomNotificationDisplayMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateCustomNotificationDisplayMutation,
  AdminCreateCustomNotificationDisplayMutationVariables
>;
export const AdminEditCustomNotificationDisplayDocument = gql`
    mutation adminEditCustomNotificationDisplay($id: String!, $input: EditCustomNotificationDisplayInput!) {
  adminEditCustomNotificationDisplay(id: $id, input: $input) {
    status
  }
}
    `;
export type AdminEditCustomNotificationDisplayMutationFn = Apollo.MutationFunction<
  AdminEditCustomNotificationDisplayMutation,
  AdminEditCustomNotificationDisplayMutationVariables
>;

/**
 * __useAdminEditCustomNotificationDisplayMutation__
 *
 * To run a mutation, you first call `useAdminEditCustomNotificationDisplayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditCustomNotificationDisplayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditCustomNotificationDisplayMutation, { data, loading, error }] = useAdminEditCustomNotificationDisplayMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditCustomNotificationDisplayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditCustomNotificationDisplayMutation,
    AdminEditCustomNotificationDisplayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminEditCustomNotificationDisplayMutation,
    AdminEditCustomNotificationDisplayMutationVariables
  >(AdminEditCustomNotificationDisplayDocument, options);
}
export type AdminEditCustomNotificationDisplayMutationHookResult = ReturnType<
  typeof useAdminEditCustomNotificationDisplayMutation
>;
export type AdminEditCustomNotificationDisplayMutationResult =
  Apollo.MutationResult<AdminEditCustomNotificationDisplayMutation>;
export type AdminEditCustomNotificationDisplayMutationOptions = Apollo.BaseMutationOptions<
  AdminEditCustomNotificationDisplayMutation,
  AdminEditCustomNotificationDisplayMutationVariables
>;
export const SendCustomNotificationsDocument = gql`
    mutation sendCustomNotifications($id: String!, $emails: [String!]!) {
  sendCustomNotifications(id: $id, emails: $emails) {
    sentTo
    warningMessages
  }
}
    `;
export type SendCustomNotificationsMutationFn = Apollo.MutationFunction<
  SendCustomNotificationsMutation,
  SendCustomNotificationsMutationVariables
>;

/**
 * __useSendCustomNotificationsMutation__
 *
 * To run a mutation, you first call `useSendCustomNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomNotificationsMutation, { data, loading, error }] = useSendCustomNotificationsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendCustomNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendCustomNotificationsMutation,
    SendCustomNotificationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendCustomNotificationsMutation,
    SendCustomNotificationsMutationVariables
  >(SendCustomNotificationsDocument, options);
}
export type SendCustomNotificationsMutationHookResult = ReturnType<
  typeof useSendCustomNotificationsMutation
>;
export type SendCustomNotificationsMutationResult =
  Apollo.MutationResult<SendCustomNotificationsMutation>;
export type SendCustomNotificationsMutationOptions = Apollo.BaseMutationOptions<
  SendCustomNotificationsMutation,
  SendCustomNotificationsMutationVariables
>;
export const AdminRecordInvitesDocument = gql`
    mutation adminRecordInvites($eventId: String!, $userIds: [String!]!, $source: OutreachSource, $filters: [String!]) {
  adminRecordInvites(
    eventId: $eventId
    userIds: $userIds
    source: $source
    filters: $filters
  )
}
    `;
export type AdminRecordInvitesMutationFn = Apollo.MutationFunction<
  AdminRecordInvitesMutation,
  AdminRecordInvitesMutationVariables
>;

/**
 * __useAdminRecordInvitesMutation__
 *
 * To run a mutation, you first call `useAdminRecordInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRecordInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRecordInvitesMutation, { data, loading, error }] = useAdminRecordInvitesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userIds: // value for 'userIds'
 *      source: // value for 'source'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminRecordInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminRecordInvitesMutation,
    AdminRecordInvitesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminRecordInvitesMutation, AdminRecordInvitesMutationVariables>(
    AdminRecordInvitesDocument,
    options,
  );
}
export type AdminRecordInvitesMutationHookResult = ReturnType<typeof useAdminRecordInvitesMutation>;
export type AdminRecordInvitesMutationResult = Apollo.MutationResult<AdminRecordInvitesMutation>;
export type AdminRecordInvitesMutationOptions = Apollo.BaseMutationOptions<
  AdminRecordInvitesMutation,
  AdminRecordInvitesMutationVariables
>;
export const AdminEditQuestionDocument = gql`
    mutation adminEditQuestion($input: EditQuestionInput!) {
  adminEditQuestion(input: $input) {
    id
    question
  }
}
    `;
export type AdminEditQuestionMutationFn = Apollo.MutationFunction<
  AdminEditQuestionMutation,
  AdminEditQuestionMutationVariables
>;

/**
 * __useAdminEditQuestionMutation__
 *
 * To run a mutation, you first call `useAdminEditQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditQuestionMutation, { data, loading, error }] = useAdminEditQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditQuestionMutation,
    AdminEditQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditQuestionMutation, AdminEditQuestionMutationVariables>(
    AdminEditQuestionDocument,
    options,
  );
}
export type AdminEditQuestionMutationHookResult = ReturnType<typeof useAdminEditQuestionMutation>;
export type AdminEditQuestionMutationResult = Apollo.MutationResult<AdminEditQuestionMutation>;
export type AdminEditQuestionMutationOptions = Apollo.BaseMutationOptions<
  AdminEditQuestionMutation,
  AdminEditQuestionMutationVariables
>;
export const AdminDeleteUserReportDocument = gql`
    mutation adminDeleteUserReport($id: String!) {
  adminDeleteUserReport(id: $id) {
    status
  }
}
    `;
export type AdminDeleteUserReportMutationFn = Apollo.MutationFunction<
  AdminDeleteUserReportMutation,
  AdminDeleteUserReportMutationVariables
>;

/**
 * __useAdminDeleteUserReportMutation__
 *
 * To run a mutation, you first call `useAdminDeleteUserReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteUserReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteUserReportMutation, { data, loading, error }] = useAdminDeleteUserReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteUserReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteUserReportMutation,
    AdminDeleteUserReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteUserReportMutation, AdminDeleteUserReportMutationVariables>(
    AdminDeleteUserReportDocument,
    options,
  );
}
export type AdminDeleteUserReportMutationHookResult = ReturnType<
  typeof useAdminDeleteUserReportMutation
>;
export type AdminDeleteUserReportMutationResult =
  Apollo.MutationResult<AdminDeleteUserReportMutation>;
export type AdminDeleteUserReportMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteUserReportMutation,
  AdminDeleteUserReportMutationVariables
>;
export const AdminCreateSectionDocument = gql`
    mutation adminCreateSection($input: CreateSectionInput!) {
  adminCreateSection(input: $input) {
    id
    order
    elements {
      kind
      meta
    }
  }
}
    `;
export type AdminCreateSectionMutationFn = Apollo.MutationFunction<
  AdminCreateSectionMutation,
  AdminCreateSectionMutationVariables
>;

/**
 * __useAdminCreateSectionMutation__
 *
 * To run a mutation, you first call `useAdminCreateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSectionMutation, { data, loading, error }] = useAdminCreateSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateSectionMutation,
    AdminCreateSectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateSectionMutation, AdminCreateSectionMutationVariables>(
    AdminCreateSectionDocument,
    options,
  );
}
export type AdminCreateSectionMutationHookResult = ReturnType<typeof useAdminCreateSectionMutation>;
export type AdminCreateSectionMutationResult = Apollo.MutationResult<AdminCreateSectionMutation>;
export type AdminCreateSectionMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateSectionMutation,
  AdminCreateSectionMutationVariables
>;
export const AdminEditSectionDocument = gql`
    mutation adminEditSection($id: String!, $input: EditSectionInput!) {
  adminEditSection(id: $id, input: $input) {
    id
    order
    elements {
      kind
      meta
    }
  }
}
    `;
export type AdminEditSectionMutationFn = Apollo.MutationFunction<
  AdminEditSectionMutation,
  AdminEditSectionMutationVariables
>;

/**
 * __useAdminEditSectionMutation__
 *
 * To run a mutation, you first call `useAdminEditSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditSectionMutation, { data, loading, error }] = useAdminEditSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditSectionMutation,
    AdminEditSectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditSectionMutation, AdminEditSectionMutationVariables>(
    AdminEditSectionDocument,
    options,
  );
}
export type AdminEditSectionMutationHookResult = ReturnType<typeof useAdminEditSectionMutation>;
export type AdminEditSectionMutationResult = Apollo.MutationResult<AdminEditSectionMutation>;
export type AdminEditSectionMutationOptions = Apollo.BaseMutationOptions<
  AdminEditSectionMutation,
  AdminEditSectionMutationVariables
>;
export const AdminDeleteSectionDocument = gql`
    mutation adminDeleteSection($id: String!) {
  adminDeleteSection(id: $id) {
    reason
    status
  }
}
    `;
export type AdminDeleteSectionMutationFn = Apollo.MutationFunction<
  AdminDeleteSectionMutation,
  AdminDeleteSectionMutationVariables
>;

/**
 * __useAdminDeleteSectionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSectionMutation, { data, loading, error }] = useAdminDeleteSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteSectionMutation,
    AdminDeleteSectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteSectionMutation, AdminDeleteSectionMutationVariables>(
    AdminDeleteSectionDocument,
    options,
  );
}
export type AdminDeleteSectionMutationHookResult = ReturnType<typeof useAdminDeleteSectionMutation>;
export type AdminDeleteSectionMutationResult = Apollo.MutationResult<AdminDeleteSectionMutation>;
export type AdminDeleteSectionMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteSectionMutation,
  AdminDeleteSectionMutationVariables
>;
export const AdminCreateBannerDocument = gql`
    mutation adminCreateBanner($input: CreateBannerInput!) {
  adminCreateBanner(input: $input) {
    id
    isActive
  }
}
    `;
export type AdminCreateBannerMutationFn = Apollo.MutationFunction<
  AdminCreateBannerMutation,
  AdminCreateBannerMutationVariables
>;

/**
 * __useAdminCreateBannerMutation__
 *
 * To run a mutation, you first call `useAdminCreateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateBannerMutation, { data, loading, error }] = useAdminCreateBannerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateBannerMutation,
    AdminCreateBannerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateBannerMutation, AdminCreateBannerMutationVariables>(
    AdminCreateBannerDocument,
    options,
  );
}
export type AdminCreateBannerMutationHookResult = ReturnType<typeof useAdminCreateBannerMutation>;
export type AdminCreateBannerMutationResult = Apollo.MutationResult<AdminCreateBannerMutation>;
export type AdminCreateBannerMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateBannerMutation,
  AdminCreateBannerMutationVariables
>;
export const AdminEditBannerDocument = gql`
    mutation adminEditBanner($id: String!, $input: EditBannerInput!) {
  adminEditBanner(id: $id, input: $input) {
    id
    isActive
  }
}
    `;
export type AdminEditBannerMutationFn = Apollo.MutationFunction<
  AdminEditBannerMutation,
  AdminEditBannerMutationVariables
>;

/**
 * __useAdminEditBannerMutation__
 *
 * To run a mutation, you first call `useAdminEditBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditBannerMutation, { data, loading, error }] = useAdminEditBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditBannerMutation,
    AdminEditBannerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditBannerMutation, AdminEditBannerMutationVariables>(
    AdminEditBannerDocument,
    options,
  );
}
export type AdminEditBannerMutationHookResult = ReturnType<typeof useAdminEditBannerMutation>;
export type AdminEditBannerMutationResult = Apollo.MutationResult<AdminEditBannerMutation>;
export type AdminEditBannerMutationOptions = Apollo.BaseMutationOptions<
  AdminEditBannerMutation,
  AdminEditBannerMutationVariables
>;
export const AdminDeleteBannerDocument = gql`
    mutation adminDeleteBanner($id: String!) {
  adminDeleteBanner(id: $id) {
    status
  }
}
    `;
export type AdminDeleteBannerMutationFn = Apollo.MutationFunction<
  AdminDeleteBannerMutation,
  AdminDeleteBannerMutationVariables
>;

/**
 * __useAdminDeleteBannerMutation__
 *
 * To run a mutation, you first call `useAdminDeleteBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteBannerMutation, { data, loading, error }] = useAdminDeleteBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteBannerMutation,
    AdminDeleteBannerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteBannerMutation, AdminDeleteBannerMutationVariables>(
    AdminDeleteBannerDocument,
    options,
  );
}
export type AdminDeleteBannerMutationHookResult = ReturnType<typeof useAdminDeleteBannerMutation>;
export type AdminDeleteBannerMutationResult = Apollo.MutationResult<AdminDeleteBannerMutation>;
export type AdminDeleteBannerMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteBannerMutation,
  AdminDeleteBannerMutationVariables
>;
export const AdminCreateSliderDocument = gql`
    mutation adminCreateSlider($id: String!) {
  adminCreateSlider(id: $id) {
    status
  }
}
    `;
export type AdminCreateSliderMutationFn = Apollo.MutationFunction<
  AdminCreateSliderMutation,
  AdminCreateSliderMutationVariables
>;

/**
 * __useAdminCreateSliderMutation__
 *
 * To run a mutation, you first call `useAdminCreateSliderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSliderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSliderMutation, { data, loading, error }] = useAdminCreateSliderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminCreateSliderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateSliderMutation,
    AdminCreateSliderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateSliderMutation, AdminCreateSliderMutationVariables>(
    AdminCreateSliderDocument,
    options,
  );
}
export type AdminCreateSliderMutationHookResult = ReturnType<typeof useAdminCreateSliderMutation>;
export type AdminCreateSliderMutationResult = Apollo.MutationResult<AdminCreateSliderMutation>;
export type AdminCreateSliderMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateSliderMutation,
  AdminCreateSliderMutationVariables
>;
export const AdminDeleteSliderDocument = gql`
    mutation adminDeleteSlider($id: String!) {
  adminDeleteSlider(id: $id) {
    status
  }
}
    `;
export type AdminDeleteSliderMutationFn = Apollo.MutationFunction<
  AdminDeleteSliderMutation,
  AdminDeleteSliderMutationVariables
>;

/**
 * __useAdminDeleteSliderMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSliderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSliderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSliderMutation, { data, loading, error }] = useAdminDeleteSliderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteSliderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteSliderMutation,
    AdminDeleteSliderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteSliderMutation, AdminDeleteSliderMutationVariables>(
    AdminDeleteSliderDocument,
    options,
  );
}
export type AdminDeleteSliderMutationHookResult = ReturnType<typeof useAdminDeleteSliderMutation>;
export type AdminDeleteSliderMutationResult = Apollo.MutationResult<AdminDeleteSliderMutation>;
export type AdminDeleteSliderMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteSliderMutation,
  AdminDeleteSliderMutationVariables
>;
export const AdminEditSlideDocument = gql`
    mutation adminEditSlide($id: String!, $input: EditSliderInput!) {
  adminEditSlide(id: $id, input: $input) {
    id
  }
}
    `;
export type AdminEditSlideMutationFn = Apollo.MutationFunction<
  AdminEditSlideMutation,
  AdminEditSlideMutationVariables
>;

/**
 * __useAdminEditSlideMutation__
 *
 * To run a mutation, you first call `useAdminEditSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditSlideMutation, { data, loading, error }] = useAdminEditSlideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditSlideMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditSlideMutation, AdminEditSlideMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditSlideMutation, AdminEditSlideMutationVariables>(
    AdminEditSlideDocument,
    options,
  );
}
export type AdminEditSlideMutationHookResult = ReturnType<typeof useAdminEditSlideMutation>;
export type AdminEditSlideMutationResult = Apollo.MutationResult<AdminEditSlideMutation>;
export type AdminEditSlideMutationOptions = Apollo.BaseMutationOptions<
  AdminEditSlideMutation,
  AdminEditSlideMutationVariables
>;
export const AdminOrderSliderDocument = gql`
    mutation adminOrderSlider($id: String!, $input: String!) {
  adminOrderSlider(id: $id, input: $input) {
    status
  }
}
    `;
export type AdminOrderSliderMutationFn = Apollo.MutationFunction<
  AdminOrderSliderMutation,
  AdminOrderSliderMutationVariables
>;

/**
 * __useAdminOrderSliderMutation__
 *
 * To run a mutation, you first call `useAdminOrderSliderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderSliderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrderSliderMutation, { data, loading, error }] = useAdminOrderSliderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrderSliderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminOrderSliderMutation,
    AdminOrderSliderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminOrderSliderMutation, AdminOrderSliderMutationVariables>(
    AdminOrderSliderDocument,
    options,
  );
}
export type AdminOrderSliderMutationHookResult = ReturnType<typeof useAdminOrderSliderMutation>;
export type AdminOrderSliderMutationResult = Apollo.MutationResult<AdminOrderSliderMutation>;
export type AdminOrderSliderMutationOptions = Apollo.BaseMutationOptions<
  AdminOrderSliderMutation,
  AdminOrderSliderMutationVariables
>;
export const AdminCreateThemeDocument = gql`
    mutation adminCreateTheme($input: CreateThemeInput!) {
  adminCreateTheme(input: $input) {
    id
    title
    description
    isGrammarLibrary
    isTopicLibrary
    isResource
    isStandard
    isCurrent
    cover {
      id
      title
      primary {
        mobile
        desktop
      }
      secondary {
        mobile
        desktop
      }
      tertiary {
        mobile
        desktop
      }
    }
  }
}
    `;
export type AdminCreateThemeMutationFn = Apollo.MutationFunction<
  AdminCreateThemeMutation,
  AdminCreateThemeMutationVariables
>;

/**
 * __useAdminCreateThemeMutation__
 *
 * To run a mutation, you first call `useAdminCreateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateThemeMutation, { data, loading, error }] = useAdminCreateThemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateThemeMutation,
    AdminCreateThemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateThemeMutation, AdminCreateThemeMutationVariables>(
    AdminCreateThemeDocument,
    options,
  );
}
export type AdminCreateThemeMutationHookResult = ReturnType<typeof useAdminCreateThemeMutation>;
export type AdminCreateThemeMutationResult = Apollo.MutationResult<AdminCreateThemeMutation>;
export type AdminCreateThemeMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateThemeMutation,
  AdminCreateThemeMutationVariables
>;
export const AdminEditThemeDocument = gql`
    mutation adminEditTheme($id: String!, $input: EditThemeInput!) {
  adminEditTheme(id: $id, input: $input) {
    id
    title
    description
    isCurrent
    isStandard
    isGrammarLibrary
    isTopicLibrary
    cover {
      id
      title
      primary {
        mobile
        desktop
      }
      secondary {
        mobile
        desktop
      }
      tertiary {
        mobile
        desktop
      }
    }
  }
}
    `;
export type AdminEditThemeMutationFn = Apollo.MutationFunction<
  AdminEditThemeMutation,
  AdminEditThemeMutationVariables
>;

/**
 * __useAdminEditThemeMutation__
 *
 * To run a mutation, you first call `useAdminEditThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditThemeMutation, { data, loading, error }] = useAdminEditThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditThemeMutation, AdminEditThemeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditThemeMutation, AdminEditThemeMutationVariables>(
    AdminEditThemeDocument,
    options,
  );
}
export type AdminEditThemeMutationHookResult = ReturnType<typeof useAdminEditThemeMutation>;
export type AdminEditThemeMutationResult = Apollo.MutationResult<AdminEditThemeMutation>;
export type AdminEditThemeMutationOptions = Apollo.BaseMutationOptions<
  AdminEditThemeMutation,
  AdminEditThemeMutationVariables
>;
export const AdminDeleteThemeDocument = gql`
    mutation adminDeleteTheme($id: String!) {
  adminDeleteTheme(id: $id) {
    status
  }
}
    `;
export type AdminDeleteThemeMutationFn = Apollo.MutationFunction<
  AdminDeleteThemeMutation,
  AdminDeleteThemeMutationVariables
>;

/**
 * __useAdminDeleteThemeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteThemeMutation, { data, loading, error }] = useAdminDeleteThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteThemeMutation,
    AdminDeleteThemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteThemeMutation, AdminDeleteThemeMutationVariables>(
    AdminDeleteThemeDocument,
    options,
  );
}
export type AdminDeleteThemeMutationHookResult = ReturnType<typeof useAdminDeleteThemeMutation>;
export type AdminDeleteThemeMutationResult = Apollo.MutationResult<AdminDeleteThemeMutation>;
export type AdminDeleteThemeMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteThemeMutation,
  AdminDeleteThemeMutationVariables
>;
export const AdminEditTopicDocument = gql`
    mutation adminEditTopic($id: String!, $input: EditTopicInput!) {
  adminEditTopic(id: $id, input: $input) {
    id
    title
    stars
    theme {
      id
      title
    }
    illustration {
      id
      title
      url
    }
    lessons {
      id
      kind
    }
  }
}
    `;
export type AdminEditTopicMutationFn = Apollo.MutationFunction<
  AdminEditTopicMutation,
  AdminEditTopicMutationVariables
>;

/**
 * __useAdminEditTopicMutation__
 *
 * To run a mutation, you first call `useAdminEditTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditTopicMutation, { data, loading, error }] = useAdminEditTopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditTopicMutation, AdminEditTopicMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditTopicMutation, AdminEditTopicMutationVariables>(
    AdminEditTopicDocument,
    options,
  );
}
export type AdminEditTopicMutationHookResult = ReturnType<typeof useAdminEditTopicMutation>;
export type AdminEditTopicMutationResult = Apollo.MutationResult<AdminEditTopicMutation>;
export type AdminEditTopicMutationOptions = Apollo.BaseMutationOptions<
  AdminEditTopicMutation,
  AdminEditTopicMutationVariables
>;
export const AdminDeleteTopicDocument = gql`
    mutation adminDeleteTopic($id: String!) {
  adminDeleteTopic(id: $id) {
    status
    reason
  }
}
    `;
export type AdminDeleteTopicMutationFn = Apollo.MutationFunction<
  AdminDeleteTopicMutation,
  AdminDeleteTopicMutationVariables
>;

/**
 * __useAdminDeleteTopicMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTopicMutation, { data, loading, error }] = useAdminDeleteTopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteTopicMutation,
    AdminDeleteTopicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteTopicMutation, AdminDeleteTopicMutationVariables>(
    AdminDeleteTopicDocument,
    options,
  );
}
export type AdminDeleteTopicMutationHookResult = ReturnType<typeof useAdminDeleteTopicMutation>;
export type AdminDeleteTopicMutationResult = Apollo.MutationResult<AdminDeleteTopicMutation>;
export type AdminDeleteTopicMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteTopicMutation,
  AdminDeleteTopicMutationVariables
>;
export const AdminDeleteTopicsDocument = gql`
    mutation adminDeleteTopics($input: DeleteTopicsInput!) {
  adminDeleteTopics(input: $input) {
    status
  }
}
    `;
export type AdminDeleteTopicsMutationFn = Apollo.MutationFunction<
  AdminDeleteTopicsMutation,
  AdminDeleteTopicsMutationVariables
>;

/**
 * __useAdminDeleteTopicsMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTopicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTopicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTopicsMutation, { data, loading, error }] = useAdminDeleteTopicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteTopicsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteTopicsMutation,
    AdminDeleteTopicsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteTopicsMutation, AdminDeleteTopicsMutationVariables>(
    AdminDeleteTopicsDocument,
    options,
  );
}
export type AdminDeleteTopicsMutationHookResult = ReturnType<typeof useAdminDeleteTopicsMutation>;
export type AdminDeleteTopicsMutationResult = Apollo.MutationResult<AdminDeleteTopicsMutation>;
export type AdminDeleteTopicsMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteTopicsMutation,
  AdminDeleteTopicsMutationVariables
>;
export const AdminCreateTopicDocument = gql`
    mutation adminCreateTopic($input: CreateTopicInput!) {
  adminCreateTopic(input: $input) {
    id
    title
    stars
    illustration {
      id
      title
      url
    }
    theme {
      id
      title
    }
    lessons {
      id
      kind
    }
  }
}
    `;
export type AdminCreateTopicMutationFn = Apollo.MutationFunction<
  AdminCreateTopicMutation,
  AdminCreateTopicMutationVariables
>;

/**
 * __useAdminCreateTopicMutation__
 *
 * To run a mutation, you first call `useAdminCreateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTopicMutation, { data, loading, error }] = useAdminCreateTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateTopicMutation,
    AdminCreateTopicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateTopicMutation, AdminCreateTopicMutationVariables>(
    AdminCreateTopicDocument,
    options,
  );
}
export type AdminCreateTopicMutationHookResult = ReturnType<typeof useAdminCreateTopicMutation>;
export type AdminCreateTopicMutationResult = Apollo.MutationResult<AdminCreateTopicMutation>;
export type AdminCreateTopicMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateTopicMutation,
  AdminCreateTopicMutationVariables
>;
export const DuplicateTopicDocument = gql`
    mutation duplicateTopic($id: String!) {
  duplicateTopic(id: $id) {
    status
  }
}
    `;
export type DuplicateTopicMutationFn = Apollo.MutationFunction<
  DuplicateTopicMutation,
  DuplicateTopicMutationVariables
>;

/**
 * __useDuplicateTopicMutation__
 *
 * To run a mutation, you first call `useDuplicateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTopicMutation, { data, loading, error }] = useDuplicateTopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateTopicMutation, DuplicateTopicMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DuplicateTopicMutation, DuplicateTopicMutationVariables>(
    DuplicateTopicDocument,
    options,
  );
}
export type DuplicateTopicMutationHookResult = ReturnType<typeof useDuplicateTopicMutation>;
export type DuplicateTopicMutationResult = Apollo.MutationResult<DuplicateTopicMutation>;
export type DuplicateTopicMutationOptions = Apollo.BaseMutationOptions<
  DuplicateTopicMutation,
  DuplicateTopicMutationVariables
>;
export const DuplicateLessonDocument = gql`
    mutation duplicateLesson($input: DuplicateLessonInput!) {
  duplicateLesson(input: $input) {
    status
  }
}
    `;
export type DuplicateLessonMutationFn = Apollo.MutationFunction<
  DuplicateLessonMutation,
  DuplicateLessonMutationVariables
>;

/**
 * __useDuplicateLessonMutation__
 *
 * To run a mutation, you first call `useDuplicateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateLessonMutation, { data, loading, error }] = useDuplicateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateLessonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateLessonMutation,
    DuplicateLessonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DuplicateLessonMutation, DuplicateLessonMutationVariables>(
    DuplicateLessonDocument,
    options,
  );
}
export type DuplicateLessonMutationHookResult = ReturnType<typeof useDuplicateLessonMutation>;
export type DuplicateLessonMutationResult = Apollo.MutationResult<DuplicateLessonMutation>;
export type DuplicateLessonMutationOptions = Apollo.BaseMutationOptions<
  DuplicateLessonMutation,
  DuplicateLessonMutationVariables
>;
export const CreateTopicForPreviewModeDocument = gql`
    mutation createTopicForPreviewMode($input: TopicInPreviewInput!) {
  createTopicForPreviewMode(input: $input) {
    id
  }
}
    `;
export type CreateTopicForPreviewModeMutationFn = Apollo.MutationFunction<
  CreateTopicForPreviewModeMutation,
  CreateTopicForPreviewModeMutationVariables
>;

/**
 * __useCreateTopicForPreviewModeMutation__
 *
 * To run a mutation, you first call `useCreateTopicForPreviewModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicForPreviewModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicForPreviewModeMutation, { data, loading, error }] = useCreateTopicForPreviewModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTopicForPreviewModeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTopicForPreviewModeMutation,
    CreateTopicForPreviewModeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTopicForPreviewModeMutation,
    CreateTopicForPreviewModeMutationVariables
  >(CreateTopicForPreviewModeDocument, options);
}
export type CreateTopicForPreviewModeMutationHookResult = ReturnType<
  typeof useCreateTopicForPreviewModeMutation
>;
export type CreateTopicForPreviewModeMutationResult =
  Apollo.MutationResult<CreateTopicForPreviewModeMutation>;
export type CreateTopicForPreviewModeMutationOptions = Apollo.BaseMutationOptions<
  CreateTopicForPreviewModeMutation,
  CreateTopicForPreviewModeMutationVariables
>;
export const CreateTotpDocument = gql`
    mutation createTotp {
  createTotp {
    id
    uri
  }
}
    `;
export type CreateTotpMutationFn = Apollo.MutationFunction<
  CreateTotpMutation,
  CreateTotpMutationVariables
>;

/**
 * __useCreateTotpMutation__
 *
 * To run a mutation, you first call `useCreateTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTotpMutation, { data, loading, error }] = useCreateTotpMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateTotpMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTotpMutation, CreateTotpMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTotpMutation, CreateTotpMutationVariables>(
    CreateTotpDocument,
    options,
  );
}
export type CreateTotpMutationHookResult = ReturnType<typeof useCreateTotpMutation>;
export type CreateTotpMutationResult = Apollo.MutationResult<CreateTotpMutation>;
export type CreateTotpMutationOptions = Apollo.BaseMutationOptions<
  CreateTotpMutation,
  CreateTotpMutationVariables
>;
export const ConfirmTotpDocument = gql`
    mutation confirmTotp($input: ConfirmTotpInput!, $currentPassword: String!) {
  confirmTotp(input: $input, currentPassword: $currentPassword) {
    status
  }
}
    `;
export type ConfirmTotpMutationFn = Apollo.MutationFunction<
  ConfirmTotpMutation,
  ConfirmTotpMutationVariables
>;

/**
 * __useConfirmTotpMutation__
 *
 * To run a mutation, you first call `useConfirmTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTotpMutation, { data, loading, error }] = useConfirmTotpMutation({
 *   variables: {
 *      input: // value for 'input'
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useConfirmTotpMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmTotpMutation, ConfirmTotpMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmTotpMutation, ConfirmTotpMutationVariables>(
    ConfirmTotpDocument,
    options,
  );
}
export type ConfirmTotpMutationHookResult = ReturnType<typeof useConfirmTotpMutation>;
export type ConfirmTotpMutationResult = Apollo.MutationResult<ConfirmTotpMutation>;
export type ConfirmTotpMutationOptions = Apollo.BaseMutationOptions<
  ConfirmTotpMutation,
  ConfirmTotpMutationVariables
>;
export const RemoveTotpDocument = gql`
    mutation removeTotp($totpId: String!, $currentPassword: String) {
  removeTotp(totpId: $totpId, currentPassword: $currentPassword) {
    status
  }
}
    `;
export type RemoveTotpMutationFn = Apollo.MutationFunction<
  RemoveTotpMutation,
  RemoveTotpMutationVariables
>;

/**
 * __useRemoveTotpMutation__
 *
 * To run a mutation, you first call `useRemoveTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTotpMutation, { data, loading, error }] = useRemoveTotpMutation({
 *   variables: {
 *      totpId: // value for 'totpId'
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useRemoveTotpMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveTotpMutation, RemoveTotpMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTotpMutation, RemoveTotpMutationVariables>(
    RemoveTotpDocument,
    options,
  );
}
export type RemoveTotpMutationHookResult = ReturnType<typeof useRemoveTotpMutation>;
export type RemoveTotpMutationResult = Apollo.MutationResult<RemoveTotpMutation>;
export type RemoveTotpMutationOptions = Apollo.BaseMutationOptions<
  RemoveTotpMutation,
  RemoveTotpMutationVariables
>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($id: String!) {
  deleteAccount(id: $id) {
    status
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(
    DeleteAccountDocument,
    options,
  );
}
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>;
export const AdminEditUserDocument = gql`
    mutation adminEditUser($id: String!, $input: EditUserInput!) {
  adminEditUser(id: $id, input: $input) {
    status
  }
}
    `;
export type AdminEditUserMutationFn = Apollo.MutationFunction<
  AdminEditUserMutation,
  AdminEditUserMutationVariables
>;

/**
 * __useAdminEditUserMutation__
 *
 * To run a mutation, you first call `useAdminEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditUserMutation, { data, loading, error }] = useAdminEditUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditUserMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditUserMutation, AdminEditUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditUserMutation, AdminEditUserMutationVariables>(
    AdminEditUserDocument,
    options,
  );
}
export type AdminEditUserMutationHookResult = ReturnType<typeof useAdminEditUserMutation>;
export type AdminEditUserMutationResult = Apollo.MutationResult<AdminEditUserMutation>;
export type AdminEditUserMutationOptions = Apollo.BaseMutationOptions<
  AdminEditUserMutation,
  AdminEditUserMutationVariables
>;
export const AdminGrantGuestPassTokensDocument = gql`
    mutation adminGrantGuestPassTokens($input: GrantGuestPassTokensInput!) {
  adminGrantGuestPassTokens(input: $input) {
    id
    tokenAllowance
    tokensUsed
    tokensRemaining
    daysRemaining
    isActive
  }
}
    `;
export type AdminGrantGuestPassTokensMutationFn = Apollo.MutationFunction<
  AdminGrantGuestPassTokensMutation,
  AdminGrantGuestPassTokensMutationVariables
>;

/**
 * __useAdminGrantGuestPassTokensMutation__
 *
 * To run a mutation, you first call `useAdminGrantGuestPassTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminGrantGuestPassTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminGrantGuestPassTokensMutation, { data, loading, error }] = useAdminGrantGuestPassTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminGrantGuestPassTokensMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminGrantGuestPassTokensMutation,
    AdminGrantGuestPassTokensMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminGrantGuestPassTokensMutation,
    AdminGrantGuestPassTokensMutationVariables
  >(AdminGrantGuestPassTokensDocument, options);
}
export type AdminGrantGuestPassTokensMutationHookResult = ReturnType<
  typeof useAdminGrantGuestPassTokensMutation
>;
export type AdminGrantGuestPassTokensMutationResult =
  Apollo.MutationResult<AdminGrantGuestPassTokensMutation>;
export type AdminGrantGuestPassTokensMutationOptions = Apollo.BaseMutationOptions<
  AdminGrantGuestPassTokensMutation,
  AdminGrantGuestPassTokensMutationVariables
>;
export const AdminCreateNoteDocument = gql`
    mutation adminCreateNote($id: String!, $input: NoteInput!) {
  adminCreateNote(userID: $id, input: $input) {
    id
    description
  }
}
    `;
export type AdminCreateNoteMutationFn = Apollo.MutationFunction<
  AdminCreateNoteMutation,
  AdminCreateNoteMutationVariables
>;

/**
 * __useAdminCreateNoteMutation__
 *
 * To run a mutation, you first call `useAdminCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateNoteMutation, { data, loading, error }] = useAdminCreateNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateNoteMutation,
    AdminCreateNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateNoteMutation, AdminCreateNoteMutationVariables>(
    AdminCreateNoteDocument,
    options,
  );
}
export type AdminCreateNoteMutationHookResult = ReturnType<typeof useAdminCreateNoteMutation>;
export type AdminCreateNoteMutationResult = Apollo.MutationResult<AdminCreateNoteMutation>;
export type AdminCreateNoteMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateNoteMutation,
  AdminCreateNoteMutationVariables
>;
export const AdminBanUserDocument = gql`
    mutation adminBanUser($id: String!) {
  adminBanUser(id: $id) {
    status
  }
}
    `;
export type AdminBanUserMutationFn = Apollo.MutationFunction<
  AdminBanUserMutation,
  AdminBanUserMutationVariables
>;

/**
 * __useAdminBanUserMutation__
 *
 * To run a mutation, you first call `useAdminBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBanUserMutation, { data, loading, error }] = useAdminBanUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminBanUserMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminBanUserMutation, AdminBanUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminBanUserMutation, AdminBanUserMutationVariables>(
    AdminBanUserDocument,
    options,
  );
}
export type AdminBanUserMutationHookResult = ReturnType<typeof useAdminBanUserMutation>;
export type AdminBanUserMutationResult = Apollo.MutationResult<AdminBanUserMutation>;
export type AdminBanUserMutationOptions = Apollo.BaseMutationOptions<
  AdminBanUserMutation,
  AdminBanUserMutationVariables
>;
export const AdminUnbanUserDocument = gql`
    mutation adminUnbanUser($id: String!) {
  adminUnbanUser(id: $id) {
    status
  }
}
    `;
export type AdminUnbanUserMutationFn = Apollo.MutationFunction<
  AdminUnbanUserMutation,
  AdminUnbanUserMutationVariables
>;

/**
 * __useAdminUnbanUserMutation__
 *
 * To run a mutation, you first call `useAdminUnbanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnbanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnbanUserMutation, { data, loading, error }] = useAdminUnbanUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUnbanUserMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>(
    AdminUnbanUserDocument,
    options,
  );
}
export type AdminUnbanUserMutationHookResult = ReturnType<typeof useAdminUnbanUserMutation>;
export type AdminUnbanUserMutationResult = Apollo.MutationResult<AdminUnbanUserMutation>;
export type AdminUnbanUserMutationOptions = Apollo.BaseMutationOptions<
  AdminUnbanUserMutation,
  AdminUnbanUserMutationVariables
>;
export const AssignUserBadgeDocument = gql`
    mutation assignUserBadge($input: AssignOrDeleteBadgeInput!) {
  assignUserBadge(input: $input) {
    status
  }
}
    `;
export type AssignUserBadgeMutationFn = Apollo.MutationFunction<
  AssignUserBadgeMutation,
  AssignUserBadgeMutationVariables
>;

/**
 * __useAssignUserBadgeMutation__
 *
 * To run a mutation, you first call `useAssignUserBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserBadgeMutation, { data, loading, error }] = useAssignUserBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignUserBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignUserBadgeMutation,
    AssignUserBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignUserBadgeMutation, AssignUserBadgeMutationVariables>(
    AssignUserBadgeDocument,
    options,
  );
}
export type AssignUserBadgeMutationHookResult = ReturnType<typeof useAssignUserBadgeMutation>;
export type AssignUserBadgeMutationResult = Apollo.MutationResult<AssignUserBadgeMutation>;
export type AssignUserBadgeMutationOptions = Apollo.BaseMutationOptions<
  AssignUserBadgeMutation,
  AssignUserBadgeMutationVariables
>;
export const DeleteUserBadgeDocument = gql`
    mutation deleteUserBadge($input: AssignOrDeleteBadgeInput!) {
  deleteUserBadge(input: $input) {
    status
  }
}
    `;
export type DeleteUserBadgeMutationFn = Apollo.MutationFunction<
  DeleteUserBadgeMutation,
  DeleteUserBadgeMutationVariables
>;

/**
 * __useDeleteUserBadgeMutation__
 *
 * To run a mutation, you first call `useDeleteUserBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserBadgeMutation, { data, loading, error }] = useDeleteUserBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserBadgeMutation,
    DeleteUserBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserBadgeMutation, DeleteUserBadgeMutationVariables>(
    DeleteUserBadgeDocument,
    options,
  );
}
export type DeleteUserBadgeMutationHookResult = ReturnType<typeof useDeleteUserBadgeMutation>;
export type DeleteUserBadgeMutationResult = Apollo.MutationResult<DeleteUserBadgeMutation>;
export type DeleteUserBadgeMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserBadgeMutation,
  DeleteUserBadgeMutationVariables
>;
export const RegenerateCalendarPathDocument = gql`
    mutation regenerateCalendarPath($userId: String!) {
  regenerateCalendarPath(userId: $userId) {
    status
  }
}
    `;
export type RegenerateCalendarPathMutationFn = Apollo.MutationFunction<
  RegenerateCalendarPathMutation,
  RegenerateCalendarPathMutationVariables
>;

/**
 * __useRegenerateCalendarPathMutation__
 *
 * To run a mutation, you first call `useRegenerateCalendarPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateCalendarPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateCalendarPathMutation, { data, loading, error }] = useRegenerateCalendarPathMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRegenerateCalendarPathMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegenerateCalendarPathMutation,
    RegenerateCalendarPathMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegenerateCalendarPathMutation,
    RegenerateCalendarPathMutationVariables
  >(RegenerateCalendarPathDocument, options);
}
export type RegenerateCalendarPathMutationHookResult = ReturnType<
  typeof useRegenerateCalendarPathMutation
>;
export type RegenerateCalendarPathMutationResult =
  Apollo.MutationResult<RegenerateCalendarPathMutation>;
export type RegenerateCalendarPathMutationOptions = Apollo.BaseMutationOptions<
  RegenerateCalendarPathMutation,
  RegenerateCalendarPathMutationVariables
>;
export const AdminCreateVideoSetDocument = gql`
    mutation adminCreateVideoSet($input: CreateVideoSetInput!) {
  adminCreateVideoSet(input: $input) {
    id
    title
  }
}
    `;
export type AdminCreateVideoSetMutationFn = Apollo.MutationFunction<
  AdminCreateVideoSetMutation,
  AdminCreateVideoSetMutationVariables
>;

/**
 * __useAdminCreateVideoSetMutation__
 *
 * To run a mutation, you first call `useAdminCreateVideoSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateVideoSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateVideoSetMutation, { data, loading, error }] = useAdminCreateVideoSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateVideoSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateVideoSetMutation,
    AdminCreateVideoSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateVideoSetMutation, AdminCreateVideoSetMutationVariables>(
    AdminCreateVideoSetDocument,
    options,
  );
}
export type AdminCreateVideoSetMutationHookResult = ReturnType<
  typeof useAdminCreateVideoSetMutation
>;
export type AdminCreateVideoSetMutationResult = Apollo.MutationResult<AdminCreateVideoSetMutation>;
export type AdminCreateVideoSetMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateVideoSetMutation,
  AdminCreateVideoSetMutationVariables
>;
export const AdminDeleteVideoSetDocument = gql`
    mutation adminDeleteVideoSet($id: String!) {
  adminDeleteVideoSet(id: $id) {
    status
  }
}
    `;
export type AdminDeleteVideoSetMutationFn = Apollo.MutationFunction<
  AdminDeleteVideoSetMutation,
  AdminDeleteVideoSetMutationVariables
>;

/**
 * __useAdminDeleteVideoSetMutation__
 *
 * To run a mutation, you first call `useAdminDeleteVideoSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteVideoSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteVideoSetMutation, { data, loading, error }] = useAdminDeleteVideoSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteVideoSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteVideoSetMutation,
    AdminDeleteVideoSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteVideoSetMutation, AdminDeleteVideoSetMutationVariables>(
    AdminDeleteVideoSetDocument,
    options,
  );
}
export type AdminDeleteVideoSetMutationHookResult = ReturnType<
  typeof useAdminDeleteVideoSetMutation
>;
export type AdminDeleteVideoSetMutationResult = Apollo.MutationResult<AdminDeleteVideoSetMutation>;
export type AdminDeleteVideoSetMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteVideoSetMutation,
  AdminDeleteVideoSetMutationVariables
>;
export const AdminCreateVideoDocument = gql`
    mutation adminCreateVideo($input: CreateVideoInput!) {
  adminCreateVideo(input: $input) {
    status
  }
}
    `;
export type AdminCreateVideoMutationFn = Apollo.MutationFunction<
  AdminCreateVideoMutation,
  AdminCreateVideoMutationVariables
>;

/**
 * __useAdminCreateVideoMutation__
 *
 * To run a mutation, you first call `useAdminCreateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateVideoMutation, { data, loading, error }] = useAdminCreateVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateVideoMutation,
    AdminCreateVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateVideoMutation, AdminCreateVideoMutationVariables>(
    AdminCreateVideoDocument,
    options,
  );
}
export type AdminCreateVideoMutationHookResult = ReturnType<typeof useAdminCreateVideoMutation>;
export type AdminCreateVideoMutationResult = Apollo.MutationResult<AdminCreateVideoMutation>;
export type AdminCreateVideoMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateVideoMutation,
  AdminCreateVideoMutationVariables
>;
export const AdminDeleteVideoDocument = gql`
    mutation adminDeleteVideo($id: String!) {
  adminDeleteVideo(id: $id) {
    status
  }
}
    `;
export type AdminDeleteVideoMutationFn = Apollo.MutationFunction<
  AdminDeleteVideoMutation,
  AdminDeleteVideoMutationVariables
>;

/**
 * __useAdminDeleteVideoMutation__
 *
 * To run a mutation, you first call `useAdminDeleteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteVideoMutation, { data, loading, error }] = useAdminDeleteVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteVideoMutation,
    AdminDeleteVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteVideoMutation, AdminDeleteVideoMutationVariables>(
    AdminDeleteVideoDocument,
    options,
  );
}
export type AdminDeleteVideoMutationHookResult = ReturnType<typeof useAdminDeleteVideoMutation>;
export type AdminDeleteVideoMutationResult = Apollo.MutationResult<AdminDeleteVideoMutation>;
export type AdminDeleteVideoMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteVideoMutation,
  AdminDeleteVideoMutationVariables
>;
export const AdminEditVideoSetDocument = gql`
    mutation adminEditVideoSet($id: String!, $input: EditVideoSetInput!) {
  adminEditVideoSet(id: $id, input: $input) {
    id
  }
}
    `;
export type AdminEditVideoSetMutationFn = Apollo.MutationFunction<
  AdminEditVideoSetMutation,
  AdminEditVideoSetMutationVariables
>;

/**
 * __useAdminEditVideoSetMutation__
 *
 * To run a mutation, you first call `useAdminEditVideoSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditVideoSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditVideoSetMutation, { data, loading, error }] = useAdminEditVideoSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditVideoSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditVideoSetMutation,
    AdminEditVideoSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditVideoSetMutation, AdminEditVideoSetMutationVariables>(
    AdminEditVideoSetDocument,
    options,
  );
}
export type AdminEditVideoSetMutationHookResult = ReturnType<typeof useAdminEditVideoSetMutation>;
export type AdminEditVideoSetMutationResult = Apollo.MutationResult<AdminEditVideoSetMutation>;
export type AdminEditVideoSetMutationOptions = Apollo.BaseMutationOptions<
  AdminEditVideoSetMutation,
  AdminEditVideoSetMutationVariables
>;
export const AdminOrderVideoSetDocument = gql`
    mutation adminOrderVideoSet($id: String!, $input: String!) {
  adminOrderVideoSet(id: $id, input: $input) {
    status
  }
}
    `;
export type AdminOrderVideoSetMutationFn = Apollo.MutationFunction<
  AdminOrderVideoSetMutation,
  AdminOrderVideoSetMutationVariables
>;

/**
 * __useAdminOrderVideoSetMutation__
 *
 * To run a mutation, you first call `useAdminOrderVideoSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderVideoSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrderVideoSetMutation, { data, loading, error }] = useAdminOrderVideoSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrderVideoSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminOrderVideoSetMutation,
    AdminOrderVideoSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminOrderVideoSetMutation, AdminOrderVideoSetMutationVariables>(
    AdminOrderVideoSetDocument,
    options,
  );
}
export type AdminOrderVideoSetMutationHookResult = ReturnType<typeof useAdminOrderVideoSetMutation>;
export type AdminOrderVideoSetMutationResult = Apollo.MutationResult<AdminOrderVideoSetMutation>;
export type AdminOrderVideoSetMutationOptions = Apollo.BaseMutationOptions<
  AdminOrderVideoSetMutation,
  AdminOrderVideoSetMutationVariables
>;
export const AdminEditVideoDocument = gql`
    mutation adminEditVideo($id: String!, $input: EditVideoInput!) {
  adminEditVideo(id: $id, input: $input) {
    id
  }
}
    `;
export type AdminEditVideoMutationFn = Apollo.MutationFunction<
  AdminEditVideoMutation,
  AdminEditVideoMutationVariables
>;

/**
 * __useAdminEditVideoMutation__
 *
 * To run a mutation, you first call `useAdminEditVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditVideoMutation, { data, loading, error }] = useAdminEditVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminEditVideoMutation, AdminEditVideoMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditVideoMutation, AdminEditVideoMutationVariables>(
    AdminEditVideoDocument,
    options,
  );
}
export type AdminEditVideoMutationHookResult = ReturnType<typeof useAdminEditVideoMutation>;
export type AdminEditVideoMutationResult = Apollo.MutationResult<AdminEditVideoMutation>;
export type AdminEditVideoMutationOptions = Apollo.BaseMutationOptions<
  AdminEditVideoMutation,
  AdminEditVideoMutationVariables
>;
export const AdminOrderVideoDocument = gql`
    mutation adminOrderVideo($id: String!, $input: String!) {
  adminOrderVideo(id: $id, input: $input) {
    status
  }
}
    `;
export type AdminOrderVideoMutationFn = Apollo.MutationFunction<
  AdminOrderVideoMutation,
  AdminOrderVideoMutationVariables
>;

/**
 * __useAdminOrderVideoMutation__
 *
 * To run a mutation, you first call `useAdminOrderVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrderVideoMutation, { data, loading, error }] = useAdminOrderVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrderVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminOrderVideoMutation,
    AdminOrderVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminOrderVideoMutation, AdminOrderVideoMutationVariables>(
    AdminOrderVideoDocument,
    options,
  );
}
export type AdminOrderVideoMutationHookResult = ReturnType<typeof useAdminOrderVideoMutation>;
export type AdminOrderVideoMutationResult = Apollo.MutationResult<AdminOrderVideoMutation>;
export type AdminOrderVideoMutationOptions = Apollo.BaseMutationOptions<
  AdminOrderVideoMutation,
  AdminOrderVideoMutationVariables
>;
export const AdminDeleteZineCoverDocument = gql`
    mutation adminDeleteZineCover($id: String!) {
  adminDeleteZineCover(id: $id) {
    status
  }
}
    `;
export type AdminDeleteZineCoverMutationFn = Apollo.MutationFunction<
  AdminDeleteZineCoverMutation,
  AdminDeleteZineCoverMutationVariables
>;

/**
 * __useAdminDeleteZineCoverMutation__
 *
 * To run a mutation, you first call `useAdminDeleteZineCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteZineCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteZineCoverMutation, { data, loading, error }] = useAdminDeleteZineCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteZineCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteZineCoverMutation,
    AdminDeleteZineCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteZineCoverMutation, AdminDeleteZineCoverMutationVariables>(
    AdminDeleteZineCoverDocument,
    options,
  );
}
export type AdminDeleteZineCoverMutationHookResult = ReturnType<
  typeof useAdminDeleteZineCoverMutation
>;
export type AdminDeleteZineCoverMutationResult =
  Apollo.MutationResult<AdminDeleteZineCoverMutation>;
export type AdminDeleteZineCoverMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteZineCoverMutation,
  AdminDeleteZineCoverMutationVariables
>;
export const AdminCreateZineCoverDocument = gql`
    mutation adminCreateZineCover($input: CreateZineInput!) {
  adminCreateZineCover(input: $input) {
    id
    coverUrl
    isCurrent
  }
}
    `;
export type AdminCreateZineCoverMutationFn = Apollo.MutationFunction<
  AdminCreateZineCoverMutation,
  AdminCreateZineCoverMutationVariables
>;

/**
 * __useAdminCreateZineCoverMutation__
 *
 * To run a mutation, you first call `useAdminCreateZineCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateZineCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateZineCoverMutation, { data, loading, error }] = useAdminCreateZineCoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateZineCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateZineCoverMutation,
    AdminCreateZineCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateZineCoverMutation, AdminCreateZineCoverMutationVariables>(
    AdminCreateZineCoverDocument,
    options,
  );
}
export type AdminCreateZineCoverMutationHookResult = ReturnType<
  typeof useAdminCreateZineCoverMutation
>;
export type AdminCreateZineCoverMutationResult =
  Apollo.MutationResult<AdminCreateZineCoverMutation>;
export type AdminCreateZineCoverMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateZineCoverMutation,
  AdminCreateZineCoverMutationVariables
>;
export const AdminEditZineCoverDocument = gql`
    mutation adminEditZineCover($id: String!, $input: EditZineInput!) {
  adminEditZineCover(id: $id, input: $input) {
    id
    coverUrl
    isCurrent
  }
}
    `;
export type AdminEditZineCoverMutationFn = Apollo.MutationFunction<
  AdminEditZineCoverMutation,
  AdminEditZineCoverMutationVariables
>;

/**
 * __useAdminEditZineCoverMutation__
 *
 * To run a mutation, you first call `useAdminEditZineCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEditZineCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEditZineCoverMutation, { data, loading, error }] = useAdminEditZineCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminEditZineCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEditZineCoverMutation,
    AdminEditZineCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminEditZineCoverMutation, AdminEditZineCoverMutationVariables>(
    AdminEditZineCoverDocument,
    options,
  );
}
export type AdminEditZineCoverMutationHookResult = ReturnType<typeof useAdminEditZineCoverMutation>;
export type AdminEditZineCoverMutationResult = Apollo.MutationResult<AdminEditZineCoverMutation>;
export type AdminEditZineCoverMutationOptions = Apollo.BaseMutationOptions<
  AdminEditZineCoverMutation,
  AdminEditZineCoverMutationVariables
>;
export const UploadZineCoverDocument = gql`
    mutation uploadZineCover($input: UploadCoverZineInput!) {
  uploadZineCover(input: $input) {
    id
    coverUrl
  }
}
    `;
export type UploadZineCoverMutationFn = Apollo.MutationFunction<
  UploadZineCoverMutation,
  UploadZineCoverMutationVariables
>;

/**
 * __useUploadZineCoverMutation__
 *
 * To run a mutation, you first call `useUploadZineCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadZineCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadZineCoverMutation, { data, loading, error }] = useUploadZineCoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadZineCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadZineCoverMutation,
    UploadZineCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadZineCoverMutation, UploadZineCoverMutationVariables>(
    UploadZineCoverDocument,
    options,
  );
}
export type UploadZineCoverMutationHookResult = ReturnType<typeof useUploadZineCoverMutation>;
export type UploadZineCoverMutationResult = Apollo.MutationResult<UploadZineCoverMutation>;
export type UploadZineCoverMutationOptions = Apollo.BaseMutationOptions<
  UploadZineCoverMutation,
  UploadZineCoverMutationVariables
>;
export const AdminGetArticleDocument = gql`
    query adminGetArticle($id: String!, $filters: AdminFilterUsersInput!) {
  adminGetArticle(articleID: $id) {
    id
    title
    content
    coverUrl
    isFeatured
    tags
    isVisible
    isDraft
    author {
      id
      name
    }
  }
  adminListUsers(filters: $filters) {
    items {
      id
      name
    }
    total
  }
}
    `;

/**
 * __useAdminGetArticleQuery__
 *
 * To run a query within a React component, call `useAdminGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminGetArticleQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetArticleQuery, AdminGetArticleQueryVariables> &
    ({ variables: AdminGetArticleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetArticleQuery, AdminGetArticleQueryVariables>(
    AdminGetArticleDocument,
    options,
  );
}
export function useAdminGetArticleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetArticleQuery, AdminGetArticleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetArticleQuery, AdminGetArticleQueryVariables>(
    AdminGetArticleDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetArticleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetArticleQuery,
    AdminGetArticleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetArticleQuery, AdminGetArticleQueryVariables>;
export function useAdminGetArticleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetArticleQuery, AdminGetArticleQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetArticleQuery | undefined, AdminGetArticleQueryVariables>;
export function useAdminGetArticleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetArticleQuery, AdminGetArticleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetArticleQuery, AdminGetArticleQueryVariables>(
    AdminGetArticleDocument,
    options,
  );
}
export type AdminGetArticleQueryHookResult = ReturnType<typeof useAdminGetArticleQuery>;
export type AdminGetArticleLazyQueryHookResult = ReturnType<typeof useAdminGetArticleLazyQuery>;
export type AdminGetArticleSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetArticleSuspenseQuery
>;
export type AdminGetArticleQueryResult = Apollo.QueryResult<
  AdminGetArticleQuery,
  AdminGetArticleQueryVariables
>;
export const AdminListPaginatedArticlesDocument = gql`
    query adminListPaginatedArticles($order: OrderArticlesInput!, $filters: FilterArticlesInput!) {
  adminListPaginatedArticles(order: $order, filters: $filters) {
    items {
      id
      title
      content
      coverUrl
      isFeatured
      publishedAt
      tags
      isVisible
      isDraft
      author {
        id
        name
      }
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedArticlesQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedArticlesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedArticlesQuery,
    AdminListPaginatedArticlesQueryVariables
  > &
    ({ variables: AdminListPaginatedArticlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListPaginatedArticlesQuery, AdminListPaginatedArticlesQueryVariables>(
    AdminListPaginatedArticlesDocument,
    options,
  );
}
export function useAdminListPaginatedArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedArticlesQuery,
    AdminListPaginatedArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedArticlesQuery,
    AdminListPaginatedArticlesQueryVariables
  >(AdminListPaginatedArticlesDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedArticlesQuery,
    AdminListPaginatedArticlesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedArticlesQuery,
  AdminListPaginatedArticlesQueryVariables
>;
export function useAdminListPaginatedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedArticlesQuery,
        AdminListPaginatedArticlesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedArticlesQuery | undefined,
  AdminListPaginatedArticlesQueryVariables
>;
export function useAdminListPaginatedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedArticlesQuery,
        AdminListPaginatedArticlesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedArticlesQuery,
    AdminListPaginatedArticlesQueryVariables
  >(AdminListPaginatedArticlesDocument, options);
}
export type AdminListPaginatedArticlesQueryHookResult = ReturnType<
  typeof useAdminListPaginatedArticlesQuery
>;
export type AdminListPaginatedArticlesLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedArticlesLazyQuery
>;
export type AdminListPaginatedArticlesSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedArticlesSuspenseQuery
>;
export type AdminListPaginatedArticlesQueryResult = Apollo.QueryResult<
  AdminListPaginatedArticlesQuery,
  AdminListPaginatedArticlesQueryVariables
>;
export const AdminListPaginatedCoversDocument = gql`
    query adminListPaginatedCovers($filters: AdminFilterCoversInput!) {
  adminListPaginatedCovers(filters: $filters) {
    items {
      id
      title
      primary {
        mobile
        desktop
      }
      secondary {
        mobile
        desktop
      }
      tertiary {
        mobile
        desktop
      }
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedCoversQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedCoversQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedCoversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedCoversQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedCoversQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedCoversQuery,
    AdminListPaginatedCoversQueryVariables
  > &
    ({ variables: AdminListPaginatedCoversQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListPaginatedCoversQuery, AdminListPaginatedCoversQueryVariables>(
    AdminListPaginatedCoversDocument,
    options,
  );
}
export function useAdminListPaginatedCoversLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedCoversQuery,
    AdminListPaginatedCoversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListPaginatedCoversQuery, AdminListPaginatedCoversQueryVariables>(
    AdminListPaginatedCoversDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminListPaginatedCoversSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedCoversQuery,
    AdminListPaginatedCoversQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedCoversQuery,
  AdminListPaginatedCoversQueryVariables
>;
export function useAdminListPaginatedCoversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedCoversQuery,
        AdminListPaginatedCoversQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedCoversQuery | undefined,
  AdminListPaginatedCoversQueryVariables
>;
export function useAdminListPaginatedCoversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedCoversQuery,
        AdminListPaginatedCoversQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedCoversQuery,
    AdminListPaginatedCoversQueryVariables
  >(AdminListPaginatedCoversDocument, options);
}
export type AdminListPaginatedCoversQueryHookResult = ReturnType<
  typeof useAdminListPaginatedCoversQuery
>;
export type AdminListPaginatedCoversLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedCoversLazyQuery
>;
export type AdminListPaginatedCoversSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedCoversSuspenseQuery
>;
export type AdminListPaginatedCoversQueryResult = Apollo.QueryResult<
  AdminListPaginatedCoversQuery,
  AdminListPaginatedCoversQueryVariables
>;
export const AdminGetCoverDocument = gql`
    query adminGetCover($id: String!) {
  adminGetCover(id: $id) {
    id
    title
    primary {
      mobile
      desktop
    }
    secondary {
      mobile
      desktop
    }
    tertiary {
      mobile
      desktop
    }
  }
}
    `;

/**
 * __useAdminGetCoverQuery__
 *
 * To run a query within a React component, call `useAdminGetCoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCoverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetCoverQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetCoverQuery, AdminGetCoverQueryVariables> &
    ({ variables: AdminGetCoverQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetCoverQuery, AdminGetCoverQueryVariables>(
    AdminGetCoverDocument,
    options,
  );
}
export function useAdminGetCoverLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCoverQuery, AdminGetCoverQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetCoverQuery, AdminGetCoverQueryVariables>(
    AdminGetCoverDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetCoverSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetCoverQuery, AdminGetCoverQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetCoverQuery, AdminGetCoverQueryVariables>;
export function useAdminGetCoverSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetCoverQuery, AdminGetCoverQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetCoverQuery | undefined, AdminGetCoverQueryVariables>;
export function useAdminGetCoverSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetCoverQuery, AdminGetCoverQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetCoverQuery, AdminGetCoverQueryVariables>(
    AdminGetCoverDocument,
    options,
  );
}
export type AdminGetCoverQueryHookResult = ReturnType<typeof useAdminGetCoverQuery>;
export type AdminGetCoverLazyQueryHookResult = ReturnType<typeof useAdminGetCoverLazyQuery>;
export type AdminGetCoverSuspenseQueryHookResult = ReturnType<typeof useAdminGetCoverSuspenseQuery>;
export type AdminGetCoverQueryResult = Apollo.QueryResult<
  AdminGetCoverQuery,
  AdminGetCoverQueryVariables
>;
export const AdminSearchEventsDocument = gql`
    query adminSearchEvents($filters: AdminFilterEventsInput!) {
  adminSearchEvents(filters: $filters) {
    items {
      title
      id
      endDate
      coverUrl
      startDate
      organizer {
        id
        firstName
        lastName
      }
    }
    total
  }
}
    `;

/**
 * __useAdminSearchEventsQuery__
 *
 * To run a query within a React component, call `useAdminSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminSearchEventsQuery(
  baseOptions: Apollo.QueryHookOptions<AdminSearchEventsQuery, AdminSearchEventsQueryVariables> &
    ({ variables: AdminSearchEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminSearchEventsQuery, AdminSearchEventsQueryVariables>(
    AdminSearchEventsDocument,
    options,
  );
}
export function useAdminSearchEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminSearchEventsQuery,
    AdminSearchEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminSearchEventsQuery, AdminSearchEventsQueryVariables>(
    AdminSearchEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminSearchEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminSearchEventsQuery,
    AdminSearchEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminSearchEventsQuery, AdminSearchEventsQueryVariables>;
export function useAdminSearchEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminSearchEventsQuery, AdminSearchEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminSearchEventsQuery | undefined,
  AdminSearchEventsQueryVariables
>;
export function useAdminSearchEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminSearchEventsQuery, AdminSearchEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminSearchEventsQuery, AdminSearchEventsQueryVariables>(
    AdminSearchEventsDocument,
    options,
  );
}
export type AdminSearchEventsQueryHookResult = ReturnType<typeof useAdminSearchEventsQuery>;
export type AdminSearchEventsLazyQueryHookResult = ReturnType<typeof useAdminSearchEventsLazyQuery>;
export type AdminSearchEventsSuspenseQueryHookResult = ReturnType<
  typeof useAdminSearchEventsSuspenseQuery
>;
export type AdminSearchEventsQueryResult = Apollo.QueryResult<
  AdminSearchEventsQuery,
  AdminSearchEventsQueryVariables
>;
export const GetEventAdminDocument = gql`
    query getEventAdmin($id: String!) {
  getEventAdmin(id: $id) {
    id
    coverUrl
    createdAt
    description
    endDate
    isDraft
    isPublic
    kind
    meta
    location
    noParticipants
    recurring
    startDate
    title
    updatedAt
    videoUrl
    isForUnverified
    permissions
    englishLevel
    isCoachEvent
    maxParticipants
    isFull
    seriesId
    eventCategory
    interests
    englishSkills
    topic {
      id
      title
    }
    organizer {
      id
      name
      avatarUrl
    }
    host {
      id
      name
      avatarUrl
      badge
    }
  }
}
    `;

/**
 * __useGetEventAdminQuery__
 *
 * To run a query within a React component, call `useGetEventAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventAdminQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventAdminQuery, GetEventAdminQueryVariables> &
    ({ variables: GetEventAdminQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventAdminQuery, GetEventAdminQueryVariables>(
    GetEventAdminDocument,
    options,
  );
}
export function useGetEventAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEventAdminQuery, GetEventAdminQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventAdminQuery, GetEventAdminQueryVariables>(
    GetEventAdminDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventAdminQuery, GetEventAdminQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetEventAdminQuery, GetEventAdminQueryVariables>;
export function useGetEventAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventAdminQuery, GetEventAdminQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetEventAdminQuery | undefined, GetEventAdminQueryVariables>;
export function useGetEventAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventAdminQuery, GetEventAdminQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventAdminQuery, GetEventAdminQueryVariables>(
    GetEventAdminDocument,
    options,
  );
}
export type GetEventAdminQueryHookResult = ReturnType<typeof useGetEventAdminQuery>;
export type GetEventAdminLazyQueryHookResult = ReturnType<typeof useGetEventAdminLazyQuery>;
export type GetEventAdminSuspenseQueryHookResult = ReturnType<typeof useGetEventAdminSuspenseQuery>;
export type GetEventAdminQueryResult = Apollo.QueryResult<
  GetEventAdminQuery,
  GetEventAdminQueryVariables
>;
export const GetEventAndTopicsDocument = gql`
    query getEventAndTopics($id: String!) {
  getEventAdmin(id: $id) {
    id
    coverUrl
    createdAt
    description
    endDate
    eventCategory
    host {
      kind
    }
    isDraft
    isDeleted
    isPublic
    kind
    meta
    location
    noParticipants
    recurring
    englishLevel
    isForUnverified
    permissions
    englishLevel
    startDate
    title
    updatedAt
    videoUrl
    organizer {
      id
      name
      avatarUrl
    }
    topic {
      id
      title
    }
  }
  adminListTopics {
    id
    title
  }
}
    `;

/**
 * __useGetEventAndTopicsQuery__
 *
 * To run a query within a React component, call `useGetEventAndTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAndTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAndTopicsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventAndTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables> &
    ({ variables: GetEventAndTopicsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables>(
    GetEventAndTopicsDocument,
    options,
  );
}
export function useGetEventAndTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventAndTopicsQuery,
    GetEventAndTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables>(
    GetEventAndTopicsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventAndTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventAndTopicsQuery,
    GetEventAndTopicsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables>;
export function useGetEventAndTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetEventAndTopicsQuery | undefined,
  GetEventAndTopicsQueryVariables
>;
export function useGetEventAndTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventAndTopicsQuery, GetEventAndTopicsQueryVariables>(
    GetEventAndTopicsDocument,
    options,
  );
}
export type GetEventAndTopicsQueryHookResult = ReturnType<typeof useGetEventAndTopicsQuery>;
export type GetEventAndTopicsLazyQueryHookResult = ReturnType<typeof useGetEventAndTopicsLazyQuery>;
export type GetEventAndTopicsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventAndTopicsSuspenseQuery
>;
export type GetEventAndTopicsQueryResult = Apollo.QueryResult<
  GetEventAndTopicsQuery,
  GetEventAndTopicsQueryVariables
>;
export const GetEventParticipantsDocument = gql`
    query getEventParticipants($id: String!) {
  getEventAdmin(id: $id) {
    id
    participants {
      id
      name
      createdAt
      email
      city
      isVerified
      country
      avatarUrl
      badge
    }
    invited {
      id
      name
      createdAt
      email
      city
      isVerified
      country
      avatarUrl
      badge
    }
    declined {
      id
      name
      createdAt
      email
      city
      isVerified
      country
      avatarUrl
      badge
    }
  }
}
    `;

/**
 * __useGetEventParticipantsQuery__
 *
 * To run a query within a React component, call `useGetEventParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventParticipantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventParticipantsQuery,
    GetEventParticipantsQueryVariables
  > &
    ({ variables: GetEventParticipantsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(
    GetEventParticipantsDocument,
    options,
  );
}
export function useGetEventParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventParticipantsQuery,
    GetEventParticipantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(
    GetEventParticipantsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventParticipantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventParticipantsQuery,
    GetEventParticipantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>;
export function useGetEventParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventParticipantsQuery,
        GetEventParticipantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEventParticipantsQuery | undefined,
  GetEventParticipantsQueryVariables
>;
export function useGetEventParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventParticipantsQuery,
        GetEventParticipantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(
    GetEventParticipantsDocument,
    options,
  );
}
export type GetEventParticipantsQueryHookResult = ReturnType<typeof useGetEventParticipantsQuery>;
export type GetEventParticipantsLazyQueryHookResult = ReturnType<
  typeof useGetEventParticipantsLazyQuery
>;
export type GetEventParticipantsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventParticipantsSuspenseQuery
>;
export type GetEventParticipantsQueryResult = Apollo.QueryResult<
  GetEventParticipantsQuery,
  GetEventParticipantsQueryVariables
>;
export const GetEventCommentsDocument = gql`
    query getEventComments($id: String!) {
  getEventAdmin(id: $id) {
    id
    comments {
      id
      message
      createdAt
      author {
        id
        avatarUrl
        name
      }
    }
  }
}
    `;

/**
 * __useGetEventCommentsQuery__
 *
 * To run a query within a React component, call `useGetEventCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables> &
    ({ variables: GetEventCommentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(
    GetEventCommentsDocument,
    options,
  );
}
export function useGetEventCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(
    GetEventCommentsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventCommentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventCommentsQuery,
    GetEventCommentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventCommentsQuery, GetEventCommentsQueryVariables>;
export function useGetEventCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetEventCommentsQuery | undefined, GetEventCommentsQueryVariables>;
export function useGetEventCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(
    GetEventCommentsDocument,
    options,
  );
}
export type GetEventCommentsQueryHookResult = ReturnType<typeof useGetEventCommentsQuery>;
export type GetEventCommentsLazyQueryHookResult = ReturnType<typeof useGetEventCommentsLazyQuery>;
export type GetEventCommentsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventCommentsSuspenseQuery
>;
export type GetEventCommentsQueryResult = Apollo.QueryResult<
  GetEventCommentsQuery,
  GetEventCommentsQueryVariables
>;
export const AdminMemberExperienceDocument = gql`
    query adminMemberExperience($from: Date, $to: Date, $email: String, $kind: String, $isVerified: Boolean, $planSlug: String, $speakingLevelScore: Float, $attendedEvents: Int, $joinedAt: Date) {
  adminMemberExperience(
    from: $from
    to: $to
    email: $email
    kind: $kind
    isVerified: $isVerified
    planSlug: $planSlug
    speakingLevelScore: $speakingLevelScore
    attendedEvents: $attendedEvents
    joinedAt: $joinedAt
  ) {
    member {
      userId
      name
      email
      isReal
      kind
      planSlug
      subscriptionTier
      isVerified
      isStaff
      attendedEvents
      advancedUnlocked
      joinedAt
    }
    events {
      eventId
      canAttend
      verdict
      joinReason
      lockReason
    }
    total
    canAttend
    locked
    blocked
  }
}
    `;

/**
 * __useAdminMemberExperienceQuery__
 *
 * To run a query within a React component, call `useAdminMemberExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberExperienceQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      email: // value for 'email'
 *      kind: // value for 'kind'
 *      isVerified: // value for 'isVerified'
 *      planSlug: // value for 'planSlug'
 *      speakingLevelScore: // value for 'speakingLevelScore'
 *      attendedEvents: // value for 'attendedEvents'
 *      joinedAt: // value for 'joinedAt'
 *   },
 * });
 */
export function useAdminMemberExperienceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminMemberExperienceQuery,
    AdminMemberExperienceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminMemberExperienceQuery, AdminMemberExperienceQueryVariables>(
    AdminMemberExperienceDocument,
    options,
  );
}
export function useAdminMemberExperienceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminMemberExperienceQuery,
    AdminMemberExperienceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminMemberExperienceQuery, AdminMemberExperienceQueryVariables>(
    AdminMemberExperienceDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminMemberExperienceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminMemberExperienceQuery,
    AdminMemberExperienceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminMemberExperienceQuery, AdminMemberExperienceQueryVariables>;
export function useAdminMemberExperienceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminMemberExperienceQuery,
        AdminMemberExperienceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminMemberExperienceQuery | undefined,
  AdminMemberExperienceQueryVariables
>;
export function useAdminMemberExperienceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminMemberExperienceQuery,
        AdminMemberExperienceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminMemberExperienceQuery, AdminMemberExperienceQueryVariables>(
    AdminMemberExperienceDocument,
    options,
  );
}
export type AdminMemberExperienceQueryHookResult = ReturnType<typeof useAdminMemberExperienceQuery>;
export type AdminMemberExperienceLazyQueryHookResult = ReturnType<
  typeof useAdminMemberExperienceLazyQuery
>;
export type AdminMemberExperienceSuspenseQueryHookResult = ReturnType<
  typeof useAdminMemberExperienceSuspenseQuery
>;
export type AdminMemberExperienceQueryResult = Apollo.QueryResult<
  AdminMemberExperienceQuery,
  AdminMemberExperienceQueryVariables
>;
export const AdminMemberEventsReviewDocument = gql`
    query adminMemberEventsReview($days: Int) {
  adminMemberEventsReview(days: $days) {
    eventId
    startDate
    zone
    isPublic
    priority
    title
    kind
    englishLevel
    hostName
    hostBadge
    isFirstPublic
    acceptedInvites
    spotsTaken
    maxParticipants
    spotsLeft
    labelsEdited
    labels {
      key
      name
      family
    }
  }
}
    `;

/**
 * __useAdminMemberEventsReviewQuery__
 *
 * To run a query within a React component, call `useAdminMemberEventsReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberEventsReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberEventsReviewQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useAdminMemberEventsReviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminMemberEventsReviewQuery,
    AdminMemberEventsReviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminMemberEventsReviewQuery, AdminMemberEventsReviewQueryVariables>(
    AdminMemberEventsReviewDocument,
    options,
  );
}
export function useAdminMemberEventsReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminMemberEventsReviewQuery,
    AdminMemberEventsReviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminMemberEventsReviewQuery, AdminMemberEventsReviewQueryVariables>(
    AdminMemberEventsReviewDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminMemberEventsReviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminMemberEventsReviewQuery,
    AdminMemberEventsReviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminMemberEventsReviewQuery,
  AdminMemberEventsReviewQueryVariables
>;
export function useAdminMemberEventsReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminMemberEventsReviewQuery,
        AdminMemberEventsReviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminMemberEventsReviewQuery | undefined,
  AdminMemberEventsReviewQueryVariables
>;
export function useAdminMemberEventsReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminMemberEventsReviewQuery,
        AdminMemberEventsReviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminMemberEventsReviewQuery,
    AdminMemberEventsReviewQueryVariables
  >(AdminMemberEventsReviewDocument, options);
}
export type AdminMemberEventsReviewQueryHookResult = ReturnType<
  typeof useAdminMemberEventsReviewQuery
>;
export type AdminMemberEventsReviewLazyQueryHookResult = ReturnType<
  typeof useAdminMemberEventsReviewLazyQuery
>;
export type AdminMemberEventsReviewSuspenseQueryHookResult = ReturnType<
  typeof useAdminMemberEventsReviewSuspenseQuery
>;
export type AdminMemberEventsReviewQueryResult = Apollo.QueryResult<
  AdminMemberEventsReviewQuery,
  AdminMemberEventsReviewQueryVariables
>;
export const AdminEventMemberMatchesDocument = gql`
    query adminEventMemberMatches($eventId: String!, $limit: Int, $minEnglish: String) {
  adminEventMemberMatches(
    eventId: $eventId
    limit: $limit
    minEnglish: $minEnglish
  ) {
    eventId
    title
    labelSource
    matchBasis
    eventZone
    eventLevel
    maxParticipants
    spotsTaken
    spotsLeft
    isFull
    totalMatches
    excludedCantAccess
    englishFiltered
    quietFiltered
    newcomerFiltered
    labels {
      key
      name
      family
    }
    matches {
      userId
      name
      email
      occupation
      industry
      speakingLevel
      eventsAttended
      eventsRecent
      engagement
      englishBand
      isNewcomer
      localHour
      recentNotifs
      overContacted
      connectionScore
      storyMatch
      why
      zone
    }
  }
}
    `;

/**
 * __useAdminEventMemberMatchesQuery__
 *
 * To run a query within a React component, call `useAdminEventMemberMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEventMemberMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEventMemberMatchesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      limit: // value for 'limit'
 *      minEnglish: // value for 'minEnglish'
 *   },
 * });
 */
export function useAdminEventMemberMatchesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminEventMemberMatchesQuery,
    AdminEventMemberMatchesQueryVariables
  > &
    ({ variables: AdminEventMemberMatchesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminEventMemberMatchesQuery, AdminEventMemberMatchesQueryVariables>(
    AdminEventMemberMatchesDocument,
    options,
  );
}
export function useAdminEventMemberMatchesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminEventMemberMatchesQuery,
    AdminEventMemberMatchesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminEventMemberMatchesQuery, AdminEventMemberMatchesQueryVariables>(
    AdminEventMemberMatchesDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminEventMemberMatchesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminEventMemberMatchesQuery,
    AdminEventMemberMatchesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminEventMemberMatchesQuery,
  AdminEventMemberMatchesQueryVariables
>;
export function useAdminEventMemberMatchesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminEventMemberMatchesQuery,
        AdminEventMemberMatchesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminEventMemberMatchesQuery | undefined,
  AdminEventMemberMatchesQueryVariables
>;
export function useAdminEventMemberMatchesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminEventMemberMatchesQuery,
        AdminEventMemberMatchesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminEventMemberMatchesQuery,
    AdminEventMemberMatchesQueryVariables
  >(AdminEventMemberMatchesDocument, options);
}
export type AdminEventMemberMatchesQueryHookResult = ReturnType<
  typeof useAdminEventMemberMatchesQuery
>;
export type AdminEventMemberMatchesLazyQueryHookResult = ReturnType<
  typeof useAdminEventMemberMatchesLazyQuery
>;
export type AdminEventMemberMatchesSuspenseQueryHookResult = ReturnType<
  typeof useAdminEventMemberMatchesSuspenseQuery
>;
export type AdminEventMemberMatchesQueryResult = Apollo.QueryResult<
  AdminEventMemberMatchesQuery,
  AdminEventMemberMatchesQueryVariables
>;
export const AdminEventsForMemberDocument = gql`
    query adminEventsForMember($email: String!, $days: Int, $limit: Int) {
  adminEventsForMember(email: $email, days: $days, limit: $limit) {
    member {
      userId
      name
      email
      country
      timezone
      zone
      tenureDays
      tenureBucket
      isNewcomer
      engagement
      speakingLevel
      englishBand
      occupation
      industry
      hasBio
      interests
      englishSkills
      eventsAttended
      eventsRecent
      lastOnlineAt
      upcomingBooked
      recentNotifs
      overContacted
    }
    topicMatchCount
    hiddenCantJoin
    hiddenQuietHours
    hiddenWrongLevel
    hiddenPastNewcomerWindow
    matches {
      eventId
      title
      labels {
        key
        name
        family
      }
      hostName
      hostBadge
      kind
      zone
      startsAt
      localHour
      connectionScore
      matchBasis
      inHerZone
      isFull
      spotsLeft
      why
    }
  }
}
    `;

/**
 * __useAdminEventsForMemberQuery__
 *
 * To run a query within a React component, call `useAdminEventsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEventsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEventsForMemberQuery({
 *   variables: {
 *      email: // value for 'email'
 *      days: // value for 'days'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminEventsForMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminEventsForMemberQuery,
    AdminEventsForMemberQueryVariables
  > &
    ({ variables: AdminEventsForMemberQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminEventsForMemberQuery, AdminEventsForMemberQueryVariables>(
    AdminEventsForMemberDocument,
    options,
  );
}
export function useAdminEventsForMemberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminEventsForMemberQuery,
    AdminEventsForMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminEventsForMemberQuery, AdminEventsForMemberQueryVariables>(
    AdminEventsForMemberDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminEventsForMemberSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminEventsForMemberQuery,
    AdminEventsForMemberQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminEventsForMemberQuery, AdminEventsForMemberQueryVariables>;
export function useAdminEventsForMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminEventsForMemberQuery,
        AdminEventsForMemberQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminEventsForMemberQuery | undefined,
  AdminEventsForMemberQueryVariables
>;
export function useAdminEventsForMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminEventsForMemberQuery,
        AdminEventsForMemberQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminEventsForMemberQuery, AdminEventsForMemberQueryVariables>(
    AdminEventsForMemberDocument,
    options,
  );
}
export type AdminEventsForMemberQueryHookResult = ReturnType<typeof useAdminEventsForMemberQuery>;
export type AdminEventsForMemberLazyQueryHookResult = ReturnType<
  typeof useAdminEventsForMemberLazyQuery
>;
export type AdminEventsForMemberSuspenseQueryHookResult = ReturnType<
  typeof useAdminEventsForMemberSuspenseQuery
>;
export type AdminEventsForMemberQueryResult = Apollo.QueryResult<
  AdminEventsForMemberQuery,
  AdminEventsForMemberQueryVariables
>;
export const AdminEventLabelCatalogueDocument = gql`
    query adminEventLabelCatalogue {
  adminEventLabelCatalogue {
    key
    name
    family
  }
}
    `;

/**
 * __useAdminEventLabelCatalogueQuery__
 *
 * To run a query within a React component, call `useAdminEventLabelCatalogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEventLabelCatalogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEventLabelCatalogueQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminEventLabelCatalogueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminEventLabelCatalogueQuery,
    AdminEventLabelCatalogueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminEventLabelCatalogueQuery, AdminEventLabelCatalogueQueryVariables>(
    AdminEventLabelCatalogueDocument,
    options,
  );
}
export function useAdminEventLabelCatalogueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminEventLabelCatalogueQuery,
    AdminEventLabelCatalogueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminEventLabelCatalogueQuery, AdminEventLabelCatalogueQueryVariables>(
    AdminEventLabelCatalogueDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminEventLabelCatalogueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminEventLabelCatalogueQuery,
    AdminEventLabelCatalogueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminEventLabelCatalogueQuery,
  AdminEventLabelCatalogueQueryVariables
>;
export function useAdminEventLabelCatalogueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminEventLabelCatalogueQuery,
        AdminEventLabelCatalogueQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminEventLabelCatalogueQuery | undefined,
  AdminEventLabelCatalogueQueryVariables
>;
export function useAdminEventLabelCatalogueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminEventLabelCatalogueQuery,
        AdminEventLabelCatalogueQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminEventLabelCatalogueQuery,
    AdminEventLabelCatalogueQueryVariables
  >(AdminEventLabelCatalogueDocument, options);
}
export type AdminEventLabelCatalogueQueryHookResult = ReturnType<
  typeof useAdminEventLabelCatalogueQuery
>;
export type AdminEventLabelCatalogueLazyQueryHookResult = ReturnType<
  typeof useAdminEventLabelCatalogueLazyQuery
>;
export type AdminEventLabelCatalogueSuspenseQueryHookResult = ReturnType<
  typeof useAdminEventLabelCatalogueSuspenseQuery
>;
export type AdminEventLabelCatalogueQueryResult = Apollo.QueryResult<
  AdminEventLabelCatalogueQuery,
  AdminEventLabelCatalogueQueryVariables
>;
export const AdminSetEventLabelsDocument = gql`
    mutation adminSetEventLabels($title: String!, $labels: [String!]) {
  adminSetEventLabels(title: $title, labels: $labels)
}
    `;
export type AdminSetEventLabelsMutationFn = Apollo.MutationFunction<
  AdminSetEventLabelsMutation,
  AdminSetEventLabelsMutationVariables
>;

/**
 * __useAdminSetEventLabelsMutation__
 *
 * To run a mutation, you first call `useAdminSetEventLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetEventLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetEventLabelsMutation, { data, loading, error }] = useAdminSetEventLabelsMutation({
 *   variables: {
 *      title: // value for 'title'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useAdminSetEventLabelsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminSetEventLabelsMutation,
    AdminSetEventLabelsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminSetEventLabelsMutation, AdminSetEventLabelsMutationVariables>(
    AdminSetEventLabelsDocument,
    options,
  );
}
export type AdminSetEventLabelsMutationHookResult = ReturnType<
  typeof useAdminSetEventLabelsMutation
>;
export type AdminSetEventLabelsMutationResult = Apollo.MutationResult<AdminSetEventLabelsMutation>;
export type AdminSetEventLabelsMutationOptions = Apollo.BaseMutationOptions<
  AdminSetEventLabelsMutation,
  AdminSetEventLabelsMutationVariables
>;
export const AdminEventInsightDocument = gql`
    query adminEventInsight($eventId: String!) {
  adminEventInsight(eventId: $eventId) {
    zone
    hostType
    level
    visibility
    labelSource
    registered
    maxParticipants
    unlimited
    isFull
    labels {
      key
      name
      family
    }
  }
}
    `;

/**
 * __useAdminEventInsightQuery__
 *
 * To run a query within a React component, call `useAdminEventInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEventInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEventInsightQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAdminEventInsightQuery(
  baseOptions: Apollo.QueryHookOptions<AdminEventInsightQuery, AdminEventInsightQueryVariables> &
    ({ variables: AdminEventInsightQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminEventInsightQuery, AdminEventInsightQueryVariables>(
    AdminEventInsightDocument,
    options,
  );
}
export function useAdminEventInsightLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminEventInsightQuery,
    AdminEventInsightQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminEventInsightQuery, AdminEventInsightQueryVariables>(
    AdminEventInsightDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminEventInsightSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminEventInsightQuery,
    AdminEventInsightQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminEventInsightQuery, AdminEventInsightQueryVariables>;
export function useAdminEventInsightSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminEventInsightQuery, AdminEventInsightQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminEventInsightQuery | undefined,
  AdminEventInsightQueryVariables
>;
export function useAdminEventInsightSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminEventInsightQuery, AdminEventInsightQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminEventInsightQuery, AdminEventInsightQueryVariables>(
    AdminEventInsightDocument,
    options,
  );
}
export type AdminEventInsightQueryHookResult = ReturnType<typeof useAdminEventInsightQuery>;
export type AdminEventInsightLazyQueryHookResult = ReturnType<typeof useAdminEventInsightLazyQuery>;
export type AdminEventInsightSuspenseQueryHookResult = ReturnType<
  typeof useAdminEventInsightSuspenseQuery
>;
export type AdminEventInsightQueryResult = Apollo.QueryResult<
  AdminEventInsightQuery,
  AdminEventInsightQueryVariables
>;
export const AdminEventsCalendarDocument = gql`
    query adminEventsCalendar($weekStart: String!) {
  adminEventsCalendar(weekStart: $weekStart) {
    weekStart
    total
    events {
      id
      title
      startDate
      zone
      dayOfWeek
      timeUtc
      hostType
      hostFirstName
      hostName
      kind
      level
      category
      visibility
      maxParticipants
      registered
      unlimited
      isFull
      recurring
      isCoachEvent
      needsThreeEvents
      participants
    }
  }
}
    `;

/**
 * __useAdminEventsCalendarQuery__
 *
 * To run a query within a React component, call `useAdminEventsCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEventsCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEventsCalendarQuery({
 *   variables: {
 *      weekStart: // value for 'weekStart'
 *   },
 * });
 */
export function useAdminEventsCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminEventsCalendarQuery,
    AdminEventsCalendarQueryVariables
  > &
    ({ variables: AdminEventsCalendarQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminEventsCalendarQuery, AdminEventsCalendarQueryVariables>(
    AdminEventsCalendarDocument,
    options,
  );
}
export function useAdminEventsCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminEventsCalendarQuery,
    AdminEventsCalendarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminEventsCalendarQuery, AdminEventsCalendarQueryVariables>(
    AdminEventsCalendarDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminEventsCalendarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminEventsCalendarQuery,
    AdminEventsCalendarQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminEventsCalendarQuery, AdminEventsCalendarQueryVariables>;
export function useAdminEventsCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminEventsCalendarQuery, AdminEventsCalendarQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminEventsCalendarQuery | undefined,
  AdminEventsCalendarQueryVariables
>;
export function useAdminEventsCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminEventsCalendarQuery, AdminEventsCalendarQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminEventsCalendarQuery, AdminEventsCalendarQueryVariables>(
    AdminEventsCalendarDocument,
    options,
  );
}
export type AdminEventsCalendarQueryHookResult = ReturnType<typeof useAdminEventsCalendarQuery>;
export type AdminEventsCalendarLazyQueryHookResult = ReturnType<
  typeof useAdminEventsCalendarLazyQuery
>;
export type AdminEventsCalendarSuspenseQueryHookResult = ReturnType<
  typeof useAdminEventsCalendarSuspenseQuery
>;
export type AdminEventsCalendarQueryResult = Apollo.QueryResult<
  AdminEventsCalendarQuery,
  AdminEventsCalendarQueryVariables
>;
export const AdminGetFeatureFlagDocument = gql`
    query adminGetFeatureFlag($id: String!) {
  adminGetFeatureFlag(id: $id) {
    id
    label
    active
  }
}
    `;

/**
 * __useAdminGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useAdminGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetFeatureFlagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetFeatureFlagQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGetFeatureFlagQuery,
    AdminGetFeatureFlagQueryVariables
  > &
    ({ variables: AdminGetFeatureFlagQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetFeatureFlagQuery, AdminGetFeatureFlagQueryVariables>(
    AdminGetFeatureFlagDocument,
    options,
  );
}
export function useAdminGetFeatureFlagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetFeatureFlagQuery,
    AdminGetFeatureFlagQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetFeatureFlagQuery, AdminGetFeatureFlagQueryVariables>(
    AdminGetFeatureFlagDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetFeatureFlagSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetFeatureFlagQuery,
    AdminGetFeatureFlagQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetFeatureFlagQuery, AdminGetFeatureFlagQueryVariables>;
export function useAdminGetFeatureFlagSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetFeatureFlagQuery, AdminGetFeatureFlagQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminGetFeatureFlagQuery | undefined,
  AdminGetFeatureFlagQueryVariables
>;
export function useAdminGetFeatureFlagSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetFeatureFlagQuery, AdminGetFeatureFlagQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetFeatureFlagQuery, AdminGetFeatureFlagQueryVariables>(
    AdminGetFeatureFlagDocument,
    options,
  );
}
export type AdminGetFeatureFlagQueryHookResult = ReturnType<typeof useAdminGetFeatureFlagQuery>;
export type AdminGetFeatureFlagLazyQueryHookResult = ReturnType<
  typeof useAdminGetFeatureFlagLazyQuery
>;
export type AdminGetFeatureFlagSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetFeatureFlagSuspenseQuery
>;
export type AdminGetFeatureFlagQueryResult = Apollo.QueryResult<
  AdminGetFeatureFlagQuery,
  AdminGetFeatureFlagQueryVariables
>;
export const AdminListPaginatedFeatureFlagsDocument = gql`
    query adminListPaginatedFeatureFlags($filters: AdminFilterFeatureFlagsInput!) {
  adminListPaginatedFeatureFlags(filters: $filters) {
    items {
      id
      label
      active
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedFeatureFlagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedFeatureFlagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedFeatureFlagsQuery,
    AdminListPaginatedFeatureFlagsQueryVariables
  > &
    (
      | { variables: AdminListPaginatedFeatureFlagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListPaginatedFeatureFlagsQuery,
    AdminListPaginatedFeatureFlagsQueryVariables
  >(AdminListPaginatedFeatureFlagsDocument, options);
}
export function useAdminListPaginatedFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedFeatureFlagsQuery,
    AdminListPaginatedFeatureFlagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedFeatureFlagsQuery,
    AdminListPaginatedFeatureFlagsQueryVariables
  >(AdminListPaginatedFeatureFlagsDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedFeatureFlagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedFeatureFlagsQuery,
    AdminListPaginatedFeatureFlagsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedFeatureFlagsQuery,
  AdminListPaginatedFeatureFlagsQueryVariables
>;
export function useAdminListPaginatedFeatureFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedFeatureFlagsQuery,
        AdminListPaginatedFeatureFlagsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedFeatureFlagsQuery | undefined,
  AdminListPaginatedFeatureFlagsQueryVariables
>;
export function useAdminListPaginatedFeatureFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedFeatureFlagsQuery,
        AdminListPaginatedFeatureFlagsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedFeatureFlagsQuery,
    AdminListPaginatedFeatureFlagsQueryVariables
  >(AdminListPaginatedFeatureFlagsDocument, options);
}
export type AdminListPaginatedFeatureFlagsQueryHookResult = ReturnType<
  typeof useAdminListPaginatedFeatureFlagsQuery
>;
export type AdminListPaginatedFeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedFeatureFlagsLazyQuery
>;
export type AdminListPaginatedFeatureFlagsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedFeatureFlagsSuspenseQuery
>;
export type AdminListPaginatedFeatureFlagsQueryResult = Apollo.QueryResult<
  AdminListPaginatedFeatureFlagsQuery,
  AdminListPaginatedFeatureFlagsQueryVariables
>;
export const AdminGetIllustrationDocument = gql`
    query adminGetIllustration($id: String!) {
  adminGetIllustration(id: $id) {
    id
    title
    url
  }
}
    `;

/**
 * __useAdminGetIllustrationQuery__
 *
 * To run a query within a React component, call `useAdminGetIllustrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetIllustrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetIllustrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetIllustrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGetIllustrationQuery,
    AdminGetIllustrationQueryVariables
  > &
    ({ variables: AdminGetIllustrationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetIllustrationQuery, AdminGetIllustrationQueryVariables>(
    AdminGetIllustrationDocument,
    options,
  );
}
export function useAdminGetIllustrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetIllustrationQuery,
    AdminGetIllustrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetIllustrationQuery, AdminGetIllustrationQueryVariables>(
    AdminGetIllustrationDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetIllustrationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetIllustrationQuery,
    AdminGetIllustrationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetIllustrationQuery, AdminGetIllustrationQueryVariables>;
export function useAdminGetIllustrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetIllustrationQuery,
        AdminGetIllustrationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminGetIllustrationQuery | undefined,
  AdminGetIllustrationQueryVariables
>;
export function useAdminGetIllustrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetIllustrationQuery,
        AdminGetIllustrationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetIllustrationQuery, AdminGetIllustrationQueryVariables>(
    AdminGetIllustrationDocument,
    options,
  );
}
export type AdminGetIllustrationQueryHookResult = ReturnType<typeof useAdminGetIllustrationQuery>;
export type AdminGetIllustrationLazyQueryHookResult = ReturnType<
  typeof useAdminGetIllustrationLazyQuery
>;
export type AdminGetIllustrationSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetIllustrationSuspenseQuery
>;
export type AdminGetIllustrationQueryResult = Apollo.QueryResult<
  AdminGetIllustrationQuery,
  AdminGetIllustrationQueryVariables
>;
export const AdminListPaginatedIllustrationsDocument = gql`
    query adminListPaginatedIllustrations($filters: AdminFilterIllustrationsInput!) {
  adminListPaginatedIllustrations(filters: $filters) {
    items {
      id
      title
      url
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedIllustrationsQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedIllustrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedIllustrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedIllustrationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedIllustrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedIllustrationsQuery,
    AdminListPaginatedIllustrationsQueryVariables
  > &
    (
      | { variables: AdminListPaginatedIllustrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListPaginatedIllustrationsQuery,
    AdminListPaginatedIllustrationsQueryVariables
  >(AdminListPaginatedIllustrationsDocument, options);
}
export function useAdminListPaginatedIllustrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedIllustrationsQuery,
    AdminListPaginatedIllustrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedIllustrationsQuery,
    AdminListPaginatedIllustrationsQueryVariables
  >(AdminListPaginatedIllustrationsDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedIllustrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedIllustrationsQuery,
    AdminListPaginatedIllustrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedIllustrationsQuery,
  AdminListPaginatedIllustrationsQueryVariables
>;
export function useAdminListPaginatedIllustrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedIllustrationsQuery,
        AdminListPaginatedIllustrationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedIllustrationsQuery | undefined,
  AdminListPaginatedIllustrationsQueryVariables
>;
export function useAdminListPaginatedIllustrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedIllustrationsQuery,
        AdminListPaginatedIllustrationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedIllustrationsQuery,
    AdminListPaginatedIllustrationsQueryVariables
  >(AdminListPaginatedIllustrationsDocument, options);
}
export type AdminListPaginatedIllustrationsQueryHookResult = ReturnType<
  typeof useAdminListPaginatedIllustrationsQuery
>;
export type AdminListPaginatedIllustrationsLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedIllustrationsLazyQuery
>;
export type AdminListPaginatedIllustrationsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedIllustrationsSuspenseQuery
>;
export type AdminListPaginatedIllustrationsQueryResult = Apollo.QueryResult<
  AdminListPaginatedIllustrationsQuery,
  AdminListPaginatedIllustrationsQueryVariables
>;
export const AdminRecordCampaignInvitesDocument = gql`
    mutation adminRecordCampaignInvites($campaign: InviteCampaignKey!, $eventId: String!, $userIds: [String!]!) {
  adminRecordCampaignInvites(
    campaign: $campaign
    eventId: $eventId
    userIds: $userIds
  )
}
    `;
export type AdminRecordCampaignInvitesMutationFn = Apollo.MutationFunction<
  AdminRecordCampaignInvitesMutation,
  AdminRecordCampaignInvitesMutationVariables
>;

/**
 * __useAdminRecordCampaignInvitesMutation__
 *
 * To run a mutation, you first call `useAdminRecordCampaignInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRecordCampaignInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRecordCampaignInvitesMutation, { data, loading, error }] = useAdminRecordCampaignInvitesMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      eventId: // value for 'eventId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useAdminRecordCampaignInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminRecordCampaignInvitesMutation,
    AdminRecordCampaignInvitesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminRecordCampaignInvitesMutation,
    AdminRecordCampaignInvitesMutationVariables
  >(AdminRecordCampaignInvitesDocument, options);
}
export type AdminRecordCampaignInvitesMutationHookResult = ReturnType<
  typeof useAdminRecordCampaignInvitesMutation
>;
export type AdminRecordCampaignInvitesMutationResult =
  Apollo.MutationResult<AdminRecordCampaignInvitesMutation>;
export type AdminRecordCampaignInvitesMutationOptions = Apollo.BaseMutationOptions<
  AdminRecordCampaignInvitesMutation,
  AdminRecordCampaignInvitesMutationVariables
>;
export const AdminCampaignResultsDocument = gql`
    query adminCampaignResults($campaign: InviteCampaignKey!, $from: Date, $to: Date) {
  adminCampaignResults(campaign: $campaign, from: $from, to: $to) {
    weekStarting
    events
    invited
    saidYes
    came
    totalThere
    partial
  }
}
    `;

/**
 * __useAdminCampaignResultsQuery__
 *
 * To run a query within a React component, call `useAdminCampaignResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCampaignResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCampaignResultsQuery({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAdminCampaignResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCampaignResultsQuery,
    AdminCampaignResultsQueryVariables
  > &
    ({ variables: AdminCampaignResultsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminCampaignResultsQuery, AdminCampaignResultsQueryVariables>(
    AdminCampaignResultsDocument,
    options,
  );
}
export function useAdminCampaignResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCampaignResultsQuery,
    AdminCampaignResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminCampaignResultsQuery, AdminCampaignResultsQueryVariables>(
    AdminCampaignResultsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminCampaignResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminCampaignResultsQuery,
    AdminCampaignResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminCampaignResultsQuery, AdminCampaignResultsQueryVariables>;
export function useAdminCampaignResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminCampaignResultsQuery,
        AdminCampaignResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminCampaignResultsQuery | undefined,
  AdminCampaignResultsQueryVariables
>;
export function useAdminCampaignResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminCampaignResultsQuery,
        AdminCampaignResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminCampaignResultsQuery, AdminCampaignResultsQueryVariables>(
    AdminCampaignResultsDocument,
    options,
  );
}
export type AdminCampaignResultsQueryHookResult = ReturnType<typeof useAdminCampaignResultsQuery>;
export type AdminCampaignResultsLazyQueryHookResult = ReturnType<
  typeof useAdminCampaignResultsLazyQuery
>;
export type AdminCampaignResultsSuspenseQueryHookResult = ReturnType<
  typeof useAdminCampaignResultsSuspenseQuery
>;
export type AdminCampaignResultsQueryResult = Apollo.QueryResult<
  AdminCampaignResultsQuery,
  AdminCampaignResultsQueryVariables
>;
export const AdminCampaignEventResultsDocument = gql`
    query adminCampaignEventResults($campaign: InviteCampaignKey!, $weekStarting: Date!) {
  adminCampaignEventResults(campaign: $campaign, weekStarting: $weekStarting) {
    eventId
    title
    startDate
    invited
    saidYes
    came
    totalThere
  }
}
    `;

/**
 * __useAdminCampaignEventResultsQuery__
 *
 * To run a query within a React component, call `useAdminCampaignEventResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCampaignEventResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCampaignEventResultsQuery({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      weekStarting: // value for 'weekStarting'
 *   },
 * });
 */
export function useAdminCampaignEventResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCampaignEventResultsQuery,
    AdminCampaignEventResultsQueryVariables
  > &
    ({ variables: AdminCampaignEventResultsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminCampaignEventResultsQuery, AdminCampaignEventResultsQueryVariables>(
    AdminCampaignEventResultsDocument,
    options,
  );
}
export function useAdminCampaignEventResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCampaignEventResultsQuery,
    AdminCampaignEventResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminCampaignEventResultsQuery,
    AdminCampaignEventResultsQueryVariables
  >(AdminCampaignEventResultsDocument, options);
}
// @ts-expect-error
export function useAdminCampaignEventResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminCampaignEventResultsQuery,
    AdminCampaignEventResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminCampaignEventResultsQuery,
  AdminCampaignEventResultsQueryVariables
>;
export function useAdminCampaignEventResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminCampaignEventResultsQuery,
        AdminCampaignEventResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminCampaignEventResultsQuery | undefined,
  AdminCampaignEventResultsQueryVariables
>;
export function useAdminCampaignEventResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminCampaignEventResultsQuery,
        AdminCampaignEventResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminCampaignEventResultsQuery,
    AdminCampaignEventResultsQueryVariables
  >(AdminCampaignEventResultsDocument, options);
}
export type AdminCampaignEventResultsQueryHookResult = ReturnType<
  typeof useAdminCampaignEventResultsQuery
>;
export type AdminCampaignEventResultsLazyQueryHookResult = ReturnType<
  typeof useAdminCampaignEventResultsLazyQuery
>;
export type AdminCampaignEventResultsSuspenseQueryHookResult = ReturnType<
  typeof useAdminCampaignEventResultsSuspenseQuery
>;
export type AdminCampaignEventResultsQueryResult = Apollo.QueryResult<
  AdminCampaignEventResultsQuery,
  AdminCampaignEventResultsQueryVariables
>;
export const AdminInviteCampaignDocument = gql`
    query adminInviteCampaign($campaign: InviteCampaignKey!) {
  adminInviteCampaign(campaign: $campaign) {
    zone
    programme
    eventId
    eventTitle
    eventStartDate
    memberCount
    members {
      userId
      email
      firstName
      isGuest
      why
      note
      afterPass
      option
    }
    extraMembers {
      userId
      email
      firstName
      isGuest
      why
      note
      afterPass
      option
    }
  }
}
    `;

/**
 * __useAdminInviteCampaignQuery__
 *
 * To run a query within a React component, call `useAdminInviteCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminInviteCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminInviteCampaignQuery({
 *   variables: {
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useAdminInviteCampaignQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminInviteCampaignQuery,
    AdminInviteCampaignQueryVariables
  > &
    ({ variables: AdminInviteCampaignQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminInviteCampaignQuery, AdminInviteCampaignQueryVariables>(
    AdminInviteCampaignDocument,
    options,
  );
}
export function useAdminInviteCampaignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminInviteCampaignQuery,
    AdminInviteCampaignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminInviteCampaignQuery, AdminInviteCampaignQueryVariables>(
    AdminInviteCampaignDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminInviteCampaignSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminInviteCampaignQuery,
    AdminInviteCampaignQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminInviteCampaignQuery, AdminInviteCampaignQueryVariables>;
export function useAdminInviteCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminInviteCampaignQuery, AdminInviteCampaignQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminInviteCampaignQuery | undefined,
  AdminInviteCampaignQueryVariables
>;
export function useAdminInviteCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminInviteCampaignQuery, AdminInviteCampaignQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminInviteCampaignQuery, AdminInviteCampaignQueryVariables>(
    AdminInviteCampaignDocument,
    options,
  );
}
export type AdminInviteCampaignQueryHookResult = ReturnType<typeof useAdminInviteCampaignQuery>;
export type AdminInviteCampaignLazyQueryHookResult = ReturnType<
  typeof useAdminInviteCampaignLazyQuery
>;
export type AdminInviteCampaignSuspenseQueryHookResult = ReturnType<
  typeof useAdminInviteCampaignSuspenseQuery
>;
export type AdminInviteCampaignQueryResult = Apollo.QueryResult<
  AdminInviteCampaignQuery,
  AdminInviteCampaignQueryVariables
>;
export const AdminGetLessonDocument = gql`
    query adminGetLesson($id: String!) {
  adminGetLesson(id: $id) {
    id
    kind
    title
    sections {
      id
      order
      elements {
        kind
        value
        meta
      }
    }
  }
  adminGetTopicByLessonId(id: $id) {
    id
    title
  }
}
    `;

/**
 * __useAdminGetLessonQuery__
 *
 * To run a query within a React component, call `useAdminGetLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetLessonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetLessonQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetLessonQuery, AdminGetLessonQueryVariables> &
    ({ variables: AdminGetLessonQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetLessonQuery, AdminGetLessonQueryVariables>(
    AdminGetLessonDocument,
    options,
  );
}
export function useAdminGetLessonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetLessonQuery, AdminGetLessonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetLessonQuery, AdminGetLessonQueryVariables>(
    AdminGetLessonDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetLessonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetLessonQuery, AdminGetLessonQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetLessonQuery, AdminGetLessonQueryVariables>;
export function useAdminGetLessonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetLessonQuery, AdminGetLessonQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetLessonQuery | undefined, AdminGetLessonQueryVariables>;
export function useAdminGetLessonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetLessonQuery, AdminGetLessonQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetLessonQuery, AdminGetLessonQueryVariables>(
    AdminGetLessonDocument,
    options,
  );
}
export type AdminGetLessonQueryHookResult = ReturnType<typeof useAdminGetLessonQuery>;
export type AdminGetLessonLazyQueryHookResult = ReturnType<typeof useAdminGetLessonLazyQuery>;
export type AdminGetLessonSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetLessonSuspenseQuery
>;
export type AdminGetLessonQueryResult = Apollo.QueryResult<
  AdminGetLessonQuery,
  AdminGetLessonQueryVariables
>;
export const GetDailyHooksDocument = gql`
    query getDailyHooks {
  getDailyHooks {
    uuid
    url
    state
    retryType
    eventTypes
    createdAt
  }
}
    `;

/**
 * __useGetDailyHooksQuery__
 *
 * To run a query within a React component, call `useGetDailyHooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyHooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyHooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDailyHooksQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDailyHooksQuery, GetDailyHooksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDailyHooksQuery, GetDailyHooksQueryVariables>(
    GetDailyHooksDocument,
    options,
  );
}
export function useGetDailyHooksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDailyHooksQuery, GetDailyHooksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDailyHooksQuery, GetDailyHooksQueryVariables>(
    GetDailyHooksDocument,
    options,
  );
}
// @ts-expect-error
export function useGetDailyHooksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDailyHooksQuery, GetDailyHooksQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDailyHooksQuery, GetDailyHooksQueryVariables>;
export function useGetDailyHooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDailyHooksQuery, GetDailyHooksQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDailyHooksQuery | undefined, GetDailyHooksQueryVariables>;
export function useGetDailyHooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDailyHooksQuery, GetDailyHooksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDailyHooksQuery, GetDailyHooksQueryVariables>(
    GetDailyHooksDocument,
    options,
  );
}
export type GetDailyHooksQueryHookResult = ReturnType<typeof useGetDailyHooksQuery>;
export type GetDailyHooksLazyQueryHookResult = ReturnType<typeof useGetDailyHooksLazyQuery>;
export type GetDailyHooksSuspenseQueryHookResult = ReturnType<typeof useGetDailyHooksSuspenseQuery>;
export type GetDailyHooksQueryResult = Apollo.QueryResult<
  GetDailyHooksQuery,
  GetDailyHooksQueryVariables
>;
export const BackfillConnectionStreaksRunningDocument = gql`
    query backfillConnectionStreaksRunning {
  backfillConnectionStreaksRunning
}
    `;

/**
 * __useBackfillConnectionStreaksRunningQuery__
 *
 * To run a query within a React component, call `useBackfillConnectionStreaksRunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackfillConnectionStreaksRunningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackfillConnectionStreaksRunningQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackfillConnectionStreaksRunningQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackfillConnectionStreaksRunningQuery,
    BackfillConnectionStreaksRunningQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BackfillConnectionStreaksRunningQuery,
    BackfillConnectionStreaksRunningQueryVariables
  >(BackfillConnectionStreaksRunningDocument, options);
}
export function useBackfillConnectionStreaksRunningLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackfillConnectionStreaksRunningQuery,
    BackfillConnectionStreaksRunningQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BackfillConnectionStreaksRunningQuery,
    BackfillConnectionStreaksRunningQueryVariables
  >(BackfillConnectionStreaksRunningDocument, options);
}
// @ts-expect-error
export function useBackfillConnectionStreaksRunningSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackfillConnectionStreaksRunningQuery,
    BackfillConnectionStreaksRunningQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackfillConnectionStreaksRunningQuery,
  BackfillConnectionStreaksRunningQueryVariables
>;
export function useBackfillConnectionStreaksRunningSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackfillConnectionStreaksRunningQuery,
        BackfillConnectionStreaksRunningQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackfillConnectionStreaksRunningQuery | undefined,
  BackfillConnectionStreaksRunningQueryVariables
>;
export function useBackfillConnectionStreaksRunningSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackfillConnectionStreaksRunningQuery,
        BackfillConnectionStreaksRunningQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BackfillConnectionStreaksRunningQuery,
    BackfillConnectionStreaksRunningQueryVariables
  >(BackfillConnectionStreaksRunningDocument, options);
}
export type BackfillConnectionStreaksRunningQueryHookResult = ReturnType<
  typeof useBackfillConnectionStreaksRunningQuery
>;
export type BackfillConnectionStreaksRunningLazyQueryHookResult = ReturnType<
  typeof useBackfillConnectionStreaksRunningLazyQuery
>;
export type BackfillConnectionStreaksRunningSuspenseQueryHookResult = ReturnType<
  typeof useBackfillConnectionStreaksRunningSuspenseQuery
>;
export type BackfillConnectionStreaksRunningQueryResult = Apollo.QueryResult<
  BackfillConnectionStreaksRunningQuery,
  BackfillConnectionStreaksRunningQueryVariables
>;
export const GetCustomNotificationDisplayDocument = gql`
    query getCustomNotificationDisplay($id: String!) {
  getCustomNotificationDisplay(id: $id) {
    id
    illustration
    title
    text
    buttonText
    buttonUrl
  }
}
    `;

/**
 * __useGetCustomNotificationDisplayQuery__
 *
 * To run a query within a React component, call `useGetCustomNotificationDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomNotificationDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomNotificationDisplayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomNotificationDisplayQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomNotificationDisplayQuery,
    GetCustomNotificationDisplayQueryVariables
  > &
    ({ variables: GetCustomNotificationDisplayQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomNotificationDisplayQuery,
    GetCustomNotificationDisplayQueryVariables
  >(GetCustomNotificationDisplayDocument, options);
}
export function useGetCustomNotificationDisplayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomNotificationDisplayQuery,
    GetCustomNotificationDisplayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomNotificationDisplayQuery,
    GetCustomNotificationDisplayQueryVariables
  >(GetCustomNotificationDisplayDocument, options);
}
// @ts-expect-error
export function useGetCustomNotificationDisplaySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCustomNotificationDisplayQuery,
    GetCustomNotificationDisplayQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCustomNotificationDisplayQuery,
  GetCustomNotificationDisplayQueryVariables
>;
export function useGetCustomNotificationDisplaySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomNotificationDisplayQuery,
        GetCustomNotificationDisplayQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCustomNotificationDisplayQuery | undefined,
  GetCustomNotificationDisplayQueryVariables
>;
export function useGetCustomNotificationDisplaySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomNotificationDisplayQuery,
        GetCustomNotificationDisplayQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomNotificationDisplayQuery,
    GetCustomNotificationDisplayQueryVariables
  >(GetCustomNotificationDisplayDocument, options);
}
export type GetCustomNotificationDisplayQueryHookResult = ReturnType<
  typeof useGetCustomNotificationDisplayQuery
>;
export type GetCustomNotificationDisplayLazyQueryHookResult = ReturnType<
  typeof useGetCustomNotificationDisplayLazyQuery
>;
export type GetCustomNotificationDisplaySuspenseQueryHookResult = ReturnType<
  typeof useGetCustomNotificationDisplaySuspenseQuery
>;
export type GetCustomNotificationDisplayQueryResult = Apollo.QueryResult<
  GetCustomNotificationDisplayQuery,
  GetCustomNotificationDisplayQueryVariables
>;
export const AdminListPaginatedCustomNotificationDisplayDocument = gql`
    query adminListPaginatedCustomNotificationDisplay($filters: FilterCustomNotificationDisplayInput!) {
  adminListPaginatedCustomNotificationDisplay(filters: $filters) {
    items {
      id
      illustration
      title
      text
      buttonText
      buttonUrl
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedCustomNotificationDisplayQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedCustomNotificationDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedCustomNotificationDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedCustomNotificationDisplayQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedCustomNotificationDisplayQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedCustomNotificationDisplayQuery,
    AdminListPaginatedCustomNotificationDisplayQueryVariables
  > &
    (
      | { variables: AdminListPaginatedCustomNotificationDisplayQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListPaginatedCustomNotificationDisplayQuery,
    AdminListPaginatedCustomNotificationDisplayQueryVariables
  >(AdminListPaginatedCustomNotificationDisplayDocument, options);
}
export function useAdminListPaginatedCustomNotificationDisplayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedCustomNotificationDisplayQuery,
    AdminListPaginatedCustomNotificationDisplayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedCustomNotificationDisplayQuery,
    AdminListPaginatedCustomNotificationDisplayQueryVariables
  >(AdminListPaginatedCustomNotificationDisplayDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedCustomNotificationDisplaySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedCustomNotificationDisplayQuery,
    AdminListPaginatedCustomNotificationDisplayQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedCustomNotificationDisplayQuery,
  AdminListPaginatedCustomNotificationDisplayQueryVariables
>;
export function useAdminListPaginatedCustomNotificationDisplaySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedCustomNotificationDisplayQuery,
        AdminListPaginatedCustomNotificationDisplayQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedCustomNotificationDisplayQuery | undefined,
  AdminListPaginatedCustomNotificationDisplayQueryVariables
>;
export function useAdminListPaginatedCustomNotificationDisplaySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedCustomNotificationDisplayQuery,
        AdminListPaginatedCustomNotificationDisplayQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedCustomNotificationDisplayQuery,
    AdminListPaginatedCustomNotificationDisplayQueryVariables
  >(AdminListPaginatedCustomNotificationDisplayDocument, options);
}
export type AdminListPaginatedCustomNotificationDisplayQueryHookResult = ReturnType<
  typeof useAdminListPaginatedCustomNotificationDisplayQuery
>;
export type AdminListPaginatedCustomNotificationDisplayLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedCustomNotificationDisplayLazyQuery
>;
export type AdminListPaginatedCustomNotificationDisplaySuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedCustomNotificationDisplaySuspenseQuery
>;
export type AdminListPaginatedCustomNotificationDisplayQueryResult = Apollo.QueryResult<
  AdminListPaginatedCustomNotificationDisplayQuery,
  AdminListPaginatedCustomNotificationDisplayQueryVariables
>;
export const AdminOnlineNowMembersDocument = gql`
    query adminOnlineNowMembers($faderLevels: [FaderLevel!]!) {
  adminOnlineNowMembers(faderLevels: $faderLevels) {
    userId
    name
    email
    zone
    faderLevel
  }
}
    `;

/**
 * __useAdminOnlineNowMembersQuery__
 *
 * To run a query within a React component, call `useAdminOnlineNowMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOnlineNowMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOnlineNowMembersQuery({
 *   variables: {
 *      faderLevels: // value for 'faderLevels'
 *   },
 * });
 */
export function useAdminOnlineNowMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminOnlineNowMembersQuery,
    AdminOnlineNowMembersQueryVariables
  > &
    ({ variables: AdminOnlineNowMembersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminOnlineNowMembersQuery, AdminOnlineNowMembersQueryVariables>(
    AdminOnlineNowMembersDocument,
    options,
  );
}
export function useAdminOnlineNowMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminOnlineNowMembersQuery,
    AdminOnlineNowMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminOnlineNowMembersQuery, AdminOnlineNowMembersQueryVariables>(
    AdminOnlineNowMembersDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminOnlineNowMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminOnlineNowMembersQuery,
    AdminOnlineNowMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminOnlineNowMembersQuery, AdminOnlineNowMembersQueryVariables>;
export function useAdminOnlineNowMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminOnlineNowMembersQuery,
        AdminOnlineNowMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminOnlineNowMembersQuery | undefined,
  AdminOnlineNowMembersQueryVariables
>;
export function useAdminOnlineNowMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminOnlineNowMembersQuery,
        AdminOnlineNowMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminOnlineNowMembersQuery, AdminOnlineNowMembersQueryVariables>(
    AdminOnlineNowMembersDocument,
    options,
  );
}
export type AdminOnlineNowMembersQueryHookResult = ReturnType<typeof useAdminOnlineNowMembersQuery>;
export type AdminOnlineNowMembersLazyQueryHookResult = ReturnType<
  typeof useAdminOnlineNowMembersLazyQuery
>;
export type AdminOnlineNowMembersSuspenseQueryHookResult = ReturnType<
  typeof useAdminOnlineNowMembersSuspenseQuery
>;
export type AdminOnlineNowMembersQueryResult = Apollo.QueryResult<
  AdminOnlineNowMembersQuery,
  AdminOnlineNowMembersQueryVariables
>;
export const GetCurrentTopicQuestionsDocument = gql`
    query getCurrentTopicQuestions {
  getCurrentTopicQuestions {
    id
    question
    updatedAt
    topic {
      id
      title
    }
  }
}
    `;

/**
 * __useGetCurrentTopicQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentTopicQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentTopicQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentTopicQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentTopicQuestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentTopicQuestionsQuery, GetCurrentTopicQuestionsQueryVariables>(
    GetCurrentTopicQuestionsDocument,
    options,
  );
}
export function useGetCurrentTopicQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentTopicQuestionsQuery, GetCurrentTopicQuestionsQueryVariables>(
    GetCurrentTopicQuestionsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetCurrentTopicQuestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentTopicQuestionsQuery,
  GetCurrentTopicQuestionsQueryVariables
>;
export function useGetCurrentTopicQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentTopicQuestionsQuery,
        GetCurrentTopicQuestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentTopicQuestionsQuery | undefined,
  GetCurrentTopicQuestionsQueryVariables
>;
export function useGetCurrentTopicQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentTopicQuestionsQuery,
        GetCurrentTopicQuestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >(GetCurrentTopicQuestionsDocument, options);
}
export type GetCurrentTopicQuestionsQueryHookResult = ReturnType<
  typeof useGetCurrentTopicQuestionsQuery
>;
export type GetCurrentTopicQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetCurrentTopicQuestionsLazyQuery
>;
export type GetCurrentTopicQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentTopicQuestionsSuspenseQuery
>;
export type GetCurrentTopicQuestionsQueryResult = Apollo.QueryResult<
  GetCurrentTopicQuestionsQuery,
  GetCurrentTopicQuestionsQueryVariables
>;
export const AdminListPaginatedReportsUsersDocument = gql`
    query adminListPaginatedReportsUsers($filters: AdminFilterReportsUserFilterInput!) {
  adminListPaginatedReportsUsers(filters: $filters) {
    items {
      id
      description
      reason
      createdAt
      abuser {
        id
        name
      }
      victim {
        id
        name
      }
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedReportsUsersQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedReportsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedReportsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedReportsUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedReportsUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedReportsUsersQuery,
    AdminListPaginatedReportsUsersQueryVariables
  > &
    (
      | { variables: AdminListPaginatedReportsUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListPaginatedReportsUsersQuery,
    AdminListPaginatedReportsUsersQueryVariables
  >(AdminListPaginatedReportsUsersDocument, options);
}
export function useAdminListPaginatedReportsUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedReportsUsersQuery,
    AdminListPaginatedReportsUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedReportsUsersQuery,
    AdminListPaginatedReportsUsersQueryVariables
  >(AdminListPaginatedReportsUsersDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedReportsUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedReportsUsersQuery,
    AdminListPaginatedReportsUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedReportsUsersQuery,
  AdminListPaginatedReportsUsersQueryVariables
>;
export function useAdminListPaginatedReportsUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedReportsUsersQuery,
        AdminListPaginatedReportsUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedReportsUsersQuery | undefined,
  AdminListPaginatedReportsUsersQueryVariables
>;
export function useAdminListPaginatedReportsUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedReportsUsersQuery,
        AdminListPaginatedReportsUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedReportsUsersQuery,
    AdminListPaginatedReportsUsersQueryVariables
  >(AdminListPaginatedReportsUsersDocument, options);
}
export type AdminListPaginatedReportsUsersQueryHookResult = ReturnType<
  typeof useAdminListPaginatedReportsUsersQuery
>;
export type AdminListPaginatedReportsUsersLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedReportsUsersLazyQuery
>;
export type AdminListPaginatedReportsUsersSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedReportsUsersSuspenseQuery
>;
export type AdminListPaginatedReportsUsersQueryResult = Apollo.QueryResult<
  AdminListPaginatedReportsUsersQuery,
  AdminListPaginatedReportsUsersQueryVariables
>;
export const AdminRecordRetentionOutreachDocument = gql`
    mutation adminRecordRetentionOutreach($userIds: [String!]!, $fader: String!, $eventId: String) {
  adminRecordRetentionOutreach(
    userIds: $userIds
    fader: $fader
    eventId: $eventId
  )
}
    `;
export type AdminRecordRetentionOutreachMutationFn = Apollo.MutationFunction<
  AdminRecordRetentionOutreachMutation,
  AdminRecordRetentionOutreachMutationVariables
>;

/**
 * __useAdminRecordRetentionOutreachMutation__
 *
 * To run a mutation, you first call `useAdminRecordRetentionOutreachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRecordRetentionOutreachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRecordRetentionOutreachMutation, { data, loading, error }] = useAdminRecordRetentionOutreachMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      fader: // value for 'fader'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAdminRecordRetentionOutreachMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminRecordRetentionOutreachMutation,
    AdminRecordRetentionOutreachMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminRecordRetentionOutreachMutation,
    AdminRecordRetentionOutreachMutationVariables
  >(AdminRecordRetentionOutreachDocument, options);
}
export type AdminRecordRetentionOutreachMutationHookResult = ReturnType<
  typeof useAdminRecordRetentionOutreachMutation
>;
export type AdminRecordRetentionOutreachMutationResult =
  Apollo.MutationResult<AdminRecordRetentionOutreachMutation>;
export type AdminRecordRetentionOutreachMutationOptions = Apollo.BaseMutationOptions<
  AdminRecordRetentionOutreachMutation,
  AdminRecordRetentionOutreachMutationVariables
>;
export const AdminRetentionComebackDocument = gql`
    query adminRetentionComeback($month: String!) {
  adminRetentionComeback(month: $month) {
    month
    total
    cameBack
    interested
    cancelled
    rows {
      userId
      name
      email
      country
      plan
      joinDate
      zone
      entrySegment
      entryFader
      currentFader
      subscriptionStatus
      cycles
      dates
      outreachCount
      firstOutreach
      cameBack
      comebackDate
      daysToComeback
      comebackEvent
      comebackKind
      comebackHost
      comebackHostBadge
      loggedInSince
      cancelled
      lastLoginThen
      lastLoginNow
      lastAttendanceThen
      lastAttendanceNow
    }
  }
}
    `;

/**
 * __useAdminRetentionComebackQuery__
 *
 * To run a query within a React component, call `useAdminRetentionComebackQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetentionComebackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetentionComebackQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useAdminRetentionComebackQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminRetentionComebackQuery,
    AdminRetentionComebackQueryVariables
  > &
    ({ variables: AdminRetentionComebackQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminRetentionComebackQuery, AdminRetentionComebackQueryVariables>(
    AdminRetentionComebackDocument,
    options,
  );
}
export function useAdminRetentionComebackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRetentionComebackQuery,
    AdminRetentionComebackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminRetentionComebackQuery, AdminRetentionComebackQueryVariables>(
    AdminRetentionComebackDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminRetentionComebackSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminRetentionComebackQuery,
    AdminRetentionComebackQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminRetentionComebackQuery, AdminRetentionComebackQueryVariables>;
export function useAdminRetentionComebackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminRetentionComebackQuery,
        AdminRetentionComebackQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminRetentionComebackQuery | undefined,
  AdminRetentionComebackQueryVariables
>;
export function useAdminRetentionComebackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminRetentionComebackQuery,
        AdminRetentionComebackQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminRetentionComebackQuery, AdminRetentionComebackQueryVariables>(
    AdminRetentionComebackDocument,
    options,
  );
}
export type AdminRetentionComebackQueryHookResult = ReturnType<
  typeof useAdminRetentionComebackQuery
>;
export type AdminRetentionComebackLazyQueryHookResult = ReturnType<
  typeof useAdminRetentionComebackLazyQuery
>;
export type AdminRetentionComebackSuspenseQueryHookResult = ReturnType<
  typeof useAdminRetentionComebackSuspenseQuery
>;
export type AdminRetentionComebackQueryResult = Apollo.QueryResult<
  AdminRetentionComebackQuery,
  AdminRetentionComebackQueryVariables
>;
export const AdminRetentionAttendanceDetailDocument = gql`
    query adminRetentionAttendanceDetail($month: String!) {
  adminRetentionAttendanceDetail(month: $month) {
    member
    email
    event
    kind
    hostName
    hostBadge
    attended
  }
}
    `;

/**
 * __useAdminRetentionAttendanceDetailQuery__
 *
 * To run a query within a React component, call `useAdminRetentionAttendanceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetentionAttendanceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetentionAttendanceDetailQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useAdminRetentionAttendanceDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminRetentionAttendanceDetailQuery,
    AdminRetentionAttendanceDetailQueryVariables
  > &
    (
      | { variables: AdminRetentionAttendanceDetailQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminRetentionAttendanceDetailQuery,
    AdminRetentionAttendanceDetailQueryVariables
  >(AdminRetentionAttendanceDetailDocument, options);
}
export function useAdminRetentionAttendanceDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRetentionAttendanceDetailQuery,
    AdminRetentionAttendanceDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminRetentionAttendanceDetailQuery,
    AdminRetentionAttendanceDetailQueryVariables
  >(AdminRetentionAttendanceDetailDocument, options);
}
// @ts-expect-error
export function useAdminRetentionAttendanceDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminRetentionAttendanceDetailQuery,
    AdminRetentionAttendanceDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminRetentionAttendanceDetailQuery,
  AdminRetentionAttendanceDetailQueryVariables
>;
export function useAdminRetentionAttendanceDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminRetentionAttendanceDetailQuery,
        AdminRetentionAttendanceDetailQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminRetentionAttendanceDetailQuery | undefined,
  AdminRetentionAttendanceDetailQueryVariables
>;
export function useAdminRetentionAttendanceDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminRetentionAttendanceDetailQuery,
        AdminRetentionAttendanceDetailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminRetentionAttendanceDetailQuery,
    AdminRetentionAttendanceDetailQueryVariables
  >(AdminRetentionAttendanceDetailDocument, options);
}
export type AdminRetentionAttendanceDetailQueryHookResult = ReturnType<
  typeof useAdminRetentionAttendanceDetailQuery
>;
export type AdminRetentionAttendanceDetailLazyQueryHookResult = ReturnType<
  typeof useAdminRetentionAttendanceDetailLazyQuery
>;
export type AdminRetentionAttendanceDetailSuspenseQueryHookResult = ReturnType<
  typeof useAdminRetentionAttendanceDetailSuspenseQuery
>;
export type AdminRetentionAttendanceDetailQueryResult = Apollo.QueryResult<
  AdminRetentionAttendanceDetailQuery,
  AdminRetentionAttendanceDetailQueryVariables
>;
export const AdminRetentionPrepareDocument = gql`
    query adminRetentionPrepare($fader: String, $returningEmails: [String!]) {
  adminRetentionPrepare(fader: $fader, returningEmails: $returningEmails) {
    fader
    total
    truncated
    cap
    historyKnown
    excluded
    waiting
    cycle1 {
      count
      matchTiers {
        featured
        coach
        cxt
        none
      }
      groups {
        eventId
        eventTitle
        zone
        startDate
        emails
        userIds
      }
      unmatched {
        userId
        name
        email
        zone
        route
      }
    }
    cycle2 {
      count
      members {
        userId
        name
        email
        zone
        route
      }
    }
  }
}
    `;

/**
 * __useAdminRetentionPrepareQuery__
 *
 * To run a query within a React component, call `useAdminRetentionPrepareQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetentionPrepareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetentionPrepareQuery({
 *   variables: {
 *      fader: // value for 'fader'
 *      returningEmails: // value for 'returningEmails'
 *   },
 * });
 */
export function useAdminRetentionPrepareQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminRetentionPrepareQuery,
    AdminRetentionPrepareQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminRetentionPrepareQuery, AdminRetentionPrepareQueryVariables>(
    AdminRetentionPrepareDocument,
    options,
  );
}
export function useAdminRetentionPrepareLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRetentionPrepareQuery,
    AdminRetentionPrepareQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminRetentionPrepareQuery, AdminRetentionPrepareQueryVariables>(
    AdminRetentionPrepareDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminRetentionPrepareSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminRetentionPrepareQuery,
    AdminRetentionPrepareQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminRetentionPrepareQuery, AdminRetentionPrepareQueryVariables>;
export function useAdminRetentionPrepareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminRetentionPrepareQuery,
        AdminRetentionPrepareQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminRetentionPrepareQuery | undefined,
  AdminRetentionPrepareQueryVariables
>;
export function useAdminRetentionPrepareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminRetentionPrepareQuery,
        AdminRetentionPrepareQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminRetentionPrepareQuery, AdminRetentionPrepareQueryVariables>(
    AdminRetentionPrepareDocument,
    options,
  );
}
export type AdminRetentionPrepareQueryHookResult = ReturnType<typeof useAdminRetentionPrepareQuery>;
export type AdminRetentionPrepareLazyQueryHookResult = ReturnType<
  typeof useAdminRetentionPrepareLazyQuery
>;
export type AdminRetentionPrepareSuspenseQueryHookResult = ReturnType<
  typeof useAdminRetentionPrepareSuspenseQuery
>;
export type AdminRetentionPrepareQueryResult = Apollo.QueryResult<
  AdminRetentionPrepareQuery,
  AdminRetentionPrepareQueryVariables
>;
export const AdminShareEventPreviewDocument = gql`
    query adminShareEventPreview($emails: [String!]!, $eventId: String) {
  adminShareEventPreview(emails: $emails, eventId: $eventId) {
    totalPasted
    matchedCount
    notFound
    eligibleCount
    alreadySharedCount
    notAllowedEmails
    inactiveCount
  }
}
    `;

/**
 * __useAdminShareEventPreviewQuery__
 *
 * To run a query within a React component, call `useAdminShareEventPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShareEventPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShareEventPreviewQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAdminShareEventPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminShareEventPreviewQuery,
    AdminShareEventPreviewQueryVariables
  > &
    ({ variables: AdminShareEventPreviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminShareEventPreviewQuery, AdminShareEventPreviewQueryVariables>(
    AdminShareEventPreviewDocument,
    options,
  );
}
export function useAdminShareEventPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminShareEventPreviewQuery,
    AdminShareEventPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminShareEventPreviewQuery, AdminShareEventPreviewQueryVariables>(
    AdminShareEventPreviewDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminShareEventPreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminShareEventPreviewQuery,
    AdminShareEventPreviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminShareEventPreviewQuery, AdminShareEventPreviewQueryVariables>;
export function useAdminShareEventPreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminShareEventPreviewQuery,
        AdminShareEventPreviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminShareEventPreviewQuery | undefined,
  AdminShareEventPreviewQueryVariables
>;
export function useAdminShareEventPreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminShareEventPreviewQuery,
        AdminShareEventPreviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminShareEventPreviewQuery, AdminShareEventPreviewQueryVariables>(
    AdminShareEventPreviewDocument,
    options,
  );
}
export type AdminShareEventPreviewQueryHookResult = ReturnType<
  typeof useAdminShareEventPreviewQuery
>;
export type AdminShareEventPreviewLazyQueryHookResult = ReturnType<
  typeof useAdminShareEventPreviewLazyQuery
>;
export type AdminShareEventPreviewSuspenseQueryHookResult = ReturnType<
  typeof useAdminShareEventPreviewSuspenseQuery
>;
export type AdminShareEventPreviewQueryResult = Apollo.QueryResult<
  AdminShareEventPreviewQuery,
  AdminShareEventPreviewQueryVariables
>;
export const AdminShareEventToEmailsDocument = gql`
    mutation adminShareEventToEmails($eventId: String!, $emails: [String!]!, $source: OutreachSource) {
  adminShareEventToEmails(eventId: $eventId, emails: $emails, source: $source) {
    sharedCount
    notFound
  }
}
    `;
export type AdminShareEventToEmailsMutationFn = Apollo.MutationFunction<
  AdminShareEventToEmailsMutation,
  AdminShareEventToEmailsMutationVariables
>;

/**
 * __useAdminShareEventToEmailsMutation__
 *
 * To run a mutation, you first call `useAdminShareEventToEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShareEventToEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShareEventToEmailsMutation, { data, loading, error }] = useAdminShareEventToEmailsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emails: // value for 'emails'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdminShareEventToEmailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminShareEventToEmailsMutation,
    AdminShareEventToEmailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminShareEventToEmailsMutation,
    AdminShareEventToEmailsMutationVariables
  >(AdminShareEventToEmailsDocument, options);
}
export type AdminShareEventToEmailsMutationHookResult = ReturnType<
  typeof useAdminShareEventToEmailsMutation
>;
export type AdminShareEventToEmailsMutationResult =
  Apollo.MutationResult<AdminShareEventToEmailsMutation>;
export type AdminShareEventToEmailsMutationOptions = Apollo.BaseMutationOptions<
  AdminShareEventToEmailsMutation,
  AdminShareEventToEmailsMutationVariables
>;
export const AdminShareEventToUserIdsDocument = gql`
    mutation adminShareEventToUserIds($eventId: String!, $userIds: [String!]!, $source: OutreachSource) {
  adminShareEventToUserIds(eventId: $eventId, userIds: $userIds, source: $source) {
    sharedCount
    notFound
  }
}
    `;
export type AdminShareEventToUserIdsMutationFn = Apollo.MutationFunction<
  AdminShareEventToUserIdsMutation,
  AdminShareEventToUserIdsMutationVariables
>;

/**
 * __useAdminShareEventToUserIdsMutation__
 *
 * To run a mutation, you first call `useAdminShareEventToUserIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShareEventToUserIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShareEventToUserIdsMutation, { data, loading, error }] = useAdminShareEventToUserIdsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userIds: // value for 'userIds'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdminShareEventToUserIdsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminShareEventToUserIdsMutation,
    AdminShareEventToUserIdsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminShareEventToUserIdsMutation,
    AdminShareEventToUserIdsMutationVariables
  >(AdminShareEventToUserIdsDocument, options);
}
export type AdminShareEventToUserIdsMutationHookResult = ReturnType<
  typeof useAdminShareEventToUserIdsMutation
>;
export type AdminShareEventToUserIdsMutationResult =
  Apollo.MutationResult<AdminShareEventToUserIdsMutation>;
export type AdminShareEventToUserIdsMutationOptions = Apollo.BaseMutationOptions<
  AdminShareEventToUserIdsMutation,
  AdminShareEventToUserIdsMutationVariables
>;
export const AdminUserSignUpAnswersDocument = gql`
    query adminUserSignUpAnswers($userId: String!) {
  adminUserSignUpAnswers(userId: $userId) {
    createdAt
    eligibilityAgeGender
    englishLevel
    mainSpokenEnglishPriority
    mainSpeakingPracticeChallenge
    guestPassWeeklyPracticeReadiness
    detectedTimezone
    selectedTimezone
    selectedFirstEventId
    selectedFirstEventTime
    firstEventBookingSkipped
  }
}
    `;

/**
 * __useAdminUserSignUpAnswersQuery__
 *
 * To run a query within a React component, call `useAdminUserSignUpAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserSignUpAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserSignUpAnswersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserSignUpAnswersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminUserSignUpAnswersQuery,
    AdminUserSignUpAnswersQueryVariables
  > &
    ({ variables: AdminUserSignUpAnswersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminUserSignUpAnswersQuery, AdminUserSignUpAnswersQueryVariables>(
    AdminUserSignUpAnswersDocument,
    options,
  );
}
export function useAdminUserSignUpAnswersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminUserSignUpAnswersQuery,
    AdminUserSignUpAnswersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminUserSignUpAnswersQuery, AdminUserSignUpAnswersQueryVariables>(
    AdminUserSignUpAnswersDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminUserSignUpAnswersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminUserSignUpAnswersQuery,
    AdminUserSignUpAnswersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminUserSignUpAnswersQuery, AdminUserSignUpAnswersQueryVariables>;
export function useAdminUserSignUpAnswersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminUserSignUpAnswersQuery,
        AdminUserSignUpAnswersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminUserSignUpAnswersQuery | undefined,
  AdminUserSignUpAnswersQueryVariables
>;
export function useAdminUserSignUpAnswersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminUserSignUpAnswersQuery,
        AdminUserSignUpAnswersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminUserSignUpAnswersQuery, AdminUserSignUpAnswersQueryVariables>(
    AdminUserSignUpAnswersDocument,
    options,
  );
}
export type AdminUserSignUpAnswersQueryHookResult = ReturnType<
  typeof useAdminUserSignUpAnswersQuery
>;
export type AdminUserSignUpAnswersLazyQueryHookResult = ReturnType<
  typeof useAdminUserSignUpAnswersLazyQuery
>;
export type AdminUserSignUpAnswersSuspenseQueryHookResult = ReturnType<
  typeof useAdminUserSignUpAnswersSuspenseQuery
>;
export type AdminUserSignUpAnswersQueryResult = Apollo.QueryResult<
  AdminUserSignUpAnswersQuery,
  AdminUserSignUpAnswersQueryVariables
>;
export const AdminListPaginatedBannersDocument = gql`
    query adminListPaginatedBanners($filters: AdminFilterBannersInput!) {
  adminListPaginatedBanners(filters: $filters) {
    items {
      id
      title
      isActive
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedBannersQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedBannersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedBannersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedBannersQuery,
    AdminListPaginatedBannersQueryVariables
  > &
    ({ variables: AdminListPaginatedBannersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListPaginatedBannersQuery, AdminListPaginatedBannersQueryVariables>(
    AdminListPaginatedBannersDocument,
    options,
  );
}
export function useAdminListPaginatedBannersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedBannersQuery,
    AdminListPaginatedBannersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedBannersQuery,
    AdminListPaginatedBannersQueryVariables
  >(AdminListPaginatedBannersDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedBannersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedBannersQuery,
    AdminListPaginatedBannersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedBannersQuery,
  AdminListPaginatedBannersQueryVariables
>;
export function useAdminListPaginatedBannersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedBannersQuery,
        AdminListPaginatedBannersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedBannersQuery | undefined,
  AdminListPaginatedBannersQueryVariables
>;
export function useAdminListPaginatedBannersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedBannersQuery,
        AdminListPaginatedBannersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedBannersQuery,
    AdminListPaginatedBannersQueryVariables
  >(AdminListPaginatedBannersDocument, options);
}
export type AdminListPaginatedBannersQueryHookResult = ReturnType<
  typeof useAdminListPaginatedBannersQuery
>;
export type AdminListPaginatedBannersLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedBannersLazyQuery
>;
export type AdminListPaginatedBannersSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedBannersSuspenseQuery
>;
export type AdminListPaginatedBannersQueryResult = Apollo.QueryResult<
  AdminListPaginatedBannersQuery,
  AdminListPaginatedBannersQueryVariables
>;
export const AdminGetBannerDocument = gql`
    query adminGetBanner($id: String!) {
  adminGetBanner(id: $id) {
    id
    title
    isActive
    createdAt
    updatedAt
    audience
    sliders {
      id
      position
      title
    }
  }
}
    `;

/**
 * __useAdminGetBannerQuery__
 *
 * To run a query within a React component, call `useAdminGetBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetBannerQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetBannerQuery, AdminGetBannerQueryVariables> &
    ({ variables: AdminGetBannerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetBannerQuery, AdminGetBannerQueryVariables>(
    AdminGetBannerDocument,
    options,
  );
}
export function useAdminGetBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetBannerQuery, AdminGetBannerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetBannerQuery, AdminGetBannerQueryVariables>(
    AdminGetBannerDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetBannerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetBannerQuery, AdminGetBannerQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetBannerQuery, AdminGetBannerQueryVariables>;
export function useAdminGetBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetBannerQuery, AdminGetBannerQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetBannerQuery | undefined, AdminGetBannerQueryVariables>;
export function useAdminGetBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetBannerQuery, AdminGetBannerQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetBannerQuery, AdminGetBannerQueryVariables>(
    AdminGetBannerDocument,
    options,
  );
}
export type AdminGetBannerQueryHookResult = ReturnType<typeof useAdminGetBannerQuery>;
export type AdminGetBannerLazyQueryHookResult = ReturnType<typeof useAdminGetBannerLazyQuery>;
export type AdminGetBannerSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetBannerSuspenseQuery
>;
export type AdminGetBannerQueryResult = Apollo.QueryResult<
  AdminGetBannerQuery,
  AdminGetBannerQueryVariables
>;
export const AdminGetSlideDocument = gql`
    query adminGetSlide($id: String!) {
  adminGetSlide(id: $id) {
    background {
      desktop
      mobile
    }
    banner {
      id
      title
    }
    buttonText
    buttonURL
    createdAt
    featureImage
    id
    imageAlignment
    subtitle
    textColour
    title
    titleStyle
    updatedAt
  }
}
    `;

/**
 * __useAdminGetSlideQuery__
 *
 * To run a query within a React component, call `useAdminGetSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSlideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetSlideQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetSlideQuery, AdminGetSlideQueryVariables> &
    ({ variables: AdminGetSlideQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetSlideQuery, AdminGetSlideQueryVariables>(
    AdminGetSlideDocument,
    options,
  );
}
export function useAdminGetSlideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetSlideQuery, AdminGetSlideQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetSlideQuery, AdminGetSlideQueryVariables>(
    AdminGetSlideDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetSlideSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetSlideQuery, AdminGetSlideQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetSlideQuery, AdminGetSlideQueryVariables>;
export function useAdminGetSlideSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetSlideQuery, AdminGetSlideQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetSlideQuery | undefined, AdminGetSlideQueryVariables>;
export function useAdminGetSlideSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetSlideQuery, AdminGetSlideQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetSlideQuery, AdminGetSlideQueryVariables>(
    AdminGetSlideDocument,
    options,
  );
}
export type AdminGetSlideQueryHookResult = ReturnType<typeof useAdminGetSlideQuery>;
export type AdminGetSlideLazyQueryHookResult = ReturnType<typeof useAdminGetSlideLazyQuery>;
export type AdminGetSlideSuspenseQueryHookResult = ReturnType<typeof useAdminGetSlideSuspenseQuery>;
export type AdminGetSlideQueryResult = Apollo.QueryResult<
  AdminGetSlideQuery,
  AdminGetSlideQueryVariables
>;
export const AdminListPaginatedThemesDocument = gql`
    query adminListPaginatedThemes($filters: AdminFilterThemesInput!) {
  adminListPaginatedThemes(filters: $filters) {
    items {
      title
      id
      isCurrent
      isStandard
      isGrammarLibrary
      isTopicLibrary
      isResource
      topics {
        id
        title
      }
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedThemesQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedThemesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedThemesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedThemesQuery,
    AdminListPaginatedThemesQueryVariables
  > &
    ({ variables: AdminListPaginatedThemesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListPaginatedThemesQuery, AdminListPaginatedThemesQueryVariables>(
    AdminListPaginatedThemesDocument,
    options,
  );
}
export function useAdminListPaginatedThemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedThemesQuery,
    AdminListPaginatedThemesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListPaginatedThemesQuery, AdminListPaginatedThemesQueryVariables>(
    AdminListPaginatedThemesDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminListPaginatedThemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedThemesQuery,
    AdminListPaginatedThemesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedThemesQuery,
  AdminListPaginatedThemesQueryVariables
>;
export function useAdminListPaginatedThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedThemesQuery,
        AdminListPaginatedThemesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedThemesQuery | undefined,
  AdminListPaginatedThemesQueryVariables
>;
export function useAdminListPaginatedThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedThemesQuery,
        AdminListPaginatedThemesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedThemesQuery,
    AdminListPaginatedThemesQueryVariables
  >(AdminListPaginatedThemesDocument, options);
}
export type AdminListPaginatedThemesQueryHookResult = ReturnType<
  typeof useAdminListPaginatedThemesQuery
>;
export type AdminListPaginatedThemesLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedThemesLazyQuery
>;
export type AdminListPaginatedThemesSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedThemesSuspenseQuery
>;
export type AdminListPaginatedThemesQueryResult = Apollo.QueryResult<
  AdminListPaginatedThemesQuery,
  AdminListPaginatedThemesQueryVariables
>;
export const AdminListThemesDocument = gql`
    query adminListThemes {
  adminListThemes {
    title
    id
    isCurrent
    isStandard
    isGrammarLibrary
    isTopicLibrary
    isResource
    topics {
      id
      title
    }
  }
}
    `;

/**
 * __useAdminListThemesQuery__
 *
 * To run a query within a React component, call `useAdminListThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminListThemesQuery(
  baseOptions?: Apollo.QueryHookOptions<AdminListThemesQuery, AdminListThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListThemesQuery, AdminListThemesQueryVariables>(
    AdminListThemesDocument,
    options,
  );
}
export function useAdminListThemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminListThemesQuery, AdminListThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListThemesQuery, AdminListThemesQueryVariables>(
    AdminListThemesDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminListThemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListThemesQuery,
    AdminListThemesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminListThemesQuery, AdminListThemesQueryVariables>;
export function useAdminListThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminListThemesQuery, AdminListThemesQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminListThemesQuery | undefined, AdminListThemesQueryVariables>;
export function useAdminListThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminListThemesQuery, AdminListThemesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminListThemesQuery, AdminListThemesQueryVariables>(
    AdminListThemesDocument,
    options,
  );
}
export type AdminListThemesQueryHookResult = ReturnType<typeof useAdminListThemesQuery>;
export type AdminListThemesLazyQueryHookResult = ReturnType<typeof useAdminListThemesLazyQuery>;
export type AdminListThemesSuspenseQueryHookResult = ReturnType<
  typeof useAdminListThemesSuspenseQuery
>;
export type AdminListThemesQueryResult = Apollo.QueryResult<
  AdminListThemesQuery,
  AdminListThemesQueryVariables
>;
export const AdminGetThemeAndCoversDocument = gql`
    query adminGetThemeAndCovers($id: String!) {
  adminGetTheme(id: $id) {
    id
    title
    description
    isCurrent
    isStandard
    isGrammarLibrary
    isTopicLibrary
    isResource
    cover {
      id
      title
      primary {
        mobile
        desktop
      }
      secondary {
        mobile
        desktop
      }
      tertiary {
        mobile
        desktop
      }
    }
  }
  adminListCovers {
    id
    title
    primary {
      mobile
      desktop
    }
    secondary {
      mobile
      desktop
    }
    tertiary {
      mobile
      desktop
    }
  }
}
    `;

/**
 * __useAdminGetThemeAndCoversQuery__
 *
 * To run a query within a React component, call `useAdminGetThemeAndCoversQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetThemeAndCoversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetThemeAndCoversQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetThemeAndCoversQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGetThemeAndCoversQuery,
    AdminGetThemeAndCoversQueryVariables
  > &
    ({ variables: AdminGetThemeAndCoversQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetThemeAndCoversQuery, AdminGetThemeAndCoversQueryVariables>(
    AdminGetThemeAndCoversDocument,
    options,
  );
}
export function useAdminGetThemeAndCoversLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetThemeAndCoversQuery,
    AdminGetThemeAndCoversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetThemeAndCoversQuery, AdminGetThemeAndCoversQueryVariables>(
    AdminGetThemeAndCoversDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetThemeAndCoversSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetThemeAndCoversQuery,
    AdminGetThemeAndCoversQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetThemeAndCoversQuery, AdminGetThemeAndCoversQueryVariables>;
export function useAdminGetThemeAndCoversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetThemeAndCoversQuery,
        AdminGetThemeAndCoversQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminGetThemeAndCoversQuery | undefined,
  AdminGetThemeAndCoversQueryVariables
>;
export function useAdminGetThemeAndCoversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetThemeAndCoversQuery,
        AdminGetThemeAndCoversQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetThemeAndCoversQuery, AdminGetThemeAndCoversQueryVariables>(
    AdminGetThemeAndCoversDocument,
    options,
  );
}
export type AdminGetThemeAndCoversQueryHookResult = ReturnType<
  typeof useAdminGetThemeAndCoversQuery
>;
export type AdminGetThemeAndCoversLazyQueryHookResult = ReturnType<
  typeof useAdminGetThemeAndCoversLazyQuery
>;
export type AdminGetThemeAndCoversSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetThemeAndCoversSuspenseQuery
>;
export type AdminGetThemeAndCoversQueryResult = Apollo.QueryResult<
  AdminGetThemeAndCoversQuery,
  AdminGetThemeAndCoversQueryVariables
>;
export const AdminListPaginatedTopicsDocument = gql`
    query adminListPaginatedTopics($filters: AdminFilterTopicsInput!) {
  adminListPaginatedTopics(filters: $filters) {
    items {
      title
      id
      status
      updatedAt
      theme {
        id
        title
        isGrammarLibrary
        isTopicLibrary
        isStandard
        isResource
      }
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedTopicsQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedTopicsQuery,
    AdminListPaginatedTopicsQueryVariables
  > &
    ({ variables: AdminListPaginatedTopicsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListPaginatedTopicsQuery, AdminListPaginatedTopicsQueryVariables>(
    AdminListPaginatedTopicsDocument,
    options,
  );
}
export function useAdminListPaginatedTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedTopicsQuery,
    AdminListPaginatedTopicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListPaginatedTopicsQuery, AdminListPaginatedTopicsQueryVariables>(
    AdminListPaginatedTopicsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminListPaginatedTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedTopicsQuery,
    AdminListPaginatedTopicsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedTopicsQuery,
  AdminListPaginatedTopicsQueryVariables
>;
export function useAdminListPaginatedTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedTopicsQuery,
        AdminListPaginatedTopicsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedTopicsQuery | undefined,
  AdminListPaginatedTopicsQueryVariables
>;
export function useAdminListPaginatedTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedTopicsQuery,
        AdminListPaginatedTopicsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedTopicsQuery,
    AdminListPaginatedTopicsQueryVariables
  >(AdminListPaginatedTopicsDocument, options);
}
export type AdminListPaginatedTopicsQueryHookResult = ReturnType<
  typeof useAdminListPaginatedTopicsQuery
>;
export type AdminListPaginatedTopicsLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedTopicsLazyQuery
>;
export type AdminListPaginatedTopicsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedTopicsSuspenseQuery
>;
export type AdminListPaginatedTopicsQueryResult = Apollo.QueryResult<
  AdminListPaginatedTopicsQuery,
  AdminListPaginatedTopicsQueryVariables
>;
export const AdminGetTopicThemesAndIllustrationsDocument = gql`
    query adminGetTopicThemesAndIllustrations($id: String!) {
  adminGetTopic(id: $id) {
    id
    title
    theme {
      id
      title
    }
    comments {
      id
      createdAt
      message
      author {
        id
        name
        avatarUrl
      }
      replies {
        id
        createdAt
        message
        author {
          id
          name
          avatarUrl
        }
      }
    }
    status
    illustration {
      id
      title
      url
    }
    lessons {
      id
      kind
      title
    }
  }
  adminListThemes {
    id
    title
  }
  adminListIllustrations {
    id
    title
    url
  }
}
    `;

/**
 * __useAdminGetTopicThemesAndIllustrationsQuery__
 *
 * To run a query within a React component, call `useAdminGetTopicThemesAndIllustrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTopicThemesAndIllustrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTopicThemesAndIllustrationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetTopicThemesAndIllustrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGetTopicThemesAndIllustrationsQuery,
    AdminGetTopicThemesAndIllustrationsQueryVariables
  > &
    (
      | { variables: AdminGetTopicThemesAndIllustrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminGetTopicThemesAndIllustrationsQuery,
    AdminGetTopicThemesAndIllustrationsQueryVariables
  >(AdminGetTopicThemesAndIllustrationsDocument, options);
}
export function useAdminGetTopicThemesAndIllustrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetTopicThemesAndIllustrationsQuery,
    AdminGetTopicThemesAndIllustrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminGetTopicThemesAndIllustrationsQuery,
    AdminGetTopicThemesAndIllustrationsQueryVariables
  >(AdminGetTopicThemesAndIllustrationsDocument, options);
}
// @ts-expect-error
export function useAdminGetTopicThemesAndIllustrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetTopicThemesAndIllustrationsQuery,
    AdminGetTopicThemesAndIllustrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminGetTopicThemesAndIllustrationsQuery,
  AdminGetTopicThemesAndIllustrationsQueryVariables
>;
export function useAdminGetTopicThemesAndIllustrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetTopicThemesAndIllustrationsQuery,
        AdminGetTopicThemesAndIllustrationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminGetTopicThemesAndIllustrationsQuery | undefined,
  AdminGetTopicThemesAndIllustrationsQueryVariables
>;
export function useAdminGetTopicThemesAndIllustrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetTopicThemesAndIllustrationsQuery,
        AdminGetTopicThemesAndIllustrationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminGetTopicThemesAndIllustrationsQuery,
    AdminGetTopicThemesAndIllustrationsQueryVariables
  >(AdminGetTopicThemesAndIllustrationsDocument, options);
}
export type AdminGetTopicThemesAndIllustrationsQueryHookResult = ReturnType<
  typeof useAdminGetTopicThemesAndIllustrationsQuery
>;
export type AdminGetTopicThemesAndIllustrationsLazyQueryHookResult = ReturnType<
  typeof useAdminGetTopicThemesAndIllustrationsLazyQuery
>;
export type AdminGetTopicThemesAndIllustrationsSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetTopicThemesAndIllustrationsSuspenseQuery
>;
export type AdminGetTopicThemesAndIllustrationsQueryResult = Apollo.QueryResult<
  AdminGetTopicThemesAndIllustrationsQuery,
  AdminGetTopicThemesAndIllustrationsQueryVariables
>;
export const ListTotpDocument = gql`
    query listTotp {
  listTotp {
    id
    deviceName
    createdAt
  }
}
    `;

/**
 * __useListTotpQuery__
 *
 * To run a query within a React component, call `useListTotpQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTotpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTotpQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTotpQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTotpQuery, ListTotpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTotpQuery, ListTotpQueryVariables>(ListTotpDocument, options);
}
export function useListTotpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTotpQuery, ListTotpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTotpQuery, ListTotpQueryVariables>(ListTotpDocument, options);
}
// @ts-expect-error
export function useListTotpSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListTotpQuery, ListTotpQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTotpQuery, ListTotpQueryVariables>;
export function useListTotpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTotpQuery, ListTotpQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTotpQuery | undefined, ListTotpQueryVariables>;
export function useListTotpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTotpQuery, ListTotpQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTotpQuery, ListTotpQueryVariables>(ListTotpDocument, options);
}
export type ListTotpQueryHookResult = ReturnType<typeof useListTotpQuery>;
export type ListTotpLazyQueryHookResult = ReturnType<typeof useListTotpLazyQuery>;
export type ListTotpSuspenseQueryHookResult = ReturnType<typeof useListTotpSuspenseQuery>;
export type ListTotpQueryResult = Apollo.QueryResult<ListTotpQuery, ListTotpQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    name
    email
    avatarUrl
    needSpeakingPartner
    cambridgeEnglishLevel
    kind
    firstName
    otherLanguage
    isComplete
    badge
    createdAt
    lastName
    city
    country
    timezone
    story
    birthday
    interests
    occupation {
      id
      name
    }
    showBirthday
    showBirthdayYear
    nationality
    nativeLanguage
    completedPercentage
    isVisible
    wantsNewsletter
    availability {
      from
      until
    }
    promotionalCredits
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
// @ts-expect-error
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const AdminMemberStatsDocument = gql`
    query adminMemberStats($userIds: [String!]!) {
  adminMemberStats(userIds: $userIds) {
    userId
    zone
    eventsAttended
    status
    lastMessagedAt
    plan
    lastOnlineAt
    faderLevel
    engagementLevel
    commitmentLevel
    loginsRecent
    tenure
  }
}
    `;

/**
 * __useAdminMemberStatsQuery__
 *
 * To run a query within a React component, call `useAdminMemberStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberStatsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useAdminMemberStatsQuery(
  baseOptions: Apollo.QueryHookOptions<AdminMemberStatsQuery, AdminMemberStatsQueryVariables> &
    ({ variables: AdminMemberStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>(
    AdminMemberStatsDocument,
    options,
  );
}
export function useAdminMemberStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>(
    AdminMemberStatsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminMemberStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminMemberStatsQuery,
    AdminMemberStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>;
export function useAdminMemberStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminMemberStatsQuery | undefined, AdminMemberStatsQueryVariables>;
export function useAdminMemberStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminMemberStatsQuery, AdminMemberStatsQueryVariables>(
    AdminMemberStatsDocument,
    options,
  );
}
export type AdminMemberStatsQueryHookResult = ReturnType<typeof useAdminMemberStatsQuery>;
export type AdminMemberStatsLazyQueryHookResult = ReturnType<typeof useAdminMemberStatsLazyQuery>;
export type AdminMemberStatsSuspenseQueryHookResult = ReturnType<
  typeof useAdminMemberStatsSuspenseQuery
>;
export type AdminMemberStatsQueryResult = Apollo.QueryResult<
  AdminMemberStatsQuery,
  AdminMemberStatsQueryVariables
>;
export const AdminListUsersDocument = gql`
    query adminListUsers($filters: AdminFilterUsersInput!) {
  adminListUsers(filters: $filters) {
    items {
      id
      name
      email
      name
      avatarUrl
      needSpeakingPartner
      cambridgeEnglishLevel
      otherLanguage
      isComplete
      isVerified
      occupation {
        id
        name
      }
      badge
      createdAt
      recoveryStartedAt
      city
      country
      timezone
      story
      birthday
      interests
      showBirthday
      nativeLanguage
      completedPercentage
      isVisible
      wantsNewsletter
      availability {
        from
        until
      }
    }
    total
  }
}
    `;

/**
 * __useAdminListUsersQuery__
 *
 * To run a query within a React component, call `useAdminListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListUsersQuery(
  baseOptions: Apollo.QueryHookOptions<AdminListUsersQuery, AdminListUsersQueryVariables> &
    ({ variables: AdminListUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListUsersQuery, AdminListUsersQueryVariables>(
    AdminListUsersDocument,
    options,
  );
}
export function useAdminListUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminListUsersQuery, AdminListUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListUsersQuery, AdminListUsersQueryVariables>(
    AdminListUsersDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminListUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListUsersQuery, AdminListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminListUsersQuery, AdminListUsersQueryVariables>;
export function useAdminListUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminListUsersQuery, AdminListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminListUsersQuery | undefined, AdminListUsersQueryVariables>;
export function useAdminListUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminListUsersQuery, AdminListUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminListUsersQuery, AdminListUsersQueryVariables>(
    AdminListUsersDocument,
    options,
  );
}
export type AdminListUsersQueryHookResult = ReturnType<typeof useAdminListUsersQuery>;
export type AdminListUsersLazyQueryHookResult = ReturnType<typeof useAdminListUsersLazyQuery>;
export type AdminListUsersSuspenseQueryHookResult = ReturnType<
  typeof useAdminListUsersSuspenseQuery
>;
export type AdminListUsersQueryResult = Apollo.QueryResult<
  AdminListUsersQuery,
  AdminListUsersQueryVariables
>;
export const AdminGetSelectedUsersDocument = gql`
    query adminGetSelectedUsers($filters: AdminFilterUsersInput!) {
  adminGetSelectedUsers(filters: $filters) {
    id
    firstName
    lastName
    email
    cambridgeEnglishLevel
    speakingLevelScore
    speakingLevel
    availableAssessmentCharges
    takenSpeakingAssessment
    city
    country
    birthday
    nativeLanguage
    needSpeakingPartner
    badge
    isVerified
    lastOnlineAt
    availability {
      from
      until
    }
    timezone
    isActive
    isComplete
    occupation {
      id
      name
    }
    interests
    englishSkills
    createdAt
    kind
    customers {
      subscriptions {
        status
        plan
        currentPeriodStart
        currentPeriodEnd
        resumesAt
        cancelledAt
      }
    }
    showBirthday
    completedPercentage
    isVisible
    wantsNewsletter
  }
}
    `;

/**
 * __useAdminGetSelectedUsersQuery__
 *
 * To run a query within a React component, call `useAdminGetSelectedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSelectedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSelectedUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminGetSelectedUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGetSelectedUsersQuery,
    AdminGetSelectedUsersQueryVariables
  > &
    ({ variables: AdminGetSelectedUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetSelectedUsersQuery, AdminGetSelectedUsersQueryVariables>(
    AdminGetSelectedUsersDocument,
    options,
  );
}
export function useAdminGetSelectedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetSelectedUsersQuery,
    AdminGetSelectedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetSelectedUsersQuery, AdminGetSelectedUsersQueryVariables>(
    AdminGetSelectedUsersDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetSelectedUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetSelectedUsersQuery,
    AdminGetSelectedUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetSelectedUsersQuery, AdminGetSelectedUsersQueryVariables>;
export function useAdminGetSelectedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetSelectedUsersQuery,
        AdminGetSelectedUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminGetSelectedUsersQuery | undefined,
  AdminGetSelectedUsersQueryVariables
>;
export function useAdminGetSelectedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetSelectedUsersQuery,
        AdminGetSelectedUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetSelectedUsersQuery, AdminGetSelectedUsersQueryVariables>(
    AdminGetSelectedUsersDocument,
    options,
  );
}
export type AdminGetSelectedUsersQueryHookResult = ReturnType<typeof useAdminGetSelectedUsersQuery>;
export type AdminGetSelectedUsersLazyQueryHookResult = ReturnType<
  typeof useAdminGetSelectedUsersLazyQuery
>;
export type AdminGetSelectedUsersSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetSelectedUsersSuspenseQuery
>;
export type AdminGetSelectedUsersQueryResult = Apollo.QueryResult<
  AdminGetSelectedUsersQuery,
  AdminGetSelectedUsersQueryVariables
>;
export const AdminGetPlanDetailsDocument = gql`
    query adminGetPlanDetails($userId: String!) {
  adminGetPlanDetails(userId: $userId) {
    itemPriceId
    subscriptionChargebeeId
    customerChargebeeId
    userAmount
  }
}
    `;

/**
 * __useAdminGetPlanDetailsQuery__
 *
 * To run a query within a React component, call `useAdminGetPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPlanDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminGetPlanDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGetPlanDetailsQuery,
    AdminGetPlanDetailsQueryVariables
  > &
    ({ variables: AdminGetPlanDetailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetPlanDetailsQuery, AdminGetPlanDetailsQueryVariables>(
    AdminGetPlanDetailsDocument,
    options,
  );
}
export function useAdminGetPlanDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetPlanDetailsQuery,
    AdminGetPlanDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetPlanDetailsQuery, AdminGetPlanDetailsQueryVariables>(
    AdminGetPlanDetailsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetPlanDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetPlanDetailsQuery,
    AdminGetPlanDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetPlanDetailsQuery, AdminGetPlanDetailsQueryVariables>;
export function useAdminGetPlanDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetPlanDetailsQuery, AdminGetPlanDetailsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminGetPlanDetailsQuery | undefined,
  AdminGetPlanDetailsQueryVariables
>;
export function useAdminGetPlanDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetPlanDetailsQuery, AdminGetPlanDetailsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetPlanDetailsQuery, AdminGetPlanDetailsQueryVariables>(
    AdminGetPlanDetailsDocument,
    options,
  );
}
export type AdminGetPlanDetailsQueryHookResult = ReturnType<typeof useAdminGetPlanDetailsQuery>;
export type AdminGetPlanDetailsLazyQueryHookResult = ReturnType<
  typeof useAdminGetPlanDetailsLazyQuery
>;
export type AdminGetPlanDetailsSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetPlanDetailsSuspenseQuery
>;
export type AdminGetPlanDetailsQueryResult = Apollo.QueryResult<
  AdminGetPlanDetailsQuery,
  AdminGetPlanDetailsQueryVariables
>;
export const GetUserAdminDocument = gql`
    query getUserAdmin($id: String!) {
  getUserAdmin(id: $id) {
    id
    email
    name
    createdAt
    kind
    avatarUrl
    needSpeakingPartner
    cambridgeEnglishLevel
    speakingLevelScore
    speakingLevel
    firstName
    otherLanguage
    isComplete
    badge
    createdAt
    lastName
    isActive
    isBanned
    isVerified
    hasPassword
    city
    country
    timezone
    story
    birthday
    interests
    occupation {
      id
      name
    }
    badges {
      id
      type
      achievedDate
    }
    isAgeVisible
    showBirthday
    nativeLanguage
    completedPercentage
    isVisible
    isFeatured
    wantsNewsletter
    hasActivePlan
    availability {
      from
      until
    }
    notes {
      id
      description
    }
    availableAssessmentCharges
    engagementMetrics {
      totalRsvps
    }
    extraInvitedFriends
  }
}
    `;

/**
 * __useGetUserAdminQuery__
 *
 * To run a query within a React component, call `useGetUserAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAdminQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserAdminQuery, GetUserAdminQueryVariables> &
    ({ variables: GetUserAdminQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserAdminQuery, GetUserAdminQueryVariables>(
    GetUserAdminDocument,
    options,
  );
}
export function useGetUserAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserAdminQuery, GetUserAdminQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserAdminQuery, GetUserAdminQueryVariables>(
    GetUserAdminDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserAdminQuery, GetUserAdminQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserAdminQuery, GetUserAdminQueryVariables>;
export function useGetUserAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserAdminQuery, GetUserAdminQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserAdminQuery | undefined, GetUserAdminQueryVariables>;
export function useGetUserAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserAdminQuery, GetUserAdminQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserAdminQuery, GetUserAdminQueryVariables>(
    GetUserAdminDocument,
    options,
  );
}
export type GetUserAdminQueryHookResult = ReturnType<typeof useGetUserAdminQuery>;
export type GetUserAdminLazyQueryHookResult = ReturnType<typeof useGetUserAdminLazyQuery>;
export type GetUserAdminSuspenseQueryHookResult = ReturnType<typeof useGetUserAdminSuspenseQuery>;
export type GetUserAdminQueryResult = Apollo.QueryResult<
  GetUserAdminQuery,
  GetUserAdminQueryVariables
>;
export const AdminGuestPassSummaryDocument = gql`
    query adminGuestPassSummary($userId: String!) {
  adminGuestPassSummary(userId: $userId) {
    id
    startsAt
    endsAt
    daysRemaining
    tokenAllowance
    tokensUsed
    tokensRemaining
    isActive
  }
  adminGuestPassTokenAdjustments(userId: $userId) {
    id
    amount
    reason
    grantedById
    grantedByName
    grantedByEmail
    createdAt
  }
}
    `;

/**
 * __useAdminGuestPassSummaryQuery__
 *
 * To run a query within a React component, call `useAdminGuestPassSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGuestPassSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGuestPassSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminGuestPassSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminGuestPassSummaryQuery,
    AdminGuestPassSummaryQueryVariables
  > &
    ({ variables: AdminGuestPassSummaryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGuestPassSummaryQuery, AdminGuestPassSummaryQueryVariables>(
    AdminGuestPassSummaryDocument,
    options,
  );
}
export function useAdminGuestPassSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGuestPassSummaryQuery,
    AdminGuestPassSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGuestPassSummaryQuery, AdminGuestPassSummaryQueryVariables>(
    AdminGuestPassSummaryDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGuestPassSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGuestPassSummaryQuery,
    AdminGuestPassSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGuestPassSummaryQuery, AdminGuestPassSummaryQueryVariables>;
export function useAdminGuestPassSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGuestPassSummaryQuery,
        AdminGuestPassSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminGuestPassSummaryQuery | undefined,
  AdminGuestPassSummaryQueryVariables
>;
export function useAdminGuestPassSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGuestPassSummaryQuery,
        AdminGuestPassSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGuestPassSummaryQuery, AdminGuestPassSummaryQueryVariables>(
    AdminGuestPassSummaryDocument,
    options,
  );
}
export type AdminGuestPassSummaryQueryHookResult = ReturnType<typeof useAdminGuestPassSummaryQuery>;
export type AdminGuestPassSummaryLazyQueryHookResult = ReturnType<
  typeof useAdminGuestPassSummaryLazyQuery
>;
export type AdminGuestPassSummarySuspenseQueryHookResult = ReturnType<
  typeof useAdminGuestPassSummarySuspenseQuery
>;
export type AdminGuestPassSummaryQueryResult = Apollo.QueryResult<
  AdminGuestPassSummaryQuery,
  AdminGuestPassSummaryQueryVariables
>;
export const AdminGetOccupationsDocument = gql`
    query adminGetOccupations {
  adminGetOccupations {
    id
    name
  }
}
    `;

/**
 * __useAdminGetOccupationsQuery__
 *
 * To run a query within a React component, call `useAdminGetOccupationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetOccupationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetOccupationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminGetOccupationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminGetOccupationsQuery,
    AdminGetOccupationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetOccupationsQuery, AdminGetOccupationsQueryVariables>(
    AdminGetOccupationsDocument,
    options,
  );
}
export function useAdminGetOccupationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetOccupationsQuery,
    AdminGetOccupationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetOccupationsQuery, AdminGetOccupationsQueryVariables>(
    AdminGetOccupationsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetOccupationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetOccupationsQuery,
    AdminGetOccupationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetOccupationsQuery, AdminGetOccupationsQueryVariables>;
export function useAdminGetOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetOccupationsQuery, AdminGetOccupationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminGetOccupationsQuery | undefined,
  AdminGetOccupationsQueryVariables
>;
export function useAdminGetOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetOccupationsQuery, AdminGetOccupationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetOccupationsQuery, AdminGetOccupationsQueryVariables>(
    AdminGetOccupationsDocument,
    options,
  );
}
export type AdminGetOccupationsQueryHookResult = ReturnType<typeof useAdminGetOccupationsQuery>;
export type AdminGetOccupationsLazyQueryHookResult = ReturnType<
  typeof useAdminGetOccupationsLazyQuery
>;
export type AdminGetOccupationsSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetOccupationsSuspenseQuery
>;
export type AdminGetOccupationsQueryResult = Apollo.QueryResult<
  AdminGetOccupationsQuery,
  AdminGetOccupationsQueryVariables
>;
export const AdminGetGroupedOccupationsDocument = gql`
    query adminGetGroupedOccupations {
  adminGetGroupedOccupations {
    id
    name
    industry {
      id
      name
    }
  }
}
    `;

/**
 * __useAdminGetGroupedOccupationsQuery__
 *
 * To run a query within a React component, call `useAdminGetGroupedOccupationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetGroupedOccupationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetGroupedOccupationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminGetGroupedOccupationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminGetGroupedOccupationsQuery,
    AdminGetGroupedOccupationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetGroupedOccupationsQuery, AdminGetGroupedOccupationsQueryVariables>(
    AdminGetGroupedOccupationsDocument,
    options,
  );
}
export function useAdminGetGroupedOccupationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetGroupedOccupationsQuery,
    AdminGetGroupedOccupationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminGetGroupedOccupationsQuery,
    AdminGetGroupedOccupationsQueryVariables
  >(AdminGetGroupedOccupationsDocument, options);
}
// @ts-expect-error
export function useAdminGetGroupedOccupationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetGroupedOccupationsQuery,
    AdminGetGroupedOccupationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminGetGroupedOccupationsQuery,
  AdminGetGroupedOccupationsQueryVariables
>;
export function useAdminGetGroupedOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetGroupedOccupationsQuery,
        AdminGetGroupedOccupationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminGetGroupedOccupationsQuery | undefined,
  AdminGetGroupedOccupationsQueryVariables
>;
export function useAdminGetGroupedOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminGetGroupedOccupationsQuery,
        AdminGetGroupedOccupationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminGetGroupedOccupationsQuery,
    AdminGetGroupedOccupationsQueryVariables
  >(AdminGetGroupedOccupationsDocument, options);
}
export type AdminGetGroupedOccupationsQueryHookResult = ReturnType<
  typeof useAdminGetGroupedOccupationsQuery
>;
export type AdminGetGroupedOccupationsLazyQueryHookResult = ReturnType<
  typeof useAdminGetGroupedOccupationsLazyQuery
>;
export type AdminGetGroupedOccupationsSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetGroupedOccupationsSuspenseQuery
>;
export type AdminGetGroupedOccupationsQueryResult = Apollo.QueryResult<
  AdminGetGroupedOccupationsQuery,
  AdminGetGroupedOccupationsQueryVariables
>;
export const GetInvitedFriendsStatsDocument = gql`
    query getInvitedFriendsStats($userId: String!) {
  getInvitedFriendsStats(userId: $userId) {
    invitedFriendsTotal
    invitedPaidFriends
  }
}
    `;

/**
 * __useGetInvitedFriendsStatsQuery__
 *
 * To run a query within a React component, call `useGetInvitedFriendsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitedFriendsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitedFriendsStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetInvitedFriendsStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvitedFriendsStatsQuery,
    GetInvitedFriendsStatsQueryVariables
  > &
    ({ variables: GetInvitedFriendsStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvitedFriendsStatsQuery, GetInvitedFriendsStatsQueryVariables>(
    GetInvitedFriendsStatsDocument,
    options,
  );
}
export function useGetInvitedFriendsStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvitedFriendsStatsQuery,
    GetInvitedFriendsStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvitedFriendsStatsQuery, GetInvitedFriendsStatsQueryVariables>(
    GetInvitedFriendsStatsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetInvitedFriendsStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInvitedFriendsStatsQuery,
    GetInvitedFriendsStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInvitedFriendsStatsQuery, GetInvitedFriendsStatsQueryVariables>;
export function useGetInvitedFriendsStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInvitedFriendsStatsQuery,
        GetInvitedFriendsStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInvitedFriendsStatsQuery | undefined,
  GetInvitedFriendsStatsQueryVariables
>;
export function useGetInvitedFriendsStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInvitedFriendsStatsQuery,
        GetInvitedFriendsStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInvitedFriendsStatsQuery, GetInvitedFriendsStatsQueryVariables>(
    GetInvitedFriendsStatsDocument,
    options,
  );
}
export type GetInvitedFriendsStatsQueryHookResult = ReturnType<
  typeof useGetInvitedFriendsStatsQuery
>;
export type GetInvitedFriendsStatsLazyQueryHookResult = ReturnType<
  typeof useGetInvitedFriendsStatsLazyQuery
>;
export type GetInvitedFriendsStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetInvitedFriendsStatsSuspenseQuery
>;
export type GetInvitedFriendsStatsQueryResult = Apollo.QueryResult<
  GetInvitedFriendsStatsQuery,
  GetInvitedFriendsStatsQueryVariables
>;
export const ListPaginatedAssessmentResultsDocument = gql`
    query listPaginatedAssessmentResults($filters: PaginatedAssessmentResultInput!) {
  listPaginatedAssessmentResults(filters: $filters) {
    total
    items {
      id
      assessmentId
      cefrScore
      halloScore
      createdAt
    }
  }
}
    `;

/**
 * __useListPaginatedAssessmentResultsQuery__
 *
 * To run a query within a React component, call `useListPaginatedAssessmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaginatedAssessmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaginatedAssessmentResultsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListPaginatedAssessmentResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  > &
    (
      | { variables: ListPaginatedAssessmentResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >(ListPaginatedAssessmentResultsDocument, options);
}
export function useListPaginatedAssessmentResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >(ListPaginatedAssessmentResultsDocument, options);
}
// @ts-expect-error
export function useListPaginatedAssessmentResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListPaginatedAssessmentResultsQuery,
  ListPaginatedAssessmentResultsQueryVariables
>;
export function useListPaginatedAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPaginatedAssessmentResultsQuery,
        ListPaginatedAssessmentResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListPaginatedAssessmentResultsQuery | undefined,
  ListPaginatedAssessmentResultsQueryVariables
>;
export function useListPaginatedAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPaginatedAssessmentResultsQuery,
        ListPaginatedAssessmentResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >(ListPaginatedAssessmentResultsDocument, options);
}
export type ListPaginatedAssessmentResultsQueryHookResult = ReturnType<
  typeof useListPaginatedAssessmentResultsQuery
>;
export type ListPaginatedAssessmentResultsLazyQueryHookResult = ReturnType<
  typeof useListPaginatedAssessmentResultsLazyQuery
>;
export type ListPaginatedAssessmentResultsSuspenseQueryHookResult = ReturnType<
  typeof useListPaginatedAssessmentResultsSuspenseQuery
>;
export type ListPaginatedAssessmentResultsQueryResult = Apollo.QueryResult<
  ListPaginatedAssessmentResultsQuery,
  ListPaginatedAssessmentResultsQueryVariables
>;
export const GetUserAssessmentResultsDocument = gql`
    query getUserAssessmentResults($userId: String!, $filters: PaginatedAssessmentResultInput!) {
  getUserAssessmentResults(userId: $userId, filters: $filters) {
    total
    items {
      id
      assessmentId
      cefrScore
      halloScore
      createdAt
      isAddedByAdmin
    }
  }
}
    `;

/**
 * __useGetUserAssessmentResultsQuery__
 *
 * To run a query within a React component, call `useGetUserAssessmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAssessmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAssessmentResultsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUserAssessmentResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserAssessmentResultsQuery,
    GetUserAssessmentResultsQueryVariables
  > &
    ({ variables: GetUserAssessmentResultsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserAssessmentResultsQuery, GetUserAssessmentResultsQueryVariables>(
    GetUserAssessmentResultsDocument,
    options,
  );
}
export function useGetUserAssessmentResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserAssessmentResultsQuery,
    GetUserAssessmentResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserAssessmentResultsQuery, GetUserAssessmentResultsQueryVariables>(
    GetUserAssessmentResultsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserAssessmentResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserAssessmentResultsQuery,
    GetUserAssessmentResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUserAssessmentResultsQuery,
  GetUserAssessmentResultsQueryVariables
>;
export function useGetUserAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserAssessmentResultsQuery,
        GetUserAssessmentResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUserAssessmentResultsQuery | undefined,
  GetUserAssessmentResultsQueryVariables
>;
export function useGetUserAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserAssessmentResultsQuery,
        GetUserAssessmentResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserAssessmentResultsQuery,
    GetUserAssessmentResultsQueryVariables
  >(GetUserAssessmentResultsDocument, options);
}
export type GetUserAssessmentResultsQueryHookResult = ReturnType<
  typeof useGetUserAssessmentResultsQuery
>;
export type GetUserAssessmentResultsLazyQueryHookResult = ReturnType<
  typeof useGetUserAssessmentResultsLazyQuery
>;
export type GetUserAssessmentResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetUserAssessmentResultsSuspenseQuery
>;
export type GetUserAssessmentResultsQueryResult = Apollo.QueryResult<
  GetUserAssessmentResultsQuery,
  GetUserAssessmentResultsQueryVariables
>;
export const TotalHostedParticipantsDocument = gql`
    query totalHostedParticipants($userId: String!) {
  totalHostedParticipants(userId: $userId)
}
    `;

/**
 * __useTotalHostedParticipantsQuery__
 *
 * To run a query within a React component, call `useTotalHostedParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalHostedParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalHostedParticipantsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTotalHostedParticipantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  > &
    ({ variables: TotalHostedParticipantsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalHostedParticipantsQuery, TotalHostedParticipantsQueryVariables>(
    TotalHostedParticipantsDocument,
    options,
  );
}
export function useTotalHostedParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalHostedParticipantsQuery, TotalHostedParticipantsQueryVariables>(
    TotalHostedParticipantsDocument,
    options,
  );
}
// @ts-expect-error
export function useTotalHostedParticipantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TotalHostedParticipantsQuery,
  TotalHostedParticipantsQueryVariables
>;
export function useTotalHostedParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalHostedParticipantsQuery,
        TotalHostedParticipantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TotalHostedParticipantsQuery | undefined,
  TotalHostedParticipantsQueryVariables
>;
export function useTotalHostedParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalHostedParticipantsQuery,
        TotalHostedParticipantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  >(TotalHostedParticipantsDocument, options);
}
export type TotalHostedParticipantsQueryHookResult = ReturnType<
  typeof useTotalHostedParticipantsQuery
>;
export type TotalHostedParticipantsLazyQueryHookResult = ReturnType<
  typeof useTotalHostedParticipantsLazyQuery
>;
export type TotalHostedParticipantsSuspenseQueryHookResult = ReturnType<
  typeof useTotalHostedParticipantsSuspenseQuery
>;
export type TotalHostedParticipantsQueryResult = Apollo.QueryResult<
  TotalHostedParticipantsQuery,
  TotalHostedParticipantsQueryVariables
>;
export const TotalPublishedArticlesDocument = gql`
    query totalPublishedArticles($userId: String!) {
  totalPublishedArticles(userId: $userId)
}
    `;

/**
 * __useTotalPublishedArticlesQuery__
 *
 * To run a query within a React component, call `useTotalPublishedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalPublishedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalPublishedArticlesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTotalPublishedArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    TotalPublishedArticlesQuery,
    TotalPublishedArticlesQueryVariables
  > &
    ({ variables: TotalPublishedArticlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>(
    TotalPublishedArticlesDocument,
    options,
  );
}
export function useTotalPublishedArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalPublishedArticlesQuery,
    TotalPublishedArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>(
    TotalPublishedArticlesDocument,
    options,
  );
}
// @ts-expect-error
export function useTotalPublishedArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TotalPublishedArticlesQuery,
    TotalPublishedArticlesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>;
export function useTotalPublishedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalPublishedArticlesQuery,
        TotalPublishedArticlesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TotalPublishedArticlesQuery | undefined,
  TotalPublishedArticlesQueryVariables
>;
export function useTotalPublishedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalPublishedArticlesQuery,
        TotalPublishedArticlesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>(
    TotalPublishedArticlesDocument,
    options,
  );
}
export type TotalPublishedArticlesQueryHookResult = ReturnType<
  typeof useTotalPublishedArticlesQuery
>;
export type TotalPublishedArticlesLazyQueryHookResult = ReturnType<
  typeof useTotalPublishedArticlesLazyQuery
>;
export type TotalPublishedArticlesSuspenseQueryHookResult = ReturnType<
  typeof useTotalPublishedArticlesSuspenseQuery
>;
export type TotalPublishedArticlesQueryResult = Apollo.QueryResult<
  TotalPublishedArticlesQuery,
  TotalPublishedArticlesQueryVariables
>;
export const AttendanceRatioDocument = gql`
    query attendanceRatio($userId: String!) {
  attendanceRatio(userId: $userId)
}
    `;

/**
 * __useAttendanceRatioQuery__
 *
 * To run a query within a React component, call `useAttendanceRatioQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceRatioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceRatioQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAttendanceRatioQuery(
  baseOptions: Apollo.QueryHookOptions<AttendanceRatioQuery, AttendanceRatioQueryVariables> &
    ({ variables: AttendanceRatioQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttendanceRatioQuery, AttendanceRatioQueryVariables>(
    AttendanceRatioDocument,
    options,
  );
}
export function useAttendanceRatioLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AttendanceRatioQuery, AttendanceRatioQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttendanceRatioQuery, AttendanceRatioQueryVariables>(
    AttendanceRatioDocument,
    options,
  );
}
// @ts-expect-error
export function useAttendanceRatioSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttendanceRatioQuery,
    AttendanceRatioQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AttendanceRatioQuery, AttendanceRatioQueryVariables>;
export function useAttendanceRatioSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceRatioQuery, AttendanceRatioQueryVariables>,
): Apollo.UseSuspenseQueryResult<AttendanceRatioQuery | undefined, AttendanceRatioQueryVariables>;
export function useAttendanceRatioSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceRatioQuery, AttendanceRatioQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttendanceRatioQuery, AttendanceRatioQueryVariables>(
    AttendanceRatioDocument,
    options,
  );
}
export type AttendanceRatioQueryHookResult = ReturnType<typeof useAttendanceRatioQuery>;
export type AttendanceRatioLazyQueryHookResult = ReturnType<typeof useAttendanceRatioLazyQuery>;
export type AttendanceRatioSuspenseQueryHookResult = ReturnType<
  typeof useAttendanceRatioSuspenseQuery
>;
export type AttendanceRatioQueryResult = Apollo.QueryResult<
  AttendanceRatioQuery,
  AttendanceRatioQueryVariables
>;
export const AttendanceMetricsDocument = gql`
    query attendanceMetrics($userId: String!) {
  attendanceMetrics(userId: $userId) {
    totalEvents
    totalOneToOnes
    totalGroup
    totalWebinars
    totalInPerson
    totalOther
    totalDuration
    hostedEvents
    hostedOneToOnes
    hostedGroup
    hostedWebinars
    hostedInPerson
    hostedOther
    hostedDuration
    attendedEvents
    totalAttendedScheduledEvents
    totalAttendedNonScheduledEvents
    attendedOneToOnes
    attendedGroup
    attendedWebinars
    attendedInPerson
    attendedOther
    attendedDuration
    videoCalls
  }
}
    `;

/**
 * __useAttendanceMetricsQuery__
 *
 * To run a query within a React component, call `useAttendanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceMetricsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAttendanceMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables> &
    ({ variables: AttendanceMetricsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(
    AttendanceMetricsDocument,
    options,
  );
}
export function useAttendanceMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttendanceMetricsQuery,
    AttendanceMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(
    AttendanceMetricsDocument,
    options,
  );
}
// @ts-expect-error
export function useAttendanceMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttendanceMetricsQuery,
    AttendanceMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>;
export function useAttendanceMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AttendanceMetricsQuery | undefined,
  AttendanceMetricsQueryVariables
>;
export function useAttendanceMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(
    AttendanceMetricsDocument,
    options,
  );
}
export type AttendanceMetricsQueryHookResult = ReturnType<typeof useAttendanceMetricsQuery>;
export type AttendanceMetricsLazyQueryHookResult = ReturnType<typeof useAttendanceMetricsLazyQuery>;
export type AttendanceMetricsSuspenseQueryHookResult = ReturnType<
  typeof useAttendanceMetricsSuspenseQuery
>;
export type AttendanceMetricsQueryResult = Apollo.QueryResult<
  AttendanceMetricsQuery,
  AttendanceMetricsQueryVariables
>;
export const GetUserCalendarDocument = gql`
    query getUserCalendar($userId: String!) {
  getUserCalendar(userId: $userId) {
    url
  }
}
    `;

/**
 * __useGetUserCalendarQuery__
 *
 * To run a query within a React component, call `useGetUserCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCalendarQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserCalendarQuery, GetUserCalendarQueryVariables> &
    ({ variables: GetUserCalendarQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserCalendarQuery, GetUserCalendarQueryVariables>(
    GetUserCalendarDocument,
    options,
  );
}
export function useGetUserCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserCalendarQuery, GetUserCalendarQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserCalendarQuery, GetUserCalendarQueryVariables>(
    GetUserCalendarDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserCalendarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserCalendarQuery,
    GetUserCalendarQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetUserCalendarQuery, GetUserCalendarQueryVariables>;
export function useGetUserCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserCalendarQuery, GetUserCalendarQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserCalendarQuery | undefined, GetUserCalendarQueryVariables>;
export function useGetUserCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserCalendarQuery, GetUserCalendarQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserCalendarQuery, GetUserCalendarQueryVariables>(
    GetUserCalendarDocument,
    options,
  );
}
export type GetUserCalendarQueryHookResult = ReturnType<typeof useGetUserCalendarQuery>;
export type GetUserCalendarLazyQueryHookResult = ReturnType<typeof useGetUserCalendarLazyQuery>;
export type GetUserCalendarSuspenseQueryHookResult = ReturnType<
  typeof useGetUserCalendarSuspenseQuery
>;
export type GetUserCalendarQueryResult = Apollo.QueryResult<
  GetUserCalendarQuery,
  GetUserCalendarQueryVariables
>;
export const AdminListPaginatedVideoSetsDocument = gql`
    query adminListPaginatedVideoSets($filters: AdminFilterVideoSetInput!) {
  adminListPaginatedVideoSets(filters: $filters) {
    items {
      id
      title
      isActive
      audience
      colour
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedVideoSetsQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedVideoSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedVideoSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedVideoSetsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedVideoSetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedVideoSetsQuery,
    AdminListPaginatedVideoSetsQueryVariables
  > &
    ({ variables: AdminListPaginatedVideoSetsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListPaginatedVideoSetsQuery,
    AdminListPaginatedVideoSetsQueryVariables
  >(AdminListPaginatedVideoSetsDocument, options);
}
export function useAdminListPaginatedVideoSetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedVideoSetsQuery,
    AdminListPaginatedVideoSetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedVideoSetsQuery,
    AdminListPaginatedVideoSetsQueryVariables
  >(AdminListPaginatedVideoSetsDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedVideoSetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedVideoSetsQuery,
    AdminListPaginatedVideoSetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedVideoSetsQuery,
  AdminListPaginatedVideoSetsQueryVariables
>;
export function useAdminListPaginatedVideoSetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedVideoSetsQuery,
        AdminListPaginatedVideoSetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedVideoSetsQuery | undefined,
  AdminListPaginatedVideoSetsQueryVariables
>;
export function useAdminListPaginatedVideoSetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedVideoSetsQuery,
        AdminListPaginatedVideoSetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedVideoSetsQuery,
    AdminListPaginatedVideoSetsQueryVariables
  >(AdminListPaginatedVideoSetsDocument, options);
}
export type AdminListPaginatedVideoSetsQueryHookResult = ReturnType<
  typeof useAdminListPaginatedVideoSetsQuery
>;
export type AdminListPaginatedVideoSetsLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedVideoSetsLazyQuery
>;
export type AdminListPaginatedVideoSetsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedVideoSetsSuspenseQuery
>;
export type AdminListPaginatedVideoSetsQueryResult = Apollo.QueryResult<
  AdminListPaginatedVideoSetsQuery,
  AdminListPaginatedVideoSetsQueryVariables
>;
export const AdminGetVideoSetDocument = gql`
    query adminGetVideoSet($id: String!) {
  adminGetVideoSet(id: $id) {
    id
    title
    isActive
    audience
    colour
    updatedAt
    videos {
      id
      title
      videoURL
      thumbnail
      isActive
      position
    }
  }
}
    `;

/**
 * __useAdminGetVideoSetQuery__
 *
 * To run a query within a React component, call `useAdminGetVideoSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetVideoSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetVideoSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetVideoSetQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables> &
    ({ variables: AdminGetVideoSetQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>(
    AdminGetVideoSetDocument,
    options,
  );
}
export function useAdminGetVideoSetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>(
    AdminGetVideoSetDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetVideoSetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetVideoSetQuery,
    AdminGetVideoSetQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>;
export function useAdminGetVideoSetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>,
): Apollo.UseSuspenseQueryResult<AdminGetVideoSetQuery | undefined, AdminGetVideoSetQueryVariables>;
export function useAdminGetVideoSetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetVideoSetQuery, AdminGetVideoSetQueryVariables>(
    AdminGetVideoSetDocument,
    options,
  );
}
export type AdminGetVideoSetQueryHookResult = ReturnType<typeof useAdminGetVideoSetQuery>;
export type AdminGetVideoSetLazyQueryHookResult = ReturnType<typeof useAdminGetVideoSetLazyQuery>;
export type AdminGetVideoSetSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetVideoSetSuspenseQuery
>;
export type AdminGetVideoSetQueryResult = Apollo.QueryResult<
  AdminGetVideoSetQuery,
  AdminGetVideoSetQueryVariables
>;
export const AdminGetZineCoverDocument = gql`
    query adminGetZineCover($id: String!) {
  adminGetZineCover(id: $id) {
    id
    coverUrl
    isCurrent
  }
}
    `;

/**
 * __useAdminGetZineCoverQuery__
 *
 * To run a query within a React component, call `useAdminGetZineCoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetZineCoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetZineCoverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetZineCoverQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables> &
    ({ variables: AdminGetZineCoverQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables>(
    AdminGetZineCoverDocument,
    options,
  );
}
export function useAdminGetZineCoverLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetZineCoverQuery,
    AdminGetZineCoverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables>(
    AdminGetZineCoverDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminGetZineCoverSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminGetZineCoverQuery,
    AdminGetZineCoverQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables>;
export function useAdminGetZineCoverSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminGetZineCoverQuery | undefined,
  AdminGetZineCoverQueryVariables
>;
export function useAdminGetZineCoverSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminGetZineCoverQuery, AdminGetZineCoverQueryVariables>(
    AdminGetZineCoverDocument,
    options,
  );
}
export type AdminGetZineCoverQueryHookResult = ReturnType<typeof useAdminGetZineCoverQuery>;
export type AdminGetZineCoverLazyQueryHookResult = ReturnType<typeof useAdminGetZineCoverLazyQuery>;
export type AdminGetZineCoverSuspenseQueryHookResult = ReturnType<
  typeof useAdminGetZineCoverSuspenseQuery
>;
export type AdminGetZineCoverQueryResult = Apollo.QueryResult<
  AdminGetZineCoverQuery,
  AdminGetZineCoverQueryVariables
>;
export const AdminListPaginatedZineCoversDocument = gql`
    query adminListPaginatedZineCovers($filters: AdminFilterZineCoversInput!) {
  adminListPaginatedZineCovers(filters: $filters) {
    items {
      id
      coverUrl
      isCurrent
    }
    total
  }
}
    `;

/**
 * __useAdminListPaginatedZineCoversQuery__
 *
 * To run a query within a React component, call `useAdminListPaginatedZineCoversQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListPaginatedZineCoversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListPaginatedZineCoversQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdminListPaginatedZineCoversQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListPaginatedZineCoversQuery,
    AdminListPaginatedZineCoversQueryVariables
  > &
    ({ variables: AdminListPaginatedZineCoversQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListPaginatedZineCoversQuery,
    AdminListPaginatedZineCoversQueryVariables
  >(AdminListPaginatedZineCoversDocument, options);
}
export function useAdminListPaginatedZineCoversLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListPaginatedZineCoversQuery,
    AdminListPaginatedZineCoversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListPaginatedZineCoversQuery,
    AdminListPaginatedZineCoversQueryVariables
  >(AdminListPaginatedZineCoversDocument, options);
}
// @ts-expect-error
export function useAdminListPaginatedZineCoversSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListPaginatedZineCoversQuery,
    AdminListPaginatedZineCoversQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedZineCoversQuery,
  AdminListPaginatedZineCoversQueryVariables
>;
export function useAdminListPaginatedZineCoversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedZineCoversQuery,
        AdminListPaginatedZineCoversQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListPaginatedZineCoversQuery | undefined,
  AdminListPaginatedZineCoversQueryVariables
>;
export function useAdminListPaginatedZineCoversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListPaginatedZineCoversQuery,
        AdminListPaginatedZineCoversQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListPaginatedZineCoversQuery,
    AdminListPaginatedZineCoversQueryVariables
  >(AdminListPaginatedZineCoversDocument, options);
}
export type AdminListPaginatedZineCoversQueryHookResult = ReturnType<
  typeof useAdminListPaginatedZineCoversQuery
>;
export type AdminListPaginatedZineCoversLazyQueryHookResult = ReturnType<
  typeof useAdminListPaginatedZineCoversLazyQuery
>;
export type AdminListPaginatedZineCoversSuspenseQueryHookResult = ReturnType<
  typeof useAdminListPaginatedZineCoversSuspenseQuery
>;
export type AdminListPaginatedZineCoversQueryResult = Apollo.QueryResult<
  AdminListPaginatedZineCoversQuery,
  AdminListPaginatedZineCoversQueryVariables
>;
export const AdminForceSignOutDocument = gql`
    mutation adminForceSignOut($userId: String!) {
  adminForceSignOut(userId: $userId) {
    status
  }
}
    `;
export type AdminForceSignOutMutationFn = Apollo.MutationFunction<
  AdminForceSignOutMutation,
  AdminForceSignOutMutationVariables
>;

/**
 * __useAdminForceSignOutMutation__
 *
 * To run a mutation, you first call `useAdminForceSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceSignOutMutation, { data, loading, error }] = useAdminForceSignOutMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminForceSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminForceSignOutMutation,
    AdminForceSignOutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminForceSignOutMutation, AdminForceSignOutMutationVariables>(
    AdminForceSignOutDocument,
    options,
  );
}
export type AdminForceSignOutMutationHookResult = ReturnType<typeof useAdminForceSignOutMutation>;
export type AdminForceSignOutMutationResult = Apollo.MutationResult<AdminForceSignOutMutation>;
export type AdminForceSignOutMutationOptions = Apollo.BaseMutationOptions<
  AdminForceSignOutMutation,
  AdminForceSignOutMutationVariables
>;
export const AdminSecurityEventsDocument = gql`
    query adminSecurityEvents($userId: String!, $limit: Int) {
  adminSecurityEvents(userId: $userId, limit: $limit) {
    id
    type
    ipAddress
    userAgent
    createdAt
  }
}
    `;

/**
 * __useAdminSecurityEventsQuery__
 *
 * To run a query within a React component, call `useAdminSecurityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSecurityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSecurityEventsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminSecurityEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminSecurityEventsQuery,
    AdminSecurityEventsQueryVariables
  > &
    ({ variables: AdminSecurityEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminSecurityEventsQuery, AdminSecurityEventsQueryVariables>(
    AdminSecurityEventsDocument,
    options,
  );
}
export function useAdminSecurityEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminSecurityEventsQuery,
    AdminSecurityEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminSecurityEventsQuery, AdminSecurityEventsQueryVariables>(
    AdminSecurityEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useAdminSecurityEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminSecurityEventsQuery,
    AdminSecurityEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminSecurityEventsQuery, AdminSecurityEventsQueryVariables>;
export function useAdminSecurityEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminSecurityEventsQuery, AdminSecurityEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AdminSecurityEventsQuery | undefined,
  AdminSecurityEventsQueryVariables
>;
export function useAdminSecurityEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdminSecurityEventsQuery, AdminSecurityEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminSecurityEventsQuery, AdminSecurityEventsQueryVariables>(
    AdminSecurityEventsDocument,
    options,
  );
}
export type AdminSecurityEventsQueryHookResult = ReturnType<typeof useAdminSecurityEventsQuery>;
export type AdminSecurityEventsLazyQueryHookResult = ReturnType<
  typeof useAdminSecurityEventsLazyQuery
>;
export type AdminSecurityEventsSuspenseQueryHookResult = ReturnType<
  typeof useAdminSecurityEventsSuspenseQuery
>;
export type AdminSecurityEventsQueryResult = Apollo.QueryResult<
  AdminSecurityEventsQuery,
  AdminSecurityEventsQueryVariables
>;
